import {
  Component,
  OnInit,
  ElementRef,
  Input,
  ViewChild,
  HostListener,
  Renderer2,
  ChangeDetectorRef,
  QueryList,
  OnDestroy,
} from '@angular/core';
import { TaskService } from 'src/app/services/task.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CollectionPopupComponent } from '../shared';
import * as JSZipUtils from '../../../assets/script/jszip-utils.js';
import * as JSZip from 'jszip';
import { saveAs } from 'file-saver';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
var turf = require('@turf/turf');
import { environment } from 'src/environments/environment';
import { ApiService } from 'src/app/services/api.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatSelect } from '@angular/material/select';
import { PopupService } from 'src/app/services/popup.service';
import { DownloadService } from 'src/app/services/download.service';
import {
  EMPTY,
  Observable,
  Subject,
  Subscription,
  catchError,
  finalize,
  firstValueFrom,
  forkJoin,
  map,
  of,
  switchMap,
  take,
  takeUntil,
  tap,
  timeout,
} from 'rxjs';
import {
  DEFAULT_ZOOMLEVEL,
  OPERATORS,
  ZOOM_SCALES,
  feedsConfig,
  ANNOTATION,
  POINT_TASKING,
  VESSEL_PREDICTION,
  SOIL_MOISTURE_SAR_CLASS_MAP,VESSEL_CLASS_COLOR_MAP
} from 'src/app/services/constants';
import { BehaviorSubject } from 'rxjs';
import { DatePipe, formatDate } from '@angular/common';
import { ReturnRefundComponent } from '../collections/return-refund/return-refund.component';
import { MatDialog } from '@angular/material/dialog';
import { DataService } from 'src/app/services/data.service';
import { ThemeService } from 'src/app/services/theme.service';
import { FilterPopupComponent } from '../collections/filter-popup/filter-popup.component';
import { baseLayers, overlays } from '../../config/baseLayer';
import * as L from 'leaflet';
import 'proj4';
import { SplitMap } from 'src/lib/leaflet-compare';
import parseGeoRaster from 'georaster';
import GeoRasterLayer from 'georaster-layer-for-leaflet';
import chroma from 'chroma-js';
import { AuthService } from 'src/app/services/auth.service';
import { GeoSearchControl, OpenStreetMapProvider } from 'leaflet-geosearch';
import { CreateTaskConfirmDialog } from '../collections/confirm-dialog/confirmdialog';
import { UserService } from 'src/app/services/user.service';
import { WarningPopupComponent } from '../collections/warning-popup/warning-popup.component';
import { UtilsService } from 'src/app/services/utils.service';
import { HelperService, FeedSection } from 'src/app/services/helper.service';
import { MatCheckbox } from '@angular/material/checkbox';
import type {
  FeatureCollection,
  Feature,
  Geometry,
  GeoJsonProperties,
} from 'geojson';
import { attachVesselHoverPopup } from '../../services/map-tooltip-helper.service';
import { STRINGCONSTANTS } from '../../shared/constants/app-strings.constants';
import { bearingDeg } from 'src/app/shared/utils/geo.utils';
import {
  PredictionMarker,
  ProjectInfo,
} from '../../shared/models/collection.models';
import {
  cwsiCategories,
  mbsiCategories,
  ncciCategories,
  ndtiCategories,
  ndmiCategories,
  ndreCategories,
  ndviCategories,
  tvdiCategories,
} from 'src/app/shared/constants/indices-color.constants';
import { getIndicesColor } from 'src/app/shared/utils/indicies-color-picker';
import { IndicesDownloadService } from 'src/app/shared/service/download-indices.service';
import { OperationManagerService } from 'src/app/shared/service/operation-manager.service';
import { WarningPopup } from '../shared/warning-popup/warning-popup';
import { tiffLayerModel } from 'src/app/shared/models/tif-layer.model';
import { SoilMoistureSarClassMap } from 'src/app/shared/models/soil-moisture-model';
import { createNavigationGlobalIcon } from 'src/app/shared/service/icon.service';
import { BandSelectorComponent } from '../shared/band-selector/band-selector.component';
import { ActivatedRoute } from '@angular/router';
import { CollectionReportDialogComponent } from './collection-report-dialog/collection-report-dialog.component';
import {
  captureElementAsJpegBlob,
  captureLeafletCompareElementAsJpegBlob,
} from './collection-report/collection-report.utils';
import { buildCollectionReportSelectionsSummaryText } from './collection-report/collection-report.builder';

type FeatureProps = GeoJsonProperties & { _color?: string };
type FeedCache = {
  fc: FeatureCollection<Geometry, FeatureProps>;
  type?: string;
  color?: string;
  title: string;
};
interface LegendItem {
  color: string;
  value?: number;
}

interface LegendData {
  minValue: number;
  maxValue: number;
  items: LegendItem[];
}
interface CustomGeoJsonLayer extends L.GeoJSON {
  sensorId?: string;
  sceneId?: string;
  refreshId?: string;
  name?: string;
  type?: string;
}

interface CustomWMSOptions extends L.WMSOptions {
  env?: string;
  styles?: string;
  CQL_FILTER?: string;
}
interface FilterCriteria {
  destination?: string;
  flag?: string;
  length?: number;
  isGreater?: boolean;
  vesselType?: string;
  vesselSpeed?: number;
  isSpeedGreater?: boolean;
  vesselName?: string;
  MMSI?: string;
  IMO?: string;
}
type FeedPanel = {
  title: string;
  color?: string | SoilMoistureSarClassMap;
  sections: FeedSection[];
};

@Component({
  selector: 'app-leaflet-newcollections',
  templateUrl: './leaflet-newcollections.component.html',
  styleUrls: ['./leaflet-newcollections.component.scss'],
})
export class LeafletNewcollectionsComponent implements OnInit, OnDestroy {
  @ViewChild(MatCheckbox) checkboxes!: QueryList<MatCheckbox>;
  private map: L.Map;
  private shapeVectorOverlay?: L.GeoJSON;
  private dotRenderer = L.canvas({ padding: 0.5 });
  private feedPanels = new Map<string, FeedPanel>();
  @ViewChild('map', { static: true }) mapContainer!: ElementRef;
  @ViewChild('reportCaptureRoot') reportCaptureRoot?: ElementRef<HTMLElement>;
  @ViewChild('layerToggleButton', { static: true }) layerBtn!: ElementRef;
  @ViewChild('homeButton', { static: true }) homeButton!: ElementRef;
  @ViewChild('layerToggle', { static: true }) layerToggle!: ElementRef;
  @ViewChild('leftLayerLabel', { static: false }) leftLayerLabel!: ElementRef;
  @ViewChild('rightLayerLabel', { static: false }) rightLayerLabel!: ElementRef;
  @ViewChild('fileInput') fileInput: ElementRef;
  @ViewChild('bandSelect') bandSelect: MatSelect;
  zoomLevel = 3;
  mapDistance = 0;
  latLngDMS = '';
  isCompare = false;
  isCompareClicked = false;
  pointerEvent = 'auto';
  isNoScenes = false;
  leftData: any[] = [];
  rightData: any[] = [];
  offset = 0.01;
  mapFontColor = 'white';
  opportunityId: any;
  feasibilityArray: any = [];
  currentDownloadingSR: any;
  selectedSites: any[] = [];
  projectSelected: any;
  dateRange: boolean = false;
  metaDataTooltip: any;
  taskSelected: boolean = false;
  RF: boolean = false;
  sceneBands: any;
  bandSelected: string = 'both';
  selectedStartDate: any;
  selectedEndDate: any;
  recurrentTask: boolean = false;
  recurrencyDownload: boolean = false;
  isInIframe: boolean;
  sensorsIS: boolean = true;
  sceneSelected: any;
  selectedSceneNew: any;
  sceneId: any;
  leftBand: boolean = false;
  rightBand: boolean = false;
  taskCreatedDate: any;
  displayedIS: any;
  imageType: string = 'png';

  private collectionReportDialogOpening = false;
  metric = 'kg';
  vesselPolygon: any;
  ghgEmissionMsg = '';
  selectvdap: string;
  enableBand: any = false;
  annotationContent = '';
  filterData: any = [];
  filterVesselDataValue: boolean = false;
  filterVesselData: boolean = false;
  lastVisibleEntities: any = [];
  displayedSpireData: any;
  spireJsonData: any;
  spireSensorId: any;
  spireLayerRef: L.GeoJSON | null = null;
  filterObject: any;
  private spireGroup: L.LayerGroup;
  sceneFilterData: boolean = false;
  private geoByFeed = new Map<string, FeedCache>();
  private destroy$ = new Subject<void>();
  private currentFilteredLayers: { [feedKey: string]: L.Layer } = {};
  private predictionSubscription: Subscription | null = null;
  private vesselMarkerCache = new Map<string, L.Marker>();
  groupedVessels: { [key: string]: any[] } = {};
  prediction: boolean = false;
  filterInfoVisible: boolean = false;
  filterIconShown: boolean = false;
  predictionLayers: { [date: string]: L.LayerGroup } = {};
  predictionPathLayers: { [date: string]: L.Polyline } = {};
  pastPredictedPathLayers: { [date: string]: L.Polyline } = {};
  lastPredictionLatLng: L.LatLng | null = null;
  predictedVesselData: any;
  progressing: boolean = false;
  selectedPredictionId: string | null = null;
  predictionLastPoint: { lat: number; lng: number } | null = null;
  nonVesselFeed: any[] = [
    { name: 'Flood detection', color: 'rgb(205 0 0 / 66%)' },
    { name: 'Tree crown detection and count', color: '' },
    { name: 'Deforestation detection and area', color: '#765341' },
    { name: 'Oil spill detection', color: 'magenta' },
  ];
  pastPrediction: boolean = false;
  vessel: boolean = false;
  feedInfo: boolean = false;
  combinedFeedSections: FeedSection[] = [];
  dynamicLayers: any = [];
  feedSections: FeedSection[] = [];
  ecursSensorObject: any;
  private getCollectionSub?: Subscription;
  // TODO: Replace 'any' with the correct type definition for FeedUI if available
  feedUi?: any;

  toggleOptions(select: MatSelect): void {
    select.open();
  }
  isFirst = true;
  displayedColumns: string[] = ['position', 'name', 'weight', 'symbol'];
  dataSource: any[] = [];
  tableDataLength = 0;
  color = '#1059a9';
  CARTDATA: any[] = [];
  isVisible = false;
  expandedElement: any | null;
  currentUser: any;
  NAVLISTRT: any;
  tasktabs: any;
  tasksCount: any;
  userid: any;
  selectedSensors: any = [];
  selectedCost = 0;
  length = 0;
  pageSize = 10;
  pageIndex = 0;
  pageSizeOptions = [10, 20, 50];
  showFirstLastButtons = true;
  interval: any;
  refreshCount = 0;
  roll: any = 0;
  leftLayer: any;
  rightLayer: any;
  layer = 0;
  hs: any;
  baseLayers: any = [];
  sliderLayers: any = [];
  showMe = true;
  isDisableIS = true;
  @Input() accept = '.topojson, .geojson, .kml';
  fileAttr = 'Choose File';
  acceptFile = '.topojson, .geojson, .kml';
  selectedItems = 0;
  selectedSubDailyItems: any = [];
  selectedSubDailyItemsNew: any[] = [];
  selectedSubDailyItemValue = 1;
  collections: any;
  checked = true;
  scene: any;
  compassOverlay: any;
  sliderOverlay: any;
  acc: any;
  datafile: any;
  dataForm: FormGroup | any;
  options: any;
  selectedLeft: string;
  selectedRight: string;
  baseAlpha: any;
  FP: any;
  metadata: any;
  loadTiff: boolean = false;
  jump = false;
  panelOpenState = false;
  isExpanded: boolean[] = [];
  previousSelectionText: any = null;
  previousEndText: any = null;
  subDailyCount: any = null;
  previousSelection: any = null;
  previousSelectedProject: any = null;
  previousSelectedTask: any = null;
  downloadedScene: any = [];
  refundRequestScenes: any = [];
  scnLyr: any = [];
  scnLyr2: any = [];
  collectionsData: any = undefined;
  collection: any;
  subDailyArray: any = [];
  subDailyFinalArray: any[] = [];
  sensorList: any;
  collectionIndex: any;
  taskName: any;
  taskid: any;
  taskUuid: any;
  overlay: any = [100, 100];
  baseOverlay: any = 100;
  projectData: any;
  projectName: any;
  fail: number = 0;
  recurrencyOption: any;
  progress: any = 0;
  progressSubscription: Subscription;
  disable: boolean = true;
  freeze: boolean = false;
  mapLoad: boolean = false;
  fullCollection: any;
  filteredCollection: any = [];
  defaultSubdailyCount = 1;
  subDailyCountarray: any[] = [];
  OPERATOR: any;
  ZOOM_SCALES: any;
  downloadObj: any;
  downloadClick: boolean;
  operatorArray: any = [];
  showDailyRecurrencyCheckboxes: boolean = false;
  maxSelections = 2;
  recurrencyArray: any = [];
  selectedValueSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  selectedSensorSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  selectedcompareSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  selectedValue$ = this.selectedValueSubject.asObservable();
  selectedSensor$ = this.selectedSensorSubject.asObservable();
  selectedcompare$ = this.selectedcompareSubject.asObservable();
  selectedCheckboxes: any = [];
  SensorIndex: any = 0;
  selectionChange = new BehaviorSubject<any>('');
  subSelectionSelectionChange = new BehaviorSubject<any>('');
  selection: string = '14/06/2023 - 20/06/2023';
  selectionLabel: any = null;
  selectionLabelEnd: any = null;
  selectionLabels: any = '14/06/2023 - 20/06/2023';
  selectedSubdaily: any;
  selectedIndex: any = 0;
  isDragging = false;
  public emissionMessage: string = '';
  showSubDailyList = false;
  splitRightPostion = false;
  splitLeftPostion = false;
  taskCollection: any;
  selectedIS: boolean[] = [];
  selectedBand = 'all';
  legendData: LegendData;
  ghglegend: string;
  scaleArray: any = [];
  legendColor: string;
  currentTaskId: string;
  restoreRequestedSensors: any = [];
  darkTheme: boolean;
  tooltipImagePath: string;
  downloadImage: string;
  refundImage: string;
  feedLoaded: boolean = false;
  timeseries: boolean = false;
  sliderView = false;
  sliderShow = false;
  sliderDateRangeArray: any[] = [];
  groupedScenes: any;
  currentSliderValue = 0;
  usl = false;
  spire = false;
  lband = false;
  ISGeojsonLayer: any;
  indicesLayer: any;
  superResolutionLayer: any;
  superResolutionFootprintLayer: any;
  indicesLegendLayer: any;
  indicesFootprintLayer: any;
  indicesLayers: any[] = [];
  ISMarkers: any[] = [];
  historicalVesselData: any[] = [];
  dateDisable = false;
  lattitude = 41.2;
  longitude = 74.66;
  downloadedImage: string;
  downloadedSensor: any = [];
  currentDownloadingVADP: any;
  failScene = 0;
  scenes: any[] = [];
  sensors: any[] = [];
  scenesNew: any[] = [];
  sensorsNew: any[] = [];
  compare: any;
  leftImageNew: any;
  rightImageNew: any;
  legendScale: any;
  ghgLayers: any[] = [];
  annotaionMarker: any;
  collectionTaskMarker: any;
  isAnnotationSaved = false;
  annotatedLat: any;
  annotatedLng: any;
  filterSiteData: any = [];
  filterDateData: any = [];
  spireMarkers: any[] = [];
  spireBBox: any;
  annotateClicked = false;
  newTaskButtonClicked = false;
  isSitechanged = false;
  selectedSceneIndex = 0;
  signalSelected: any = 'All';
  signalLayers: any[] = [];
  audioAvailable: boolean = false;
  isClydeHistorical = false;
  refundRequestVADP: any = [];
  refundRequestSR: any = [];
  selectedOptions: any[] = [];
  infoserviceModelType = 'feature extraction';
  tooltipDisabled = false;
  downloadTooltip: any = '';
  filterStart: any;
  filterEnd: any;
  sensorSelected: any;
  clydeData: any;
  spireData: any;
  isFullscreen = false;
  clydeHistoricalLayer: any[] = [];
  spireHistoricalLayer: any[] = [];
  spirePredictionLayer: any[] = [];
  clydeVesselLayer: any;
  spireVesselLayer: any;
  clydevesselfootprintlayer: any;
  spirevesselfootprintlayer: any;
  HistoricalLayer: any[] = [];
  trendLinecordinates: any[] = [];
  indiceType = 'display';
  isTextareaDisabled = true;
  feedData = '';
  vesselData: any;
  dateRangeArray: any[] = [];
  mapPane = '';
  selectedCheckboxesNew: any[] = [];
  cloneselectedCheckboxesNew: any[] = [];
  overlayVessel: any;
  overlayClydeVessel: any;
  overlaySpireVessel: any;
  clickedAIS: any = '';
  clickedMarker: any;
  sensorLength = 0;
  selectedOperator: any;
  shipTypes: { type: string; color: string }[];
  shipColor: string;
  refreshData: boolean;
  previousMmsi: any;
  taskScene: any;
  currentHistoryIndex = 0;
  annotationMarkers: any[] = [];
  refreshFilterObject: any;
  currentEvent: { checked: boolean };
  private currentTooltip: L.Tooltip | null = null;
  vesselLength: any;
  selectedHistory: any = {};
  observationChecked: boolean = false;
  observationEnabled: boolean = false;
  vesselIsGreater: any = null;
  feedLayers: { [feedKey: string]: L.Layer } = {};
  info: any;
  private activeFeedKeys = new Set<string>();
  lastPointByIndex: { [index: number]: L.LatLng } = {};
  pastpreditedVesselData: any;
  combinedScenes: boolean = false;
  isMutltiscenSingleFeed: boolean = false;
  isScenSelected: boolean = false;
  isVadapSelected: boolean = false;
  isData:boolean = false;
  scenIdList: any[] = [];
  leftComparisonObjectLayer : any;
  rightComparisonObjectLayer : any;
  isCompareRecurrency: boolean = false;
  leftFeedPanels = new Map<string, FeedPanel>();
  rightFeedPanels = new Map<string, FeedPanel>();
  isLoadFeedComapre: boolean = false;
  private needsCompareResetToCenter = true;
  lastSliderValue = 0;

  isBandSelectorOpen: boolean = false;
  drawerOpen = false;
  selectedBands: number[] = [];
  isBandApplied: boolean = false;
  isFeedTasking: boolean = false;
  recurrrencyIndexValue: any;
  colorCode = {
    ClydeSpace: 'Orange',
    USL: 'Red',
    Spire: 'Red',
    'Spire-RF': 'Yellowgreen',
  };

  recurrentColorCode = {
    0: 'YELLOWGREEN',
    1: 'ROSYBROWN',
  };
  refreshHistoryColor = {
    ClydeSpace: 'Orange',
    Spire: 'Red',
  };
  nonImageryKey: string[] = ['Spire-RF', 'USL', 'Spire', 'ClydeSpace'];

  currentDownloadingIndices: any;
  oilSpil: boolean;
  displayedScene: any;
  displayedUrl: any;
  displayedSensorId: any;
  shapeOverlay: any;
  shapeLayerName: any;
  responseResult: any;
  blankspot: boolean = false;
  blankspotCount: any;
  blankspotArea: any;
  treeCounting: any;
  vesselCount: any;
  deforestationArea: any;
  tifPopupShown: number = 1;
  private _hoverMove?: (e: L.LeafletMouseEvent) => void;
  private _hoverOut?: () => void;
  private baseShapeCql = '';
  currentShapeLayerName: any;
  currentSelectedConfig: any;
  checkedObservation: boolean = false;
  private observationMarkerEntity: L.Marker | null = null;
  private colorLegendControl:
    | L.Control.Layers
    | L.Control.Zoom
    | L.Control
    | null = null;
  suppressSubDailyCheckbox = false;
  isAllRecurrencyDisabled :boolean = false;
  taskMode: string | null = null;
  isFeedBasedTasking: boolean = true;
  isShowSubDailyLegend: boolean = false;
  constructor(
    private httpClient: HttpClient,
    private taskService: TaskService,
    private apiService: ApiService,
    private el: ElementRef,
    private fb: FormBuilder,
    private spinnerService: NgxSpinnerService,
    private popupService: PopupService,
    private downloadService: DownloadService,
    private renderer: Renderer2,
    private datePipe: DatePipe,
    private matdialog: MatDialog,
    private localStorageService: DataService,
    private themeService: ThemeService,
    private changDetectionRef: ChangeDetectorRef,
    private authService: AuthService,
    private userService: UserService,
    private dialog: MatDialog,
    private http: HttpClient,
    private helperService: HelperService,
    private utilsService: UtilsService,
    private downloadIndicesService: IndicesDownloadService,
    private opManager: OperationManagerService,
    private route: ActivatedRoute
  ) {
    this.authService.getCurrentUser();
    this.OPERATOR = OPERATORS;
    this.ZOOM_SCALES = ZOOM_SCALES;
    this.spinnerService.hide();
    this.disable = true;
    this.downloadObj = this.downloadService.getProgress();
    if (this.downloadObj?.progress && this.downloadObj?.downloadClick) {
      this.progress = this.downloadObj?.progress;
      this.downloadProgress(this.downloadObj);
    }
    this.progressSubscription = this.downloadService
      .getProgressObservable()
      .subscribe((progress) => {
        this.progress = progress?.progress;
        this.downloadProgress(progress);
      });
    localStorage.removeItem('refund-request');
    localStorage.removeItem('scene-downloaded');
    localStorage.removeItem('restore-request');
    this.isInIframe = this.themeService.isInIframe();
    this.localStorageService.darkTheme.subscribe((newValue) => {
      this.darkTheme = newValue;
      this.tooltipImagePath = this.darkTheme
        ? '../../../assets/images/union-dark.svg'
        : '../../../assets/images/union.svg';
      this.downloadImage = this.darkTheme
        ? '../../../assets/images/icon-dark.svg'
        : '../../../assets/images/icon-img.svg';
      this.refundImage = this.darkTheme
        ? '../../../assets/images/refund-dark.png'
        : '../../../assets/images/refund.png';
      this.downloadedImage = this.darkTheme
        ? '../../../assets/images/cloud_done_dark.svg'
        : '../../../assets/images/cloud_done.svg';
    });
  }

  fullscreenIncon = '../../../assets/images/download.svg';

  toggleFullscreen() {
    const elem = this.mapContainer.nativeElement;
    if (!document.fullscreenElement) {
      this.fullscreenIncon = '../../../assets/images/download-3.svg';
      if (elem.requestFullscreen) {
        elem.requestFullscreen().then(() => {
          this.map.invalidateSize();
        });
      } else if (elem.mozRequestFullScreen) {
        elem.mozRequestFullScreen().then(() => {
          this.map.invalidateSize();
        });
      } else if (elem.webkitRequestFullscreen) {
        elem.webkitRequestFullscreen().then(() => {
          this.map.invalidateSize();
        });
      } else if (elem.msRequestFullscreen) {
        elem.msRequestFullscreen().then(() => {
          this.map.invalidateSize();
        });
      }
    } else {
      this.fullscreenIncon = '../../../assets/images/download.svg';
      if (document.exitFullscreen) {
        document.exitFullscreen().then(() => {
          this.map.invalidateSize();
        });
      }
    }
  }

  async openCollectionReportDialog(): Promise<void> {
    if (this.collectionReportDialogOpening) return;

    const taskId = this.collection?.taskId || this.taskid || this.collection?.id;
    if (!taskId) {
      this.popupService.openPopup(CollectionPopupComponent, 'Task is not selected.', '', '40%');
      return;
    }

    const taskName =
      (typeof this.taskName === 'string' && this.taskName.trim() ? this.taskName.trim() : '') ||
      (typeof this.collection?.taskname === 'string' && this.collection.taskname.trim() ? this.collection.taskname.trim() : '') ||
      '';

    const selectionsSummaryText = buildCollectionReportSelectionsSummaryText({
      collection: this.collection,
      currentUser: this.currentUser,
      isFeedTasking: this.isFeedTasking,
      isCompare: this.isCompare,
      selectedValue: this.selectedValue,
      selectionLabel: this.selectionLabel,
      defaultSubdailyCount: this.defaultSubdailyCount,
      selectedSubDailyItemsNew: this.selectedSubDailyItemsNew,
      subDailyFinalArray: this.subDailyFinalArray,
      selectedCheckboxesNew: this.selectedCheckboxesNew,
      selectedSceneNew: this.selectedSceneNew,
      selectedHistory: this.selectedHistory,
      scenesNew: this.scenesNew,
      filteredCollection: this.filteredCollection,
      leftData: this.leftData,
      rightData: this.rightData,
      leftFeedPanels: this.leftFeedPanels,
      rightFeedPanels: this.rightFeedPanels,
      pastPrediction: this.pastPrediction,
    });

    this.collectionReportDialogOpening = true;

    try {
      this.dialog.open(CollectionReportDialogComponent, {
        width: '700px',
        disableClose: true,
        data: {
          taskId,
          taskName,
          selectionsSummaryText,
          aoiTarget: (this.collection as any)?.target,
          captureMap: (options = {}) => {
            const captureRoot =
              this.reportCaptureRoot?.nativeElement ??
              (this.mapContainer?.nativeElement as HTMLElement | undefined);
            if (!captureRoot) {
              throw new Error('Map is not available for screenshot.');
            }

            if (this.isCompare && this.compare) {
              const dividerX =
                typeof (this.compare as any)?.getPosition2 === 'function'
                  ? (this.compare as any).getPosition2()
                  : this.lastSliderValue === 0
                    ? this.map.getSize().x / 2
                    : this.lastSliderValue;
              return captureLeafletCompareElementAsJpegBlob({ el: captureRoot, dividerX, options });
            }

            return captureElementAsJpegBlob(captureRoot, options);
          },
        },
      });
    } finally {
      this.collectionReportDialogOpening = false;
    }
  }

  async loadUserDetails(userId, isHomeClicked = false) {
    if (userId) {
      const defaultLocation: [number, number] = [20.5937, 78.9629];
      
      this.userService.personalInfo(userId)
        .pipe(
          take(1),
          switchMap((res: any) => {
            this.currentUser = res;
            if(!isHomeClicked) {
              this.getProjects(res?.id);
            }
            const url = `https://nominatim.openstreetmap.org/search?format=json&q=${this.currentUser?.country}`;
            return this.httpClient.get<any[]>(url).pipe(
              take(1),
              timeout(5000),
              catchError((error) => {
                return of([{ lat: defaultLocation[0], lon: defaultLocation[1] }]);
              })
            );
          }),
          catchError((error) => {
            return of([{ lat: defaultLocation[0], lon: defaultLocation[1] }]);
          })
        )
        .subscribe({
          next: (data: any) => {
            if (data && data.length > 0) {
              const lat = data[0].lat;
              const lon = data[0].lon;
              this.map.setView([lat, lon], 9);
              setTimeout(() => {
                this.map.invalidateSize();
              }, 100);
            } else {
              this.map.setView(defaultLocation, 9);
              setTimeout(() => {
                this.map.invalidateSize();
              }, 100);
            }
          },
          error: (error) => {
            this.map.setView(defaultLocation, 9);
            setTimeout(() => {
              this.map.invalidateSize();
            }, 100);
          }
        });
    }
  }

  onFullscreenChange() {
    this.isFullscreen = !!document.fullscreenElement;
    this.isFullscreen
      ? (this.fullscreenIncon = '../../../assets/images/download-3.svg')
      : (this.fullscreenIncon = '../../../assets/images/download.svg');
    this.map.invalidateSize();
  }

  locateTaskonMap(event: any) {
    this.jump = event.checked;
  }

  formatDates(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}Z`;
  }

  filterByDate() {
    const dialogRef = this.matdialog.open(FilterPopupComponent, {
      width: '35%',
      backdropClass: 'blurr',
      disableClose: true,
      data: {
        type: 'date',
        startDate: this.collection?.openWindow,
        endDate: this.collection?.closeWindow,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.dateRangeArray = [];
        this.sliderDateRangeArray = [];
        this.resetMapNew();
        this.currentSliderValue = 0;
        this.previousIndex = -1;
        this.filterStart = this.formatDates(result.start);
        this.filterEnd = this.formatDates(result.end);
        let checkedSensors: any[] = this.collection.sensors.filter(
          (sensor) => sensor.checked == true
        );

        if (checkedSensors.length > 0) {
          this.sensorSelected = this.collection.sensors[0].id;
          this.groupedScenes = this.groupCollections();
        }
      }
    });
  }

  toggleTimeSeries(event: any) {
    this.annotateClicked = false;
    this.newTaskButtonClicked = false;
    this.overlayClydeVessel = null;
    this.overlaySpireVessel = null;
    this.dateRangeArray = [];
    for (const [sensorIndex, sensor] of this.collection.sensors.entries()) {
      sensor.checked = false;
      for (const [sceneIndex, scene] of sensor.scenes.entries()) {
        scene.checked = false;
      }
    }
    this.sliderView = event.checked;
    this.sliderShow = false;
    this.sliderDateRangeArray = [];
    this.resetMapNew();
    this.currentSliderValue = 0;
    this.currentHistoryIndex = 0;
    this.showDailyRecurrencyCheckboxes = false;
    this.previousIndex = -1;
    this.isCompare = false;
    this.isCompareClicked = false;
    this.filterStart = null;
    this.filterEnd = null;

    if (this.collection?.sensors[0]?.operatorKey == OPERATORS.GHG) {
      this.defaultSubdailyCount = 1;
      this.metric = 'kg';
      this.getCollections(
        this.previousSelectedProject?.projectid
          ? this.previousSelectedProject?.projectid
          : this.projectSelected,
        this.collectionIndex
      );
      this.selectionChange.next(this.collection.recurrencyArray[0]);
    }

    if (!this.timeseries) {
      this.isSitechanged = false;
    }
    this.timeseries = event.checked;
    this.sliderView = event.checked;
  }

  resetTimeSeries() {
    this.sliderView = false;
    this.timeseries = false;
    this.sliderShow = false;
    this.sliderDateRangeArray = [];
    this.currentSliderValue = 0;
    this.currentHistoryIndex = 0;
    this.previousIndex = -1;
    this.isSitechanged = false;
  }

  previousIndex = -1;

sliderRecurrentData(sliderIndex: number) {
  const index = sliderIndex - 1;

  if (sliderIndex === 0 || index < 0) {
    this.clearAllMapLayers();
    this.previousIndex = -1;
    return;
  }
  
  const taskId = this.collection?.taskId;
  const selectedRange = this.sliderDateRangeArray[index];
  const rangeKey = `${selectedRange.start} to ${selectedRange.end}`;
  const selectedScenes = this.groupedScenes[rangeKey];

 const isGhg = selectedScenes?.length > 0 && selectedScenes[0].operatorKey === OPERATORS.GHG;

  if (!isGhg) {
    this.clearAllMapLayers();
  } else if (this.previousIndex > index) {
    const currentEndDate = selectedRange.end;
    const retainedScenes = this.scenesNew.filter((scene) => {
      const renderedPredictedDate =
        scene.renderedPredictedDate ??
        scene.scene?.predicted_date?.split('T')[0];

      return renderedPredictedDate <= currentEndDate;
    });
    const scenesToRemove = this.scenesNew.filter((scene) => {
      const renderedPredictedDate =
        scene.renderedPredictedDate ??
        scene.scene?.predicted_date?.split('T')[0];

      return renderedPredictedDate > currentEndDate;
    });

    scenesToRemove.forEach((scene) => {
      this.removeLayerByScene(scene);
    });

    this.ghgLayers = this.ghgLayers.filter((ghg) => {
      const renderedPredictedDate =
        ghg.renderedPredictedDate ??
        ghg.scene?.renderedPredictedDate ??
        ghg.scene?.scene?.predicted_date?.split('T')[0];

      if (renderedPredictedDate > currentEndDate) {
        this.removeGHGLayerByScene(ghg);
        return false;
      }

      return true;
    });

    this.scenesNew = this.scenesNew.filter((scene) => {
      const renderedPredictedDate =
        scene.renderedPredictedDate ??
        scene.scene?.predicted_date?.split('T')[0];

      return renderedPredictedDate <= currentEndDate;
    });

    this.ghgLayers.forEach((ghg) => {
      this.removeGHGLayerByScene(ghg);
    });
    this.ghgLayers = [];
    this.trendLinecordinates = [];

    retainedScenes
      .sort((leftScene: any, rightScene: any) => {
        const leftDate =
          leftScene.renderedPredictedDate ??
          leftScene.scene?.predicted_date?.split('T')[0] ?? '';
        const rightDate =
          rightScene.renderedPredictedDate ??
          rightScene.scene?.predicted_date?.split('T')[0] ?? '';

        return leftDate.localeCompare(rightDate);
      })
      .forEach((scene) => {
        this.showMetric(this.metric, scene);
      });
  }

  this.feedPanels = new Map();
  this.rebuildCombined();

  if (!selectedScenes?.length) return;

  for (const scn of selectedScenes) {
    const renderedPredictedDate = scn?.predicted_date?.split('T')[0];

    if (
      !scn?.id ||
      scn?.status === 'failed' ||
      (scn.siteId && scn.siteId !== this.defaultSubdailyCount)
    ) {
      continue;
    }

    if (!scn.footprint) continue;
      if (
      isGhg &&
      this.scenesNew.some(
        (scene) =>
          scene.id === scn.id &&
          (scene.renderedPredictedDate ??
            scene.scene?.predicted_date?.split('T')[0]) ===
            renderedPredictedDate
      )
    ) {
      continue;
    }

    const sensorId = this.sensorSelected?.id ?? this.sensorSelected;

    this.spinnerService.show();
    this.mapLoad = true;

    const sensorObj =
      this.imageType === 'tif'
        ? {
            sensorId,
            sceneId: scn.id,
            action: 'scene',
            fileType: this.imageType,
          }
        : {
            sensorId,
            sceneId: scn.id,
            action: 'scene',
            type: this.imageType,
          };

    this.apiService.getCollectionImage(taskId, sensorObj).subscribe({
      next: (res: any) => {
        this.DisplayPopupsBasedOnResponse(res);

        scn.thumbnailUrl = res.result?.COGUrl ?? res.result?.imageUrl;
        this.imageType === 'tif'
          ?
            this.displayFootprintImageNew(
                scn,
                res.result,
                sensorObj.sensorId,
                'image',
                taskId
              ) :
        this.displayFootprintImageTimeseriesNew(
          scn,
          res.result,
          sensorId
        );

        this.spinnerService.hide();
        this.mapLoad = false;
      },
      error: () => {
        this.spinnerService.hide();
        this.mapLoad = false;
      },
    });
  }

  if (this.collection.recurrencyArray?.length > 0) {
    this.loadTimeSeriesDataObject(this.collection, index);
  }

  this.previousIndex = index;
}

clearAllMapLayers() {
  this.scenesNew.forEach((scene) => {
    this.removeLayerByScene(scene);
  });
  this.scenesNew = [];

  this.ghgLayers.forEach((ghg) => {
    this.removeGHGLayerByScene(ghg);
  });
  this.ghgLayers = [];
  this.trendLinecordinates = [];

  Object.values(this.feedLayers || {}).forEach((layer: any) => {
    if (this.map.hasLayer(layer)) {
      this.removeVesselLabelLayer(layer);
      this.map.removeLayer(layer);
    }
  });
  this.feedLayers = {};
}


  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const container = this.el.nativeElement.querySelector(
      '.leaflet-control-layers-expanded'
    );
    if (container && this.layerBtn) {
      this.renderer.removeClass(
        this.layerBtn.nativeElement,
        'highlight-border'
      );
      this.renderer.removeClass(container, 'leaflet-control-layers-expanded');
      this.renderer.setStyle(this.layerBtn.nativeElement, 'top', '0px');
    }
  }
  public getMap(): any {
    return this.map;
  }
  ngOnInit(): void {
    this.selectionChange.subscribe((selectedValue: any) => {
      if (selectedValue && selectedValue?.start) {
        const start = this.formatDate(new Date(selectedValue?.start));
        const end = this.formatDate(new Date(selectedValue?.end));
        const combinedDate = `${start} - ${end}`;
        this.selectionLabel = new Date(selectedValue?.start);
        this.selectionLabelEnd = new Date(selectedValue?.end);
        this.selectionLabels = combinedDate;
      }
    });
    this.subSelectionSelectionChange.subscribe((selectedValue: any) => {
      this.selectedSubDailyItemValue = selectedValue;
    });
    this.taskMode = this.route.snapshot.queryParamMap.get('mode') ?? null;
    this.isFeedTasking = this.taskMode === 'feed';
    localStorage.removeItem('taskData');
    this.compassOverlay = document.getElementById('compass');
    this.baseLayers = [];
    this.baseAlpha = 1;
    this.dataForm = this.fb.group({
      datafile: ['', [Validators.required]],
    });
    this.sliderOverlay = document.getElementById('slider');
    this.acc = document.getElementsByClassName('accordion');
  }

  ngAfterViewChecked() {
    this.changDetectionRef.detectChanges();
  }

  ngOnDestroy(): void {
    this.map.remove();
    this.selectionChange.unsubscribe();
    this.stopHover();
    this.destroy$.next();
    this.destroy$.complete();
    this.getCollectionSub?.unsubscribe();
  }
  getProjects(userId) {
    this.apiService.getProjectName().subscribe((res: any) => {
      this.projectData = res.result;
      this.projectName = this.projectData[0]?.project;
      this.getCollections(res.result[0]?.projectid, 0);
      this.projectSelected = res.result[0]?.projectid;
      this.collectionIndex = 0;
    });
  }

  selectedValue: any;
  selectedSite: any;
  getCollectionData(userId: any) {
    this.tableDataLength = 0;
    this.taskService.getCollections(userId).subscribe(
      (result: any) => {
        this.tableDataLength =
          result.results.length > 0 ? result.results.length : 0;
        this.dataSource = result.results;
        if (result.results.length > 0) {
          this.collectionsData = result.results;
          this.collections = [];
          result.results.forEach((item, index) => {
            const project = item.project;
            const taskname = item.taskname;
            const taskUuid = item.sensors[0]?.sensor_uuid;
            const taskId = item.id;
            const questionId = item.questionId;
            let sensorName = item?.sensors?.[0]?.sensor;
            const target = JSON.parse(item.target);
            const sensors: any = [];
            item.sensors.forEach((sensor, i) => {
              const scenes: any = [];
              if (sensor?.scenes?.length > 0) {
                sensor?.scenes?.forEach((scene, index) => {
                  scene.checked = false;
                  let thumbnailUrl;
                  if (scene?.id != null) {
                    sensor.scenes[index] = scene;
                    thumbnailUrl =
                      environment.eeTaskServer + '/' + scene.thumbnailUrl || '';
                    const exists = scenes.find(
                      (sn: any) => sn.id === scene?.id
                    );
                    if (!exists) {
                      scenes.push({
                        id: scene.id,
                        name: `Scene ${index + 1}`,
                        sceneIdx: index + 1,
                        footprint: scene.footprint,
                        metadata: scene.metadata,
                        metadata_tooltip: scene?.metadata_tooltip,
                        thumbnailUrl: thumbnailUrl,
                        previewUrl: scene.previewUrl,
                        downloadUrl: scene.downloadUrl,
                        checked: false,
                        color: 'primary',
                        scene_id: scene?.scene_id,
                        operatorKey: sensor?.operatorKey,
                        isName: scene?.isName,
                        png_footprint: scene?.png_footprint,
                        tif_footprint: scene?.tif_footprint,
                        legendScale: scene?.legendScale,
                        legend_min: scene?.legend_min,
                        legend_max: scene?.legend_max,
                        legend_long: scene?.legend_long,
                        legend_lat: scene?.legend_lat,
                        min: scene?.min,
                        max: scene?.max,
                        rawIQDownloaded: scene?.raw_iq_downloaded,
                        rawIQIncluded: scene?.raw_iq_included,
                      });
                    }
                  }
                });
                if (scenes.length > 0) {
                  sensors.push({
                    name: sensor.sensor,
                    scenes,
                    checked: false,
                    id: sensor?.sensor_uuid,
                    downloadUrl: sensor?.downloadUrl,
                    questionName: sensor?.questionName,
                    questionId: sensor?.questionId,
                  });
                }
              }
            });
            let taskCollection = item?.taskcollection;
            let captures = item?.captures;
            let sensorsName = item?.sensorsName;
            let info = item?.info;
            if (sensors.length > 0) {
              this.collections.push({
                project,
                taskname,
                target,
                sensors,
                taskId,
                sensorName,
                taskCollection,
                captures,
                sensorsName,
                info,
                questionId
              });
              this.collection = this.collections[0];
              this.collectionIndex = 0;
              this.taskName = this.collections[0].taskname;
              this.taskid = this.collections[0].taskId;
              this.selectionChange.next(this.collection.recurrencyArray[0]);
            }
          });
        } else {
          this.collectionsData = [];
        }
      },
      (err) => {
        return false;
      }
    );
  }

  initializeDefaultValue() {
    if (this.collection?.recurrencyArray?.length) {
      this.selectedValue = this.collection.recurrencyArray[0];
    }
  }

  togglePanel() {
    this.showMe = !this.showMe;
  }

  ngAfterViewInit() {
    this.initializeMap();
    this.initGeoSearchControl();
    this.setupEventListeners();
  }

  chngAlphaNew(value: any) {
    const sliderValue = value / 100;
    const tilePane: any = document.querySelector('.leaflet-tile-pane');
    tilePane.style.opacity = sliderValue;
  }

  chngSceneOpacity(value: any, sensor) {
    const sliderValue = value / 100;
    this.scenesNew.map((scene) => {
      if (sensor.start) {
        if (scene.scene.start == sensor.start) {
          if (scene.leftImageLayer) {
            scene.leftImageLayer.setOpacity(sliderValue);
          }
          if (scene.rightImageLayer) {
            scene.rightImageLayer.setOpacity(sliderValue);
          }
        }
      } else if (sensor.id) {
        if (scene.sensorId == sensor.id) {
          if (scene.leftImageLayer) {
            scene.leftImageLayer.setOpacity(sliderValue);
          }
          if (scene.rightImageLayer) {
            scene.rightImageLayer.setOpacity(sliderValue);
          }
        }
      }
    });
  }

  chngSceneSite(value: any, sensor) {
    const sliderValue = value / 100;
    this.scenesNew.map((scene) => {
      if (sensor.sequenceNumber) {
        if (scene.scene.siteId == sensor.sequenceNumber) {
          if (scene.leftImageLayer) {
            scene.leftImageLayer.setOpacity(sliderValue);
          }
          if (scene.rightImageLayer) {
            scene.rightImageLayer.setOpacity(sliderValue);
          }
        }
      }
    });
  }

  createPixelValuesToColorFn(georaster: any, scene: any) {
    if (georaster.numberOfRasters === 1) {
      return (values) => {
        if (georaster.noDataValue === values[0]) {
          return 'rgba(0, 0, 0, 0)';
        }
        return chroma
          .scale(['black', 'white'])
          .domain([scene?.min, scene?.max])(values[0])
          .hex();
      };
    } else {
      return undefined;
    }
  }

  private setupEventListeners(): void {
    this.map.on('mousemove', this.handleMouseMove);
    this.map.on('contextmenu', this.handleMouseRightclick);
    document.addEventListener(
      'fullscreenchange',
      this.onFullscreenChange.bind(this)
    );
    this.map.doubleClickZoom.disable();
  }

  private async initializeMap() {
    this.map = L.map(this.mapContainer.nativeElement, {
      zoom: this.zoomLevel,
      maxZoom: 18,
      minZoom: 7,
      layers: [
        environment.enableSentinelBaseMap === 'true' && baseLayers['Sentinel']
          ? baseLayers['Sentinel']
          : baseLayers['Openstreetmap'],
      ],
      attributionControl: false,
      worldCopyJump: true,
      maxBounds: [
      [-90, -180],
      [90, 180]
      ],
      maxBoundsViscosity: 1.0,
    });
    if (!(this.map as any).getPane('annotationMarkersPane')) {
      this.map.createPane('annotationMarkersPane');

      (this.map as any)
        .getPane('annotationMarkersPane')
        .style.setProperty('z-index', '2700', 'important');
      (this.map as any).getPane('annotationMarkersPane').style.zIndex = 2700;
    }

    (this.map as any).getPane('popupPane').style.zIndex = 5000;
    (this.map as any).getPane('tooltipPane').style.zIndex = 4900;

    var myAttrControl = L.control.attribution().addTo(this.map);
    myAttrControl.setPrefix('<a href="https://leafletjs.com/">Leaflet</a>');

    setTimeout(() => {
      this.map.invalidateSize();
      this.changDetectionRef.detectChanges();
    }, 0);

    L.control
      .layers(baseLayers, overlays, {
        collapsed: false,
        position: 'topright',
      })
      .addTo(this.map);

    const castUser = this.authService.castCurrentUser
      .pipe(take(1))
      .subscribe(
        async (res: any) => {
          this.loadUserDetails(res?.id);
        }
      );

    L.Icon.Default.mergeOptions({
      iconUrl: '../../../assets/map-icons/marker-icon.png',
      iconSize: [25, 41],
      iconAnchor: [12, 41],
      popupAnchor: [1, -34],
      shadowUrl: '../../../assets/map-icons/marker-shadow.png',
      shadowSize: [41, 41],
      shadowAnchor: [12, 41],
    });

    setTimeout(() => {
      const layersControlElement = document.querySelector(
        '.leaflet-control-layers'
      );
      if (layersControlElement) {
        const container = document.getElementsByClassName(
          'leaflet-control-layers-expanded'
        )[0];
        if (container) {
          this.renderer.removeClass(
            container,
            'leaflet-control-layers-expanded'
          );
        }
      }
    }, 0);

    this.map.on('baselayerchange', (event: any) => {
      let layerBtn: any = document.querySelector(
        '.leaflet-control-layers-toggle'
      );
      if (this.layerBtn) {
        this.renderer.removeClass(this.layerBtn, 'highlight-border');
      }
      const container = document.getElementsByClassName(
        'leaflet-control-layers-expanded'
      )[0] as HTMLElement;
      if (container) {
        this.renderer.removeClass(container, 'leaflet-control-layers-expanded');
        document
          .querySelector('.leaflet-control-layers-toggle')
          ?.setAttribute('style', 'top:0px !important'); // Set the style for the layer toggle button
      }
      if (this.homeButton) {
        this.renderer.setStyle(this.homeButton.nativeElement, 'z-index', '500');
      }
      if (event.name === 'Openstreetmap') {
        this.mapFontColor = 'black';
        myAttrControl.setPrefix('<a href="https://leafletjs.com/">Leaflet</a>');
        if (environment.enableSentinelBaseMap === 'true') {
          myAttrControl.removeAttribution(
            '<a href="https://scihub.copernicus.eu/" target="_blank">Copernicus Sentinel data 2020</a>'
          );
        }
        myAttrControl.addAttribution(
          '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> contributers'
        );
        this.map.setMinZoom(1);
        this.map.setMaxZoom(18);
        if (this.map.getZoom() < 1) {
        this.map.setZoom(1);
        }
        if (this.map.getZoom() > 18) {
        this.map.setZoom(18);
        }    
        if (environment.enableSentinelBaseMap === 'true' && this.map.hasLayer(baseLayers['Sentinel'])) {
          this.map.removeLayer(baseLayers['Sentinel']);
        }
      } else if (environment.enableSentinelBaseMap === 'true') {
        this.mapFontColor = 'white';
        myAttrControl.setPrefix('<a href="https://leafletjs.com/">Leaflet</a>');
        myAttrControl.removeAttribution(
          '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> contributers'
        );
        myAttrControl.addAttribution(
          '<a href="https://scihub.copernicus.eu/" target="_blank">Copernicus Sentinel data 2020</a>'
        );
        this.map.setMinZoom(7);
        this.map.setMaxZoom(18);
        if (this.map.getZoom() < 7) {
        this.map.setZoom(7);
        }
        if (this.map.getZoom() > 18) {
        this.map.setZoom(18);
       }
      }
    });

    document
      .querySelector('.leaflet-control-layers-toggle')
      ?.addEventListener('click', (e) => {
        let layerBtn: any = document.querySelector(
          '.leaflet-control-layers-toggle'
        );
        layerBtn.classList.add('highlight-border');
        if (document.querySelector('.leaflet-control-layers-expanded')) {
          document
            .querySelector('.leaflet-control-layers-toggle')
            ?.setAttribute('style', 'top:-48px !important');
          if (this.darkTheme) {
            document
              .querySelector('.leaflet-control-layers-expanded')
              ?.setAttribute('style', 'background:black !important');
          } else {
            document
              .querySelector('.leaflet-control-layers-expanded')
              ?.setAttribute('style', 'background:none !important');
          }
          const searchBtnParentEl = document.querySelector(
            '.leaflet-geosearch-button'
          ) as HTMLElement;
          const searchInput = document.querySelector(
            '.leaflet-geosearch-button form input'
          ) as HTMLInputElement;
          if (!searchInput.value && !searchInput.classList.contains('active')) {
            searchBtnParentEl.classList.remove('active');
          }
        }
      });

    this.map.on('click', function () {
      let homeBtn: any = document.querySelector('#homeButton');
      homeBtn.classList.remove('highlight-border');
      let layerBtn: any = document.querySelector(
        '.leaflet-control-layers-toggle'
      );
      layerBtn.classList.remove('highlight-border');
      var controlContainer = document.getElementsByClassName(
        'leaflet-control-layers-expanded'
      )[0];
      if (
        controlContainer &&
        controlContainer.classList.contains('leaflet-control-layers-expanded')
      ) {
        controlContainer.classList.remove('leaflet-control-layers-expanded');
        document
          .querySelector('.leaflet-control-layers-toggle')
          ?.setAttribute('style', 'top:0px !important');
      }
      const searchBtnParentEl = document.querySelector(
        '.leaflet-geosearch-button'
      ) as HTMLElement;
      searchBtnParentEl.classList.remove('active');
    });
    this.map.createPane('left');
    this.map.createPane('right');
    this.map.on('baselayerchange', (e: any) => {
      this.map.off('layerremove');
      this.map.off('layeradd');
    });
    this.map.on('layeradd', (e: any) => {});
    this.map.on('layerremove', (e: any) => {
      this.map.off('layerremove');
    });
    const mapContainer: any = document.getElementById('map');
    const zoomDiv = document.getElementById('zoomDiv');
    mapContainer.appendChild(zoomDiv);
    this.map.removeControl(this.map.zoomControl);
    const zoomControl = new L.Control.Zoom({ position: 'bottomright' });
    zoomControl.addTo(this.map);
    this.map.whenReady(() => {
      this.calculateZoomLevel();
    });
    this.map.on('zoomend', this.HandleZoomEnd);
    this.changDetectionRef.detectChanges();
    this.map.getContainer().addEventListener('pointerup', () => {
    this.map.dragging.enable();
    });
    this.map.on('mousemove', (e: any) => {
    const lat = e.latlng.lat;
    const lng = ((e.latlng.lng + 180) % 360 + 360) % 360 - 180;
    });



  }

  HandleZoomEnd = () => {
    this.calculateZoomLevel();
  };

  calculateZoomLevel = () => {
    if (this.map) {
      this.zoomLevel = this.map.getZoom();
      const bounds = this.map.getBounds();
      const distance = bounds.getSouthWest().distanceTo(bounds.getNorthEast());
      this.mapDistance = distance / 1000;
    }
  };

  handleMouseMove = (e: any) => {
  const lat = e.latlng.lat;
  const lng = this.normalizeLng(e.latlng.lng); 
    this.latLngDMS = this.decimalToDMS(lat, lng);
  };

  private normalizeLng(lng: number): number {
  return ((lng + 180) % 360 + 360) % 360 - 180;
  }


  handleMouseRightclick = (e: any) => {
    this.isAnnotationSaved = false;
    let scene: any;
    let isInsideAnyFeature = false;
    var isInside = false;
    if (this.annotateClicked && !this.isCompare) {
      let latlng = e.latlng;
      this.annotatedLat = latlng.lat;
      this.annotatedLng = latlng.lng;
      var point = turf.point([latlng.lng, latlng.lat]);
      const isInsideAnyPolygon = this.scenesNew.some((scenesNew) => {
        var polyCoords;
        var polygonFeature;
        if (
          scenesNew?.scene?.operatorKey == this.OPERATOR.LBAND &&
          scenesNew?.scene?.metadata
        ) {
          const features = scenesNew.scene.metadata.features;
          for (const feature of features) {
            const polygonFeature = turf.multiPolygon(
              feature.geometry.coordinates
            );
            if (turf.booleanPointInPolygon(point, polygonFeature)) {
              isInsideAnyFeature = true;
              break;
            }
          }
        } else if (
          scenesNew?.tiffootprint?.toGeoJSON().geometry.coordinates[0].length >
          0
        ) {
          polyCoords = scenesNew?.tiffootprint.toGeoJSON().geometry.coordinates;
          polyCoords[0].push(
            scenesNew?.tiffootprint.toGeoJSON().geometry.coordinates[0][0]
          );
          polygonFeature = turf.polygon(polyCoords);
          isInside = turf.booleanPointInPolygon(point, polygonFeature);
        } else if (
          scenesNew?.footprint?.toGeoJSON().geometry.coordinates[0].length > 0
        ) {
          polyCoords = scenesNew?.footprint.toGeoJSON().geometry.coordinates;
          polyCoords[0].push(
            scenesNew?.footprint.toGeoJSON().geometry.coordinates[0][0]
          );
          polygonFeature = turf.polygon(polyCoords);
          isInside = turf.booleanPointInPolygon(point, polygonFeature);
        } else if (this.scenesNew[0].bboxs?.length > 0) {
          polyCoords =
            scenesNew?.bboxs[0].toGeoJSON()?.features[0].geometry.coordinates;
          polyCoords[0].push(
            scenesNew?.bboxs[0].toGeoJSON()?.features[0].geometry
              .coordinates[0][0]
          );
          polygonFeature = turf.polygon(polyCoords);
          isInside = turf.booleanPointInPolygon(point, polygonFeature);
        } else {
          var polyCoords =
            this.scenesNew[0]?.footprint.toGeoJSON().geometry.coordinates[0];
          polyCoords.push(
            scenesNew?.footprint.toGeoJSON().geometry.coordinates[0][0]
          );
          polygonFeature = turf.polygon([polyCoords]);
          isInside = turf.booleanPointInPolygon(point, polygonFeature);
        }
        if (isInside || isInsideAnyFeature) {
          scene = scenesNew;
          return true;
        }
        return false;
      });

      if (isInsideAnyPolygon) {
        var customIcon = L.icon({
          iconUrl: 'assets/images/notes.png',
          iconSize: [27, 27],
          iconAnchor: [13.5, 13.5],
          popupAnchor: [0, -13],
        });
        let sceneId = scene.id;
        let sensorId = scene.sensorId;
        const uniqueId = `annotation-text-${Date.now()}`;
        const savedContent = this.annotationContent[uniqueId] || '';
        var popupContent = `
          <div style="position: relative; width: 200px;">
            <textarea id="${uniqueId}" value="${uniqueId}" style="width: 100%; height: 90px;  resize: none; margin-top: 6px; margin-bottom: 3px;" onclick="this.setSelectionRange(0, 0);"
                onfocus="this.setSelectionRange(0, 0);">
            </textarea>
            <span style="position: absolute; bottom: 0px; cursor: pointer; color: rgb(182, 182, 186);">
              <i class="material-icons" style="font-size:18px; color: #000000b8" onclick="window.saveAnnotationContent('${uniqueId}', '${sceneId}', '${sensorId}')">save</i>
            </span>
            <div>Lng: ${latlng.lng.toFixed(4)}, Lat: ${latlng.lat.toFixed(
          4
        )}</div>
          </div>
        `;

        if (!this.isAnnotationSaved && this.annotaionMarker) {
          this.map.removeLayer(this.annotaionMarker);
          this.annotaionMarker = null;
        }
        this.annotaionMarker = L.marker(latlng, {
          icon: customIcon,
          pane: 'annotationMarkersPane',
          zIndexOffset: 1000,
        }).addTo(this.map);
        this.annotaionMarker.bindPopup(popupContent).openPopup();
        this.annotaionMarker.on('popupclose', () => {
          if (!this.isAnnotationSaved && this.annotaionMarker) {
            this.map.removeLayer(this.annotaionMarker);
            this.annotaionMarker = null;
          }
        });
      }
      (window as any).saveAnnotationContent =
        this.saveAnnotationContent.bind(this);
    } else if (this.newTaskButtonClicked) {
      var customIcon = L.icon({
        iconUrl: '../../../assets/map-icons/marker-icon.png',
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        shadowUrl: '../../../assets/map-icons/marker-shadow.png',
        shadowSize: [41, 41],
        shadowAnchor: [12, 41],
      });
      let latlng = e.latlng;
      this.collectionTaskMarker = L.marker(latlng, { icon: customIcon }).addTo(
        this.map
      );
      let message = '';
      const dialogRef = this.dialog.open(CreateTaskConfirmDialog, {
        backdropClass: 'blurr',
        disableClose: true,
        data: {
          message: message,
          longitude: ((latlng.lng + 180) % 360 + 360) % 360 - 180,
          latitude: latlng.lat,
          task: this.collection,
          user: this.currentUser,
        },
      });
      dialogRef.afterClosed().subscribe((result) => {
        this.map.removeLayer(this.collectionTaskMarker);
        this.collectionTaskMarker = null;
      });
    }
  };

  saveAnnotationContent(textAreaId: any, sceneId: any, sensorId: any) {
    this.annotationMarkers.push({
      marker: this.annotaionMarker,
      scene: sceneId,
    });
    const textAreaElement: any = document.querySelector(`#${textAreaId}`);
    this.annotationContent = textAreaElement.value;
    if (this.annotationContent) {
      this.isAnnotationSaved = true;
      const annotation = {
        customerid: '',
        taskid: this.collection.taskId,
        sensorid: sensorId,
        sceneid: sceneId,
        property: this.annotationContent,
        lat: this.annotatedLat,
        lng: this.annotatedLng,
      };
      this.apiService.addAnnotation(annotation).subscribe((res: any) => {
        if (res?.msg === 'Success') {
          this.map.closePopup();
          this.getAnnotations();
        }
      });
      this.map.closePopup();
    } else {
      this.isAnnotationSaved = false;
    }
  }

  decimalToDMS(lat: number, lng: number): string {
    const convert = (decimal: number) => {
      const absolute = Math.abs(decimal);
      const degrees = Math.floor(absolute);
      const minutesNotTruncated = (absolute - degrees) * 60;
      const minutes = Math.floor(minutesNotTruncated);
      const seconds = Math.floor((minutesNotTruncated - minutes) * 60);
      return `${degrees}° ${minutes}' ${seconds}"`;
    };
    const latitude = convert(lat) + (lat >= 0 ? ' N' : ' S');
    const longitude = convert(lng) + (lng >= 0 ? ' E' : ' W');
    return `Lng:${longitude}, Lat:${latitude}`;
  }

  removeHighlight() {
    let homeBtn: any = document.querySelector('#homeButton');
    if (homeBtn) {
      homeBtn.classList.remove('highlight-border');
    }
    let layerBtn: any = document.querySelector(
      '.leaflet-control-layers-toggle'
    );
    if (layerBtn) {
      layerBtn.classList.remove('highlight-border');
    }
  }

  viewHome(event: any) {
    this.removeHighlight();
    let layerList: any = document.querySelector(
      '.leaflet-control-layers-expanded'
    );
    if (layerList) {
      layerList.classList.remove('leaflet-control-layers-expanded');
    }
    document
      .querySelector('.leaflet-control-layers-toggle')
      ?.setAttribute('style', 'top:0px !important');
    let homeBtn: any = document.querySelector('#homeButton');
    homeBtn.classList.add('highlight-border');
    if (this.scenesNew.length > 0) {
      if (this.scenesNew[0]?.scene.operatorKey == 'USL') {
        if (this.scenesNew[0]?.scene?.uslFootprint) {
          const geojsonLayer = L.geoJSON(this.scenesNew[0].scene?.uslFootprint);
          this.map.fitBounds(geojsonLayer.getBounds());
        } else {
          const geojsonLayer = L.geoJSON(
            this.scenesNew[0].scene?.usl_footprint
          );
          this.map.fitBounds(geojsonLayer.getBounds());
        }
      } else if (this.scenesNew[0]?.scene.operatorKey == this.OPERATOR.LBAND) {
        this.map.fitBounds(this.scenesNew[0].signalLayers[0].getBounds());
      } else {
        let footprintcordinates = JSON.parse(
          JSON.stringify(
            this.scenesNew[0].scene.footprint.coordinates[0].map((sub) => {
              return [sub[1], sub[0]];
            })
          )
        );
        footprintcordinates.push(footprintcordinates[0]);
        const polygon: any = L.polygon(footprintcordinates).getBounds();
        if (
          this.scenesNew.filter((scnNew) => scnNew.scene?.imageType == 'tif')
            .length > 0
        ) {
          this.map.setMinZoom(DEFAULT_ZOOMLEVEL);
          this.map.fitBounds(
            this.scenesNew
              .filter((scnNew) => scnNew.scene?.imageType == 'tif')[0]
              .tiffootprint.getBounds(),
            {
              maxZoom: DEFAULT_ZOOMLEVEL,
            }
          );
          this.map.setMaxZoom(Number(this.calculateZoomFromResolution()));
        } else {
          this.map.fitBounds(polygon);
        }
      }
    } else {
      if (this.clydevesselfootprintlayer || this.spirevesselfootprintlayer) {
        let layer =
          this.clydevesselfootprintlayer || this.spirevesselfootprintlayer;
        this.map.fitBounds(layer.getBounds());
      } else {
        const castUser = this.authService.castCurrentUser.subscribe(
          async (res: any) => {
            this.loadUserDetails(res?.id, true);
          }
        );
      }
    }
    event.stopPropagation();
  }

  async getFile(url: string) {
    const httpOptions = { responseType: 'blob' as 'json' };
    const res = await this.httpClient
      .get(url, httpOptions)
      .toPromise()
      .catch((err: HttpErrorResponse) => {
        const error = err.error;
        return error;
      });
    return res;
  }

  async downloadAndZip(url: string): Promise<JSZip> {
    const response = await fetch(url);
    const data = await response.blob();
    const fileName: any = url.split('/').pop();
    const zip = new JSZip();
    zip.file(fileName, data);
    return zip;
  }

  async createZip(zipArray: JSZip[], zipName: string): Promise<void> {
    const zip = new JSZip();
    zipArray.forEach((z) => {
      const files = z.files;
      for (const fileName in files) {
        if (Object.prototype.hasOwnProperty.call(files, fileName)) {
          zip.file(fileName, files[fileName].async('blob'));
        }
      }
    });
    const content = await zip.generateAsync({ type: 'blob' });
    saveAs(content, `${zipName}.zip`);
  }

  createNewTask() {
    this.newTaskButtonClicked = !this.newTaskButtonClicked;
  }

  getAnnotations() {
    let requests: any[] = [];
    for (let scene of this.scenesNew) {
      const request = this.apiService.getAnnotations(
        this.collection.taskId,
        scene.sensorId,
        scene.id
      );
      requests.push(request);
    }

    forkJoin(requests).subscribe((results) => {
      this.removeAnnotationMarkers();
      this.displayAnnotationNew(results);
    });
  }

  annotateImageNew() {
    this.annotateClicked = !this.annotateClicked;
    if (this.annotateClicked) {
      this.getAnnotations();
    } else {
      this.removeAnnotationMarkers();
    }
  }

  displayAnnotationNew(annotations: any[]) {
    annotations.map((annotation) => {
      annotation.data?.features.forEach((feature) => {
        var customIcon = L.icon({
          iconUrl: 'assets/images/notes.png',
          iconSize: [27, 27],
          iconAnchor: [13.5, 13.5],
          popupAnchor: [0, -13],
        });
        let scene: any = this.scenesNew.filter(
          (sceneNew) => sceneNew.id == annotation.data.sceneid
        )[0];
        let sceneId = annotation.data.sceneid;
        let sensorId = annotation.data.sensorid;
        let text = feature.property;
        let featureId = feature._id;
        const uniqueId = `annotation-text-${Date.now()}`;
        var popupContent;

        if (this.isCompare) {
          popupContent = `
          <div style="position: relative; width: 200px;">
              <textarea id="${uniqueId}" style="width: 100%; height: 90px;  resize: none; margin-top: 6px; margin-bottom: 3px;" disabled>${text}</textarea>
              <div>Lng: ${feature.coordinates.longitude.toFixed(
                4
              )}, Lat: ${feature.coordinates.latitude.toFixed(4)}</div>
          </div>
        `;
        } else {
          popupContent = `
          <div style="position: relative; width: 200px;">
              <textarea id="${uniqueId}" style="width: 100%; height: 90px;  resize: none; margin-top: 6px; margin-bottom: 3px;" disabled>${text}</textarea>
              <span id="saveIcon" style="position: absolute; bottom: 0px; cursor: pointer; color: rgb(182, 182, 186); right: 10px;">
                <i class="material-icons" id="edit-save-button" style="font-size:18px;color: #000000b8" onclick="window.editAnnotationContent('${uniqueId}', '${sceneId}', '${sensorId}', '${featureId}')">edit</i>
              </span>
              <span style="position: absolute; bottom: 0px; cursor: pointer; color: rgb(182, 182, 186);" id="deleteIcon">
                <i class="material-icons" id="edit-save-button" style="font-size:18px;color: #000000b8" onclick="window.deleteAnnotationContent('${uniqueId}', '${sceneId}', '${sensorId}', '${featureId}')">delete</i>
              </span>
              
              <div>Lng: ${feature.coordinates.longitude.toFixed(
                4
              )}, Lat: ${feature.coordinates.latitude.toFixed(4)}5</div>
          </div>
        `;
        }

        (window as any).editAnnotationContent =
          this.editAnnotationContent.bind(this);
        (window as any).deleteAnnotationContent =
          this.deleteAnnotationContent.bind(this);

        const popupOffset: any = [0, 20];
        let annotaionMarker = L.marker(
          [feature.coordinates.latitude, feature.coordinates.longitude],
          {
            icon: customIcon,
            pane: 'annotationMarkersPane',
            zIndexOffset: 1000,
          }
        )
          .bindPopup(popupContent, { offset: popupOffset })
          .addTo(this.map);

        this.annotationMarkers.push({
          marker: annotaionMarker,
          scene: sceneId,
        });
      });
    });
  }

  editAnnotationContent(textAreaId, sceneId, sensorId, featureId) {
    const textarea = document.getElementById(textAreaId) as HTMLTextAreaElement;
    const buttonIcon = document.getElementById(
      'edit-save-button'
    ) as HTMLElement;
    this.isTextareaDisabled = true;
    this.isTextareaDisabled = !this.isTextareaDisabled;
    if (buttonIcon.textContent != 'save') {
      textarea.disabled = false;
      buttonIcon.textContent = 'save';
      const textAreaElement: any = document.querySelector(`#${textAreaId}`);
      this.annotationContent = textAreaElement.value;
      document
        .getElementById('deleteIcon')
        ?.setAttribute('style', 'display: none !important');
      const saveIcon = document.getElementById('saveIcon');
      if (saveIcon) {
        saveIcon.style.right = 'auto';
      }
      textarea.addEventListener('focus', () => {
        const len = textarea.value.length - 12;
        textarea.setSelectionRange(len, len);
      });

      textarea.addEventListener('click', () => {
        const len = textarea.value.length - 12;
        textarea.setSelectionRange(len, len);
      });
    } else {
      const textAreaElement: any = document.querySelector(`#${textAreaId}`);
      this.annotationContent = textAreaElement.value;
      let updateObj = {
        customerid: '',
        taskid: this.collection.taskId,
        sensorid: sensorId,
        sceneid: sceneId,
        featureid: featureId,
        property: this.annotationContent,
      };
      this.apiService.editAnnotations(updateObj).subscribe((res: any) => {
        if (res?.msg === 'Success') {
          this.map.closePopup();
          this.getAnnotations();
        }
      });
      this.isTextareaDisabled = true;
    }
  }

  deleteAnnotationContent(textAreaId, sceneId, sensorId, featureId) {
    let deleteObj = {
      customerid: '',
      taskid: this.collection.taskId,
      sensorid: sensorId,
      sceneid: sceneId,
      featureid: featureId,
    };
    this.apiService.deleteAnnotations(deleteObj).subscribe((res: any) => {
      if (res?.msg === 'Success') {
        this.map.closePopup();
        this.getAnnotations();
      }
    });
  }

  getVesselsGeojson(geoJSONdata, customIcon, isHistorical, sensor, type) {
    return L.geoJSON(geoJSONdata, {
      pointToLayer: (feature, latlng) => {
        if (type === 'SPIRE') {
          const icon = this.makeNavIconFromFeature(feature);
          return L.marker(latlng, {
            icon,
            zIndexOffset: 100000,
            riseOnHover: true,
            opacity: 1,
          });
        }
        return L.marker(latlng, { icon: customIcon });
      },
      onEachFeature: (ftr, lyr) => {
        const iconOpts = (lyr as any)?.options?.icon?.options;
        const iconW = iconOpts?.iconSize?.[0] ?? 24;
        const offsetX = Math.round(iconW / 2 + 6);
        this.attachTooltip(
          lyr,
          `<span style="text-transform: capitalize;">
            ${this.formatProperties(ftr.properties)}
        </span>`
        );
        {
          sensor?.noOfHistoricalData != '' &&
            lyr.on('click', () => {
              this.clickedMarker = lyr;
              if (this.clickedMarker) this.clickedMarker.closeTooltip();
              this.handleLayerClick(
                ftr,
                isHistorical,
                sensor,
                this.clickedMarker
              );
            });
        }

        if (type === 'CLYDE') {
          this.clydeHistoricalLayer.push({
            marker: lyr,
            type: type,
          });
        } else {
          this.spireHistoricalLayer.push({
            marker: lyr,
            type: type,
          });
        }
      },
    }).addTo(this.map);
  }

  private makeNavIconFromFeature(ftr: any, history?: any): L.Icon {
    const baseSize = 50;
    const histSize = 24;
    const size = history === 'historySpire' ? histSize : baseSize;
    const shipType = ftr?.properties?.['Ship Type'] ?? 'OTHER';
    const course = Number(ftr?.properties?.['Course']) || 0;
    const color =
      history === 'historySpire'
        ? '#99BF00'
        : this.utilsService.getShipColor(shipType);

    const canvas = this.createNavigationIconSpire(color, course, history);
    return L.icon({
      iconUrl: canvas.toDataURL(),
      iconSize: [size, size],
      iconAnchor: [25, 25], // center
      popupAnchor: [0, -25],
    });
  }

  displayClydeAISNew(scene: any, data: any, sensor: any, type: any, res?: any) {
    let sensorId = sensor.id;
    let ischangerefreshes = data?.ischangerefreshes === true;
    if (type == 'SPIRE' && ischangerefreshes == false) {
      this.collection.sensors.map((sensor) => {
        if (sensor.operatorKey === OPERATORS.SPIRE) {
          if (sensor.updatedRefreshes) sensor.updatedRefreshes -= 1;
          else sensor.updatedRefreshes = sensor.noOfRefreshes - 1;
        }
      });
    }
    let footprintcordinates: any[] = [];
    let isHistorical = sensor?.isHistorical;
    footprintcordinates = scene?.footprint?.coordinates[0].map((sub) => {
      return [sub[1], sub[0]];
    });

    if (type == 'CLYDE' && !this.clydevesselfootprintlayer) {
      this.clydevesselfootprintlayer = L.polygon(footprintcordinates, {
        color: 'yellow',
        fillColor: 'none',
        pane: 'left',
      }).addTo(this.map);
    } else if (type == 'SPIRE' && !this.spirevesselfootprintlayer) {
      this.spirevesselfootprintlayer = L.polygon(footprintcordinates, {
        color: 'yellow',
        fillColor: 'none',
        pane: 'left',
      }).addTo(this.map);
    }
    let geoJSONdata: any = this.convertToGeoJSONNew(data, type);
    if (this.isObservation(sensor)) {
      this.observationChecked = true;
      this.selectedHistory[res.newRefreshHistory.refreshId] = geoJSONdata;
    }

    if (res) {
      const sensorIndex = this.collection.sensors.findIndex(
        (sensor) => sensor.id === sensorId
      );
      if (sensorIndex !== -1) {
        if (!sensor.refreshHistory) {
          sensor.refreshHistory = []; // Initialize if not present
        }
        sensor.refreshHistory.push(res?.newRefreshHistory);
      }
    }

    this.spireJsonData = JSON.parse(JSON.stringify(geoJSONdata));
    this.displayedSpireData = geoJSONdata;
    this.spireSensorId = sensor?.id;
    var customIcon = L.icon({
      iconUrl:
        type == 'SPIRE'
          ? 'assets/images/yellow-cross.png'
          : 'assets/images/orange-cross.png',
      iconSize: [23, 23],
      iconAnchor: [16, 23],
      popupAnchor: [0, -32],
    });

    if (type == 'CLYDE') {
      this.clydeVesselLayer = this.getVesselsGeojson(
        geoJSONdata,
        customIcon,
        isHistorical,
        sensor,
        type
      );
    } else {
      this.spireVesselLayer = this.getVesselsGeojson(
        geoJSONdata,
        null,
        isHistorical,
        sensor,
        type
      );
    }

    if (this.clydevesselfootprintlayer) {
      this.map.fitBounds(this.clydevesselfootprintlayer.getBounds());
    } else {
      this.map.fitBounds(this.spirevesselfootprintlayer.getBounds());
    }
    let index = this.scenesNew.findIndex(
      (scenesNew) => scenesNew.id == scene.id
    );
    if (index == -1) {
      this.scenesNew.push({
        footprint:
          type == 'CLYDE'
            ? this.clydevesselfootprintlayer
            : this.spirevesselfootprintlayer,
        id: scene.id,
        scene: scene,
        sensorId: sensor?.id,
        pane: this.mapPane,
      });
    }
  }

  groupVesselsByDateRange(dateRangeArray: string[]) {
    this.vesselData = {};
    this.sliderShow = true;
    for (let i = 0; i < dateRangeArray.length - 1; i++) {
      const startDate = new Date(dateRangeArray[i]);
      const endDate = new Date(dateRangeArray[i + 1]);
      this.vesselData[dateRangeArray[i]] = this.historicalVesselData.filter(
        (data) => {
          const dataDate = new Date(data.timestamp);
          return dataDate >= startDate && dataDate < endDate;
        }
      );
    }
    const lastDate = new Date(dateRangeArray[dateRangeArray.length - 1]);
    this.vesselData[dateRangeArray[dateRangeArray.length - 1]] =
      this.historicalVesselData.filter((data) => {
        const dataDate = new Date(data.timestamp);
        return dataDate >= lastDate;
      });

    this.dateRangeArray = dateRangeArray.reverse();
  }

  handleLayerClick(
    entity: any,
    isHistorical: any,
    sensor: any,
    clickedMarker: any
  ) {
    let historicalFetchCount: any;
    let type;
    if (sensor?.operatorKey === OPERATORS.SPIRE) {
      historicalFetchCount =
        sensor?.updatedFetches == 0
          ? 0
          : sensor?.updatedFetches || sensor?.noOfHistoricalData;
      type = 'ais';
    } else {
      historicalFetchCount = sensor?.noOfHistoricalData;
      type = 'clyde';
    }
    if (historicalFetchCount > 0) {
      const dialogRef = this.matdialog.open(FilterPopupComponent, {
        width: '35%',
        backdropClass: 'blurr',
        disableClose: true,
        data: {
          type: type,
          historicalDays: historicalFetchCount,
          isVessel: this.isVesselInfoService(sensor.InfoServices),
        },
      });

      dialogRef.afterClosed().subscribe((result) => {
        if (this.clickedMarker) this.clickedMarker.closeTooltip();
        this.mapLoad = true;
        let timestamp = entity.properties['Timestamp UTC'];
        let mmsi = entity.properties['MMSI'];
        let courseValue = entity.properties['Course'];
        let compassDirection =
          this.utilsService.getCompassDirection(courseValue);
        const shipType = entity.properties['Ship Type'] || 'OTHER';
        const iconColor = this.utilsService.getShipColor(shipType);
        this.shipColor = iconColor;
        let vesselName = entity?.properties.Name;
        let taskId = this.collection?.taskId;
        this.predictedVesselData = {
          color: iconColor,
          lng: entity.properties.Lng,
          lat: entity.properties.Lat,
          timestamp: timestamp,
        };
        this.prediction = result?.type === STRINGCONSTANTS.PREDICTION;

        if (result) {
          if (sensor?.operatorKey === OPERATORS.CLYDE) {
            this.spinnerService.show();
            let endDate: any = new Date(timestamp);
            let startDate: any;
            if (result?.type === 'minutes') {
              const millisecondsBack = result?.duration * 60 * 1000;
              const newDateObj = new Date(endDate - millisecondsBack);
              startDate = newDateObj.toISOString();
            } else {
              const previousDate = endDate;
              previousDate.setDate(endDate.getDate() - (result?.duration - 1));
              startDate = previousDate.toDateString();
            }
            this.clydeHistoricalLayer.forEach((innerLayer: any) => {
              if (innerLayer.marker !== clickedMarker) {
                innerLayer.marker.setOpacity(0);
              }
            });
            let vesselObject = {
              mmsi: mmsi,
              endTime: timestamp,
              inputMinutes: result?.duration,
              eeTaskId: taskId,
              startTime: startDate,
              polygon: this.vesselPolygon,
              startTimeType: result?.type,
              duration: result?.duration,
            };
            const sliderStart = new Date(timestamp);
            const sliderEnd = new Date(startDate);
            const differenceInMilliseconds =
              sliderStart.getTime() - sliderEnd.getTime();
            const differenceInDays =
              differenceInMilliseconds / (1000 * 60 * 60 * 24);
            if (this.clickedMarker) this.clickedMarker.closeTooltip();
            this.apiService
              .getClydeHistoricalData(vesselObject)
              .subscribe((response: any) => {
                this.spinnerService.hide();
                this.mapLoad = false;
                if (response?.data?.length > 0) {
                  if (this.clickedAIS) {
                    this.resetSelectedVessels(false);
                  }
                  this.clickedAIS = sensor;
                  this.sliderView = false;
                  this.currentHistoryIndex = 0;
                  this.previousIndex = -1;
                  if (!this.timeseries) {
                    this.resetTimeSeries();
                  } else {
                    this.sliderDateRangeArray = [];
                  }
                  this.isClydeHistorical = true;
                  this.historicalVesselData = response?.data;
                  let dateRangeArray = this.generateSliderDateRange(
                    timestamp,
                    startDate
                  );
                  if (differenceInDays <= 10)
                    this.groupVesselsByDate(dateRangeArray, compassDirection);
                  else this.groupVesselsByDateRange(dateRangeArray);
                  this.sliderView = true;
                  this.clydeHistoricalLayer.forEach((innerLayer: any) => {
                    if (innerLayer.marker !== clickedMarker) {
                      this.map.removeLayer(innerLayer.marker);
                    }
                  });
                } else {
                  const message = `There are no vessels in the duration requested. Please change the historical period to try again.`;
                  this.popupService.openPopup(
                    CollectionPopupComponent,
                    message,
                    '',
                    '40%'
                  );
                  this.clydeHistoricalLayer.forEach((innerLayer: any) => {
                    if (innerLayer.marker !== clickedMarker) {
                      innerLayer.marker.setOpacity(1);
                    }
                  });
                  this.resetSelectedVessels(true);
                }
              });
          } else if (result.type === 'history') {
            this.spinnerService.show();
            this.spireHistoricalLayer.forEach((innerLayer: any) => {
              if (innerLayer.marker !== clickedMarker) {
                innerLayer.marker.setOpacity(0);
              }
            });
            let endDate: any = new Date(timestamp);
            let startDate: any;
            const millisecondsBack = result?.duration * 60 * 1000;
            const newDateObj = new Date(endDate - millisecondsBack);
            startDate = newDateObj.toISOString();
            let vesselObject = {
              mmsi: mmsi,
              endTime: timestamp,
              inputMinutes: result?.duration,
              eeTaskId: this.collection.taskId,
              compassDirection: compassDirection,
              fetchType: result.type,
            };
            const sliderStart = new Date(timestamp);
            const sliderEnd = new Date(startDate);
            const differenceInMilliseconds =
              sliderStart.getTime() - sliderEnd.getTime();
            const differenceInDays =
              differenceInMilliseconds / (1000 * 60 * 60 * 24);
            this.apiService
              .getHistoricalData(vesselObject)
              .subscribe((response: any) => {
                this.spinnerService.hide();
                this.mapLoad = false;
                if (response?.data?.length > 0) {
                  if (this.clickedAIS) {
                    this.resetSelectedVessels(false, true, true);
                  }
                  this.clickedAIS = sensor;
                  this.sliderView = false;
                  this.currentHistoryIndex = 0;
                  this.previousIndex = -1;
                  if (!this.timeseries) {
                    this.resetTimeSeries();
                  } else {
                    this.sliderDateRangeArray = [];
                  }
                  this.isClydeHistorical = true;
                  this.collection.sensors.map((sensor) => {
                    if (sensor.operatorKey === OPERATORS.SPIRE) {
                      if (sensor.updatedFetches) sensor.updatedFetches -= 1;
                      else
                        sensor.updatedFetches = sensor.noOfHistoricalData - 1;
                    }
                  });
                  this.sliderView = true;
                  this.historicalVesselData = response?.data;
                  let dateRangeArray = this.generateSliderDateRange(
                    timestamp,
                    startDate
                  );
                  this.groupVesselsByDate(dateRangeArray, compassDirection);
                  this.sliderView = true;
                  this.spireHistoricalLayer.forEach((innerLayer: any) => {
                    if (innerLayer.marker !== clickedMarker) {
                      this.map.removeLayer(innerLayer.marker);
                    }
                  });
                } else {
                  const message = `There are no vessels in the duration requested. Please change the historical period to try again.`;
                  this.popupService.openPopup(
                    CollectionPopupComponent,
                    message,
                    '',
                    '40%'
                  );
                  this.spireHistoricalLayer.forEach((innerLayer: any) => {
                    if (innerLayer.marker !== clickedMarker) {
                      innerLayer.marker.setOpacity(1);
                    }
                  });
                  this.resetSelectedVessels(true, false);
                }
              });
          } else if (result.type === STRINGCONSTANTS.PREDICTION) {
            let vesselId = entity.properties.ID;
            const selectedVesselJson = this.spireData?.vessels?.nodes.find(
              (item) => item.id === vesselId
            );
            this.progressing = true;
            if (this.clickedMarker) this.clickedMarker.closeTooltip();
            this.spireHistoricalLayer.forEach((innerLayer: any) => {
              if (innerLayer.marker !== clickedMarker) {
                innerLayer.marker.setOpacity(0);
              }
            });

            let predictedObject = {
              fetchType: result.type,
              feedId: sensor.InfoServices[0]._id,
              sensorId: sensor.InfoServices[0].sensorId,
              timestamp: timestamp,
              mmsi: mmsi,
              eeTaskId: taskId,
              endTime: timestamp,
              vesselName: vesselName,
              selectedVesselJson: selectedVesselJson,
            };
            const abort$ = this.opManager.startOperation();
            this.predictionSubscription = this.apiService
              .getPredictionData(predictedObject)
              .pipe(takeUntil(abort$))
              .subscribe((response: any) => {
                this.prediction = true;
                if (this.clickedMarker) this.clickedMarker.closeTooltip();
                if (response.msg === 'success') {
                  if (response?.data?.vessel_predict?.length > 0) {
                    //Remove last known vessel location from vessel_predict array
                    response.data.vessel_predict =
                      response?.data?.vessel_predict?.slice(1);
                    this.clickedAIS = sensor;
                    this.sliderView = false;
                    this.currentHistoryIndex = 0;
                    this.previousIndex = -1;
                    if (!this.timeseries) {
                      this.resetTimeSeries();
                    } else {
                      this.sliderDateRangeArray = [];
                    }
                    this.collection.sensors.map((sensor) => {
                      if (sensor.operatorKey === OPERATORS.SPIRE) {
                        if (sensor.updatedFetches) sensor.updatedFetches -= 1;
                        else
                          sensor.updatedFetches = sensor.noOfHistoricalData - 1;
                      }
                    });
                    this.historicalVesselData = response?.data?.vessel_predict;
                    if(Object.keys(response?.data?.feed_results || {})?.length > 0){
                    const formattedPrediction = {
                    locations: this.historicalVesselData.length + 2,
                    location_time: response?.data?.feed_results.location_after_one_hour.location_time,
                    location: {
                    LAT: response?.data?.feed_results?.location_after_one_hour?.location?.LAT,
                    LON: response?.data?.feed_results?.location_after_one_hour?.location?.LON
                     }
                    };
                    this.historicalVesselData.push(formattedPrediction);
                     }
                    const startTime =
                      this.historicalVesselData[0].location_time;
                    const endTime =
                      this.historicalVesselData[
                        this.historicalVesselData.length - 1
                      ].location_time;
                    let dateRangeArray = this.generateSliderDateRangePredict(
                      endTime,
                      startTime
                    );
                    this.groupVesselsByDatePredict(dateRangeArray);
                    this.sliderView = true;
                    this.progressing = false;
                    this.sliderView = false;
                    const feedId = String(sensor.InfoServices[0]?._id);
                    const config = feedsConfig[feedId];
                    const color = 'Yellowgreen';
                    const vm = this.helperService.buildFeedSections(config, response?.data?.feed_results, color);
                    const title = this.feedTitleOf(config, sensor.InfoServices[0]?.feedName || sensor.InfoServices[0]?.name);
                    this.addFeedPanel(sensor.InfoServices[0]?._id, title, color, vm.sections);
                    this.spinnerService.hide();
                    this.opManager.completeOperation();
                  } else {
                    const message = `There are no vessel location(s) predicted because of a lack of sufficient historical data.`;
                    this.popupService.openPopup(
                      CollectionPopupComponent,
                      message,
                      '',
                      '40%'
                    );
                    this.spinnerService.hide();
                    this.progressing = false;
                    this.resetSelectedVessels(false, false);
                    this.clearAllPredictionData();
                    this.opManager.completeOperation();
                    this.spireHistoricalLayer.forEach((innerLayer: any) => {
                      innerLayer.marker.setOpacity(1);
                    });
                  }
                } else {
                  if (response?.msg) {
                    const message = response?.msg;
                    this.popupService.openPopup(
                      CollectionPopupComponent,
                      message,
                      '',
                      '40%'
                    );
                    this.spinnerService.hide();
                    this.progressing = false;
                    this.resetSelectedVessels(true, false);
                    this.clearAllPredictionData();
                    this.spireHistoricalLayer.forEach((innerLayer: any) => {
                      if (innerLayer.marker !== clickedMarker) {
                        innerLayer.marker.setOpacity(1);
                      }
                    });
                  } else {
                    const message = `An error occurred during processing and ingestion of the request. Please try after sometime.`;
                    this.popupService.openPopup(
                      CollectionPopupComponent,
                      message,
                      '',
                      '40%'
                    );
                    this.spinnerService.hide();
                    this.progressing = false;
                    this.resetSelectedVessels(true, false);
                    this.clearAllPredictionData();
                    this.spireHistoricalLayer.forEach((innerLayer: any) => {
                      if (innerLayer.marker !== clickedMarker) {
                        innerLayer.marker.setOpacity(1);
                      }
                    });
                  }
                  this.opManager.completeOperation();
                }
              });
          }
        }
      });
    } else if (sensor.operatorKey === OPERATORS.SPIRE) {
      const message = `Your historical fetches for this task has been exhausted. Please retask.`;
      this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
    }
    this.progressing = false;
  }

  downloadPastPredicitionList(
    predictedId: any,
    date: any,
    type: any,
    sensor: any,
    scene: any
  ) {
    const sensorId = sensor.id;
    const taskId = this.collection?.taskId;

    const predictData = {
      sensorId,
      predictionId: predictedId,
      taskid: taskId,
      action: type,
    };

    this.freeze = true;
    this.spinnerService.show();

    this.apiService
      .getPastPredictedData(predictData)
      .pipe(
        takeUntil(this.destroy$),
        switchMap((res: any) => {
          if (res?.msg === 'failed') {
            this.popupService.openPopup(
              CollectionPopupComponent,
              'An error occurred during processing and ingestion of the request. Please try after sometime.',
              '',
              '40%'
            );

            this.mapLoad = false;
            this.freeze = false;

            return EMPTY;
          }

          // If success → download JSON from URL
          return this.httpClient
            .get(res?.result?.imageUrl)
            .pipe(map((data) => ({ data, res })));
        }),

        tap(({ data, res }) => {
          const parsed = data;

          // Update progress UI
          const sensorObj = {
            progress: 100,
            taskId,
            sensorId,
            sceneId: sensor.scenes[0].id,
            download: true,
            action: 'aisDownload',
          };
          this.downloadService.setProgress(sensorObj);

          // Download JSON
          const blob = new Blob([JSON.stringify(parsed)], {
            type: 'application/json',
          });
          const url = window.URL.createObjectURL(blob);

          const fileName = res.result.imageUrl.split('/').pop().split('?')[0];

          const link = document.createElement('a');
          link.href = url;
          link.download = fileName;
          link.click();

          window.URL.revokeObjectURL(url);
        }),

        finalize(() => {
          this.spinnerService.hide();
          this.freeze = false;
          this.disable = false;
        })
      )
      .subscribe();
  }

  displayPastPredicitionList(predictedId, date, type, sensor, scene) {
    this.resetAllFeedPanels();
    this.clearAllPredictionData();
    this.clearFilteredLayerAndRestore(true);
    this.sliderShow = false;
    if (this.clickedMarker) this.map.removeLayer(this.clickedMarker);
    this.predictedVesselData = null;
    this.progressing = false;
    this.prediction = false;
    this.spinnerService.show();
    this.mapLoad = true;
    this.previousIndex = -1;
    this.predictionLastPoint = null;
    if (this.selectedPredictionId === predictedId) {
      this.selectedPredictionId = null;
      this.spinnerService.hide();
      this.mapLoad = false;
      this.freeze = false;
      this.map.setView([15.0, 68.0], 5);
      return;
    }

    this.selectedPredictionId = predictedId;
    let sensorId = sensor.id;
    let taskId = this.collection?.taskId;
    const predictData = {
      sensorId: sensorId,
      predictionId: predictedId,
      taskid: taskId,
      action: type,
    };
    this.apiService
      .getPastPredictedData(predictData)
      .pipe(
        takeUntil(this.destroy$),
        switchMap((res: any) => {
          if (res?.msg === 'failed') {
            const message =
              'An error occurred during processing and ingestion of the request. Please try after sometime.';
            this.popupService.openPopup(
              CollectionPopupComponent,
              message,
              '',
              '40%'
            );
            this.spinnerService.hide();
            this.mapLoad = false;
            this.freeze = false;
            return EMPTY;
          }
          const imageUrl = res?.result?.imageUrl;
          if (!imageUrl) return EMPTY;
          return this.httpClient.get<any>(imageUrl);
        })
      )
      .subscribe((data) => {
        this.map.setView([0, 80], 4);
        this.mapLoad = false;
        this.freeze = false;
        this.sliderView = true;

        const parsedData = JSON.parse(data);
        this.pastpreditedVesselData = parsedData.vessel_predict[0];

        const result = parsedData?.vessel_predict;

        //Fiest element is last known location, so we skip it
        if (type === 'display' && result?.length > 1) {
          const startTime = result[0].location_time;
          const endTime = result[result.length - 1].location_time;

          let dateRangeArray = this.generateSliderDateRangePredict(
            endTime,
            startTime
          );
          this.groupVesselsByDatePredict(dateRangeArray, result);
          this.pastPrediction = true;
        }
      });
  }

  getGroupedVessels(sensor, taskId) {
    let getVessels =
      this.taskid === taskId &&
      sensor.pastPrediction &&
      Object.keys(sensor.pastPrediction).length > 0 &&
      this.isVesselInfoService(sensor.InfoServices);
    if (getVessels) {
      this.groupedVessels = sensor.pastPrediction;
      return true;
    } else {
      this.groupedVessels = {};
      return false;
    }
  }
  isFeedBased(InfoService) {
    if (InfoService?.ais_observation || InfoService?.rf_observation) {
      return false;
    }
    return true;
  }
  isVesselInfoService(infoService: any[]): boolean {
    if (infoService?.length > 0 && infoService[0]?._id) {
      const config = feedsConfig[infoService[0]._id];
      if (config && config.type === VESSEL_PREDICTION) {
        return true;
      }
    }
    return false;
  }

  generateSliderDateRangePredict(end: string, start: string) {
    this.dateRangeArray = [];
    const startDate = new Date(start);
    const endDate = new Date(end);
    const diffMs = endDate.getTime() - startDate.getTime();
    const diffMins = diffMs / (1000 * 60);
    const diffHours = diffMs / (1000 * 60 * 60);
    const diffDays = diffMs / (1000 * 60 * 60 * 24);

    const dateArray: string[] = [];
    const sameDay =
      startDate.toISOString().split('T')[0] ===
      endDate.toISOString().split('T')[0];

  if (sameDay) {
  const step = 2 * 60 * 1000;
  let count = 0;
  let time = startDate.getTime();
    while (time <= endDate.getTime() && count < 5) {
    const dt = new Date(time);
        const hh = String(dt.getUTCHours()).padStart(2, '0');
    const mm = String(dt.getUTCMinutes()).padStart(2, '0');

    dateArray.push(`${hh}:${mm}`);
    time += step;
    count++;
   }

  const endDt = new Date(endDate.getTime());
  const endHh = String(endDt.getUTCHours()).padStart(2, '0');
  const endMm = String(endDt.getUTCMinutes()).padStart(2, '0');

  dateArray.push(`${endHh}:${endMm}`);
  }
    return dateArray;
  }

  groupVesselsByDatePredict(dateRangeArray, data: any = false) {
    this.vesselData = {};
    this.dateRangeArray = dateRangeArray;
    this.sliderShow = true;

    const isTimeOnly = this.dateRangeArray.every(
      (d) => d.length === 5 && d.includes(':')
    );
    const isDateOnly = this.dateRangeArray.every(
      (d) => d.length === 10 && d.includes('-')
    );
    let predictData: any = '';
    if (data) {
      predictData = data;
    } else {
      predictData = this.historicalVesselData;
    }
    for (const range of this.dateRangeArray) {
      this.vesselData[range] = predictData.filter((data) => {
        const timestamp = new Date(data.location_time);
        const isoDate = timestamp.toISOString().split('T')[0];
        const isoHour = timestamp.toISOString().split('T')[1].substring(0, 5); // "HH:MM"

        if (isTimeOnly) {
          return isoHour === range;
        } else if (isDateOnly) {
          return isoDate === range;
        } else {
          return timestamp.toISOString().startsWith(range);
        }
      });
    }
  }

  convertToGeoJSONNew(vesselsData: any, type: string) {
    let AISdata: any[];
    if (type === 'overlay' || type === 'CLYDE') {
      AISdata = vesselsData;
    } else {
      AISdata = vesselsData?.vessels ? vesselsData?.vessels.nodes : vesselsData;
    }
    const dataMappers = {
      CLYDE: (vessel) => ({
        type: 'Feature',
        id: vessel.id,
        geometry: {
          type: 'Point',
          coordinates: [
            vessel.location?.longitude || vessel.longitude,
            vessel.location?.latitude || vessel.latitude,
          ],
        },
        properties: {
          ID: vessel.id,
          'Timestamp UTC': vessel.timestamp,
          Lng: (vessel.location?.longitude || vessel.longitude).toString(),
          Lat: (vessel.location?.latitude || vessel.latitude).toString(),
          MMSI: vessel.mmsi,
        },
      }),
      SPIRE: (vessel) => ({
        type: 'Feature',
        id: vessel.id,
        geometry: {
          type: 'Point',
          coordinates: [
            vessel.lastPositionUpdate?.longitude || vessel.longitude,
            vessel.lastPositionUpdate?.latitude || vessel.latitude,
          ],
        },
        properties: {
          ID: vessel.id,
          MMSI: vessel.staticData?.mmsi || vessel.mmsi,
          Name: vessel.staticData?.name || vessel.name || 'N/A',
          'Timestamp UTC':
            vessel.lastPositionUpdate?.timestamp || vessel.timestamp,
          Lng: (
            vessel.lastPositionUpdate?.longitude ||
            vessel.longitude ||
            vessel.location?.LON
          ).toString(),
          Lat: (
            vessel.lastPositionUpdate?.latitude ||
            vessel.latitude ||
            vessel.location?.LAT
          ).toString(),
          Course: vessel.lastPositionUpdate?.course || vessel.course,
          Flag: vessel.staticData?.flag || vessel.flag,
          'Ship Type': vessel.staticData?.shipType || vessel.shipType || 'N/A',
          IMO: vessel.staticData?.imo || vessel?.staticData?.imo,
          'ETA UTC': vessel.currentVoyage?.eta || vessel.eta || 'N/A',
          'Port Name':
            vessel.currentVoyage?.matchedPort?.port?.name ||
            vessel.port?.name ||
            'N/A',
          Destination: vessel?.currentVoyage?.destination
            ? vessel?.currentVoyage?.destination
            : 'N/A',
          Speed: vessel.lastPositionUpdate?.speed
            ? vessel.lastPositionUpdate.speed
            : 'N/A',
          'Vessel Length': vessel.staticData?.dimensions?.length || 'N/A',
          'Vessel Width': vessel.staticData?.dimensions?.width || 'N/A',
        },
      }),
    };
    const mapperKey = type === 'CLYDE' ? 'CLYDE' : 'SPIRE';
    const mapper = dataMappers[mapperKey];
    const features = AISdata?.map(mapper) || [];
    return {
      type: 'FeatureCollection',
      features: features,
    };
  }

  filterScenesBySiteId = (array, id) => {
    return array.map((obj) => ({
      ...obj,
      scenes: obj.scenes.filter((scene) => scene.siteId === id),
    }));
  };

  filterScenesBySubdaily = (array, id) => {
    return array.map((obj) => ({
      ...obj,
      scenes: obj.scenes.filter((scene) => scene.sequence === id),
    }));
  };

  setCollectionRecurrencyArray(
    collectionType: 'opportunityList' | 'recurrencyArray',
    recurrencyIndex: any
  ) {
    const currentList = this.collection[collectionType];
    currentList[recurrencyIndex].checked = true;
    currentList[recurrencyIndex].index = recurrencyIndex;
    currentList[recurrencyIndex].scenes.forEach((scene) => {
      if (scene.status !== 'failed') scene.checked = true;
    });
    if (collectionType == 'recurrencyArray') {
      if (
        this.selectedCheckboxesNew[this.selectedCheckboxesNew.length - 1]
          ?.pane == 'left'
      ) {
        this.mapPane = 'right';
      } else {
        this.mapPane = 'left';
      }
    } else {
      if (this.mapPane == 'left') {
        this.mapPane = 'right';
      } else {
        this.mapPane = 'left';
      }
    }
    const primarySensor = this.collection.sensors[0];
    const collectionItem = this.collection[collectionType][recurrencyIndex];
    collectionItem.name = primarySensor.name;
    collectionItem.resolution_tooltip = primarySensor?.resolution_tooltip;
    collectionItem.downloaded = primarySensor?.downloaded;
    collectionItem.status = primarySensor?.status;
    collectionItem.restoreStatus = primarySensor?.restoreStatus;
    collectionItem.restoreOption = primarySensor?.restoreOption;
    collectionItem.checked = true;
    collectionItem.pane = this.mapPane;
    collectionItem.isAdditionalCSIProducts =
      primarySensor?.isAdditionalCSIProducts;
    collectionItem.obfuscateName = primarySensor?.obfuscateName;
    collectionItem.tnqSensorType = primarySensor?.tnqSensorType;
    collectionItem.questionName = primarySensor?.questionName;
    collectionItem.assetsDelivered = primarySensor?.assetsDelivered;
  }

  setLeftRightLabels(recurrencyIndex) {
    this.sensorsNew = this.selectedCheckboxesNew;
    this.leftData = this.selectedCheckboxesNew.filter(
      (selectedCheckboxes) => selectedCheckboxes.pane == 'left'
    );
    this.rightData = this.selectedCheckboxesNew.filter(
      (selectedCheckboxes) => selectedCheckboxes.pane == 'right'
    );
    this.setPreviousSelectiontext();
    this.selectionChange.next(this.collection.recurrencyArray[recurrencyIndex]);
  }

  setLeftandRightBands(dataList) {
    this.leftBand = dataList.filter((item) => item.pane == 'left').length > 0;
    this.rightBand = dataList.filter((item) => item.pane == 'right').length > 0;
  }

  updateImageLayersBasedOnPane() {
    if (
      this.scenesNew.filter((scenenew) => scenenew.pane == 'left')[0]
        ?.leftImageLayer
    ) {
      this.leftImageNew = this.scenesNew.filter(
        (scenenew) => scenenew.pane == 'left'
      )[0]?.leftImageLayer;
    }
    if (
      this.scenesNew.filter((scenenew) => scenenew.pane == 'right')[0]
        ?.rightImageLayer
    ) {
      this.rightImageNew = this.scenesNew.filter(
        (scenenew) => scenenew.pane == 'right'
      )[0].rightImageLayer;
    }
    if (
      this.scenesNew.filter((scenenew) => scenenew.pane == 'left').length == 0
    ) {
      this.leftImageNew = null;
    }
    if (
      this.scenesNew.filter((scenenew) => scenenew.pane == 'right').length == 0
    ) {
      this.rightImageNew = null;
    }
  }

  limitSensorSelectionToTwo() {
    let selectedSensor: any;
    if (this.compare) {
      this.map.removeControl(this.compare);
      this.compare = null;
      let dateSelected: any;
      this.filterDateData = [];
      this.selectedCheckboxesNew.forEach((item) => {
        let start_date = this.datePipe.transform(
          item.start,
          'dd/MM/yyyy',
          'UTC'
        );
        let end_date = this.datePipe.transform(item.end, 'dd/MM/yyyy', 'UTC');
        dateSelected = start_date + ' - ' + end_date;
        this.filterDateData.push(dateSelected);
      });
    }
    if (this.selectedCheckboxesNew.length > 2) {
      selectedSensor = JSON.parse(
        JSON.stringify(this.selectedCheckboxesNew[0])
      );
      const indexToRemove = 0;
      this.selectedCheckboxesNew.splice(indexToRemove, 1);
      this.sensorsNew = this.selectedCheckboxesNew;
      this.selectionChange.next(this.selectedCheckboxesNew[0]);
      this.subSelectionSelectionChange.next(1);
      if (
        this.collection.recurrencyArray.filter((item) => item.checked).length >
        0
      ) {
        this.collection.recurrencyArray.forEach((sensor, index) => {
          const indexTouncheck = this.selectedCheckboxesNew.findIndex(
            (item) => item.start === sensor.start
          );
          if (indexTouncheck === -1) {
            sensor.checked = false;
            sensor.scenes.forEach((scene) => {
              scene.checked = false;
            });
          }
        });
      }
      if (this.compare) {
        this.map.removeControl(this.compare);
        this.compare = null;
        let dateSelected: any;
        this.filterDateData = [];
        this.selectedCheckboxesNew.forEach((item) => {
          let start_date = this.datePipe.transform(
            item.start,
            'dd/MM/yyyy',
            'UTC'
          );
          let end_date = this.datePipe.transform(item.end, 'dd/MM/yyyy', 'UTC');
          dateSelected = start_date + ' - ' + end_date;
          this.filterDateData.push(dateSelected);
        });
      }
      this.scenesNew.map((scene: any, index: any) => {
        if (scene.scene?.start == selectedSensor.start) {
          let ghgIndex = this.ghgLayers.findIndex(
            (ghg) => ghg.scene.id == scene.scene.id
          );
          if (ghgIndex != -1) {
            this.removeGHGLayerByScene(this.ghgLayers[ghgIndex]);
            this.ghgLayers.splice(ghgIndex, 1);
          }
          this.removeLayerByScene(scene, { paneSpecific: true });
          this.clearRFBandsByScene(scene, false);
          this.clearRFSignalsByScene(scene);
        }
      });
      this.scenesNew = this.scenesNew.filter((scene: any) => {
        return scene.scene?.start != selectedSensor.start;
      });
    }
  }

  checkForScenes(scenesList: any[]) {
    const collectionRecurrencyArray = this.collection.recurrencyArray
    this.isAllRecurrencyDisabled =
    collectionRecurrencyArray?.every(r => r.disabled) ?? false;

    if (scenesList.length == 0) {
      this.isNoScenes = true;
    } else {
      this.isNoScenes = false;
    }
  }

  toggleRecurrentSensor(indexToRemove: any, event: any, sensorSelected: any) {
    this.selectedCheckboxesNew.splice(indexToRemove, 1);
    this.sensorsNew = this.selectedCheckboxesNew;
    this.selectionChange.next(this.selectedCheckboxesNew[0]);
    this.subSelectionSelectionChange.next(1);
    if (
      this.collection.recurrencyArray.filter((item) => item.checked).length > 0
    ) {
      this.collection.recurrencyArray.forEach((sensor, index) => {
        const indexTouncheck = this.selectedCheckboxesNew.findIndex(
          (item) => item.start === sensor.start
        );
        if (indexTouncheck === -1) {
          sensor.checked = false;
          sensor.scenes.forEach((scene) => {
            scene.checked = false;
          });
        }
      });
      if (this.selectedCheckboxesNew?.length === 0) {
        this.defaultSubdailyCount = 1;
        this.toggleDailyRecurrency(event);
      }

      if (this.selectedCheckboxesNew?.length > 0) {
        if (this.compare) {
          this.map.removeControl(this.compare);
          this.compare = null;
        }

        this.scenesNew.map((scene: any, index: any) => {
          if (scene.scene?.start == sensorSelected.start) {
            let ghgIndex = this.ghgLayers.findIndex(
              (ghg) => ghg.scene.id == scene.scene.id
            );
            if (ghgIndex != -1) {
              this.removeGHGLayerByScene(this.ghgLayers[ghgIndex]);
              this.ghgLayers.splice(ghgIndex, 1);
            }
            this.removeLayerByScene(scene, { paneSpecific: true });
            this.clearRFSignalsByScene(scene);
            this.removeAnnoatationByScene(scene);
          }
        });
        this.mapPane = sensorSelected?.pane;
        if (this.mapPane == 'left') {
          this.leftImageNew = null;
          this.mapPane = 'right';
        } else {
          this.mapPane = 'left';
          this.rightImageNew = null;
        }
        if (this.leftImageNew == null && this.rightImageNew == null) {
          this.mapPane = '';
        }
        this.scenesNew = this.scenesNew.filter((scene: any) => {
          return scene.scene?.start != sensorSelected.start;
        });
        if (
          this.selectedCheckboxesNew[0]?.scenes[0]?.operatorKey ==
            this.OPERATOR.GHG &&
          this.selectedSites.length > 0
        ) {
          this.selectedCheckboxesNew[0].pane = 'left';
          this.selectedSites = [];
          this.removeLayers();
          this.removeGHGLayer();
          this.scenesNew = [];
          this.defaultSubdailyCount =
            this.selectedCheckboxesNew[0].scenes[0].siteId;
          this.selectOptionNew(this.selectedCheckboxesNew[0], 'compare');
        } else if (
          this.selectedCheckboxesNew[0]?.scenes[0]?.operatorKey ==
            this.OPERATOR.GHG &&
          this.selectedSites.length == 0
        ) {
          this.defaultSubdailyCount = 0;
          this.selectOptionNew(this.selectedCheckboxesNew[0], 'compare');
        }
      }
    }
  }

  toggleRecurrentDatesNew(
    collectionIndex: any,
    recurrencyIndex: any,
    event: any,
    type: any,
    task: any
  ) {
    this.recurrrencyIndexValue = recurrencyIndex;
    this.fail = 0;
    this.tifPopupShown = 0;
    this.lastSliderValue = 0;
    if (this.collection.opportunityList.length > 0) {
      this.toggleRecurrentDatesOpportunity(
        collectionIndex,
        recurrencyIndex,
        event,
        type,
        task
      );
      this.setLeftRightLabels(recurrencyIndex);
    } else if (
      this.collection?.recurrencyArray[recurrencyIndex]?.scenes[0]
        ?.operatorKey == this.OPERATOR.USL
    ) {
      this.toggleRecurrentDatesRFbandNew(
        collectionIndex,
        recurrencyIndex,
        event,
        type,
        task
      );
    } else if (
      this.collection?.recurrencyArray[recurrencyIndex]?.scenes[0]
        ?.operatorKey == this.OPERATOR.LBAND
    ) {
      this.toggleRecurrentDatesRFSignalNew(
        collectionIndex,
        recurrencyIndex,
        event,
        type,
        task
      );
    } else {
      this.RF = false;
      if (event.checked) {
        this.annotateClicked = false;
        this.newTaskButtonClicked = false;
        this.removeAnnotationMarkers();
        this.showSubDailyList = false;
        let selectedSensor: any;
        this.setCollectionRecurrencyArray('recurrencyArray', recurrencyIndex);
        this.cloneselectedCheckboxesNew = JSON.parse(
          JSON.stringify(this.cloneselectedCheckboxesNew)
        );
        this.selectedCheckboxesNew.push(
          this.collection.recurrencyArray[recurrencyIndex]
        );
        this.limitSensorSelectionToTwo();
        if (this.collections[collectionIndex]?.recurrencyArray?.length > 1) {
          this.selectOptionNew(
            this.collections[collectionIndex]?.recurrencyArray[recurrencyIndex],
            'compare'
          );
        } else {
          this.selectOptionNew(
            this.collections[collectionIndex]?.recurrencyArray[0],
            'compare'
          );
        }
        if (this.selectedSites.length == 1) {
          this.selectedCheckboxesNew.map((selectedDate, index) => {
            let scenes: any[] = [];
            this.filteredCollection.recurrencyArray.map((recurrency) => {
              if (selectedDate.start == recurrency.start) {
                recurrency.scenes.map((scn) => {
                  scenes.push(scn);
                });
              }
            });
            this.selectedCheckboxesNew[index].scenes = scenes;
          });
          if (this.selectedSites[0]) {
            this.selectedCheckboxesNew = this.filterScenesBySiteId(
              this.selectedCheckboxesNew,
              this.selectedSites[0].value
            );
          }
        }
        this.setLeftRightLabels(recurrencyIndex);
        let sensor = this.collection.sensors[0];
        sensor.checked = true;
        if (
          (this.selectedSites.length == 0 &&
            this.selectedSubDailyItemsNew.length == 0) ||
          this.selectedCheckboxesNew.length == 2
        ) {
          for (const [sceneIndex, scene] of this.selectedCheckboxesNew[
            this.selectedCheckboxesNew.length - 1
          ]?.scenes.entries()) {
            if (scene?.id && scene?.status !== 'failed') {
              scene.checked = true;
              if (scene.footprint) {
                const sensorId = sensor?.id;
                const sceneId = scene?.id;
                const action = 'sensor';
                const taskId = this.collection?.taskId;
                if (this.imageType == 'tiff') {
                  scene.imageType = 'tif';
                }
                const sensorObj = {
                  sensorId: sensorId,
                  sceneId: sceneId,
                  action: action,
                  fileType: scene.imageType,
                };
                scene.start =
                  this.collection.recurrencyArray[recurrencyIndex]?.start;
                this.tifPopupShown = 0;
                this.fetchImageFromServer(this.collection, sensorObj, scene);
              }
            }
          }
          this.scenIdList.push(this.collection.recurrencyArray[recurrencyIndex]?.scenes[0]?.id);
        }
      } else {
        this.leftData = [];
        this.rightData = [];
        const indexToRemove =
          type === 'dropdown'
            ? this.selectedCheckboxesNew.findIndex(
                (item) =>
                  item.start ===
                  this.collection.recurrencyArray[recurrencyIndex].start
              )
            : recurrencyIndex;
        let sensorSelected = this.collection.recurrencyArray[recurrencyIndex];
        this.toggleRecurrentSensor(indexToRemove, event, sensorSelected);
      }
    }
    if(!this.timeseries){
      this.observationChecked = true;
      if (event.checked) {
        this.observationEnabled = true;
      } else {
        this.observationEnabled = false;
      }
    }
  }

  toggleRecurrentSensorNew(collectionIndex: any, sensorIndex: any, event: any, sensor?: any) {
    if (this.collection.opportunityList.length > 0) {
      this.toggleRecurrentSensorOpportunityNew(
        collectionIndex,
        sensorIndex,
        event
      );
    } else if (this.collection.sensors[0].operatorKey == this.OPERATOR.USL) {
      this.toggleRecurrentRFNew(collectionIndex, sensorIndex, event);
    } else if (this.collection.sensors[0].operatorKey == this.OPERATOR.LBAND) {
      this.toggleRecurrentRFSignalNew(collectionIndex, sensorIndex, event);
    } else {
      if (event.checked == false) {
        this.rightData = [];
        this.leftData = [];
        const indexToRemove = sensorIndex;
        let sensorSelected = JSON.parse(
          JSON.stringify(this.selectedCheckboxesNew[indexToRemove])
        );
        this.toggleRecurrentSensor(indexToRemove, event, sensorSelected);
            this.needsCompareResetToCenter = true;

        const isLeftPane = sensor?.pane === 'left';
        const isRightPane = sensor?.pane === 'right';

        const comparisonLayer = isLeftPane
        ? this.leftComparisonObjectLayer
        : this.rightComparisonObjectLayer;

        if (comparisonLayer && this.map.hasLayer(comparisonLayer)) {
          // Remove comparison layer
          this.map.removeLayer(comparisonLayer);

          // Reset pane-specific state
          if (isLeftPane) {
            this.leftComparisonObjectLayer = null;
            this.leftFeedPanels.clear();
            this.leftImageNew = null;
            this.updateObjectVisibility(0);
          } else if (isRightPane) {
            this.rightComparisonObjectLayer = null;
            this.rightFeedPanels.clear();
            this.rightImageNew = null;
            this.updateObjectVisibility(this.map.getSize().x);
          }
          // Clean up scene-specific layers & annotations
          const sceneId = sensor.scenes[0]?.id;

          this.scenesNew.forEach(sceneNew => {
            if (sceneNew.id !== sceneId) return;

            this.removeLayerByScene(sceneNew);

            if (isLeftPane && sceneNew?.leftImageLayer) {
              this.leftImageNew = null;
            }

            if (isRightPane && sceneNew?.rightImageLayer) {
              this.rightImageNew = null;
            }

            this.removeAnnoatationByScene(sceneNew);
          });
        }
      }
    }
  }

  toggleDatesBySite(
    collectionIndex: any,
    recurrencyIndex: any,
    event: any,
    type: any,
    task: any
  ) {
    this.fail = 0;
    this.RF = false;
    this.lastSliderValue = 0;
    if (event.checked) {
      this.annotateClicked = false;
      this.newTaskButtonClicked = false;
      this.removeAnnotationMarkers();
      let selectedSensor: any;
      this.setCollectionRecurrencyArray('recurrencyArray', recurrencyIndex);
      this.cloneselectedCheckboxesNew = JSON.parse(
        JSON.stringify(this.cloneselectedCheckboxesNew)
      );
      if (
        this.selectedSites.length == 1 &&
        this.selectedCheckboxesNew.length == 0
      ) {
        this.defaultSubdailyCount = this.selectedSites[0].value;
        this.resetMapNew();
      }
      this.selectedCheckboxesNew.push(
        this.collection.recurrencyArray[recurrencyIndex]
      );
      this.limitSensorSelectionToTwo();
      if (this.collections[0]?.recurrencyArray?.length > 1) {
        this.selectOptionNew(
          this.collections[0]?.recurrencyArray[recurrencyIndex],
          'compare'
        );
      } else {
        this.selectOptionNew(
          this.collections[0]?.recurrencyArray[0],
          'compare'
        );
      }
      if (this.selectedSites.length == 1) {
        this.selectedCheckboxesNew.map((selectedDate, index) => {
          let scenes: any[] = [];
          this.filteredCollection.recurrencyArray.map((recurrency) => {
            if (selectedDate.start == recurrency.start) {
              recurrency.scenes.map((scn) => {
                scn.predictedDate = scn?.predicted_date;
                scenes.push(scn);
              });
            }
          });
          this.selectedCheckboxesNew[index].scenes = scenes;
        });
        if (this.selectedSites[0]) {
          this.selectedCheckboxesNew = this.filterScenesBySiteId(
            this.selectedCheckboxesNew,
            this.selectedSites[0].value
          );
        }
        this.subDailyFinalArray = this.selectedCheckboxesNew;
      }
      this.setLeftRightLabels(recurrencyIndex);
      let sensor = this.collection.sensors[0];
      sensor.checked = true;
      if (
        (this.selectedSites.length == 0 &&
          this.selectedSubDailyItemsNew.length == 0) ||
        this.selectedCheckboxesNew.length == 2
      ) {
        for (const [sceneIndex, scene] of this.selectedCheckboxesNew[
          this.selectedCheckboxesNew.length - 1
        ]?.scenes.entries()) {
          if (scene?.id && scene?.status !== 'failed') {
            scene.checked = true;
            scene.imageType = 'png';
            this.imageType = this.checkType();
            if (this.imageType == 'tiff') {
              scene.imageType = 'tif';
            }
            scene.tif = false;
            if (scene.footprint) {
              const sensorId = sensor?.id;
              const sceneId = scene?.id;
              const action = 'sensor';
              const taskId = this.collection?.taskId;
              const sensorObj = {
                sensorId: sensorId,
                sceneId: sceneId,
                action: action,
                fileType: scene.imageType,
              };
              scene.start =
                this.collection.recurrencyArray[recurrencyIndex]?.start;
              this.tifPopupShown = 0;
              this.fetchImageFromServer(this.collection, sensorObj, scene);
            }
          }
        }
      }
    } else {
      this.leftData = [];
      this.rightData = [];
      const indexToRemove =
        type === 'dropdown'
          ? this.selectedCheckboxesNew.findIndex(
              (item) =>
                item.start ===
                this.collection.recurrencyArray[recurrencyIndex].start
            )
          : recurrencyIndex;
      this.selectedCheckboxesNew.splice(indexToRemove, 1);
      this.sensorsNew = this.selectedCheckboxesNew;
      this.subDailyFinalArray = this.selectedCheckboxesNew;
      if (this.selectedSites.length > 0) {
        if (this.compare) {
          this.map.removeControl(this.compare);
          this.compare = null;
        }
        this.scenesNew.map((scene: any, index: any) => {
          if (
            scene.scene?.start ==
            this.collection.recurrencyArray[recurrencyIndex].start
          ) {
            this.mapPane = scene?.pane;
            let ghgIndex = this.ghgLayers.findIndex(
              (ghg) => ghg.scene.id == scene.scene.id
            );
            if (ghgIndex != -1) {
              this.removeGHGLayerByScene(this.ghgLayers[ghgIndex]);
              this.ghgLayers.splice(ghgIndex, 1);
            }
            this.removeLayerByScene(scene, { paneSpecific: true });
          }
          this.removeAnnoatationByScene(scene);
        });
        if (this.mapPane == 'left') {
          this.leftImageNew = null;
          this.mapPane = 'right';
        } else {
          this.mapPane = 'left';
          this.rightImageNew = null;
        }
        if (this.leftImageNew == null && this.rightImageNew == null) {
          this.mapPane = '';
        }
        this.scenesNew = this.scenesNew.filter((scene: any) => {
          return (
            scene.scene?.start !=
            this.collection.recurrencyArray[recurrencyIndex].start
          );
        });
        if (this.selectedCheckboxesNew.length > 0) {
          this.selectedValue = this.collection.recurrencyArray.filter(
            (recurrency) => {
              return recurrency.start == this.selectedCheckboxesNew[0].start;
            }
          )[0];
          let sceneBySite = this.collection.recurrencyArray.filter(
            (recurrency) => {
              return recurrency.start == this.selectedCheckboxesNew[0].start;
            }
          )[0];
          this.subDailyCountarray.forEach((item) => {
            item.disabled = !sceneBySite.scenes.some(
              (obj) => obj.siteId === item.siteId
            );
          });
        } else {
          this.selectedValue = this.collection.recurrencyArray[0];
        }
        if (this.selectedCheckboxesNew.length == 0) {
          this.defaultSubdailyCount = this.selectedSites[0]?.siteId;
          this.resetMapNew();
          this.filteredCollection = this.fullCollection;
          this.subDailyFinalArray = [];
          this.selectSites(this.defaultSubdailyCount, event);
        }
      }
    }
  }

  toggleRecurrentOpportunity(
    event: any,
    indexToRemove: any,
    sensorSelected: any
  ) {
    this.selectedCheckboxesNew.splice(indexToRemove, 1);
    this.sensorsNew = this.selectedCheckboxesNew;
    this.selectionChange.next(this.selectedCheckboxesNew[0]);
    this.subSelectionSelectionChange.next(1);
    if (
      this.collection.opportunityList.filter((item) => item.checked).length > 0
    ) {
      this.collection.opportunityList.forEach((sensor, index) => {
        const indexTouncheck = this.selectedCheckboxesNew.findIndex(
          (item) => item.date === sensor.date
        );
        if (indexTouncheck === -1) {
          sensor.checked = false;
          sensor.scenes.forEach((scene) => {
            scene.checked = false;
          });
        }
      });
    }
    if (this.selectedCheckboxesNew?.length === 0) {
      this.toggleDailyRecurrency(event);
    }
    if (this.selectedCheckboxesNew.length > 0) {
      if (this.compare) {
        this.map.removeControl(this.compare);
        this.compare = null;
      }
      this.scenesNew.map((scene: any, index: any) => {
        if (scene.scene?.start == sensorSelected.date) {
          this.mapPane = scene?.pane;
          this.removeLayerByScene(scene, { paneSpecific: true });
        }
      });
      if (this.mapPane == 'left') {
        this.leftImageNew = null;
        this.mapPane = 'right';
      } else {
        this.mapPane = 'left';
        this.rightImageNew = null;
      }
      if (this.leftImageNew == null && this.rightImageNew == null) {
        this.mapPane = '';
      }
      this.scenesNew = this.scenesNew.filter((scene: any) => {
        return scene.scene?.start != sensorSelected.date;
      });
    }
  }

  toggleRecurrentDatesOpportunity(
    collectionIndex: any,
    opportunityIndex: any,
    event: any,
    type: any,
    task: any
  ) {
    if (event?.checked) {
      this.setCollectionRecurrencyArray('opportunityList', opportunityIndex);
      this.cloneselectedCheckboxesNew = JSON.parse(
        JSON.stringify(this.cloneselectedCheckboxesNew)
      );
      this.selectedCheckboxesNew.push(
        this.collection.opportunityList[opportunityIndex]
      );
      this.sensorsNew = this.selectedCheckboxesNew;
      this.setPreviousSelectiontext();
      this.selectionChange.next(
        this.collection.opportunityList[opportunityIndex]
      );
      let sensor = this.collection.opportunityList[opportunityIndex];
      sensor.checked = true;
      this.tifPopupShown = 0;
      for (const [sceneIndex, scene] of this.selectedCheckboxesNew[
        this.selectedCheckboxesNew.length - 1
      ]?.scenes.entries()) {
        if (scene?.id && scene?.status !== 'failed') {
          scene.checked = true;
          if (this.imageType === 'tiff') {
            scene.imageType = 'tif';
          }
          if (scene.footprint) {
            const sensorId = sensor?.id;
            const sceneId = scene?.id;
            const action = 'sensor';
            const taskId = this.collection?.taskId;
            const sensorObj = {
              sensorId: sensorId,
              sceneId: sceneId,
              action: action,
              fileType: scene.imageType,
            };
            scene.start = sensor?.date;
            this.tifPopupShown = 0;
            this.fetchImageFromServer(this.collection, sensorObj, scene);
          }
        }
      }
    } else {
      const indexToRemove =
        type === 'dropdown'
          ? this.selectedCheckboxesNew.findIndex(
              (item) =>
                item.date ===
                this.collection.opportunityList[opportunityIndex].date
            )
          : opportunityIndex;
      let selectedSensor = this.collection.opportunityList[opportunityIndex];
      this.toggleRecurrentOpportunity(event, indexToRemove, selectedSensor);
    }
  }

  toggleRecurrentSensorOpportunityNew(
    collectionIndex: any,
    sensorIndex: any,
    event: any
  ) {
    if (event.checked == false) {
      const indexToRemove = sensorIndex;
      let sensorSelected = JSON.parse(
        JSON.stringify(this.selectedCheckboxesNew[indexToRemove])
      );
      this.toggleRecurrentOpportunity(event, indexToRemove, sensorSelected);
    }
  }

  setPreviousSelectiontext() {
    if (this.selectedCheckboxes[0] && this.selectedCheckboxes[0]?.start) {
      const start = this.formatDate(
        new Date(this.selectedCheckboxes[0]?.start)
      );
      const end = this.formatDate(new Date(this.selectedCheckboxes[0]?.end));
      const combinedDate = `${start} - ${end}`;
      if (this.dateRange) {
        this.previousSelectionText = new Date(
          this.selectedCheckboxes[0]?.start
        );
        this.previousEndText = new Date(this.selectedCheckboxes[0]?.end);
      } else
        this.previousSelectionText = new Date(
          this.selectedCheckboxes[0]?.start
        );
    }
  }

  formatDate(date) {
    const day = String(date.getDate() - 1).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = String(date.getFullYear()).slice(-4);
    return `${day}/${month}/${year}`;
  }

  selectMetric(metric, event) {
    this.removeGHGLayer();
    if (!this.isCompare || this.timeseries) {
      this.resetMapNew();
      this.resetScenesBySite(this.defaultSubdailyCount, event);
    }
    this.metric = metric;
    if (this.timeseries) {
      this.scenesNew.forEach((selectedScene) => {
        this.showMetric(this.metric, selectedScene);
      });
    } else {
      this.showMetric(this.metric, this.scenesNew[this.scenesNew.length - 1]);
    }
    let footprintcordinates = JSON.parse(
      JSON.stringify(
        this.scenesNew[0].scene.footprint.coordinates[0].map((sub) => {
          return [sub[1], sub[0]];
        })
      )
    );
    footprintcordinates.push(footprintcordinates[0]);
    const polygon = turf.polygon([footprintcordinates]);
    const centroid = turf.centroid(polygon);
    const centerCoordinates = centroid.geometry.coordinates;
    this.map.setView(centerCoordinates, this.zoomLevel);
  }

  showMetric(metric: any, scene) {
    let trendLine: any;
    this.metric = metric;
    let legendScale: any;
    let emissionMarker: any;
    let footprintcordinates = scene?.scene?.footprint?.coordinates[0].map(
      (sub) => {
        return [sub[1], sub[0]];
      }
    );

    const hasValue = this.ghgLayers.some(
      (item) => item.legendScale !== null && item.legendScale !== undefined
    );
    if (this.scenesNew.length > 0) {
      if (
        (!this.timeseries &&
          scene?.scene?.legendScale &&
          this.metric == 'ppb') ||
        (this.timeseries &&
          scene?.scene?.legendScale &&
          this.metric == 'ppb' &&
          !hasValue)
      ) {
        var legendCanvas = this.drawLegendOnCanvas(
          scene?.scene?.legendScale,
          scene?.scene?.legend_max,
          '(PPB)'
        );
        legendScale = this.addDynamicLegendToMap(legendCanvas, scene?.scene);
      } else if (this.metric == 'kg') {
        let textMarkerCordinates: any[] = JSON.parse(
          JSON.stringify(footprintcordinates)
        );
        textMarkerCordinates.push(footprintcordinates[0][0]);
        var polygon = turf.polygon([textMarkerCordinates]);
        var centroid = turf.centroid(polygon);
        var centroidCoordinates = centroid.geometry.coordinates;

        if (scene?.scene?.metadata?.emission != false) {
          this.trendLinecordinates.push([
            centroidCoordinates[0],
            centroidCoordinates[1],
          ]);
        }
        emissionMarker = L.marker(
          [centroidCoordinates[0], centroidCoordinates[1]],
          {
            pane: this.mapPane,
            icon: L.divIcon({
              html:
                '<div style="background: grey; width: 100px">' +
                `${
                  scene?.scene?.metadata?.emission == false
                    ? 'No Emission'
                    : scene?.scene?.ch4srData?.sourceRate
                }` +
                '</div>',
            }),
          }
        ).addTo(this.map);
        this.attachTooltip(
          emissionMarker,
          `<span style="text-transform: capitalize;">
            ${this.formatProperties(scene?.scene?.ch4srData)}
        </span>`
        );

        if (this.timeseries) {
          trendLine = L.polyline([this.trendLinecordinates], {
            color: 'yellow',
          }).addTo(this.map);
        }
      }
      this.ghgLayers.push({
        markerLayer: emissionMarker,
        legendScale: legendScale,
        scene: scene,
         renderedPredictedDate:
          scene?.renderedPredictedDate ??
          scene?.scene?.predicted_date?.split('T')[0],
        trendLine: trendLine,
      });
    }
  }

  shouldDisableIndicesHourGlass(collectionIndex, sensorIndex, scene, indices) {
    let isDisable: boolean = true;
    const sensor = this.collections?.[collectionIndex]?.sensors?.[sensorIndex];
    if (!sensor?.scenes) {
      return true;
    }

    const selectedScenes = sensor.scenes.filter((i) => i.checked === true);
    if (selectedScenes.length === 1) {
      if (indices?.products.length === 0) {
        isDisable = false;
      } else {
        const hasMatchingScene = selectedScenes.some((scene) =>
          indices.products.some((product) => {
            return product.sceneId == scene.id && product.status == 'success';
          })
        );
        if (hasMatchingScene) {
          isDisable = true;
        } else {
          isDisable = false;
        }
      }
    }
    return isDisable;
  }

  drawLegendOnCanvas(grades: any[], maximum: any, title?: any) {
    grades = grades.reverse();
    let legendScale: any[] = [];
    if (this.indicesLayer) {
      legendScale = [1.0, 0.8, 0.6, 0.4, 0.2, 0, -1];
    } else {
      legendScale = this.generateLegendScaleAdjusted(
        maximum,
        grades.length - 1
      ).reverse();
    }

    var canvas = document.createElement('canvas');
    var ctx: any = canvas.getContext('2d');
    canvas.width = 800;
    canvas.height = grades.length * 20 + 40;
    ctx.scale(2, 1);
    ctx.font = '8px Arial';

    this.indicesLayer
      ? (ctx.textBaseline = 'top')
      : (ctx.textBaseline = 'middle');
    ctx.fillStyle = '#fff';
    this.indicesLayer
      ? ctx.fillText(`(${title})`, 1, 23)
      : ctx.fillText(title, 3, 10);

    if (this.indicesLayer) {
      for (var i = 0; i < grades.length; i++) {
        let divident = grades.length / 7;
        if (i !== 0) {
          ctx.fillStyle = grades[i].color;
          ctx.fillRect(0, i * 20 + 20, 20, 20);
        }
        if (
          i === 0 ||
          i === grades.length - 1 ||
          i % Math.round(divident) === 0
        ) {
          ctx.fillStyle = '#fff';
          ctx.fillText(legendScale[i], 30, i * 20 + 34);
        }
      }
    } else {
      for (var i = 0; i < grades.length; i++) {
        let divident = grades.length / 7;
        ctx.fillStyle = grades[i].color;
        ctx.fillRect(0, i * 20 + 20, 20, 20);
        if (i == 0 || i == grades.length - 1 || i % Math.round(divident) == 0) {
          ctx.fillStyle = '#fff';
          ctx.fillText(Math.round(legendScale[i]), 24, i * 20 + 30);
        }
      }
    }
    return canvas;
  }

  addDynamicLegendToMap(legendCanvas: any, scene: any) {
    var legendDataURL = legendCanvas.toDataURL();
    const legendWidth = scene?.png_footprint[0][2] - scene?.png_footprint[0][0];
    const areaEasternmost = scene?.png_footprint[0][2];
    const shift = 0.01;
    const newLegendSouthWestLongitude = areaEasternmost + shift;
    const newLegendNorthEastLongitude =
      newLegendSouthWestLongitude + legendWidth;
    const newLegendBounds: any = [
      [scene?.png_footprint[0][1], newLegendSouthWestLongitude],
      [scene?.png_footprint[0][3], newLegendNorthEastLongitude],
    ];
    return L.imageOverlay(legendDataURL, newLegendBounds, {
      pane: this.mapPane,
    }).addTo(this.map);
  }

  generateLegendScaleAdjusted(legendMax: any, steps: any) {
    const startValue = 0;
    const endValue = Math.ceil(legendMax / 10) * 10;
    const interval = (endValue - startValue) / steps;
    let scale: any[] = [];
    for (let i = 0; i <= steps; i++) {
      const value = startValue + i * interval;
      scale.push(value);
    }
    return scale;
  }

  spinnerLoaderTifZoom(image: any) {
    let tileload = false;
    this.spinnerService.show();
    image.on('tileload', () => {
      this.spinnerService.hide();
    });

    this.map.on('zoomstart', () => {
      this.spinnerService.show();
    });
    this.map.on('zoomend', () => {
      this.spinnerService.hide();
    });
  }

  calculateZoomFromResolution() {
    let zoomLevel: any = 18;
    let resolution = this.sensorsNew[0]?.name.includes('Pan-sharpened')
      ? this.sensorsNew[0]?.name?.match(/Pan-sharpened:(\d+\.\d+)/)?.[1]
      : this.sensorsNew[0]?.name?.match(/\(([^)]+)\)/)[1];
    if (resolution) {
      resolution = resolution.slice(0, resolution.length - 1);
      zoomLevel = 18;
      for (let [level, meters] of Object.entries(this.ZOOM_SCALES)) {
        if (resolution >= Number(meters)) {
          zoomLevel = level;
          break;
        }
      }
    }
    return zoomLevel;
  }

  fetchImageFromServer(
    collection: any,
    sensorObj: any,
    scene: any,
    isVdapChange?: boolean
  ) {
    this.mapLoad = true;
    this.spinnerService.show();

    if(scene.imageType === 'png' && scene.skipPreview){
      this.spinnerService.hide();
      return
    }

    const api$ = isVdapChange
      ? this.apiService.getvadpFromGeoCollection(sensorObj)
      : this.apiService.getCollectionImage(collection.taskId, sensorObj);

    api$
      .pipe(
        switchMap((res: any) => {
          return of(res);
        }),
        finalize(() => {
          this.mapLoad = false;
          this.spinnerService.hide();
        })
      )
      .subscribe({
        next: (res: any) => {
          if (res?.msg === 'Failed') {
            this.pointerEvent = 'auto';
            this.fail++;

            if (this.fail === 1) {
              const message =
                'An error occurred during processing and ingestion of the request. Please try after sometime.';
              this.popupService.openPopup(
                CollectionPopupComponent,
                message,
                '',
                '40%'
              );
            }
          } else if (res?.msg === 'user storage') {
            this.freeze = false;
            this.fail++;

            if (this.fail === 1) {
              const message =
                'We cannot display or download the image as the delivery was made to your storage. You can access the image via your storage.';
              this.popupService.openPopup(
                CollectionPopupComponent,
                message,
                '',
                '40%'
              );
            }
          } else if (res?.result) {
            this.responseResult = res.result;
            this.displayFootprintImageNew(
              scene,
              res.result,
              sensorObj.sensorId,
              'image',
              collection.taskId

            );
          }
        },
        error: () => {
          this.pointerEvent = 'auto';
        },
      });
  }

  FetchCordinatesOfImage(scene: any, pane: any) {
    let footprintcordinates: any[] = [];
    if (scene?.footprint?.type != 'Point') {
      footprintcordinates = scene?.footprint?.coordinates[0].map((sub) => {
        return [sub[1], sub[0]];
      });
    } else {
      for (let i = 0; i < scene?.tif_footprint?.length; i += 2) {
        footprintcordinates.push([
          scene?.tif_footprint[i + 1],
          scene?.tif_footprint[i],
        ]);
      }
    }
    let tifcordinates: any[] = [];
    for (let i = 0; i < scene?.tif_footprint?.length; i += 2) {
      tifcordinates.push([
        scene?.tif_footprint[i + 1],
        scene?.tif_footprint[i],
      ]);
    }
    let footprintlayer = L.polygon(footprintcordinates, {
      color: 'green',
      fillColor: 'none',
      pane: pane,
    }).addTo(this.map);
    let tiffootprintlayer: any;
    if (tifcordinates.length > 0) {
      tiffootprintlayer = L.polygon(tifcordinates, {
        color: 'yellow',
        fillColor: 'none',
        pane: pane,
      }).addTo(this.map);
    }

    return {
      tiffootprintlayer: tiffootprintlayer,
      footprintlayer: footprintlayer,
      footprintcordinates: footprintcordinates,
      tifcordinates: tifcordinates,
    };
  }

  DisplayPopupsBasedOnResponse(res: any) {
    if (res?.msg === 'Failed') {
      this.spinnerService.hide();
      this.freeze = false;
      this.fail = this.fail + 1;
      if (this.fail === 1) {
        const message =
          'An error occurred during processing and ingestion of the request. Please try after sometime.';
        this.popupService.openPopup(
          CollectionPopupComponent,
          message,
          '',
          '40%'
        );
      }
    } else if (res?.msg === 'user storage') {
      this.spinnerService.hide();
      this.freeze = false;
      this.fail = this.fail + 1;
      if (this.fail === 1) {
        const message =
          'We cannot display or download the image as the delivery was made to your storage. You can access the image via your storage.';
        this.popupService.openPopup(
          CollectionPopupComponent,
          message,
          '',
          '40%'
        );
      }
    }
  }

  fetchAISDataFromServer(collection, sensorIndex, scene) {
    let timeExpired = collection.sensors[sensorIndex].timeExpired;
    let refreshCount =
      collection.sensors[sensorIndex]?.updatedRefreshes == 0
        ? 0
        : collection.sensors[sensorIndex]?.updatedRefreshes ||
          collection.sensors[sensorIndex]?.noOfRefreshes;
    if (!scene.aisAvailable) {
      const message =
        'AIS data is not available until the start of the time of interest (TOI)';
      this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
      this.spinnerService.hide();
      return;
    } else if (timeExpired) {
      const message =
        'The time of interest (TOI), along with the seven days of access to the historical data, has ended. Please re-task if the area of interest (AOI) continues to be the same.';
      this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
      this.spinnerService.hide();
      return;
    } else if (
      collection.sensors[sensorIndex].scenes[0].operatorKey ==
      this.OPERATOR.CLYDE
    ) {
      const coordinates = scene?.footprint?.coordinates[0];
      let taskId = this.collection?.taskId;
      let newCoordinates = coordinates.map((coord) => {
        return [coord[1], coord[0]];
      });
      newCoordinates = [newCoordinates];
      newCoordinates = JSON.stringify(newCoordinates);
      const encodedCoordinates = encodeURIComponent(newCoordinates);
      const startTime = encodeURIComponent(scene.openWindow);
      const endTime = encodeURIComponent(scene.closeWindow);
      const clydePayload = {
        polygon: encodedCoordinates,
        startTime: startTime,
        endTime: endTime,
        type: 'display',
      };
      const input = JSON.parse(decodeURIComponent(clydePayload.polygon));
      this.vesselPolygon = input[0]
        .map((pair) => pair.reverse().join(' '))
        .join(', ');
      clydePayload.polygon = this.vesselPolygon;
      this.apiService.getClydeAISData(clydePayload, taskId).subscribe(
        (res: any) => {
          this.clydeData = res.data;
          this.mapLoad = false;
          this.spinnerService.hide();
          if (res?.msg === 'failed') {
            const message =
              'An error occurred during processing and ingestion of the request. Please try after sometime.';
            this.popupService.openPopup(
              CollectionPopupComponent,
              message,
              '',
              '40%'
            );
          } else if (res?.data?.length === 0) {
            const message =
              'There is no AIS data in the area tasked. If there were to be vessels during the time of interest (TOI), those observations would become available when refreshed.';
            this.popupService.openPopup(
              CollectionPopupComponent,
              message,
              '',
              '40%'
            );
            collection.sensors[sensorIndex].checked = false;
            collection.sensors[sensorIndex].scenes.forEach((scene: any) => {
              scene.checked = false;
            });
          } else {
            this.displayClydeAISNew(
              scene,
              res.data,
              this.collection.sensors[sensorIndex],
              'CLYDE',
              res
            );
          }
        },
        (error) => {
          this.mapLoad = false;
          this.spinnerService.hide();
        }
      );
    } else if (
      collection.sensors[sensorIndex].scenes[0].operatorKey ==
        this.OPERATOR.SPIRE &&
      refreshCount > 0
    ) {
      this.mapLoad = true;
      this.spinnerService.show();
      const coordinates = scene?.footprint?.coordinates[0];
      let taskId = this.collection?.taskId;

      let newCoordinates = coordinates.map((coord) => {
        return [coord[0], coord[1]];
      });
      newCoordinates = [newCoordinates];
      newCoordinates = JSON.stringify(newCoordinates);
      const encodedCoordinates = encodeURIComponent(newCoordinates);
      const startTime = encodeURIComponent(scene.openWindow);
      const endTime = encodeURIComponent(scene.closeWindow);
      const spirePayload = {
        polygon: encodedCoordinates,
        startTime: startTime,
        endTime: endTime,
        type: 'display',
      };
      this.apiService.getAISData(spirePayload, taskId).subscribe(
        (res: any) => {
          this.spireData = res.data;
          this.mapLoad = false;
          this.spinnerService.hide();
          if (res?.msg === 'failed') {
            const message =
              'An error occurred during processing and ingestion of the request. Please try after sometime.';
            this.popupService.openPopup(
              CollectionPopupComponent,
              message,
              '',
              '40%'
            );
          } else {
            this.displayClydeAISNew(
              scene,
              res.data,
              this.collection.sensors[sensorIndex],
              'SPIRE',
              res
            );
          }
        },
        (error) => {
          this.mapLoad = false;
          this.spinnerService.hide();
        }
      );
    } else if (scene?.operatorKey !== this.OPERATOR.CLYDE) {
      this.mapLoad = false;
      this.spinnerService.hide();
      const message =
        'Your refresh count has been exhausted. Please re-task to continue receiving latest AIS information.';
      this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
      this.spinnerService.hide();
    }
  }

  async LoadTiffImage(imageUrl: any, scene: any, pane: any) {
    const georaster = await parseGeoRaster(imageUrl);
    let geoRasterLayer = new GeoRasterLayer({
      georaster: georaster,
      resolution: 256,
      opacity: 1,
      pane: pane,
      pixelValuesToColorFn: this.createPixelValuesToColorFn(georaster, scene),
    }).addTo(this.map);
    return geoRasterLayer;
  }

  displayTiffImage(imageLayer: any) {
    imageLayer.addTo(this.map);
    this.map.setMinZoom(DEFAULT_ZOOMLEVEL);
    this.map.fitBounds(imageLayer.getBounds(), {
      maxZoom: DEFAULT_ZOOMLEVEL,
    });
    this.map.setMaxZoom(Number(this.calculateZoomFromResolution()));
    this.spinnerLoaderTifZoom(imageLayer);
  }

  convertToLeafletBounds(coords) {
    const [west, south, east, north] = coords;
    return [
      [south, west],
      [north, east],
    ];
  }

  async displayFootprintImageNew(
    scene: any,
    urlData: any,
    sensorId: any,
    shapeFile: any,
    taskId?: any
  ) {
    this.displayedScene = scene;
    this.displayedUrl = urlData;
    this.displayedSensorId = sensorId;
    if(!this.timeseries && !this.collection.feedBased) {
    this.removeDynamicLayer();
    }
    this.needsCompareResetToCenter = true;

    this.pointerEvent = 'none';
    let legendScale: any;
    if (this.mapPane == '') {
      this.mapPane = 'left';
    }
    scene.pane = this.mapPane;
    const {
      tiffootprintlayer,
      tifcordinates,
      footprintcordinates,
      footprintlayer,
    } = await this.FetchCordinatesOfImage(scene, this.mapPane);
    if (scene?.legendScale && scene?.operatorKey != this.OPERATOR.GHG) {
      let title = '';
      if (scene?.operatorKey == 'Ororatech') {
        title = '(W/sr/m²)';
      }
      var legendCanvas = this.drawLegendOnCanvas(
        scene?.legendScale,
        scene?.legend_max,
        title
      );
      legendScale = this.addDynamicLegendToMap(legendCanvas, scene);
    }
    this.isLoadFeedComapre = true;
    if(this.mapPane === 'left' && this.leftComparisonObjectLayer && this.map.hasLayer(this.leftComparisonObjectLayer)){
      this.map.removeLayer(this.leftComparisonObjectLayer);
      this.leftComparisonObjectLayer = null;
      this.leftFeedPanels.clear();
    }
    
    if(this.mapPane === 'right' && this.rightComparisonObjectLayer && this.map.hasLayer(this.rightComparisonObjectLayer)){
      this.map.removeLayer(this.rightComparisonObjectLayer);
      this.rightComparisonObjectLayer = null;
      this.rightFeedPanels.clear();
    }
    if (this.sensorsNew.length == 1 || this.timeseries) {
      if (urlData?.imageUrl) {
        const imageLoadPromises: Promise<any>[] = [];
        const layerLength = Object.keys(urlData?.layer || {}).length;
        if (scene.imageType == 'tif' && layerLength === 0) {
          this.tifPopupShown = this.tifPopupShown + 1;
          if (this.tifPopupShown == 1) {
            this.resetMapNew();
            this.filterInfoVisible = false;
            const message = 'not-available';
            this.mapLoad = false;
            this.spinnerService.hide();
            this.popupService
              .openPopup(CollectionPopupComponent, message, '', '40%')
              .afterClosed()
              .subscribe((result) => {
                this.resetMapNew();
                scene.checked = false;
              });
          }

          return;
        }
        if ((scene.imageType == 'tif'|| this.imageType === 'tif') && layerLength > 0) {
          this.spinnerService.show();
            let bandvalue;
            if(scene?.operatorKey == this.OPERATOR.OSK && this.selectedBands.length > 0){
            bandvalue = await firstValueFrom(
            this.getBandMinMax(taskId, scene.id, this.selectedBands));
            }
          
          this.leftImageNew = this.helperService.createWmsLayer(
            this.map,
            urlData,
            shapeFile,
            1000,
            false,           
            undefined,       
            this.mapPane,
            bandvalue?.bands_info    

          );
        } else {
          let leafletBounds: any;
          if (scene?.png_footprint) {
            leafletBounds = this.convertToLeafletBounds(
              scene?.png_footprint[0]
            );
          } else {
            leafletBounds = footprintcordinates;
          }

          this.leftImageNew = L.imageOverlay(urlData.imageUrl, leafletBounds, {
            pane: this.mapPane,
            opacity: 1,
            crossOrigin: true,
          }).addTo(this.map);
          //this.handleCompareRecurrencyFeed(scene, 'left');
          this.map.fitBounds(this.leftImageNew.getBounds());
          this.spinnerService.hide();
        }
      } else {
        const layerLength = Object.keys(urlData.layer.product).length;
        const filteredProducts = urlData.layer.product.find(
          (p: any) => p.name === this.selectvdap
        );
        if (scene.imageType == 'tif' && layerLength > 0) {
            let bandvalue;
            if(scene?.operatorKey == this.OPERATOR.OSK && this.selectedBands.length > 0){
            bandvalue = await firstValueFrom(
            this.getBandMinMax(taskId, scene.id, this.selectedBands));
            }
          this.leftImageNew = this.helperService.createWmsLayer(
            this.map,
            filteredProducts,
            shapeFile,
            1000,
            true,
            urlData.layer.url,
            this.mapPane,   
            bandvalue?.bands_info   
          );
        }
      }
      if (this.displayedIS?.isInfo?.modelType == this.infoserviceModelType) {
        this.spinnerService.show();

        const payload: any = {
          action: this.combinedScenes ? 'sensorFeed' : 'ISDisplay',
          type: 'json',
          sensorId,
          ...(!this.combinedScenes && { sceneId: this.selectedSceneNew.id }),
        };

        this.apiService
          .getCollectionImage(this.collection.taskId, payload)
          .subscribe(
            (res: any) => {
              let feedDatas = res?.result?.feedData;
              this.fetchAndCombineGeoJson(feedDatas, this.displayedIS.isInfo);
            },
            (err) => {
              this.spinnerService.hide();
              this.mapLoad = false;
              this.cleanupAfterOperation();
            }
          );
      } else {
      }
      this.scenesNew.push({
        footprint: footprintlayer,
        tiffootprint: tiffootprintlayer,
        id: scene.id,
        scene: scene,
        sensorId: sensorId,
        leftImageLayer: this.mapPane == 'left' ? this.leftImageNew : null,
        rightImageLayer: this.mapPane == 'right' ? this.rightImageNew : null,
        legendScale: legendScale,
        pane: this.mapPane,
      });
      if (this.superResolutionLayer) {
        this.removeSuperResolutions();
      }
      if (scene?.operatorKey == this.OPERATOR.GHG) {
        this.showMetric(this.metric, this.scenesNew[this.scenesNew.length - 1]);
      }
      this.leftImageNew.on('load', () => {
        this.pointerEvent = 'auto';
      });
    } else if (this.sensorsNew.length == 2) {
      this.isCompare = true;
      const imageLoadPromises: Promise<any>[] = [];
      if (this.mapPane == 'right') {
        if (scene.imageType == 'tif') {
          const layerLength = Object.keys(urlData?.layer || {}).length;
          if (scene.imageType == 'tif' && layerLength === 0) {
            this.tifPopupShown = this.tifPopupShown + 1;
            if (this.tifPopupShown == 1) {
              this.resetMapNew();
              this.filterInfoVisible = false;
              const message ='not-available';
              this.mapLoad = false;
              this.spinnerService.hide();
              this.popupService
                .openPopup(CollectionPopupComponent, message, '', '40%')
                .afterClosed()
                .subscribe((result) => {
                  this.resetMapNew();
                  scene.checked = false;
                });
            }

            return;
          }
          const bounds = urlData.layer.bounds;
          const baseUrl = urlData.layer.url;
          const layerName = urlData.layer.layerName;

          this.map.fitBounds(bounds);
            let bandvalue;
            if(scene?.operatorKey == this.OPERATOR.OSK && this.selectedBands.length > 0){
            bandvalue = await firstValueFrom(
            this.getBandMinMax(taskId, scene.id, this.selectedBands));
            }
          this.rightImageNew = this.helperService.createWmsLayer(
            this.map,
            urlData,
            shapeFile,
            1000,
            false,          
            undefined,      
            this.mapPane,
            bandvalue?.bands_info        

          );

          this.rightImageNew.addTo(this.map);
        } else {
          let leafletBounds;
          if (scene?.png_footprint) {
            leafletBounds = this.convertToLeafletBounds(
              scene?.png_footprint[0]
            );
          } else {
            leafletBounds = footprintcordinates;
          }
          this.rightImageNew = L.imageOverlay(
            urlData.imageUrl,
            leafletBounds,
            { pane: this.mapPane, crossOrigin: true }
          ).addTo(this.map);
          this.map.fitBounds(leafletBounds);
          //this.handleCompareRecurrencyFeed(scene, 'right');
          this.spinnerService.hide();
        }
      } else {
        if (scene.imageType == 'tif') {
          const bounds = urlData.layer.bounds;
          const baseUrl = urlData.layer.url;
          const layerName = urlData.layer.layerName;

          this.map.fitBounds(bounds);
            let bandvalue;
            if(scene?.operatorKey == this.OPERATOR.OSK && this.selectedBands.length > 0){
            bandvalue = await firstValueFrom(
            this.getBandMinMax(taskId, scene.id, this.selectedBands));
            }
          this.leftImageNew = this.helperService.createWmsLayer(
            this.map,
            urlData,
            shapeFile,
            1000,
            false,           
            undefined,      
            this.mapPane,
            bandvalue?.bands_info     
          )
          this.leftImageNew.addTo(this.map);
        } else {
          let leafletBounds;
          if (scene?.png_footprint) {
            leafletBounds = this.convertToLeafletBounds(
              scene?.png_footprint[0]
            );
          } else {
            leafletBounds = footprintcordinates;
          }
          //this.handleCompareRecurrencyFeed(scene, 'left');
          this.leftImageNew = L.imageOverlay(
            urlData.imageUrl,
            leafletBounds,
            { pane: this.mapPane, crossOrigin: true }
          ).addTo(this.map);
          this.spinnerService.hide();
          this.map.fitBounds(leafletBounds);
        }
      }
      this.map.on('layerremove', () => {
        this.map.off('layerremove');
      });
      await Promise.all(imageLoadPromises);
      this.scenesNew.push({
        footprint: footprintlayer,
        tiffootprint: tiffootprintlayer,
        id: scene.id,
        scene: scene,
        sensorId: sensorId,
        leftImageLayer: this.mapPane == 'left' ? this.leftImageNew : null,
        rightImageLayer: this.mapPane == 'right' ? this.rightImageNew : null,
        legendScale: legendScale,
        pane: this.mapPane,
      });

      if (scene?.operatorKey == this.OPERATOR.GHG) {
        this.showMetric(this.metric, this.scenesNew[this.scenesNew.length - 1]);
      }
      let totalScenes =
        this.sensorsNew[0]?.scenes?.filter((scene) => scene.checked == true)
          .length +
        this.sensorsNew[1]?.scenes?.filter((scene) => scene.checked == true)
          .length;

      if (!this.compare && this.leftImageNew && this.rightImageNew) {
        this.compare = new SplitMap(
          this.leftImageNew,
          this.rightImageNew
        ).addTo(this.map);
        this.compare.addTo(this.map);
        if(this.compare) {
        this.compare.on('dividermove', (e: any) => {
        //this.map.dragging.disable();
        const dividerX = e.x;
        this.updateObjectVisibility(dividerX);
        this.map.dragging.enable();
         });
        }
        if (
          this.collection?.recurrencyArray.length > 0 ||
          this.collection?.opportunityList.length > 0
        ) {
          this.toggleCompareLabels();
        }
      }
    }
    if (this.annotateClicked) {
      this.getAnnotations();
    }
    if(this.isCompareRecurrency && this.leftComparisonObjectLayer && this.rightImageNew && this.needsCompareResetToCenter) {
      const mapWidth = (this.map.getSize().x);
    this.updateObjectVisibility(this.lastSliderValue === 0 ? mapWidth/2 : this.lastSliderValue);
    this.needsCompareResetToCenter = false;
    }
    this.spinnerService.hide();
  }

  handleCompareRecurrencyFeed(scene: any, pane: 'left' | 'right', infoServiceIndex?: number) {
  if (!this.isCompareRecurrency) {
    return;
  }

  const recurrencyItem = this.collection?.recurrencyArray?.find(item =>
    item?.scenes?.some(s => s?.id === scene?.id)
  );
  if (!recurrencyItem) {
    return;
  }

  const recurrencyInfoServices = Array.isArray(recurrencyItem.InfoServices)
    ? recurrencyItem.InfoServices
    : [];

  recurrencyItem.InfoServices = recurrencyInfoServices.map(
    (service, index) => ({
      ...service,
      checked: index === infoServiceIndex
    })
  );

  const infoService = recurrencyItem?.InfoServices?.[infoServiceIndex??0];

  if (!infoService) {
    return;
  }

  const insight = infoService?.insightDatas?.find(
    (sc: any) => sc.sceneId === scene.id
  );


     this.displayISNew(insight, infoService, null, true, pane);
 
}


loadInfoFeedOnCompare($event, sensor, sensorIndex, infoServiceIndex, InfoService) {
   if(this.compare) {
   this.compare.on('dividermove', (e: any) => {
    //this.map.dragging.disable();
    const dividerX = e.x;
    this.updateObjectVisibility(dividerX);
    this.map.dragging.enable();
   });
  }
  const recurrencyInfoServices = Array.isArray(
    this.collection?.recurrencyArray?.[sensorIndex]?.InfoServices
  )
    ? this.collection.recurrencyArray[sensorIndex].InfoServices
    : [];

  if (this.collection?.recurrencyArray?.[sensorIndex]) {
    this.collection.recurrencyArray[sensorIndex].InfoServices =
      recurrencyInfoServices.map((service, i) => ({
        ...service,
        checked: i === infoServiceIndex ? $event.checked : false
      }));
  }
  if($event.checked) {
       if(sensor.pane === 'left'){
      this.handleCompareRecurrencyFeed(sensor.scenes[0], 'left', infoServiceIndex);
    }
    
    if(sensor.pane === 'right'){
      this.handleCompareRecurrencyFeed(sensor.scenes[0], 'right', infoServiceIndex);
    }
     let feedId = '';
     let config: any = '';
     if (InfoService) {
      feedId = InfoService?._id;
      config = feedsConfig[feedId];   
      const key = this.getFeedKey(InfoService, config);
      const fakeEvent = { ...event, checked: true };
     this.updateFeedInfo(this.selectedCheckboxesNew[sensorIndex],fakeEvent,  key) 
    }
  } else {
    this.needsCompareResetToCenter = true;

        if(sensor.pane === 'left' && this.leftComparisonObjectLayer && this.map.hasLayer(this.leftComparisonObjectLayer)){
      this.map.removeLayer(this.leftComparisonObjectLayer);
      //this.map.removeLayer(this.leftImageNew);
      this.leftComparisonObjectLayer = null;
     this.leftFeedPanels.clear();
    }
    
    if(sensor.pane === 'right' && this.rightComparisonObjectLayer && this.map.hasLayer(this.rightComparisonObjectLayer)){
      this.map.removeLayer(this.rightComparisonObjectLayer);
      this.rightComparisonObjectLayer = null;
     this.rightFeedPanels.clear();
    }
    this.selectedCheckboxesNew[sensorIndex].InfoServices[infoServiceIndex].checked = false;
  }
}


updateObjectVisibility(dividerX: number) {
  this.lastSliderValue = dividerX;
    if (this.leftComparisonObjectLayer) {
        this.leftComparisonObjectLayer.eachLayer((layer: any) => {
            const bounds = layer.getBounds?.();
            if (bounds) {
                const layerCenter = this.map.latLngToContainerPoint(bounds.getCenter());
                layer.setStyle?.({ opacity: layerCenter.x < dividerX ? 1 : 0 });
            }
        });
    }

    if (this.rightComparisonObjectLayer) {
        this.rightComparisonObjectLayer.eachLayer((layer: any) => {
            const bounds = layer.getBounds?.();
            if (bounds) {
                const layerCenter = this.map.latLngToContainerPoint(bounds.getCenter());
                layer.setStyle?.({ opacity: layerCenter.x >= dividerX ? 1 : 0 });
            }
        });
    }
}



  async displayFootprintImageTimeseriesNew(
    scene: any,
    urlData: any,
    sensorId: any
  ) {
    this.mapPane = 'left';
    const {
      tiffootprintlayer,
      tifcordinates,
      footprintcordinates,
      footprintlayer,
    } = this.FetchCordinatesOfImage(scene, 'left');
    if (urlData?.imageUrl) {
      let leafletBounds: any;
          if (scene?.png_footprint) {
            leafletBounds = this.convertToLeafletBounds(
              scene?.png_footprint[0]
            );
          } else {
            leafletBounds = footprintcordinates;
          }

          this.leftImageNew = L.imageOverlay(urlData.imageUrl, leafletBounds, {
            pane: this.mapPane,
            opacity: 1,
            crossOrigin: true,
          }).addTo(this.map);
          this.map.fitBounds(this.leftImageNew.getBounds());
          this.spinnerService.hide();
    }
    this.scenesNew.push({
      footprint: footprintlayer,
      tiffootprint: tiffootprintlayer,
      id: scene.id,
      scene: scene,
      renderedPredictedDate: scene?.predicted_date?.split('T')[0],
      sensorId: sensorId,
      leftImageLayer: this.leftImageNew,
      rightImageLayer: this.rightImageNew,
      pane: this.mapPane,
    });
    if (scene?.operatorKey == this.OPERATOR.GHG) {
      this.showMetric(this.metric, this.scenesNew[this.scenesNew.length - 1]);
    }
  }

  async displayFootprintImageByRecurrentDataNew(
    scene: any,
    urlData: any,
    sensorId: any,
    dataList: any
  ) {
    if (this.mapPane == '') {
      this.mapPane = 'left';
    }
    const {
      tiffootprintlayer,
      tifcordinates,
      footprintcordinates,
      footprintlayer,
    } = await this.FetchCordinatesOfImage(scene, this.mapPane);
    let dateSelected: any;
    if (dataList.length == 1) {
      const imageLoadPromises: Promise<any>[] = [];
      if (urlData?.imageUrl) {
        if (scene.imageType == 'tif') {
          const bounds = urlData.layer.bounds;
          const baseUrl = urlData.layer.url;
          const layerName = urlData.layer.layerName;

          this.map.fitBounds(bounds);
            let bandvalue;
            if(scene?.operatorKey == this.OPERATOR.OSK && this.selectedBands.length > 0){
            bandvalue = await firstValueFrom(
            this.getBandMinMax(this.collection?.taskId, scene.id, this.selectedBands));
            }
          this.leftImageNew = this.helperService.createWmsLayer(
            this.map,
            urlData,
            this.imageType,
            1000,
            false,          
            undefined,      
            this.mapPane,
            bandvalue?.bands_info     

          );

          this.leftImageNew.addTo(this.map);
        } else {
          this.leftImageNew = L.imageOverlay(
            urlData.imageUrl,
            footprintcordinates,
            { pane: this.mapPane, crossOrigin: true }
          ).addTo(this.map);
        }
        this.map.fitBounds(footprintcordinates);
      }
      await Promise.all(imageLoadPromises);
      this.scenesNew.push({
        footprint: footprintlayer,
        tiffootprint: tiffootprintlayer,
        id: scene.id,
        scene: scene,
        sensorId: sensorId,
        leftImageLayer: this.leftImageNew,
        rightImageLayer: this.rightImageNew,
        pane: this.mapPane,
      });
      if (scene?.operatorKey == this.OPERATOR.GHG) {
        this.showMetric(this.metric, this.scenesNew[this.scenesNew.length - 1]);
      }
      this.selectedCheckboxesNew.forEach((date) => {
        let start_date = this.datePipe.transform(
          date.start,
          'dd/MM/yyyy',
          'UTC'
        );
        let end_date = this.datePipe.transform(date.end, 'dd/MM/yyyy', 'UTC');
        dateSelected = start_date + ' - ' + end_date;
      });
      this.filterSiteData = [];
      this.selectedSites.forEach((item) => {
        this.filterDateData.push(dateSelected);
        this.filterSiteData.push(item?.siteName);
      });
    } else if (dataList.length == 2) {
      const imageLoadPromises: Promise<any>[] = [];
      if (this.mapPane == 'right') {
        if (scene.imageType == 'tif') {
          const bounds = urlData.layer.bounds;
          const baseUrl = urlData.layer.url;
          const layerName = urlData.layer.layerName;

          this.map.fitBounds(bounds);
            let bandvalue;
            if(scene?.operatorKey == this.OPERATOR.OSK && this.selectedBands.length > 0){
            bandvalue = await firstValueFrom(
            this.getBandMinMax(this.collection?.taskId, scene.id, this.selectedBands));
            }
          this.rightImageNew = this.helperService.createWmsLayer(
            this.map,
            urlData,
            this.imageType,
            1000,
            false,           
            undefined,      
            this.mapPane,
            bandvalue?.bands_info     

          );

          this.rightImageNew.addTo(this.map);
        } else {
          this.rightImageNew = L.imageOverlay(
            urlData.imageUrl,
            footprintcordinates,
            { pane: this.mapPane, crossOrigin: true }
          ).addTo(this.map);
          this.map.fitBounds(footprintcordinates);
          this.spinnerService.hide();
        }
      } else {
        if (scene.imageType == 'tif') {
          const bounds = urlData.layer.bounds;
          const baseUrl = urlData.layer.url;
          const layerName = urlData.layer.layerName;

          this.map.fitBounds(bounds);

            let bandvalue;
            if(scene?.operatorKey == this.OPERATOR.OSK && this.selectedBands.length > 0){
            bandvalue = await firstValueFrom(
            this.getBandMinMax(this.collection?.taskId, scene.id, this.selectedBands));
            }
          this.leftImageNew = this.helperService.createWmsLayer(
            this.map,
            urlData,
            this.imageType,
            1000,
            false,          
            undefined,      
            this.mapPane,
            bandvalue?.bands_info     

          );

          this.leftImageNew.addTo(this.map);
        } else {
          this.leftImageNew = L.imageOverlay(
            urlData.imageUrl,
            footprintcordinates,
            { pane: this.mapPane, crossOrigin: true }
          ).addTo(this.map);
          this.spinnerService.hide();
          this.map.fitBounds(footprintcordinates);
        }
      }
      this.map.on('layerremove', () => {
        this.map.off('layerremove');
      });
      await Promise.all(imageLoadPromises);
      this.scenesNew.push({
        footprint: footprintlayer,
        tiffootprint: tiffootprintlayer,
        id: scene.id,
        scene: scene,
        sensorId: sensorId,
        rightImageLayer: this.rightImageNew,
        leftImageLayer: this.leftImageNew,
        pane: this.mapPane,
      });
      if (scene?.operatorKey == this.OPERATOR.GHG) {
        this.showMetric(this.metric, this.scenesNew[this.scenesNew.length - 1]);
      }
      if (!this.compare && this.leftImageNew && this.rightImageNew) {
        this.compare = new SplitMap(
          this.leftImageNew,
          this.rightImageNew
        ).addTo(this.map);
        this.toggleCompareLabels();
      }
    }
  }

  toggleCompareLabels() {
    if (this.compare) {
      this.compare.on('dividermove', (v) => {
        if (v.x < 245) {
          document.getElementById('leftLayerLabel')!.style.display = 'none';
        } else {
          document.getElementById('leftLayerLabel')!.style.display = '';
        }
        if (v.x > 698) {
          document.getElementById('rightLayerLabel')!.style.display = 'none';
        } else {
          document.getElementById('rightLayerLabel')!.style.display = '';
        }
      });
    }
  }

  recurrentSlider = false;
  createSliderData(data: any[]): { start: string; end: string }[] {
    return data.map((item) => ({
      start: item.start.split('T')[0],
      end: item.end.split('T')[0],
    }));
  }

  groupRecurrencyCollections(recurrencyArray) {
    this.recurrentSlider = true;
    let sliderDates: any;
    sliderDates = this.createSliderData(recurrencyArray);
    const groupedScenes = {};
    this.groupedScenes = {};
    this.sliderDateRangeArray = [];
    this.sliderDateRangeArray = sliderDates;
    for (const range of this.sliderDateRangeArray) {
      const key = `${range.start} to ${range.end}`;
      groupedScenes[key] = [];
    }
    for (const sensor of recurrencyArray) {
      for (const scene of sensor.scenes) {
        const sceneDate = scene.predicted_date.split('T')[0];
        for (const range of this.sliderDateRangeArray) {
          if (sceneDate >= range.start && sceneDate <= range.end) {
            const key = `${range.start} to ${range.end}`;
            groupedScenes[key].push(scene);
            break;
          }
        }
      }
    }
    return groupedScenes;
  }

  getDateArray(start: string, end: string): string[] {
    const dateArray: string[] = [];
    let currentDate = new Date(start);
    const endDate = new Date(end);
    while (currentDate <= endDate) {
      dateArray.push(currentDate.toISOString().split('T')[0]);
      currentDate.setDate(currentDate.getDate() + 1);
    }
    return dateArray;
  }

  AISdata = false;
  selectedClydeScene: any;
  groupCollections() {
    const groupedScenes = {};
    this.groupedScenes = {};
    this.sliderDateRangeArray = [];
    this.AISdata = false;
    this.recurrentSlider = false;
    let startDate = this.collection?.openWindow;
    let endDate = this.collection?.closeWindow;
    if (this.filterStart && this.filterEnd) {
      startDate = this.filterStart;
      endDate = this.filterEnd;
    }
    let dateRangeArray = this.getDateArray(startDate, endDate);
    this.sliderDateRangeArray = dateRangeArray;
    for (const date of this.sliderDateRangeArray) {
      groupedScenes[date] = [];
    }
    for (const sensor of this.collection.sensors) {
      if (sensor.checked) {
        if (
          sensor.scenes[0].operatorKey === OPERATORS.SPIRE ||
          sensor.scenes[0].operatorKey === OPERATORS.CLYDE
        ) {
          this.getAISData(sensor.scenes[0], 'display', sensor);
        } else {
          for (const scene of sensor.scenes) {
            const sceneDate = scene.predictedDate.split('T')[0];
            if (groupedScenes.hasOwnProperty(sceneDate)) {
              groupedScenes[sceneDate].push(scene);
              this.AISdata = true;
            }
          }
        }
      }
    }
    return groupedScenes;
  }

  generateSliderDateRange(end, start) {
    const dateArray: string[] = [];

    this.dateRangeArray = [];

    const toDateOnly = (d) => {
      const dt = new Date(d);
      return new Date(dt.getFullYear(), dt.getMonth(), dt.getDate());
    };

    const formatLocalDate = (d: Date) => d.toLocaleDateString('en-CA');

    const startDate = toDateOnly(start);
    const endDate = toDateOnly(end);

    const diffDays = Math.floor(
      (endDate.getTime() - startDate.getTime()) / (1000 * 60 * 60 * 24)
    );

    if (diffDays <= 10) {
      for (
        let d = new Date(startDate);
        d <= endDate;
        d.setDate(d.getDate() + 1)
      ) {
        dateArray.push(formatLocalDate(new Date(d)));
      }
    } else {
      const step = diffDays / 9;
      for (let i = 0; i < 10; i++) {
        const d = new Date(
          startDate.getTime() + i * step * 24 * 60 * 60 * 1000
        );
        dateArray.push(formatLocalDate(d));
      }
    }

    return dateArray;
  }

  groupVesselsByDate(dateRangeArray, compassDirection) {
    let vesselDirection =
      this.utilsService.getVesselDirection(compassDirection);
    this.vesselData = {};
    if (vesselDirection === 'LR') this.dateRangeArray = dateRangeArray;
    else this.dateRangeArray = dateRangeArray.reverse();

    this.sliderShow = true;
    for (const date of this.dateRangeArray) {
      this.vesselData[date] = this.historicalVesselData.filter((data) => {
        const dataDate = new Date(data.timestamp || data.location_time)
          .toISOString()
          .split('T')[0];
        return dataDate === date;
      });
    }
  }

  private getOrCreateVesselMarker(
    feature: any,
    latlng: any,
    sensor: any,
    customIcon: any,
    history: string
  ) {
    const vesselId = feature.properties?.ID;
    if (!vesselId) return L.marker(latlng);

    if (this.vesselMarkerCache.has(vesselId)) {
      const marker = this.vesselMarkerCache.get(vesselId)!;
      marker.setLatLng(latlng);

      if (sensor?.operatorKey === OPERATORS.SPIRE) {
        marker.setOpacity(history === 'historySpire' ? 0.65 : 1);
        marker.setZIndexOffset(history === 'historySpire' ? 0 : 100000);
      }

      return marker;
    }

    let marker: L.Marker;

    if (sensor?.operatorKey === OPERATORS.SPIRE) {
      const iconCanvas = createNavigationGlobalIcon(
        this.shipColor,
        'dotted'
      );

      const customIcon = L.icon({
        iconUrl: iconCanvas.toDataURL(),
        iconSize: [28, 24],
        iconAnchor: [14, 12],
      });
      const icon = customIcon;
      marker = L.marker(latlng, {
        icon,
        rotationAngle: feature.properties?.Course + 90,
        zIndexOffset: history === 'historySpire' ? 0 : 100000,
        riseOnHover: !(history === 'historySpire'),
        opacity: history === 'historySpire' ? 0.65 : 1,
      });
    } else {
      marker = L.marker(latlng, { icon: customIcon });
    }

    this.vesselMarkerCache.set(vesselId, marker);

    return marker;
  }

  displayVesselData(
    date,
    vesselData: any,
    iconUrl: any,
    sensor: any,
    isTimeseries,
    history?: string
  ) {
    let customIcon;
    if (iconUrl) {
      customIcon = L.icon({
        iconUrl: iconUrl,
        iconSize: [23, 23],
        iconAnchor: [16, 23],
        popupAnchor: [0, -32],
      });
    }
    const geoJsonLayer = (L as any)
      .geoJSON(vesselData, {
        pointToLayer: (feature, latlng) => {
          return this.getOrCreateVesselMarker(
            feature,
            latlng,
            sensor,
            customIcon,
            history ?? ''
          );
        },
        onEachFeature: (ftr, lyr) => {
          let isHistorical = sensor?.isHistorical;

          if (isTimeseries || history === 'historySpire') {
            this.attachTooltip(lyr, this.formatProperties(ftr.properties));

            if (isTimeseries) {
              lyr.on('click', () => {
                this.clickedMarker = lyr;
                if (this.clickedMarker) this.clickedMarker.closeTooltip();
                this.handleLayerClick(
                  ftr,
                  isHistorical,
                  sensor,
                  this.clickedMarker
                );
              });

              if (sensor?.operatorKey === OPERATORS.CLYDE) {
                this.clydeHistoricalLayer.push({ date, marker: lyr });
              }
              if (sensor?.operatorKey === OPERATORS.SPIRE) {
                this.spireHistoricalLayer.push({ date, marker: lyr });
              }
            } else {
              this.HistoricalLayer.push({ date, marker: lyr });
            }
          } else {
            this.HistoricalLayer.push({ date, marker: lyr });
          }
        },
      })
      .addTo(this.map);
    if (geoJsonLayer.getBounds().isValid()) {
      this.map.flyToBounds(geoJsonLayer.getBounds(), {
        padding: [50, 50],
        duration: 1,
        maxZoom: 18,
      });
    }
  }

  removeVesselData(date: any) {
    this.clydeHistoricalLayer = this.clydeHistoricalLayer.filter(
      (clydeData) => {
        if (!this.isClydeHistorical && this.timeseries) {
          if (clydeData.date >= date) {
            this.map.removeLayer(clydeData.marker);
            return false;
          }
        } else {
          if (clydeData.date <= date) {
            this.map.removeLayer(clydeData.marker);
            return false;
          }
        }
        return true;
      }
    );

    this.spireHistoricalLayer = this.spireHistoricalLayer.filter(
      (spireData) => {
        if (!this.isClydeHistorical && this.timeseries) {
          if (spireData.date >= date) {
            this.map.removeLayer(spireData.marker);
            return false;
          }
        } else {
          if (spireData.date <= date) {
            this.map.removeLayer(spireData.marker);
            return false;
          }
        }
        return true;
      }
    );

    this.spirePredictionLayer = this.spirePredictionLayer.filter((layer) => {
      if (layer.date > date) {
        if (layer.marker) {
          this.map.removeLayer(layer.marker);
        }

        if (layer.path) {
          this.map.removeLayer(layer.path);
        }

        return false;
      }

      return true;
    });
  }

  removeHistoricalData(date: any) {
    this.HistoricalLayer = this.HistoricalLayer.filter((clydeData) => {
      if (clydeData.marker !== this.clickedMarker) {
        if (clydeData.date == date) {
          this.map.removeLayer(clydeData.marker);
          return false;
        }
      }
      return true;
    });
    this.spireHistoricalLayer = this.spireHistoricalLayer.filter(
      (spireData) => {
        if (spireData.marker !== this.clickedMarker) {
          if (spireData.date == date) {
            this.map.removeLayer(spireData.marker);
            return false;
          }
        }
        return true;
      }
    );

    this.spirePredictionLayer = this.spirePredictionLayer.filter((layer) => {
      if (layer.date >= date) {
        // Remove markers
        if (layer.marker) {
          this.map.removeLayer(layer.marker);
        }

        if (layer.path) {
          this.map.removeLayer(layer.path);
        }

        return false;
      }

      return true;
    });

    if (this.predictionLayers[date]) {
      this.predictionLayers[date].clearLayers();
      this.map.removeLayer(this.predictionLayers[date]);
      delete this.predictionLayers[date];
    }

    if (this.predictionPathLayers[date]) {
      this.map.removeLayer(this.predictionPathLayers[date]);
      delete this.predictionPathLayers[date];
    }
  }

  clearAllPredictionData() {
    this.currentSliderValue = 0;
    this.currentHistoryIndex = 0;
    this.previousIndex = -1;

    Object.keys(this.predictionLayers).forEach((key) => {
      this.map.removeLayer(this.predictionLayers[key]);
    });
    this.predictionLayers = {};
    Object.keys(this.predictionPathLayers).forEach((key) => {
      this.map.removeLayer(this.predictionPathLayers[key]);
    });
    Object.values(this.pastPredictedPathLayers).forEach((layer) => {
      if (this.map.hasLayer(layer)) this.map.removeLayer(layer);
    });
    this.pastPredictedPathLayers = {};
    this.predictionPathLayers = {};
    this.predictionLastPoint = null;
  }

  getSelectedDateVessels(event: any): void {
    const index = event.value;
    let type = '';
    if (this.clickedAIS.operatorKey == this.OPERATOR.CLYDE) {
      type = 'CLYDE';
    } else {
      type = 'SPIRE';
    }

    if (index !== null && index !== undefined) {
      let currentIndex = index - 1;
      if (currentIndex > this.previousIndex) {
        for (let i = this.previousIndex + 1; i <= currentIndex; i++) {
          let convertedVessels: any = '';
          const date = this.dateRangeArray[i];
          this.removeFutureLayers(currentIndex);
          const vessels = this.vesselData[date];
          if (this.prediction) {
            convertedVessels = this.vesselData[date];
            this.displayPredictionData(date, convertedVessels);
          } else if (this.pastPrediction) {
            const date = this.dateRangeArray[currentIndex];
            const vesselData = this.vesselData[date];
            this.displayPastPrediction(date, vesselData);
            this.drawPredictionPath(date, vesselData, 'dash');
          } else {
            let convertedVessels = this.convertToGeoJSONNew(
              this.vesselData[date],
              type
            );

            let iconUrl =
              type === 'SPIRE' ? null : 'assets/images/green-cross.png';
            let historySpire: any = iconUrl === null ? 'historySpire' : null;
            let sensor =
              type === 'SPIRE'
                ? this.collection.sensors.filter(
                    (sensor) => sensor.operatorKey == this.OPERATOR.SPIRE
                  )[0]
                : this.collection.sensors.filter(
                    (sensor) => sensor.operatorKey == this.OPERATOR.CLYDE
                  )[0];
            this.displayVesselData(
              date,
              convertedVessels,
              iconUrl,
              sensor,
              false,
              historySpire
            );
          }
        }
      } else {
        for (let i = this.previousIndex; i > currentIndex; i--) {
          const date = this.dateRangeArray[i];
          this.removeHistoricalData(date);
          if (currentIndex < this.previousIndex) {
            this.lastPredictionLatLng = null; // RESET
          }
          const rebuilt = this.getLastPointForIndex(currentIndex);
          if (rebuilt) {
            this.predictionLastPoint = rebuilt;
          } else {
            // no previous date: if you have a base predicted vessel position, use it:
            if (this.predictedVesselData) {
              this.predictionLastPoint = {
                lat: Number(this.predictedVesselData.lat),
                lng: Number(this.predictedVesselData.lng),
              };
            } else {
              this.predictionLastPoint = null;
            }
          }
        }
      }
      this.previousIndex = currentIndex;
    }
  }

  removeFutureLayers(currentIndex: number) {
    this.spirePredictionLayer = this.spirePredictionLayer.filter((layer) => {
      if (layer.index > currentIndex) {
        if (layer.marker) this.map.removeLayer(layer.marker);
        if (layer.path) this.map.removeLayer(layer.path);
        return false;
      }
      return true;
    });
  }

  displayPastPrediction(date: string, vesselData: any[]) {
    // Remove old layer for this date
    if (this.predictionLayers[date]) {
      this.map.removeLayer(this.predictionLayers[date]);
    }

    const layerGroup = L.featureGroup();
    const previousDate = this.getPreviousVesselDate(date);
    if (previousDate === 'baseDate') {
      this.predictionLastPoint = {
        lat: Number(this.pastpreditedVesselData.location.LAT),
        lng: Number(this.pastpreditedVesselData.location.LON),
      };
    }

    vesselData.forEach((item) => {
      const currLat = Number(item?.location?.LAT ?? item.latitude);
      const currLng = Number(item?.location?.LON ?? item.longitude);
      let bearing;
      if (!this.predictionLastPoint) {
        this.predictionLastPoint = { lat: currLat, lng: currLng };
        return;
      }
      if (!item?.course) {
        const prevLat = Number(this.predictionLastPoint.lat);
        const prevLng = Number(this.predictionLastPoint.lng);

        bearing = bearingDeg(prevLat, prevLng, currLat, currLng);
      }
      const rotationDeg = item?.course ? item?.course + 90 : bearing + 90;

      this.predictionLastPoint = { lat: currLat, lng: currLng }; // FIXED

      // Create icon
      const iconCanvas = createNavigationGlobalIcon(
        'Yellowgreen',
        item?.course ? 'filled' : 'dotted',
        false,
        item?.course ? true : false
      );

      const icon = L.icon({
        iconUrl: iconCanvas.toDataURL(),
        iconSize: [28, 24],
        iconAnchor: [14, 12],
      });

      // Marker
      const marker = L.marker([currLat, currLng], {
        icon,
        rotationAngle: rotationDeg,
        rotationOrigin: 'center',
      }).addTo(layerGroup);
      const tooltipContent = `
      <strong>Location:</strong> ${item.locations - 1}<br>
      <strong>Timestamp(UTC):</strong> ${item.location_time}<br>
      <strong>Lng:</strong> ${currLng}<br>
      <strong>Lat:</strong> ${currLat}<br>
    `;

      this.attachTooltip(marker, tooltipContent);
    });

    // Add layer group to map
    layerGroup.addTo(this.map);

    // Store reference
    this.predictionLayers[date] = layerGroup;

    const bounds = layerGroup.getBounds();
    if (bounds && bounds.isValid()) {
      this.map.flyToBounds(bounds, {
        padding: [50, 50],
        duration: 1.5,
      });
    }
  }

  getLastPointForDate(index: number) {
    // If there is no previous date, we cannot build a correct dash
    if (index <= 0) return null;

    const prevDate = this.dateRangeArray[index - 1];
    const prevData = this.vesselData[prevDate];

    if (!prevData || prevData.length === 0) return null;

    return L.latLng(prevData[0].location.LAT, prevData[0].location.LON);
  }

  getRandomColor(): string {
    const letters = '0123456789ABCDEF';
    let color = '#';
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }

  displayPredictionData(date: string, vesselData: any[]) {
    const color = this.predictedVesselData?.color ?? 'Yellowgreen';
    if (this.predictionLayers[date]) {
      this.map.removeLayer(this.predictionLayers[date]);
      delete this.predictionLayers[date];
    }
    const layerGroup = L.featureGroup();
    this.predictionLayers[date] = layerGroup;
    const previousDate = this.getPreviousVesselDate(date);
    if (previousDate === 'baseDate') {
      this.predictionLastPoint = {
        lat: Number(this.predictedVesselData.lat),
        lng: Number(this.predictedVesselData.lng),
      };
    }
    vesselData.forEach((item) => {
      const currLat = Number(item.location.LAT);
      const currLng = Number(item.location.LON);
      if (!this.predictionLastPoint) {
        this.predictionLastPoint = { lat: currLat, lng: currLng };
        return;
      }
      const prevLat = Number(this.predictionLastPoint.lat);
      const prevLng = Number(this.predictionLastPoint.lng);

      const bearing = bearingDeg(prevLat, prevLng, currLat, currLng);
      const rotationDeg = bearing + 90;

      this.predictionLastPoint = { lat: currLat, lng: currLng }; // FIXED

      // Create icon
      const iconCanvas = createNavigationGlobalIcon(
        vesselData[0]?.locations === 7 ?'Yellowgreen' : color,
        'dotted'
      );

      const icon = L.icon({
        iconUrl: iconCanvas.toDataURL(),
        iconSize: [28, 24],
        iconAnchor: [14, 12],
      });

      // Marker
      const marker = L.marker([currLat, currLng], {
        icon,
        rotationAngle: rotationDeg,
        rotationOrigin: 'center',
      }).addTo(layerGroup);
      const tooltipContent = `
      <strong>Location:</strong> ${item.locations - 1}<br>
      <strong>Timestamp(UTC):</strong> ${item.location_time}<br>
      <strong>Lng:</strong> ${currLng}<br>
      <strong>Lat:</strong> ${currLat}<br>
    `;
      this.attachTooltip(marker, tooltipContent);
    });

    layerGroup.addTo(this.map);
    this.drawPredictionPath(date, vesselData, 'dash', vesselData[0]?.locations === 7 ?'Yellowgreen' : color);

    const bounds = layerGroup.getBounds();
    if (bounds && bounds.isValid()) {
      this.map.flyToBounds(bounds, {
        padding: [50, 50],
        duration: 1.5,
      });
    }
  }

  getPreviousVesselDate(date: string): string | null {
    const dates = Object.keys(this.vesselData);
    const index = dates.indexOf(date);

    if (index === -1) {
      return null;
    }

    if (index === 0) {
      this.lastPredictionLatLng = null;
      return 'baseDate';
    }

    return dates[index - 1];
  }

  getLastPointForIndex(index: number): { lat: number; lng: number } | null {
    if (index <= 0) return null;
    const prevDate = this.dateRangeArray[index - 1];
    if (!prevDate) return null;
    const prevData = this.vesselData[prevDate];
    if (!prevData || prevData.length === 0) return null;

    const last = prevData[prevData.length - 1];
    return {
      lat: Number(last.location.LAT),
      lng: Number(last.location.LON),
    };
  }

  drawPredictionPath(
    date: string,
    vesselData: any[],
    mode: 'dash' | 'arrow' | 'solid' = 'solid',
    color = 'Yellowgreen'
  ) {
    const latlngs = vesselData
      .filter((v) => v.location?.LAT && v.location?.LON)
      .map((v) => L.latLng(v.location.LAT, v.location.LON));
    const previousDate = this.getPreviousVesselDate(date);
    if (previousDate && previousDate !== 'baseDate') {
      const prev = this.vesselData[previousDate][0];
      latlngs.unshift(L.latLng(prev.location.LAT, prev.location.LON));
    } else if (previousDate === 'baseDate' && this.predictedVesselData) {
      latlngs.unshift(
        L.latLng(this.predictedVesselData.lat, this.predictedVesselData.lng)
      );
    }
    if (latlngs.length > 0) {
      this.lastPredictionLatLng = latlngs[latlngs.length - 1];
    }

    if (latlngs && latlngs.length < 2) return;

    if (this.predictionPathLayers[date]) {
      this.map.removeLayer(this.predictionPathLayers[date]);
    }

    const polyline = L.polyline(latlngs, {
      color,
      weight: 4,
      opacity: 1,
      dashArray: mode === 'dash' ? '10, 10' : undefined,
    }).addTo(this.map);

    if (mode === 'arrow') {
      polyline.arrowheads({
        size: '12px',
        frequency: '30px',
        fill: true,
        color,
      });
    }

    this.predictionPathLayers[date] = polyline;
  }

  getSelectedDateClydeVessels(event: any): void {
    if (this.clydevesselfootprintlayer) {
      this.map.removeLayer(this.clydevesselfootprintlayer);
      this.clydevesselfootprintlayer = null;
    }
    if (this.spirevesselfootprintlayer) {
      this.map.removeLayer(this.spirevesselfootprintlayer);
      this.spirevesselfootprintlayer = null;
    }

    if (event.value !== 0) {
      let footprintcordinates =
        this.selectedClydeScene?.footprint?.coordinates[0].map((sub) => {
          return [sub[1], sub[0]];
        });
      const randomColor = this.getRandomColor();
      this.clydevesselfootprintlayer = L.polygon(footprintcordinates, {
        color: randomColor,
        fillColor: 'none',
      }).addTo(this.map);
      this.map.fitBounds(this.clydevesselfootprintlayer.getBounds());
    }
    const index = event.value;
    if (index !== null && index !== undefined) {
      let currentIndex = index - 1;
      if (currentIndex > this.previousIndex) {
        for (let i = this.previousIndex + 1; i <= currentIndex; i++) {
          const date = this.sliderDateRangeArray[i];
          if (this.overlayClydeVessel) {
            let convertedVessels = this.convertToGeoJSONNew(
              this.overlayClydeVessel[date],
              'CLYDE'
            );
            this.displayVesselData(
              date,
              convertedVessels,
              'assets/images/orange-cross.png',
              this.collection.sensors.filter(
                (sensor) =>
                  sensor.checked && sensor.operatorKey == this.OPERATOR.CLYDE
              )[0],
              true
            );
          }
          if (this.overlaySpireVessel) {
            let convertedVessels = this.convertToGeoJSONNew(
              this.overlaySpireVessel[date],
              'SPIRE'
            );
            this.displayVesselData(
              date,
              convertedVessels,
              'assets/images/yellow-cross.png',
              this.collection.sensors.filter(
                (sensor) =>
                  sensor.checked && sensor.operatorKey == this.OPERATOR.SPIRE
              )[0],
              true
            );
          }
        }
      } else {
        for (let i = this.previousIndex; i > currentIndex; i--) {
          const date = this.sliderDateRangeArray[i];
          this.removeVesselData(date);
        }
      }

      this.previousIndex = currentIndex;
    }
  }

  getAISData(scene: any, type: any, sensor: any) {
    let refreshCount;
    let timeExpired;
    let sensorId;
    let taskId;
    if (sensor.operatorKey === OPERATORS.SPIRE) {
      sensorId = sensor.id;
      timeExpired = sensor.timeExpired;
      refreshCount =
        sensor.updatedRefreshes == 0
          ? 0
          : sensor.updatedRefreshes || sensor.noOfRefreshes;
      this.selectedClydeScene = scene;
    } else if (sensor.operatorKey === OPERATORS.CLYDE) {
      this.selectedClydeScene = scene;
      sensorId = sensor.id;
      timeExpired = sensor.timeExpired;
    }
    if (!scene.aisAvailable) {
      this.spinnerService.hide();
      const message =
        'AIS data is not available until the start of the time of interest (TOI)';
      this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
      this.spinnerService.hide();
      for (const item of this.collection.sensors) {
        if (item.id === sensor.id) {
          item.checked = false;
        }
      }
      return;
    } else if (timeExpired && sensor.operatorKey === OPERATORS.SPIRE) {
      const message =
        'The time of interest (TOI), along with the seven days of access to the historical data, has ended. Please re-task if the area of interest (AOI) continues to be the same.';
      this.spinnerService.hide();
      this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
      for (const item of this.collection.sensors) {
        if (item.id === sensor.id) {
          item.checked = false;
        }
      }
    } else if (refreshCount > 0 && sensor.operatorKey === OPERATORS.SPIRE) {
      const coordinates = scene?.footprint?.coordinates[0];
      taskId = this.collection?.taskId;
      let newCoordinates = coordinates.map((coord) => {
        return [coord[0], coord[1]];
      });
      newCoordinates = [newCoordinates];
      newCoordinates = JSON.stringify(newCoordinates);
      const encodedCoordinates = encodeURIComponent(newCoordinates);
      const startTime = encodeURIComponent(scene.openWindow);
      const endTime = encodeURIComponent(scene.closeWindow);
      const aisReq = {
        polygon: encodedCoordinates,
        startTime: startTime,
        endTime: endTime,
        type: type,
      };
      this.spinnerService.show();
      this.mapLoad = true;
      this.apiService.getAISData(aisReq, taskId).subscribe((res: any) => {
        if (res?.msg === 'failed') {
          this.spinnerService.hide();
          this.mapLoad = false;
          const message =
            'An error occurred during processing and ingestion of the request. Please try after sometime.';
          this.popupService.openPopup(
            CollectionPopupComponent,
            message,
            '',
            '40%'
          );
          for (const item of this.collection.sensors) {
            if (item.id === sensor.id) {
              item.checked = false;
            }
          }
        } else if (res?.msg === 'success') {
          if (res?.data?.vessels?.nodes?.length === 0) {
            this.spinnerService.hide();
            this.mapLoad = false;
            const message =
              'There is no AIS data in the area tasked. If there were to be vessels during the time of interest (TOI), those observations would become available when refreshed.';
            this.popupService.openPopup(
              CollectionPopupComponent,
              message,
              '',
              '40%'
            );
            for (const item of this.collection.sensors) {
              if (item.id === sensor.id) {
                item.checked = false;
              }
            }
          } else {
            this.groupVessels(res?.data, sensor);
            this.collection.sensors.map((sensor) => {
              if (sensor.operatorKey === OPERATORS.SPIRE) {
                if (sensor.updatedRefreshes) sensor.updatedRefreshes -= 1;
                else sensor.updatedRefreshes = sensor.noOfRefreshes - 1;
                if (!sensor.refreshHistory) {
                  sensor.refreshHistory = []; // Initialize if not present
                }
                sensor.refreshHistory.push(res.newRefreshHistory);
              }
            });
            this.AISdata = true;
          }
        }
      });
    } else if (sensor.operatorKey === OPERATORS.CLYDE) {
      const coordinates = scene?.footprint?.coordinates[0];
      taskId = this.collection?.taskId;
      let newCoordinates = coordinates.map((coord) => {
        return [coord[1], coord[0]];
      });
      newCoordinates = [newCoordinates];
      newCoordinates = JSON.stringify(newCoordinates);
      const encodedCoordinates = encodeURIComponent(newCoordinates);
      const startTime = encodeURIComponent(scene.openWindow);
      const endTime = encodeURIComponent(scene.closeWindow);
      const aisReq = {
        polygon: encodedCoordinates,
        startTime: startTime,
        endTime: endTime,
        type: type,
      };
      this.spinnerService.show();
      this.mapLoad = true;
      if (timeExpired) {
        const message =
          'The time of interest (TOI) has ended. Please re-task if the area of interest (AOI) continues to be the same.';
        this.spinnerService.hide();
        this.popupService.openPopup(
          CollectionPopupComponent,
          message,
          '',
          '40%'
        );
        this.spinnerService.hide();
        this.mapLoad = false;
        this.freeze = false;
        for (const item of this.collection.sensors) {
          if (item.id === sensor.id) {
            item.checked = false;
          }
        }
        return;
      }
      const input = JSON.parse(decodeURIComponent(aisReq.polygon));
      this.vesselPolygon = input[0]
        .map((pair) => pair.reverse().join(' '))
        .join(', ');
      aisReq.polygon = this.vesselPolygon;
      this.apiService.getClydeAISData(aisReq, taskId).subscribe((res: any) => {
        if (res?.msg === 'failed') {
          const message =
            'An error occurred during processing and ingestion of the request. Please try after sometime.';
          this.popupService.openPopup(
            CollectionPopupComponent,
            message,
            '',
            '40%'
          );
          this.spinnerService.hide();
          this.mapLoad = false;
          this.freeze = false;
          for (const item of this.collection.sensors) {
            if (item.id === sensor.id) {
              item.checked = false;
            }
          }
        } else if (res?.msg === 'Success') {
          if (res?.data?.length === 0) {
            this.spinnerService.hide();
            this.mapLoad = false;
            const message =
              'There is no AIS data in the area tasked. If there were to be vessels during the time of interest (TOI), those observations would become available when refreshed.';
            this.popupService.openPopup(
              CollectionPopupComponent,
              message,
              '',
              '40%'
            );
            for (const item of this.collection.sensors) {
              if (item.id === sensor.id) {
                item.checked = false;
              }
            }
          } else {
            for (const item of this.collection.sensors) {
              if (item.id === sensor.id) {
                if (!sensor.refreshHistory) {
                  sensor.refreshHistory = []; // Initialize if not present
                }
                sensor.refreshHistory.push(res.newRefreshHistory);
              }
            }
            this.groupVessels(res?.data, sensor);
            this.AISdata = true;
          }
        }
      });
    } else if (timeExpired) {
      const message =
        'The time of interest (TOI), along with the seven days of access to the historical data, has ended. Please re-task if the area of interest (AOI) continues to be the same.';
      this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
      this.spinnerService.hide();
      for (const item of this.collection.sensors) {
        if (item.id === sensor.id) {
          item.checked = false;
        }
      }
      this.spinnerService.hide();
    } else {
      const message =
        'Your refresh count has been exhausted. Please re-task to continue receiving latest AIS information.';
      this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
      this.spinnerService.hide();
      for (const item of this.collection.sensors) {
        if (item.id === sensor.id) {
          item.checked = false;
        }
      }
    }
  }

  groupVessels(responseData: any, sensor: any) {
    let vessels: any;
    if (sensor.operatorKey === OPERATORS.SPIRE) {
      this.overlaySpireVessel = {};
      vessels = responseData?.vessels?.nodes;
      for (const date of this.sliderDateRangeArray) {
        this.overlaySpireVessel[date] = vessels.filter((data) => {
          const dataDate = new Date(data.lastPositionUpdate.timestamp)
            .toISOString()
            .split('T')[0];
          return dataDate === date;
        });
      }
    }
    if (sensor.operatorKey === OPERATORS.CLYDE) {
      this.overlayClydeVessel = {};
      vessels = responseData;
      for (const date of this.sliderDateRangeArray) {
        this.overlayClydeVessel[date] = vessels.filter((data) => {
          const dataDate = new Date(data.timestamp).toISOString().split('T')[0];
          return dataDate === date;
        });
      }
    }
    this.spinnerService.hide();
    this.mapLoad = false;
  }

  resetSelectedVessels(
    isButtonClicked: any,
    isRemoveHistrorical = true,
    ischangerefreshes = false
  ) {
    this.sliderView = false;
    this.sliderShow = false;
    this.previousIndex = -1;
    if (this.clickedMarker && isButtonClicked) {
      this.map.removeLayer(this.clickedMarker);
      this.clickedMarker = null;
      this.isClydeHistorical = false;
    }
    this.clydeVesselLayer = null;
    this.HistoricalLayer.forEach((clydeData) => {
      this.map.removeLayer(clydeData.marker);
    });
    this.HistoricalLayer = [];
    let sensor = this.clickedAIS;
    let type = '';
    if (
      sensor?.operatorKey == this.OPERATOR.CLYDE ||
      (sensor?.operatorKey == this.OPERATOR.CLYDE && this.timeseries)
    ) {
      type = 'CLYDE';
      if (isRemoveHistrorical) {
        this.clydeHistoricalLayer.map((layer) => {
          if (this.clickedMarker != layer.marker) {
            this.map.removeLayer(layer.marker);
          }
          this.clydeHistoricalLayer = [];
        });
      }
    }
    if (
      sensor?.operatorKey == this.OPERATOR.SPIRE ||
      (sensor?.operatorKey == this.OPERATOR.SPIRE && this.timeseries)
    ) {
      type = 'SPIRE';
      if (isRemoveHistrorical) {
        this.spireHistoricalLayer.map((layer) => {
          if (this.clickedMarker != layer.marker) {
            this.map.removeLayer(layer.marker);
          }
          this.spireHistoricalLayer = [];
        });
      }
    }
    if (!this.timeseries) {
      sensor?.scenes?.forEach((scene) => {
        if (scene.checked == true) {
          if (type == 'CLYDE') {
            this.displayClydeAISNew(scene, this.clydeData, sensor, type);
          } else {
            this.spireData.ischangerefreshes = ischangerefreshes;
            this.displayClydeAISNew(scene, this.spireData, sensor, type);
          }
          this.sliderShow = false;
          this.filterObject = undefined;
          this.sceneFilterData = false;
        }
      });
    }
    if (this.timeseries) {
      this.sliderView = true;
      let dateRangeArray = this.getDateArray(
        this.collection?.openWindow,
        this.collection?.closeWindow
      );
      this.sliderDateRangeArray = dateRangeArray;
      this.clydeHistoricalLayer.map((layer) => {
        if (this.clickedMarker != layer.marker) {
          this.map.removeLayer(layer.marker);
        }
      });
      this.spireHistoricalLayer.map((layer) => {
        if (this.clickedMarker != layer.marker) {
          this.map.removeLayer(layer.marker);
        }
      });
      for (let i = this.previousIndex + 1; i <= this.currentSliderValue; i++) {
        const date = this.sliderDateRangeArray[i];
        if (this.overlayClydeVessel) {
          let convertedVessels = this.convertToGeoJSONNew(
            this.overlayClydeVessel[date],
            'CLYDE'
          );
          this.displayVesselData(
            date,
            convertedVessels,
            'assets/images/orange-cross.png',
            this.collection.sensors.filter(
              (sensor) =>
                sensor.checked && sensor.operatorKey == this.OPERATOR.CLYDE
            )[0],
            true
          );
        }
        if (this.overlaySpireVessel) {
          let convertedVessels = this.convertToGeoJSONNew(
            this.overlaySpireVessel[date],
            'SPIRE'
          );
          this.displayVesselData(
            date,
            convertedVessels,
            'assets/images/yellow-cross.png',
            this.collection.sensors.filter(
              (sensor) =>
                sensor.checked && sensor.operatorKey == this.OPERATOR.SPIRE
            )[0],
            true
          );
        }
      }
    }
    this.isClydeHistorical = false;
    if (this.clickedMarker) this.clickedMarker.closeTooltip();
    this.clearAllPredictionData();
    this.clearAllFeedPanels();
  }

  clearAllFeedPanels() {
    if (!this.feedPanels || this.feedPanels.size === 0) return;
    this.feedPanels = new Map();
    this.rebuildCombined();
 } 

  updateFeedsStatus(
    sensorIndex,
    feedDetails,
    feedDetailsindex,
    itemType: 'superResolutions' | 'indicesDetails'
  ) {
    if (
      this.collection.sensors[sensorIndex].id == feedDetails.sensorId &&
      feedDetails?.products?.length > 0
    ) {
      this.collection.sensors[sensorIndex][itemType][
        feedDetailsindex
      ].isDisable = false;
    } else {
      this.collection.sensors[sensorIndex][itemType][
        feedDetailsindex
      ].isDisable = true;
      this.collection.sensors[sensorIndex][itemType][feedDetailsindex].loadTif =
        false;
    }
  }

  resetFeedsStatus(collection: any) {
    collection.sensors.map((sensor) => {
      sensor?.InfoServices?.map((infoService) => {
        infoService.checked = false;
        infoService.isDisable = true;
      });
    });

    collection.sensors.map((sensor) => {
      sensor?.indicesDetails?.map((indicesDetails) => {
        indicesDetails.checked = false;
        indicesDetails.isDisable = true;
        indicesDetails.loadTif = false;
      });
    });

    collection.sensors.map((sensor) => {
      sensor?.superResolutions?.map((superResolutions) => {
        superResolutions.checked = false;
        superResolutions.isDisable = true;
      });
    });
  }
  showNoPreview(event, scenes?: any) {
    if (scenes?.isNonImagery) {
      if (scenes.operatorKey === 'USL' && !scenes.s_band && !scenes.x_band)
        this.handleOptionError(
          event,
          `We cannot display or download the image as the delivery was made to your storage. You can access the image via your storage.`
        );
      else
        this.handleOptionError(
          event,
          `The observation delivered can only be downloaded now and cannot be visualised on the map here.`
        );
    } else if (!scenes?.isNonImagery) {
      this.handleOptionError(
        event,
        `The imagery delivered can only be downloaded now and cannot be visualised on the map here.`
      );
    }
  }

  private handleToggleFlow(collection, collectionIndex, sensorIndex, event, sensor?) {
  if (!this.showDailyRecurrencyCheckboxes) {
    this.handleSensorToggleWithAbort(collection, collectionIndex, sensorIndex, event);
  } else if (!this.showSubDailyList) {
    this.toggleRecurrentSensorNew(collectionIndex, sensorIndex, event, sensor);
  } else {
    this.toggleSubDailyRecurrentSensorNew(sensorIndex, sensor, event);
  }
 }

  private handlePostPopupFlow(collection, collectionIndex, sensorIndex, event, sensor?) {
   if (this.selectedBands.length === 0 && this.imageType === 'tif' && this.collection.sensors[sensorIndex].operatorKey === this.OPERATOR.OSK) {
    this.openBandSelectorOnSensorChange(collection, collectionIndex, sensorIndex, event, sensor);
   } else {
    this.handleToggleFlow(collection, collectionIndex, sensorIndex, event, sensor);
   }
 }



  handleSensorChange(collection, collectionIndex, sensorIndex, event, sensor?) {

  if(!event.checked && this.collection?.recurrencyArray[sensor?.index]){
   const infoServices = Array.isArray(
    this.collection?.recurrencyArray?.[sensor?.index]?.InfoServices
   )
    ? this.collection.recurrencyArray[sensor.index].InfoServices
    : [];

   infoServices.forEach(service => {
    service.checked = false;
    });
   } 
  const currentSensor = collection && collection?.sensors[sensorIndex];
  const hasSkipPreviewNotPending =
    currentSensor?.scenes?.some(
      (scene) =>
        (scene.skipPreview === true || !scene.footprint) &&
        !this.isScenePending(scene)
    ) ?? false;

  const isOSKTif =
    event.checked &&
    currentSensor?.operatorKey === this.OPERATOR.OSK
  if (hasSkipPreviewNotPending && isOSKTif) {

    const message = `Not all scenes on this project can be visualised.
    Clicking on scene's checkboxes will identify those that cannot be visualised.
    All scenes can still be downloaded individually or at the project level.`;

    const dialogRef = this.popupService.openPopup(
      CollectionPopupComponent,
      message,
      '',
      '40%'
    );

    dialogRef.afterClosed().subscribe(() => {
      this.handlePostPopupFlow(collection, collectionIndex, sensorIndex, event, sensor);
    });

    return; 
  }
  if (isOSKTif && this.imageType === 'tif' && this.selectedBands.length === 0) {
    this.openBandSelectorOnSensorChange(collection, collectionIndex, sensorIndex, event, sensor);
    return;
  }
  this.handleToggleFlow(collection, collectionIndex, sensorIndex, event, sensor);
}


  handleSceneChange(collection, collectionIndex, sensorIndex, scenesIndex, event, scene?, sensor?) {
  if(!event.checked && this.collection?.recurrencyArray[sensor?.index]){
   const infoServices = Array.isArray(
    this.collection?.recurrencyArray?.[sensor?.index]?.InfoServices
   )
    ? this.collection.recurrencyArray[sensor.index].InfoServices
    : [];

   infoServices.forEach(service => {
    service.checked = false;
  });

   } 
    if(event.checked && this.collection.sensors[sensorIndex].operatorKey === this.OPERATOR.OSK && this.imageType === 'tif' && this.selectedBands.length === 0) {
      collection.sensors[sensorIndex].scenes[scenesIndex].checked = event.checked; 
      this.openBandSelectorOnScenChange(collection, collectionIndex, sensorIndex, scenesIndex, event, scene);
    } else {
    if(!this.showDailyRecurrencyCheckboxes) {
    this.toggleSceneNew(collection, collectionIndex, sensorIndex, scenesIndex, event);
    } else if(this.showDailyRecurrencyCheckboxes && !this.showSubDailyList) {
        this.toggleRecurrentSceneNew(collection, collectionIndex, sensorIndex, scenesIndex, scene, event)
      } else if(this.showDailyRecurrencyCheckboxes && this.showSubDailyList) {
        this.toggleRecurrentSubdailySceneNew(collection, collectionIndex, sensorIndex, scenesIndex, event);
      }
   }
  }

  handleSensorToggleWithAbort(collection, collectionIndex, sensorIndex, event) {
    collection.sensors[sensorIndex]?.InfoServices?.map((infoService) => {
      infoService.checked = false;
    });
    
    if (
      this.opManager?.isOperationRunning &&
      !event.checked &&
      collection.sensors.length > 1
    ) {
      return this.showAbortRetainPopup().then((shouldAbort) => {
        if (shouldAbort) {
          this.opManager.abortOperation();
          collection.sensors[sensorIndex].checked = false;
          this.resetAllFeedPanels();
          this.clearAllPredictionData();
          this.clearFilteredLayerAndRestore(true);
          this.resetMapNew();
          this.progressing = false;
          this.spinnerService.hide();
          return this.toggleSensorNew(
            collection,
            collectionIndex,
            sensorIndex,
            event
          );
        } else {
          collection.sensors[sensorIndex].checked = true;
        }
      });
    }
    return this.toggleSensorNew(
      collection,
      collectionIndex,
      sensorIndex,
      event
    );
  }

  openBandSelectorOnSensorChange(collection, collectionIndex, sensorIndex, event, sensor? ) {
  const dialogRef = this.dialog.open(BandSelectorComponent, {
    width: '500px',
    maxHeight: '80vh',
    disableClose: true,
    data: { selectedBands: this.selectedBands, operatorKey: OPERATORS.OSK }
  });

  dialogRef.afterClosed().subscribe(result => {
    if (result === 'cancel' && result) {
      collection.sensors[sensorIndex].checked = false;
      collection.sensors[sensorIndex].scenes?.map((scene) => {scene.checked = false; });
      
    } else if(result === 'clear_bands') {
      this.selectedBands = [];
      collection.sensors[sensorIndex].checked = false;
      collection.sensors[sensorIndex].scenes?.map((scene) => {scene.checked = false; });
      this.resetMapNew();
     } else {
      this.selectedBands = result??[];
      if(!this.showDailyRecurrencyCheckboxes){
      this.handleSensorToggleWithAbort(collection, collectionIndex, sensorIndex, event);
      } else if(this.showDailyRecurrencyCheckboxes &&!this.showSubDailyList) {
        this.toggleRecurrentSensorNew(collectionIndex,sensorIndex, event, sensor)
      } else if(this.showDailyRecurrencyCheckboxes && this.showSubDailyList) {
        this.toggleSubDailyRecurrentSensorNew(sensorIndex, sensor, event )
        }
       }
     });
   }

  openBandSelectorOnScenChange(collection, collectionIndex, sensorIndex, scenesIndex, event, scene? ) {
    const dialogRef = this.dialog.open(BandSelectorComponent, {
    width: '500px',
    maxHeight: '80vh',
    disableClose: true,
    data: { selectedBands: this.selectedBands, operatorKey: OPERATORS.OSK }
  });

  dialogRef.afterClosed().subscribe(result => {
    if (result === 'cancel' && result) {
      collection.sensors[sensorIndex].scenes[scenesIndex].checked = false;
    } else if(result === 'clear_bands') {
      this.selectedBands = [];
      collection.sensors[sensorIndex].scenes[scenesIndex].checked = false;
      this.resetMapNew();
    } else {
      this.selectedBands = result??[];
      if(!this.showDailyRecurrencyCheckboxes){
      this.toggleSceneNew(collection, collectionIndex, sensorIndex, scenesIndex, event);
      } else if(this.showDailyRecurrencyCheckboxes && !this.showSubDailyList) {
        this.toggleRecurrentSceneNew(collection, collectionIndex, sensorIndex, scenesIndex, scene, event)
      } else if(this.showDailyRecurrencyCheckboxes && this.showSubDailyList) {
        this.toggleRecurrentSubdailySceneNew(collection, collectionIndex, sensorIndex, scenesIndex, event);
       }
      }
    });
  }

  private isScenePending(scene: any): boolean {
  return (
    (
      (
        (scene.operatorKey === OPERATORS.SPIRE ||
         scene.operatorKey === OPERATORS.CLYDE) &&
        !scene.aisAvailable &&
        scene.id
      ) ||
      (
        scene.operatorKey !== OPERATORS.SPIRE &&
        scene.operatorKey !== OPERATORS.CLYDE &&
        !scene.id
      )
    ) &&
    scene.status !== 'failed'
  );
}


  toggleSensorNew(collection, collectionIndex, sensorIndex, event) {
    this.resetAllFeedPanels();
    this.clearAllPredictionData();
    this.clearFilteredLayerAndRestore(true);
    this.unSubscribeAPI();
    this.opManager.completeOperation();
    if (
      collection.sensors?.length == 1 &&
      collection.sensors.filter((sensor) => sensor.checked).length == 1
    ) {
      this.resetMapNew();
      this.clickedAIS = '';
      this.spireData = null;
      this.removeSpireVesselLayer();
    }
    if (event.checked) {

      if (
        this.collections[collectionIndex]?.sensors[sensorIndex]
          ?.valueAddedOption?.length > 0
      ) {
        this.collections[collectionIndex].sensors[
          sensorIndex
        ].valueAddedOption.map((valueAddedOption) => {
          valueAddedOption.checked = false;
        });
      }

      // Check if there are scenes with skipPreview/no footprint that are NOT pending
      const hasSkipPreviewNotPending =
        collection.sensors[sensorIndex]?.scenes?.some(
          (scene) =>
            (scene.skipPreview === true || !scene.footprint) &&
            !this.isScenePending(scene)
        ) ?? false;
      if (hasSkipPreviewNotPending &&  this.collection.sensors[sensorIndex].operatorKey !== this.OPERATOR.OSK) {
        let message = `Not all scenes on this project can be visualised. Clicking on scene's
                        checkboxes will identify those that cannot be visualised. All scenes can
                        still be downloaded individually or at the project level.`;
        this.popupService.openPopup(
          CollectionPopupComponent,
          message,
          '',
          '40%'
        );
      }
    }
    if (this.getCollectionSub) {
      this.getCollectionSub.unsubscribe();
      this.spinnerService.hide();
    }

    if (collection.sensors[sensorIndex].scenes?.length > 0) {
      collection.sensors[sensorIndex].scenes.forEach((scene) => {
        if (
          ((scene.operatorKey === OPERATORS.SPIRE ||
            scene.operatorKey === OPERATORS.CLYDE) &&
            !scene.aisAvailable) ||
          !scene.id ||
          scene?.status === 'failed' ||
          collection.sensors[sensorIndex]?.status === 'archived' ||
          this.timeseries ||
          (collection.sensors[sensorIndex]?.operatorKey ===
            OPERATORS.SATELLOGIC &&
            scene?.sceneName?.includes('L1D'))
        )
          scene.checked = false;
      });
    }

    collection.sensors[sensorIndex].scenes.map((scene) => {
      scene.imageType = this.imageType;
      scene.tif = this.imageType == 'tif' ? true : false;
    });
    if (collection.sensors[sensorIndex].scenes.length === 1) {
      this.sceneSelected = collection.sensors[sensorIndex]?.scenes[0]?.id;
    }
    if (
      collection.sensors[sensorIndex]?.scenes?.length > 1 &&
      collection.sensors[sensorIndex]?.InfoServices?.length === 1
    )
      this.combinedScenes = event.checked;
    this.indiceType = 'display';
    this.fail = 0;
    this.tifPopupShown = 0;
    let count = 0;
    this.newTaskButtonClicked = false;
    if (this.displayedIS) {
      this.displayedIS = null;
    }
    this.isClydeHistorical = false;
    this.HistoricalLayer.forEach((HisLayer) => {
      this.map.removeLayer(HisLayer.marker);
    });
    this.HistoricalLayer = [];
    this.removeDynamicLayer();
    if (this.timeseries) {
      this.currentHistoryIndex = 0;
      this.previousIndex = -1;
      this.currentSliderValue = 0;
      if (event.checked) {
        this.resetMapNew();
        this.isClydeHistorical = false;
        this.sliderShow = false;
        collection.sensors[sensorIndex].checked = event?.checked;
        this.sensorSelected = collection.sensors[sensorIndex].id;
        if (collection?.recurrencyArray?.length > 1 && !this.spire) {
          this.groupedScenes = this.groupRecurrencyCollections(
            collection?.recurrencyArray
          );
        } else {
          this.groupedScenes = this.groupCollections();
        }
      } else {
        if (collection?.recurrencyArray?.length > 1 && !this.spire) {
          this.groupedScenes = this.groupRecurrencyCollections(
            collection?.recurrencyArray
          );
        } else {
          this.groupedScenes = this.groupCollections();
        }
        if (
          collection.sensors[sensorIndex]?.operatorKey == this.OPERATOR.SPIRE
        ) {
          this.overlaySpireVessel = null;
        }
        if (
          collection.sensors[sensorIndex]?.operatorKey == this.OPERATOR.CLYDE
        ) {
          this.overlayClydeVessel = null;
        }
        this.resetMapNew();
        this.isSitechanged = false;
      }
    } else {
      this.observationChecked = true;
      if (event.checked) {
        this.observationEnabled = true;
      } else {
        this.observationEnabled = false;
      }
      if (event.checked) {
        this.collection.sensors[sensorIndex]?.indicesDetails?.map(
          (indicesDetails) => {
            indicesDetails.checked = false;
            indicesDetails.loadTif = false;
          }
        );
        this.removeISLayers();
        this.removeIndices();
        this.removeSuperResolutions();
        this.annotateClicked = false;
        this.newTaskButtonClicked = false;
        this.removeAnnotationMarkers();
        this.pointerEvent = 'none';
        if (
          this.sensorsNew.findIndex(
            (sensor) => sensor.id == collection.sensors[sensorIndex].id
          ) == -1
        ) {
          this.sensorsNew.push(collection.sensors[sensorIndex]);
          if (this.mapPane == 'left') {
            this.mapPane = 'right';
          } else {
            this.mapPane = 'left';
          }
        } else {
          if (this.mapPane == '') {
            this.mapPane = 'left';
          }
        }
        if (collection.sensors[sensorIndex].scenes.length == 0) {
          this.spinnerService.hide();
        }

        collection.sensors[sensorIndex].scenes.forEach((scene: any) => {
          if (
            this.scenesNew.findIndex((sceneNew) => sceneNew.id == scene.id) ==
            -1
          ) {
            if (
              scene?.id &&
              scene?.status !== 'failed' &&
              !scene?.sceneName?.includes('L1D')
            ) {
              this.sceneId = scene?.id;
              scene.checked = true;
              const sensorObj = {
                sensorId: collection.sensors[sensorIndex].id,
                sceneId: scene?.id,
                action: 'sensor',
                fileType: scene.imageType,
              };
              if (
                collection.sensors[sensorIndex].scenes[0].operatorKey ==
                  this.OPERATOR.CLYDE ||
                collection.sensors[sensorIndex].scenes[0].operatorKey ==
                  this.OPERATOR.SPIRE
              ) {
                if (
                  collection.sensors[sensorIndex].scenes[0]?.operatorKey ===
                    this.OPERATOR.CLYDE &&
                  collection.sensors[sensorIndex].status === 'canceled'
                ) {
                  const message =
                    'The user has cancelled the task, and the data is unavailable';
                  this.popupService.openPopup(
                    WarningPopupComponent,
                    message,
                    '',
                    '40%'
                  );
                }
                this.fetchAISDataFromServer(collection, sensorIndex, scene);
              } else if (
                collection.sensors[sensorIndex].scenes[0].operatorKey ==
                this.OPERATOR.USL
              ) {
                this.mapLoad = false;
                this.spinnerService.hide();
                scene.pane = 'left';
                if (!scene?.s_band && !scene?.x_band && scene?.usl_footprint) {
                  scene.x_band = scene?.usl_footprint;
                }
                this.displayRFBandNew(
                  scene,
                  collection.sensors[sensorIndex].id,
                  this.selectedBand
                );
              } else if (
                collection.sensors[sensorIndex].scenes[0].operatorKey ==
                this.OPERATOR.LBAND
              ) {
                this.mapLoad = false;
                this.spinnerService.hide();
                scene.pane = 'left';
                this.displayRFSignalsNew(
                  scene,
                  collection.sensors[sensorIndex].id,
                  this.signalSelected
                );
              } else if (!scene?.sceneName?.includes('L1D')) {
                this.tifPopupShown = 0;
                this.fetchImageFromServer(collection, sensorObj, scene);
              }
            }
          }
        });
        if (this.clydeData && this.clickedAIS?.operatorKey == OPERATORS.CLYDE) {
          let selectedAISSensor = collection.sensors.filter((snsr) => {
            return snsr.operatorKey == OPERATORS.CLYDE;
          })[0];
          this.displayClydeAISNew(
            selectedAISSensor.scenes[0],
            this.clydeData,
            selectedAISSensor,
            'CLYDE'
          );
        }
        if (this.spireData && this.clickedAIS?.operatorKey == OPERATORS.SPIRE) {
          let selectedAISSensor = collection.sensors.filter((snsr) => {
            return snsr.operatorKey == OPERATORS.SPIRE;
          })[0];
          this.displayClydeAISNew(
            selectedAISSensor.scenes[0],
            this.spireData,
            selectedAISSensor,
            'SPIRE'
          );
        }

        if (this.collection.sensors[sensorIndex].indicesDetails?.length > 0) {
          const scenesArray = this.collection.sensors[sensorIndex].scenes;
          const checkedScenes = scenesArray.filter(
            (scene) => scene.checked === true
          );
          count = checkedScenes.length;
          const checkedSensors = this.collection.sensors.filter(
            (scene) => scene.checked === true
          );
          const selectedScenes: any = [],
            sceneList: any = [];
          for (const sensors of checkedSensors) {
            for (const item of sensors.scenes) {
              if (item.checked) {
                selectedScenes.push(item);
              }
            }
          }
          if (
            this.collection.sensors[0].operatorKey == this.OPERATOR.AXELSPACE ||
            this.collection.sensors[0].operatorKey == this.OPERATOR.AZISTA
          ) {
            for (const sensors of this.collection.sensors) {
              for (const item of sensors.scenes) {
                if (item.checked) {
                  sceneList.push(item);
                }
              }
            }
          }

          if (
            (count != 2 &&
              this.collection.sensors[0].operatorKey !==
                this.OPERATOR.AXELSPACE) ||
            this.collection.sensors[0].operatorKey !== this.OPERATOR.AZISTA
          ) {
            for (const sensors of this.collection.sensors) {
              for (const item of sensors.scenes) {
                if (item.checked) {
                  sceneList.push(item);
                }
              }
            }
          }
          if (sceneList?.length > 0) {
            this.sceneSelected = sceneList[0]?.id;
            this.selectedSceneNew = sceneList[0];
          }
        }
        if (
          this.collection.sensors[sensorIndex].indicesDetails?.length > 0 &&
          this.sensorsNew.length == 1
        ) {
          if (
            this.collection.sensors[0].operatorKey == this.OPERATOR.AXELSPACE ||
            this.collection.sensors[0].operatorKey == this.OPERATOR.AZISTA
          ) {
            let selectedScenes = this.collection.sensors[
              sensorIndex
            ].scenes.filter((scene) => scene.checked == true);
            if (selectedScenes.length > 0) {
              this.collection.sensors[sensorIndex].indicesDetails?.map(
                (indicesDetails, indicesDetailsindex) => {
                  this.updateFeedsStatus(
                    sensorIndex,
                    indicesDetails,
                    indicesDetailsindex,
                    'indicesDetails'
                  );
                }
              );
            }
          } else {
            let selectedScenes = this.collection.sensors[
              sensorIndex
            ].scenes.filter((scene) => scene.checked == true);
            if (selectedScenes.length == 1) {
              this.collection.sensors[sensorIndex].indicesDetails?.map(
                (indicesDetails, indicesDetailindex) => {
                  this.updateFeedsStatus(
                    sensorIndex,
                    indicesDetails,
                    indicesDetailindex,
                    'indicesDetails'
                  );
                }
              );
            } else {
              this.collection.sensors.map((sensor) => {
                sensor.InfoServices.map((infoService) => {
                  infoService.isDisable = true;
                  infoService.checked = false;
                });
              });
              this.removeISLayers();
            }
          }
        } else {
          this.collection.sensors.map((sensor) => {
            sensor.indicesDetails?.map((indicesDetail) => {
              indicesDetail.isDisable = true;
              indicesDetail.checked = false;
              indicesDetail.loadTif = false;
            });
          });
        }
        if (
          this.collection.sensors[sensorIndex]?.superResolutions?.length > 0
        ) {
          const scenesArray = this.collection.sensors[sensorIndex].scenes;
          const checkedScenes = scenesArray.filter(
            (scene) => scene.checked === true
          );
          count = checkedScenes.length;
          const checkedSensors = this.collection.sensors.filter(
            (scene) => scene.checked === true
          );
          const selectedScenes: any = [],
            sceneList: any = [];
          for (const sensors of checkedSensors) {
            for (const item of sensors.scenes) {
              if (item.checked) {
                selectedScenes.push(item);
              }
            }
          }
          if (
            this.collection.sensors[0].operatorKey == this.OPERATOR.AXELSPACE ||
            this.collection.sensors[0].operatorKey == this.OPERATOR.AZISTA
          ) {
            for (const sensors of this.collection.sensors) {
              for (const item of sensors.scenes) {
                if (item.checked) {
                  sceneList.push(item);
                }
              }
            }
          }
          if (
            count != 2 &&
            (this.collection.sensors[0].operatorKey !==
              this.OPERATOR.AXELSPACE ||
              this.collection.sensors[0].operatorKey !== this.OPERATOR.AZISTA)
          ) {
            for (const sensors of this.collection.sensors) {
              for (const item of sensors.scenes) {
                if (item.checked) {
                  sceneList.push(item);
                }
              }
            }
          }
        }
        if (
          this.collection.sensors[sensorIndex]?.superResolutions?.length > 0 &&
          this.sensorsNew.length == 1
        ) {
          if (
            this.collection.sensors[0].operatorKey == this.OPERATOR.AXELSPACE ||
            this.collection.sensors[0].operatorKey == this.OPERATOR.AZISTA
          ) {
            let selectedScenes = this.collection.sensors[
              sensorIndex
            ].scenes.filter((scene) => scene.checked == true);
            if (
              this.collection.sensors[0].scenes.length == selectedScenes.length
            ) {
              this.collection.sensors[sensorIndex].superResolutions?.map(
                (superResolution, superResolutionsindex) => {
                  this.updateFeedsStatus(
                    sensorIndex,
                    superResolution,
                    superResolutionsindex,
                    'superResolutions'
                  );
                }
              );
            }
          } else {
            let selectedScenes = this.collection.sensors[
              sensorIndex
            ].scenes.filter((scene) => scene.checked == true);
            if (selectedScenes.length == 1) {
              this.collection.sensors[sensorIndex].superResolutions?.map(
                (superResolutions, superResolutionsindex) => {
                  this.updateFeedsStatus(
                    sensorIndex,
                    superResolutions,
                    superResolutionsindex,
                    'superResolutions'
                  );
                }
              );
            } else {
              this.collection.sensors.map((sensor) => {
                sensor.superResolutions.map((superResolutions) => {
                  superResolutions.isDisable = true;
                  superResolutions.checked = false;
                });
              });
            }
          }
        } else {
          this.collection.sensors.map((sensor) => {
            sensor.superResolutions?.map((superResolutions) => {
              superResolutions.isDisable = true;
              superResolutions.checked = false;
            });
          });
        }

        if (this.collection.sensors[sensorIndex].InfoServices.length > 0) {
          const scenesArray = this.collection.sensors[sensorIndex].scenes;
          const checkedScenes = scenesArray.filter(
            (scene) => scene.checked === true
          );
          const checkedInfo = this.collection.sensors[
            sensorIndex
          ].InfoServices.filter((info) => info.checked === true);
          count = checkedScenes.length;
          const checkedSensors = this.collection.sensors.filter(
            (scene) => scene.checked === true
          );
          const selectedScenes: any = [],
            sceneList: any = [];
          for (const sensors of checkedSensors) {
            for (const item of sensors.scenes) {
              if (item.checked) {
                selectedScenes.push(item);
              }
            }
          }
          if (
            this.collection.sensors[0].operatorKey == this.OPERATOR.AXELSPACE ||
            this.collection.sensors[0].operatorKey == this.OPERATOR.AZISTA
          ) {
            for (const sensors of this.collection.sensors) {
              for (const item of sensors.scenes) {
                if (item.checked) {
                  sceneList.push(item);
                }
              }
            }
          }
          if (
            count != 2 &&
            (this.collection.sensors[0].operatorKey !==
              this.OPERATOR.AXELSPACE ||
              this.collection.sensors[0].operatorKey !== this.OPERATOR.AZISTA)
          ) {
            for (const sensors of this.collection.sensors) {
              for (const item of sensors.scenes) {
                if (item.checked) {
                  sceneList.push(item);
                }
              }
            }
          }
        }
        if (
          this.collection.sensors[sensorIndex].InfoServices.length > 0 &&
          this.sensorsNew.length == 1
        ) {
          if (
            this.collection.sensors[0].operatorKey == this.OPERATOR.AXELSPACE ||
            this.collection.sensors[0].operatorKey == this.OPERATOR.AZISTA
          ) {
            let selectedScenes = this.collection.sensors[
              sensorIndex
            ].scenes.filter((scene) => scene.checked == true);
            if (
              this.collection.sensors[0].scenes.length == selectedScenes.length
            ) {
              this.collection.sensors[sensorIndex].InfoServices.map(
                (infoService, infoserviceindex) => {
                  if (
                    this.collection.sensors[sensorIndex].id ==
                      infoService.sensorId &&
                    infoService?.insightDatas?.length > 0
                  ) {
                    this.collection.sensors[sensorIndex].InfoServices[
                      infoserviceindex
                    ].isDisable = false;
                  } else {
                    this.collection.sensors[sensorIndex].InfoServices[
                      infoserviceindex
                    ].isDisable = true;
                  }
                }
              );
            }
          } else {
            let selectedScenes = this.collection.sensors[
              sensorIndex
            ].scenes.filter((scene) => scene.checked == true);

            if (selectedScenes.length == 1) {
              this.collection.sensors[sensorIndex].InfoServices.map(
                (infoService, infoserviceindex) => {
                  if (
                    this.collection.sensors[sensorIndex].id ==
                      infoService.sensorId &&
                    infoService?.insightDatas?.length > 0
                  ) {
                    this.collection.sensors[sensorIndex].InfoServices[
                      infoserviceindex
                    ].isDisable = false;
                  } else {
                    this.collection.sensors[sensorIndex].InfoServices[
                      infoserviceindex
                    ].isDisable = true;
                  }
                }
              );
            } else {
              this.collection.sensors.map((sensor) => {
                sensor.InfoServices.map((infoService) => {
                  infoService.isDisable = true;
                  infoService.checked = false;
                });
              });
              this.removeISLayers();
            }
          }
        } else {
          this.collection.sensors.map((sensor) => {
            sensor.InfoServices.map((infoService) => {
              infoService.isDisable = true;
              infoService.checked = false;
            });
          });
          this.removeISLayers();
        }
      } else {
        this.feedUi = { showFilterIcon: false };
        this.removeVectorOverlay();
        this.selectedSignals = this.selectedSignals.filter(
          (signal) => signal.sensorId !== collection.sensors[sensorIndex].id
        );
        this.spireJsonData = undefined;
        this.resetTimeSeries();
        if (this.compare) {
          this.map.removeControl(this.compare);
          this.compare = null;
        }

        this.sensorsNew = this.sensorsNew.filter((sensor: any) => {
          return collection.sensors[sensorIndex].id != sensor.id;
        });
        let selectedSensor = collection.sensors.filter((sensor) => {
          return collection.sensors[sensorIndex].id != sensor.id;
        });

        this.isCompare = false;
        if (this.sensorsNew.length == 1) {
          selectedSensor.map((sensor) => {
            if (
              sensor.scenes.filter((scene) => scene.checked == true).length == 1
            ) {
              sensor.InfoServices.map((infoService, infoserviceindex) => {
                if (
                  sensor.id == infoService.sensorId &&
                  infoService?.insightDatas?.length > 0
                ) {
                  infoService.isDisable = false;
                } else {
                  infoService.isDisable = true;
                }
              });
            } else {
              sensor.InfoServices.map((infoService, infoserviceindex) => {
                infoService.isDisable = true;
              });
            }
          });
        }
        if (this.sensorsNew.length == 0) {
          this.resetFeedsStatus(this.collection);
          this.removeAnnotationMarkers();
        }
        collection.sensors[sensorIndex].scenes.map((scene: any) => {
          scene.checked = false;
        });
        this.scenesNew.map((scene: any, index: any) => {
          if (scene.sensorId == collection.sensors[sensorIndex].id) {
            this.mapPane = scene?.pane;
            if (
              collection.sensors[sensorIndex].scenes[0].operatorKey ==
              this.OPERATOR.USL
            ) {
              this.clearRFBandsByScene(scene, true);
              this.removeGHGLayer();
            } else {
              if (scene?.legendScale) {
                this.map.removeLayer(scene?.legendScale);
              }
              this.removeLayerByScene(scene, { paneSpecific: true });
              this.clearRFSignalsByScene(scene);
            }
            this.removeAnnoatationByScene(scene);
          }
        });

        this.ghgLayers.map((ghgLayer) => {
          if (ghgLayer.scene.sensorId == collection.sensors[sensorIndex].id) {
            this.removeGHGLayerByScene(ghgLayer);
          }
        });
        this.collection.sensors[sensorIndex]?.InfoServices.map(
          (infoService) => {
            infoService.checked = false;
          }
        );
        this.collection.sensors[sensorIndex]?.indicesDetails?.map(
          (indicesDetails) => {
            indicesDetails.checked = false;
          }
        );
        this.removeISLayers();
        this.removeIndices();
        if (this.mapPane == 'left') {
          this.leftImageNew = null;
          this.mapPane = 'right';
          this.leftBand = false;
        } else {
          this.mapPane = 'left';
          this.rightImageNew = null;
          this.rightBand = false;
        }
        if (this.leftImageNew == null && this.rightImageNew == null) {
          this.mapPane = '';
        }

        this.scenesNew = this.scenesNew.filter((scene: any) => {
          return scene.sensorId != collection.sensors[sensorIndex].id;
        });
        this.ghgLayers = this.ghgLayers.filter((ghgLayer: any) => {
          return ghgLayer.scene.sensorId != collection.sensors[sensorIndex].id;
        });

        if (
          collection?.sensors[sensorIndex]?.scenes[0]?.operatorKey ==
          this.OPERATOR.CLYDE
        ) {
          this.removeClydeVesselLayer();
          this.clydeData = null;
          if (this.clickedMarker) {
            this.map.removeLayer(this.clickedMarker);
            this.clickedMarker = null;
          }
          if (this.spireData && this.sensorsNew.length > 0) {
            if (
              this.scenesNew[0].scene?.operatorKey == OPERATORS.SPIRE &&
              this.scenesNew[0].scene.checked
            ) {
              this.displayClydeAISNew(
                this.scenesNew[0].scene,
                this.spireData,
                selectedSensor[0],
                'SPIRE'
              );
            }
          }
        } else if (
          collection.sensors[sensorIndex].scenes[0].operatorKey ==
          this.OPERATOR.SPIRE
        ) {
          this.spireData = null;
          this.removeSpireVesselLayer();
          if (this.clickedMarker) {
            this.map.removeLayer(this.clickedMarker);
            this.clickedMarker = null;
          }
          if (this.clydeData && this.sensorsNew.length > 0) {
            if (
              this.scenesNew[0].scene?.operatorKey == OPERATORS.CLYDE &&
              this.scenesNew[0].scene.checked
            ) {
              this.displayClydeAISNew(
                this.scenesNew[0].scene,
                this.clydeData,
                selectedSensor[0],
                'CLYDE'
              );
            }
          }
        }
      }
      if (
        collection.sensors[sensorIndex].scenes.filter(
          (scene) => scene.checked == true
        ) > 1
      ) {
        this.isDisableIS = true;
      } else if (
        collection.sensors[sensorIndex].scenes.filter(
          (scene) => scene.checked == true
        ) == 1
      ) {
        let selectedScene = collection.sensors[sensorIndex].scenes[0];
      }
    }
    if (event.checked) {
      collection.sensors[sensorIndex].InfoServices.forEach((feed) => {
        feed.isDisable = false;
      });
    } else {
      collection.sensors[sensorIndex].InfoServices.forEach((feed) => {
        feed.isDisable = true;
      });
    }
    if (this.isFeedTasking) {
      collection.sensors[sensorIndex].InfoServices.forEach(
        (InfoService, infoServiceIndex) => {
          this.selectISNew(
            collectionIndex,
            sensorIndex,
            infoServiceIndex,
            event,
            InfoService,
            collection?.taskId
          );
        }
      );
    }
  }

  showAbortRetainPopup(): Promise<boolean> {
    return new Promise((resolve) => {
      const dialogRef = this.dialog.open(WarningPopup, {
        width: '40%',
        data: {
          type: 'abortApi',
          title: 'Operation Running',
          message:
            'Changing project name, task name or navigating away from the page will abort the current operation. Please confirm whether to abort or continue the ongoing operation.',
        },
      });

      dialogRef.afterClosed().subscribe((result) => {
        resolve(result === 'confirm'); // return true if confirmed
      });
    });
  }

  toggleSceneNew(collection, collectionIndex, sensorIndex, sceneIndex, event) {
    this.resetAllFeedPanels();
    this.clearAllPredictionData();
    this.clearFilteredLayerAndRestore(true);
    this.feedInfo = false;
    this.indiceType = 'display';
    this.failScene = 0;
    this.sliderShow = false;
    let scene = collection.sensors[sensorIndex].scenes[sceneIndex];
    this.selectedSceneNew = scene;
    this.removeDynamicLayer();
    this.opManager.completeOperation();
    collection.sensors[sensorIndex].scenes[sceneIndex].checked = event.checked;
    this.removeVectorOverlay();
    {
      this.feedUi = { showFilterIcon: false };
    }
    this.unSubscribeAPI();
    if (this.getCollectionSub) {
      this.getCollectionSub.unsubscribe();
      this.spinnerService.hide();
    }
    if (
      (collection.sensors[sensorIndex].scenes[sceneIndex]?.skipPreview &&
        this.imageType !== 'tif') ||
      ((!collection.sensors[sensorIndex].scenes[sceneIndex]?.footprint ||
        !collection.sensors[sensorIndex].scenes[sceneIndex]?.id) &&
        !collection.sensors[sensorIndex].scenes[sceneIndex]?.uslFootprint &&
        !collection.sensors[sensorIndex].scenes[sceneIndex]?.signalOfInterest)
    ) {
      if (event.checked) {
        this.showNoPreview(
          event,
          collection.sensors[sensorIndex].scenes[sceneIndex]
        );
      }
      collection.sensors[sensorIndex].scenes[sceneIndex].checked =
        event.checked;
      return;
    }
    if (scene) {
      this.sceneSelected = scene?.id;
    }
    collection.sensors[sensorIndex].scenes.forEach((scene: any) => {
      scene.imageType = this.imageType;
      scene.tif = this.imageType == 'tif' ? true : false;
    });

    collection.sensors[sensorIndex].indicesDetails?.map((indicesDetails) => {
      indicesDetails.checked = false;
      indicesDetails.loadTif = false;
    });

    this.isClydeHistorical = false;
    this.HistoricalLayer.forEach((HisLayer) => {
      this.map.removeLayer(HisLayer.marker);
    });
    this.HistoricalLayer = [];
    this.observationChecked = true;
    if (event.checked) {
      this.observationEnabled = true;
    } else {
      this.observationEnabled = false;
    }

    if (event.checked) {
      this.newTaskButtonClicked = false;
      this.selectedSceneIndex = sceneIndex;
      this.mapLoad = true;
      this.spinnerService.show();
      this.selectedSceneNew = scene;
      this.isScenSelected = true;

      this.removeIndices();
      if (
        this.collections[collectionIndex]?.sensors[sensorIndex]
          ?.valueAddedOption?.length > 0
      ) {
        this.collections[collectionIndex].sensors[
          sensorIndex
        ].valueAddedOption.map((valueAddedOption) => {
          valueAddedOption.checked = false;
        });
      }

      collection.sensors[sensorIndex].indicesDetails?.map((indicesDetails) => {
        indicesDetails.checked = false;
        indicesDetails.loadTif = false;
      });

      if (
        this.collections[collectionIndex].sensors[
          sensorIndex
        ].InfoServices.filter((InfoService) => InfoService.checked == true)
          .length > 0 &&
        this.collections[collectionIndex].sensors[sensorIndex]?.operatorKey !==
          OPERATORS.AXELSPACE
      ) {
        let selectedSceneIS = this.collections[collectionIndex].sensors[
          sensorIndex
        ].InfoServices.filter(
          (infoService) => infoService.checked === true
        )[0].insightDatas.filter(
          (scene) => scene.sceneId === this.selectedSceneNew.id
        );

        this.displayedIS = {
          insightFootprint: JSON.parse(
            JSON.stringify(selectedSceneIS[0].insightFootprint)
          ),
          isInfo: this.collections[collectionIndex].sensors[
            sensorIndex
          ].InfoServices.filter(
            (InfoService) => InfoService.checked == true
          )[0],
        };
      }
      if (
        this.sensorsNew.findIndex(
          (sensor) => sensor.id == collection.sensors[sensorIndex].id
        ) == -1
      ) {
        // collection.sensors[sensorIndex].checked = true;
        this.sensorsNew.push(collection.sensors[sensorIndex]);
        if (this.mapPane == 'left') {
          this.mapPane = 'right';
        } else {
          this.mapPane = 'left';
        }
      } else {
        if (
          (this.leftImageNew == null && this.rightImageNew == null) ||
          this.mapPane == ''
        ) {
          this.mapPane = 'left';
        }
      }

      if (scene?.id && scene?.status !== 'failed') {
        scene.checked = true;
        scene.pane = this.mapPane;
        const sensorObj = {
          sensorId: collection.sensors[sensorIndex].id,
          sceneId: scene?.id,
          action: 'scene',
          fileType: scene.imageType,
        };
        if (collection.sensors[sensorIndex].checked != true) {
          collection.sensors[sensorIndex].checked = false;
        }
        let selectedScenes: any[] = this.collection.sensors[
          sensorIndex
        ].scenes.filter((scene) => scene.checked == true);
        if (this.clydeData && this.clickedAIS?.operatorKey == OPERATORS.CLYDE) {
          let selectedAISSensor = collection.sensors.filter((snsr) => {
            return snsr.operatorKey == OPERATORS.CLYDE;
          })[0];
          this.displayClydeAISNew(
            selectedAISSensor.scenes[0],
            this.clydeData,
            selectedAISSensor,
            'CLYDE'
          );
        }
        if (this.spireData && this.clickedAIS?.operatorKey == OPERATORS.SPIRE) {
          let selectedAISSensor = collection.sensors.filter((snsr) => {
            return snsr.operatorKey == OPERATORS.SPIRE;
          })[0];
          this.displayClydeAISNew(
            selectedAISSensor.scenes[0],
            this.spireData,
            selectedAISSensor,
            'SPIRE'
          );
        }

        if (
          this.collections[collectionIndex].sensors[sensorIndex]
            ?.operatorKey === OPERATORS.AXELSPACE ||
          this.collections[collectionIndex].sensors[sensorIndex]
            ?.operatorKey === OPERATORS.AZISTA
        ) {
          if (
            this.collection.sensors[sensorIndex]?.indicesDetails?.length > 0
          ) {
            if (selectedScenes.length > 0) {
              this.collection.sensors[sensorIndex].indicesDetails?.map(
                (indicesDetails, indicesDetailsindex) => {
                  if (
                    this.collection.sensors[sensorIndex].id ==
                      indicesDetails.sensorId &&
                    indicesDetails?.products?.length > 0
                  ) {
                    this.collection.sensors[sensorIndex].indicesDetails[
                      indicesDetailsindex
                    ].isDisable = false;
                  } else {
                    this.collection.sensors[sensorIndex].indicesDetails[
                      indicesDetailsindex
                    ].isDisable = true;
                  }
                }
              );
            }
          }
          if (
            this.collection.sensors[0].scenes.length != selectedScenes.length
          ) {
            collection.sensors[sensorIndex].InfoServices.map((infoService) => {
              infoService.isDisable = true;
            });
          } else {
            collection.sensors[sensorIndex].InfoServices.map((infoService) => {
              infoService.isDisable = false;
            });
          }
        } else if (
          collection.sensors[sensorIndex].scenes.filter(
            (scene) =>
              scene?.id && scene?.status !== 'failed' && scene.checked == true
          ).length == 1 &&
          this.sensorsNew.length == 1
        ) {
          this.removeIndices();
          this.removeSuperResolutions();
          collection.sensors[sensorIndex].InfoServices.map((infoService) => {
            infoService.isDisable = false;
          });
          collection.sensors[sensorIndex].indicesDetails?.map(
            (indicesDetails) => {
              indicesDetails.isDisable = false;
            }
          );
          collection.sensors[sensorIndex].superResolutions?.map(
            (superResolutions) => {
              superResolutions.isDisable = false;
            }
          );
        } else if (this.sensorsNew.length == 2) {
          this.removeIndices();
          this.resetFeedsStatus(collection);
        } else {
          this.removeIndices();
          this.resetFeedsStatus(collection);
        }
        if (
          collection.sensors[sensorIndex].scenes[0].operatorKey ==
          this.OPERATOR.CLYDE
        ) {
          const coordinates = scene?.footprint?.coordinates[0];
          let taskId = this.collection?.taskId;
          let newCoordinates = coordinates.map((coord) => {
            return [coord[1], coord[0]];
          });
          newCoordinates = [newCoordinates];
          newCoordinates = JSON.stringify(newCoordinates);
          const encodedCoordinates = encodeURIComponent(newCoordinates);
          const startTime = encodeURIComponent(scene.openWindow);
          const endTime = encodeURIComponent(scene.closeWindow);
          const clydePayload = {
            polygon: encodedCoordinates,
            startTime: startTime,
            endTime: endTime,
            type: 'display',
          };
          const input = JSON.parse(decodeURIComponent(clydePayload.polygon));
          this.vesselPolygon = input[0]
            .map((pair) => pair.reverse().join(' '))
            .join(', ');
          clydePayload.polygon = this.vesselPolygon;
          this.apiService.getClydeAISData(clydePayload, taskId).subscribe(
            (res: any) => {
              this.clydeData = res.data;
              this.mapLoad = false;
              this.spinnerService.hide();
              if (res?.data?.length === 0) {
                const message =
                  'There is no AIS data in the area tasked. If there were to be vessels during the time of interest (TOI), those observations would become available when refreshed.';
                this.popupService.openPopup(
                  CollectionPopupComponent,
                  message,
                  '',
                  '40%'
                );
                collection.sensors[sensorIndex].checked = false;
                collection.sensors[sensorIndex].scenes.forEach((scene: any) => {
                  scene.checked = false;
                });
              } else {
                this.displayClydeAISNew(
                  scene,
                  res.data,
                  this.collection.sensors[sensorIndex],
                  'CLYDE',
                  res
                );
              }
            },
            (error) => {
              this.mapLoad = false;
              this.spinnerService.hide();
            }
          );
        }
        if (
          collection.sensors[sensorIndex].scenes[0].operatorKey ==
            this.OPERATOR.CLYDE ||
          collection.sensors[sensorIndex].scenes[0].operatorKey ==
            this.OPERATOR.SPIRE
        ) {
          this.fetchAISDataFromServer(collection, sensorIndex, scene);
        } else if (
          collection.sensors[sensorIndex].scenes[0].operatorKey ==
          this.OPERATOR.USL
        ) {
          if (!scene?.s_band && !scene?.x_band && scene?.usl_footprint) {
            scene.x_band = scene?.usl_footprint;
          }
          this.displayRFBandNew(
            scene,
            collection.sensors[sensorIndex].id,
            this.selectedBand
          );
        } else if (
          collection.sensors[sensorIndex].scenes[0].operatorKey ==
          this.OPERATOR.LBAND
        ) {
          this.displayRFSignalsNew(
            scene,
            collection.sensors[sensorIndex].id,
            this.signalSelected
          );
        } else {
          this.tifPopupShown = 0;
          this.fetchImageFromServer(collection, sensorObj, scene);
        }
      }
    } else {
      this.isScenSelected = false;
      scene.checked = false;
      this.spireJsonData = undefined;
      let selectedSensor = collection.sensors.filter((sensor) => {
        return collection.sensors[sensorIndex].id != sensor.id;
      });
      if (
        collection.sensors[sensorIndex].scenes.filter(
          (scene) => scene?.id && scene?.status !== 'failed'
        ).length !=
        collection.sensors[sensorIndex].scenes.filter(
          (scene) =>
            scene?.id && scene?.status !== 'failed' && scene.checked == true
        ).length
      ) {
        this.removeIndices();
        this.removeISLayers();
        this.removeSuperResolutions();
        if (this.displayedIS) {
          this.displayedIS = null;
        }
      }
      let selectedScenes: any[] = this.collection.sensors[
        sensorIndex
      ].scenes.filter((scene) => scene.checked == true);
      if (
        this.collections[collectionIndex].sensors[sensorIndex]?.operatorKey ===
          OPERATORS.AXELSPACE ||
        this.collections[collectionIndex].sensors[sensorIndex]?.operatorKey ===
          OPERATORS.AZISTA
      ) {
        if (this.collection.sensors[sensorIndex]?.indicesDetails?.length > 0) {
          if (selectedScenes.length == 0) {
            this.resetFeedsStatus(this.collection);
          }
        }
        if (this.collection.sensors[0].scenes.length != selectedScenes.length) {
          collection.sensors[sensorIndex].InfoServices.map((infoService) => {
            infoService.isDisable = true;
          });
          this.removeISLayers();
          if (this.displayedIS) {
            this.displayedIS = null;
          }
        } else {
          collection.sensors[sensorIndex].InfoServices.map((infoService) => {
            infoService.isDisable = false;
          });
        }
      } else {
        if (
          collection.sensors[sensorIndex].scenes.filter((scene) => {
            return (
              scene?.id && scene?.status !== 'failed' && scene.checked == true
            );
          }).length == 1
        ) {
          this.selectedSceneNew = collection.sensors[sensorIndex].scenes.filter(
            (scene) => {
              return (
                scene?.id && scene?.status !== 'failed' && scene.checked == true
              );
            }
          )[0];
          collection.sensors[sensorIndex].InfoServices.map((infoService) => {
            infoService.isDisable = false;
          });
          collection.sensors[sensorIndex].indicesDetails?.map(
            (indicesDetails) => {
              indicesDetails.isDisable = false;
            }
          );
          collection.sensors[sensorIndex].superResolutions?.map(
            (superResolutions) => {
              superResolutions.isDisable = false;
            }
          );
        } else {
          this.resetFeedsStatus(collection);
        }
      }

      this.collection.sensors[sensorIndex]?.InfoServices.map((infoService) => {
        infoService.checked = false;
      });

      this.collection.sensors[sensorIndex]?.indicesDetails?.map(
        (indicesDetails) => {
          indicesDetails.checked = false;
        }
      );
      this.collection.sensors[sensorIndex]?.superResolutions?.map(
        (superResolutions) => {
          superResolutions.checked = false;
        }
      );
      let sensorNewIndex = this.sensorsNew.findIndex(
        (sensor) => sensor.id == collection.sensors[sensorIndex].id
      );
      if (
        collection.sensors[sensorIndex].scenes.filter(
          (scene) =>
            scene?.id && scene?.status !== 'failed' && scene.checked == false
        ).length ==
        this.sensorsNew[sensorNewIndex]?.scenes.filter(
          (scene) => scene?.id && scene?.status !== 'failed'
        ).length
      ) {
        this.sensorsNew.splice(sensorNewIndex, 1);
        if (this.sensorsNew.length == 1) {
          this.isCompare = false;
          let index = this.collection.sensors.findIndex(
            (sensor) => sensor.id == this.sensorsNew[0].id
          );
          if (
            collection.sensors[index].scenes.filter(
              (scene) =>
                scene?.id && scene?.status !== 'failed' && scene.checked == true
            ).length == 1
          ) {
            collection.sensors[index].InfoServices.map((infoService) => {
              infoService.isDisable = false;
            });
            collection.sensors[index].indicesDetails?.map((indicesDetails) => {
              indicesDetails.isDisable = false;
            });

            collection.sensors[index].superResolutions?.map(
              (superResolutions) => {
                superResolutions.isDisable = false;
              }
            );
            this.selectedSceneNew = collection.sensors[index].scenes[0];
          }
        }
        let sceneNewIndex = this.scenesNew.findIndex(
          (sceneNew) => sceneNew.id == scene.id
        );
        this.mapPane = this.scenesNew[sceneNewIndex]?.pane;
        if (this.sensorsNew.length == 0) {
          this.mapPane = '';
          this.leftBand = false;
          this.annotateClicked = false;
          this.newTaskButtonClicked = false;
        } else if (this.mapPane == 'left') {
          this.leftImageNew = null;
          this.mapPane = 'right';
        } else {
          this.mapPane = 'left';
          this.rightImageNew = null;
        }
        if (this.compare) {
          this.map.removeControl(this.compare);
          this.compare = null;
        }
      }
      let sceneNewIndex = this.scenesNew.findIndex(
        (sceneNew) => sceneNew.id == scene.id
      );
      if (
        collection.sensors[sensorIndex].scenes[0].operatorKey ==
        this.OPERATOR.USL
      ) {
        this.clearRFBandsByScene(this.scenesNew[sceneNewIndex], true);
        this.removeAnnoatationByScene(this.scenesNew[sceneNewIndex]);
      } else {
        this.scenesNew.forEach((sceneItem) => {
          if (sceneItem?.scene?.id === scene?.id && !this.isVadapSelected) {
            this.removeAnnoatationByScene(sceneItem);
            let ghgIndex = this.ghgLayers.findIndex(
              (ghg) => ghg.scene.id == sceneItem.id
            );
            if (ghgIndex != -1) {
              this.removeGHGLayerByScene(this.ghgLayers[ghgIndex]);
              this.ghgLayers.splice(ghgIndex, 1);
            }
            if (sceneItem?.footprint) {
              this.map.removeLayer(sceneItem?.footprint);
            }
            if (sceneItem?.legendScale) {
              this.map.removeLayer(sceneItem?.legendScale);
            }
            if (sceneItem?.tiffootprint) {
              this.map.removeLayer(sceneItem?.tiffootprint);
            }
            if (this.scenesNew[sceneNewIndex]?.tiffootprint) {
              this.scenesNew.forEach((sceneItem) => {
                if (sceneItem?.scene?.id === scene?.id) {
                  this.map.removeLayer(sceneItem.tiffootprint);
                }
              });
            }
            this.clearRFSignalsByScene(sceneItem);
            if (this.selectedSignals.length > 0) {
              let removeIndex = this.selectedSignals.findIndex(
                (Signal) => Signal.sceneId == sceneItem?.id
              );
              this.selectedSignals.splice(removeIndex, 1);
            }
            if (sceneItem?.leftImageLayer && sceneItem?.pane == 'left') {
              this.map.removeLayer(sceneItem?.leftImageLayer);
            }
            if (sceneItem?.rightImageLayer && sceneItem?.pane == 'right') {
              this.map.removeLayer(sceneItem?.rightImageLayer);
            }
            if (this.leftImageNew == null && this.rightImageNew == null) {
              this.mapPane = '';
            }
          }
        });
      }
      this.removeISLayers();
      this.removeIndices();
      this.removeSuperResolutions();
      if (sceneNewIndex != -1) {
        this.scenesNew.splice(sceneNewIndex, 1);
      }

      if (
        collection.sensors[sensorIndex].scenes.filter(
          (scene) =>
            scene?.id && scene?.status !== 'failed' && scene.checked == true
        ).length == 1
      ) {
        this.isDisableIS = false;
      } else {
        this.isDisableIS = true;
      }
      if (
        collection.sensors[sensorIndex].scenes[0].operatorKey ==
        this.OPERATOR.CLYDE
      ) {
        this.removeClydeVesselLayer();
        this.clydeData = null;
        if (this.clickedMarker) {
          this.map.removeLayer(this.clickedMarker);
          this.clickedMarker = null;
        }
        if (this.spireData && this.sensorsNew.length > 0) {
          if (
            this.scenesNew[0].scene?.operatorKey == OPERATORS.SPIRE &&
            this.scenesNew[0].scene.checked
          ) {
            let selectedAISSensor = collection.sensors.filter((snsr) => {
              return snsr.operatorKey == OPERATORS.SPIRE;
            })[0];
            if (this.clickedMarker) {
              this.map.removeLayer(this.clickedMarker);
              this.clickedMarker = null;
            }
            this.displayClydeAISNew(
              selectedAISSensor.scenes[0],
              this.spireData,
              selectedAISSensor,
              'SPIRE'
            );
          }
        }
      } else if (
        collection.sensors[sensorIndex].scenes[0].operatorKey ==
        this.OPERATOR.SPIRE
      ) {
        this.spireData = null;
        this.removeSpireVesselLayer();
        if (this.clickedMarker) {
          this.map.removeLayer(this.clickedMarker);
          this.clickedMarker = null;
        }
        if (this.clydeData && this.sensorsNew.length > 0) {
          if (
            this.scenesNew[0].scene?.operatorKey == OPERATORS.CLYDE &&
            this.scenesNew[0].scene.checked
          ) {
            let selectedAISSensor = collection.sensors.filter((snsr) => {
              return snsr.operatorKey == OPERATORS.CLYDE;
            })[0];
            this.displayClydeAISNew(
              selectedAISSensor.scenes[0],
              this.clydeData,
              selectedAISSensor,
              'CLYDE'
            );
          }
        }
      }
    }
    if (
      collection.sensors[sensorIndex]?.scenes?.length > 1 &&
      collection.sensors[sensorIndex]?.InfoServices?.length === 1
    )
      this.updateFeedEnabledState(collectionIndex, sensorIndex);
  }

  toggleRecurrentSceneNew(
    collection,
    collectionIndex,
    sensorIndex,
    sceneIndex,
    scene,
    event
  ) {
    this.failScene = 0;
    this.selectedCheckboxesNew[sensorIndex].scenes[sceneIndex].checked =
      event.checked;
    if (
      this.collection.sensors[0].operatorKey == this.OPERATOR.USL ||
      this.collection.sensors[0].operatorKey == this.OPERATOR.LBAND
    ) {
      if (event.checked) {
        this.removeAnnotationMarkers();
        this.annotateClicked = false;
        this.newTaskButtonClicked = false;
        if (
          this.selectedCheckboxesNew[sensorIndex].scenes.filter(
            (scene) => scene?.id && scene?.status !== 'failed'
          ).length ==
          this.selectedCheckboxesNew[sensorIndex].scenes.filter(
            (scene) =>
              scene?.id && scene?.status !== 'failed' && scene.checked == true
          ).length
        ) {
          this.selectedCheckboxesNew[sensorIndex].checked = true;
        }
        if (
          scene?.id &&
          scene?.status !== 'failed' &&
          this.collection.sensors[0].operatorKey == this.OPERATOR.USL
        ) {
          scene.checked = true;
          scene.start = this.selectedCheckboxesNew[sensorIndex]?.start;
          if (!scene?.s_band && !scene?.x_band && scene?.usl_footprint) {
            scene.x_band = scene?.usl_footprint;
          }
          this.displayRFBandNew(
            scene,
            this.collection.sensors[0].id,
            this.selectedBand
          );
        } else {
          scene.checked = true;
          scene.start = this.selectedCheckboxesNew[sensorIndex]?.start;
          this.displayRFSignalsNew(
            scene,
            this.collection.sensors[0].id,
            this.signalSelected
          );
        }
      } else {
        this.selectedCheckboxesNew[sensorIndex].scenes[sceneIndex].checked =
          false;
        if (
          this.selectedCheckboxesNew[sensorIndex].scenes.filter(
            (scene) => scene?.id && scene?.status !== 'failed'
          ).length ==
          this.selectedCheckboxesNew[sensorIndex].scenes.filter(
            (scene) =>
              scene?.id && scene?.status !== 'failed' && scene.checked == false
          ).length
        ) {
          this.toggleRecurrentSensorNew(collectionIndex, sensorIndex, event);
        } else {
          let sceneNewIndex = this.scenesNew.findIndex(
            (sceneNew) => sceneNew.id == scene.id
          );
          if (
            this.selectedCheckboxesNew[sensorIndex].scenes[0].operatorKey ==
            this.OPERATOR.USL
          ) {
            this.clearRFBandsByScene(this.scenesNew[sceneNewIndex], false);
            this.removeAnnoatationByScene(this.scenesNew[sceneNewIndex]);
            this.scenesNew = this.scenesNew.filter(
              (sceneNew) => sceneNew.id != scene.id
            );
          } else if (
            this.selectedCheckboxesNew[sensorIndex].scenes[0].operatorKey ==
            this.OPERATOR.LBAND
          ) {
            this.scenesNew.map((scene: any, index: any) => {
              this.clearRFSignalsByScene(scene);
            });
            this.scenesNew = this.scenesNew.filter(
              (sceneNew) => sceneNew.id != scene.id
            );
          }
        }
      }
    } else {
      if (this.collection.recurrencyArray.length > 0) {
        if (event.checked) {
          this.removeAnnotationMarkers();
          this.annotateClicked = false;
          this.newTaskButtonClicked = false;
          this.spinnerService.show();
          if (scene.pane == undefined) {
            scene.pane = 'left';
          }
          this.mapPane = scene.pane;
          if (this.compare) {
            this.map.removeControl(this.compare);
            this.compare = null;
          }
          if (scene?.id && scene?.status !== 'failed') {
            scene.checked = true;
            const sensorObj = {
              sensorId: collection.sensors[collection.sensors.length - 1].id,
              sceneId: scene?.id,
              action: 'scene',
              fileType: scene.imageType,
            };
            this.tifPopupShown = 0;
            this.fetchImageFromServer(collection, sensorObj, scene);
          }
        } else {
          scene.tif = false;
          scene.imageType = 'png';
          this.imageType = this.checkType();
          if (this.compare) {
            this.map.removeControl(this.compare);
            this.compare = null;
          }
          this.scenesNew.forEach((sceneNew) => {
            if (sceneNew.id == scene.id) {
              this.removeLayerByScene(sceneNew);
              if (sceneNew?.leftImageLayer) {
                this.leftImageNew = null;
              }
              if (sceneNew?.rightImageLayer) {
                this.rightImageNew = null;
              }
              this.removeAnnoatationByScene(sceneNew);
            }
          });

          this.ghgLayers.forEach((ghgLayer) => {
            if (ghgLayer.scene.id == scene.id) {
              this.removeGHGLayerByScene(ghgLayer);
            }
          });

          this.scenesNew = this.scenesNew.filter((sceneNew) => {
            return sceneNew.id != scene.id;
          });
          this.ghgLayers = this.ghgLayers.filter((ghgLayer) => {
            return ghgLayer.scene.id != scene.id;
          });
          this.updateImageLayersBasedOnPane();
          if (
            this.selectedCheckboxesNew[sensorIndex].scenes.filter(
              (scene) => scene?.id && scene?.status !== 'failed'
            ).length ==
            this.selectedCheckboxesNew[sensorIndex].scenes.filter(
              (scene) =>
                scene?.id &&
                scene?.status !== 'failed' &&
                scene.checked == false
            ).length
          ) {
            this.toggleRecurrentSensorNew(collectionIndex, sensorIndex, event, this.selectedCheckboxesNew[sensorIndex]);
          }
          if (this.leftImageNew && this.rightImageNew) {
            this.compare = new SplitMap(
              this.leftImageNew,
              this.rightImageNew
            ).addTo(this.map);
          }
        }
        this.toggleCompareLabels();
      } else if (
        this.collection.sensors[0].operatorKey == this.OPERATOR.AXELSPACE ||
        this.collection.sensors[0].operatorKey == this.OPERATOR.AZISTA
      ) {
        if (event.checked) {
          this.removeAnnotationMarkers();
          this.annotateClicked = false;
          this.newTaskButtonClicked = false;
          this.spinnerService.show();
          this.mapPane = scene.pane;
          if (this.compare) {
            this.map.removeControl(this.compare);
            this.compare = null;
          }
          if (scene?.id && scene?.status !== 'failed') {
            scene.checked = true;
            const sensorObj = {
              sensorId: collection.sensors[collection.sensors.length - 1].id,
              sceneId: scene?.id,
              action: 'scene',
              fileType: scene.imageType,
            };
            this.tifPopupShown = 0;
            this.fetchImageFromServer(collection, sensorObj, scene);
          }
        } else {
          if (this.compare) {
            this.map.removeControl(this.compare);
            this.compare = null;
          }
          this.scenesNew.forEach((sceneNew) => {
            if (sceneNew.id == scene.id) {
              this.removeLayerByScene(sceneNew);
              if (sceneNew?.leftImageLayer) {
                this.leftImageNew = null;
              }
              if (sceneNew?.rightImageLayer) {
                this.rightImageNew = null;
              }
              this.removeAnnoatationByScene(sceneNew);
            }
          });
          this.scenesNew = this.scenesNew.filter((sceneNew) => {
            return sceneNew.id != scene.id;
          });
          this.updateImageLayersBasedOnPane();
          if (
            this.selectedCheckboxesNew[sensorIndex].scenes.filter(
              (scene) => scene?.id && scene?.status !== 'failed'
            ).length ==
            this.selectedCheckboxesNew[sensorIndex].scenes.filter(
              (scene) =>
                scene?.id &&
                scene?.status !== 'failed' &&
                scene.checked == false
            ).length
          ) {
            this.toggleRecurrentSensorNew(collectionIndex, sensorIndex, event);
          }
          if (this.leftImageNew && this.rightImageNew) {
            this.compare = new SplitMap(
              this.leftImageNew,
              this.rightImageNew
            ).addTo(this.map);
          }
        }
      }
    }
    if (
      collection.sensors[sensorIndex].scenes?.length > 1 &&
      collection.sensors[sensorIndex].InfoServices.length === 1
    )
      this.updateFeedEnabledState(collectionIndex, sensorIndex);
  }

  updateFeedEnabledState(
    collectionIndex: number,
    sensorIndex: number,
    isLoadCombineScenes?: any
  ): void {
    const sensor = this.collections[collectionIndex].sensors[sensorIndex];
    const scenes = sensor.scenes;
    if (isLoadCombineScenes?.checked) {
      scenes.forEach((scene) => {
        scene.checked = true;
      });
      sensor.checked = true;
      this.combinedScenes = true;
      sensor.InfoServices.forEach((feed) => {
        feed.isDisable = false;
      });
      this.toggleSensorNew(
        this.collections[collectionIndex],
        collectionIndex,
        sensorIndex,
        { checked: true }
      );
    } else if (isLoadCombineScenes?.checked === false) {
      sensor.InfoServices.forEach((feed) => {
        feed.isDisable = false;
      });
      scenes.forEach((scene) => {
        scene.checked = false;
      });
      sensor.InfoServices.forEach((feed) => {
        feed.isDisable = true;
      });
      this.combinedScenes = false;
      this.resetMapNew();
    }

    if (!isLoadCombineScenes) {
      const selectedCount = scenes.filter((s) => s.checked).length;
      const totalScenes = scenes.length;

      const enableFeeds = selectedCount === 1 || selectedCount === totalScenes;

      sensor.InfoServices.forEach((feed) => {
        feed.isDisable = !enableFeeds;
      });
      this.combinedScenes = selectedCount === totalScenes && totalScenes > 1;
      if (selectedCount === totalScenes && totalScenes > 1)
        sensor.checked = true;
    }
    this.collections[collectionIndex]?.sensors[
      sensorIndex
    ]?.InfoServices.forEach((feed) => {
      feed.checked = false;
    });
    scenes.forEach((scene) => {
      if (scene.checked == true) this.sceneSelected = scene.id;
    });
    this.resetAllFeedPanels();
    this.clearFilteredLayerAndRestore(true);
    this.removeISLayers();
    this.removeSuperResolutions();
    this.removeDynamicLayer();
    this.removeVectorOverlay();
    this.clearAllPredictionData();
  }

  toggleRecurrentSubdailySceneNew(
    collection,
    collectionIndex,
    sensorIndex,
    sceneIndex,
    event
  ) {
    this.failScene = 0;
    let scene = this.subDailyFinalArray[sensorIndex].scenes[sceneIndex];
    this.subDailyFinalArray[sensorIndex].scenes[sceneIndex].checked =
      event.checked;
    if (
      this.collection.sensors[0].operatorKey == this.OPERATOR.USL ||
      this.collection.sensors[0].operatorKey == this.OPERATOR.LBAND
    ) {
      if (event.checked) {
        this.annotateClicked = false;
        this.newTaskButtonClicked = false;
        this.removeAnnotationMarkers();
        if (
          this.subDailyFinalArray[sensorIndex].scenes.filter(
            (scene) => scene?.id && scene?.status !== 'failed'
          ).length ==
          this.subDailyFinalArray[sensorIndex].scenes.filter(
            (scene) =>
              scene?.id && scene?.status !== 'failed' && scene.checked == true
          ).length
        ) {
          this.subDailyFinalArray[sensorIndex].checked = true;
        }
        if (scene?.id && scene?.status !== 'failed') {
          scene.checked = true;
          scene.sequenceNumber =
            this.selectedCheckboxesNew[sensorIndex]?.sequenceNumber;
          if (this.collection.sensors[0].operatorKey == this.OPERATOR.USL) {
            if (!scene?.s_band && !scene?.x_band && scene?.usl_footprint) {
              scene.x_band = scene?.usl_footprint;
            }
            this.displayRFBandNew(
              scene,
              this.selectedCheckboxesNew[sensorIndex].id,
              this.selectedBand
            );
          } else {
            this.displayRFSignalsNew(
              scene,
              this.selectedCheckboxesNew[sensorIndex].id,
              this.signalSelected
            );
          }
        }
      } else {
        this.subDailyFinalArray[sensorIndex].scenes[sceneIndex].checked = false;
        const allScenesUnchecked = this.subDailyFinalArray.every((obj) =>
          obj.scenes.every((scene) => scene.checked === false)
        );

        if (allScenesUnchecked) {
          this.showDailyRecurrencyCheckboxes = false;
          this.toggleDailyRecurrency(event);
        }
        if (
          this.subDailyFinalArray[sensorIndex].scenes.filter(
            (scene) => scene?.id && scene?.status !== 'failed'
          ).length ==
          this.subDailyFinalArray[sensorIndex].scenes.filter(
            (scene) =>
              scene?.id && scene?.status !== 'failed' && scene.checked == false
          ).length
        ) {
          this.toggleSubDailyRecurrentSensorNew(
            sensorIndex,
            this.subDailyFinalArray[sensorIndex],
            event
          );
        } else {
          let sceneNewIndex = this.scenesNew.findIndex(
            (sceneNew) => sceneNew.id == scene.id
          );
          if (
            this.subDailyFinalArray[sensorIndex].scenes[0].operatorKey ==
              this.OPERATOR.USL ||
            this.subDailyFinalArray[sensorIndex].scenes[0].operatorKey ==
              this.OPERATOR.LBAND
          ) {
            this.clearRFBandsByScene(this.scenesNew[sceneNewIndex], false);
            this.clearRFSignalsByScene(this.scenesNew[sceneNewIndex]);
          }
        }
      }
    } else {
      if (event.checked) {
        this.annotateClicked = false;
        this.newTaskButtonClicked = false;
        this.removeAnnotationMarkers();
        this.spinnerService.show();
        this.mapPane = scene.pane;
        if (this.compare) {
          this.map.removeControl(this.compare);
          this.compare = null;
        }
        if (scene?.id && scene?.status !== 'failed') {
          scene.checked = true;
          const sensorObj = {
            sensorId: collection.sensors[collection.sensors.length - 1].id,
            sceneId: scene?.id,
            action: 'scene',
            fileType: scene.imageType,
          };
          this.apiService
            .getCollectionImage(collection.taskId, sensorObj)
            .subscribe((res: any) => {
              if (res?.msg === 'Failed') {
                this.mapLoad = false;
                this.spinnerService.hide();
                this.failScene = this.failScene + 1;
                if (this.failScene == 1) {
                  const message =
                    'An error occurred during processing and ingestion of the request. Please try after sometime.';
                  this.popupService.openPopup(
                    CollectionPopupComponent,
                    message,
                    '',
                    '40%'
                  );
                }
              } else if (res?.result) {
                if (this.selectedSites.length > 0) {
                  let site = this.selectedSites.filter((selectedSite) => {
                    return selectedSite.value == scene.siteId;
                  })[0];
                  this.mapPane = site.mapPane;
                  this.displayFootprintImageByRecurrentDataNew(
                    scene,
                    res.result,
                    collection.sensors[collection.sensors.length - 1].id,
                    this.selectedSites
                  );
                } else {
                  this.displayFootprintImageByRecurrentDataNew(
                    scene,
                    res.result,
                    collection.sensors[collection.sensors.length - 1].id,
                    this.selectedSubDailyItemsNew
                  );
                }
              } else {
                this.mapLoad = false;
                this.spinnerService.hide();
              }
            });
        }
      } else {
        if (this.compare) {
          this.map.removeControl(this.compare);
          this.compare = null;
        }
        this.scenesNew.forEach((sceneNew) => {
          if (sceneNew.id == scene.id) {
            this.removeLayerByScene(sceneNew, { paneSpecific: true });
            this.removeAnnoatationByScene(sceneNew);
          }
        });

        this.ghgLayers.forEach((ghgLayer) => {
          if (ghgLayer.scene.id == scene.id) {
            this.removeGHGLayerByScene(ghgLayer);
          }
        });

        this.scenesNew = this.scenesNew.filter((sceneNew) => {
          return sceneNew.id != scene.id;
        });
        this.ghgLayers = this.ghgLayers.filter((ghgLayer) => {
          return ghgLayer.scene.id != scene.id;
        });
        scene.tif = false;
        scene.imageType = 'png';
        this.imageType = this.checkType();
        this.updateImageLayersBasedOnPane();
        if (
          this.subDailyFinalArray[sensorIndex].scenes.filter(
            (scene) => scene?.id && scene?.status !== 'failed'
          ).length ==
          this.subDailyFinalArray[sensorIndex].scenes.filter(
            (scene) =>
              scene?.id && scene?.status !== 'failed' && scene.checked == false
          ).length
        ) {
          this.toggleSubDailyRecurrentSensorNew(
            sensorIndex,
            this.subDailyFinalArray[sensorIndex],
            event
          );
        }
        if (this.leftImageNew && this.rightImageNew) {
          this.compare = new SplitMap(
            this.leftImageNew,
            this.rightImageNew
          ).addTo(this.map);
        }
      }
    }
    if (
      collection.sensors[sensorIndex].scenes?.length > 1 &&
      collection.sensors[sensorIndex].InfoServices.length === 1
    )
      this.updateFeedEnabledState(collectionIndex, sensorIndex);
  }

  toggleUSLSensorNew(collection, collectionIndex, sensorIndex, event) {
    this.mapPane = 'left';
    if (event.checked) {
      if (
        this.sensorsNew.findIndex(
          (sensorNew) => sensorNew.id == collection.sensors[sensorIndex].id
        ) == -1
      ) {
        this.sensorsNew.push(collection.sensors[sensorIndex]);
      }
      collection.sensors[sensorIndex].scenes.map((scene: any) => {
        if (scene?.id && scene?.status !== 'failed') {
          scene.checked = true;
          if (!scene?.s_band && !scene?.x_band && scene?.usl_footprint) {
            scene.x_band = scene?.usl_footprint;
          }
          this.displayRFBandNew(
            scene,
            collection.sensors[sensorIndex].id,
            this.selectedBand
          );
        }
      });
    } else {
      this.sensorsNew = this.sensorsNew.filter((sensor: any) => {
        return collection.sensors[sensorIndex].id != sensor.id;
      });
      collection.sensors[sensorIndex].scenes.map((scene: any) => {
        scene.checked = false;
      });
      this.scenesNew.map((scene: any, index: any) => {
        if (scene.sensorId == collection.sensors[sensorIndex].id) {
          this.clearRFBandsByScene(scene, false);
        }
      });
      this.scenesNew = this.scenesNew.filter((scene: any) => {
        return scene.sensorId != collection.sensors[sensorIndex].id;
      });
    }
  }

  toggleRecurrentRFNew(collectionIndex: any, sensorIndex: any, event: any) {
    this.subDailyFinalArray = [];
    if (event.checked == false) {
      const indexToRemove = sensorIndex;
      let sensorSelected = JSON.parse(
        JSON.stringify(this.selectedCheckboxesNew[indexToRemove])
      );
      if (sensorSelected?.pane == 'left') {
        this.mapPane = 'right';
      } else if (sensorSelected?.pane == 'right') {
        this.mapPane = 'left';
      }
      this.selectedCheckboxesNew.splice(indexToRemove, 1);
      this.sensorsNew = this.selectedCheckboxesNew;
      this.selectionChange.next(this.selectedCheckboxesNew[0]);
      this.subSelectionSelectionChange.next(1);
      this.collection.recurrencyArray.forEach((sensor, index) => {
        const indexTouncheck = this.selectedCheckboxesNew.findIndex(
          (item) => item.start === sensor.start
        );
        if (indexTouncheck === -1) {
          sensor.checked = false;
          sensor.scenes.forEach((scene) => {
            scene.checked = false;
          });
        }
      });
      if (this.selectedCheckboxesNew.length === 0) {
        this.defaultSubdailyCount = 1;
        this.toggleDailyRecurrency(event);
      }
      if (this.selectedCheckboxesNew.length > 0) {
        this.scenesNew.map((scene: any, index: any) => {
          if (scene.scene?.start == sensorSelected.start) {
            this.clearRFBandsByScene(scene, false);
          }
        });
        this.scenesNew = this.scenesNew.filter((scene: any) => {
          return scene.scene?.start != sensorSelected.start;
        });
        if (this.selectedSubDailyItemsNew.length == 0) {
          this.defaultSubdailyCount = 0;
          this.selectOptionNew(this.selectedCheckboxesNew[0], 'compare');
        }
      }
      this.setLeftandRightBands(this.selectedCheckboxesNew);
    }
  }

  toggleRecurrentRFSignalNew(
    collectionIndex: any,
    sensorIndex: any,
    event: any
  ) {
    this.subDailyFinalArray = [];
    if (event.checked == false) {
      const indexToRemove = sensorIndex;
      let sensorSelected = JSON.parse(
        JSON.stringify(this.selectedCheckboxesNew[indexToRemove])
      );
      if (sensorSelected?.pane == 'left') {
        this.mapPane = 'right';
      } else if (sensorSelected?.pane == 'right') {
        this.mapPane = 'left';
      }
      this.selectedCheckboxesNew.splice(indexToRemove, 1);
      this.sensorsNew = this.selectedCheckboxesNew;
      this.selectionChange.next(this.selectedCheckboxesNew[0]);
      this.subSelectionSelectionChange.next(1);
      this.collection.recurrencyArray.forEach((sensor, index) => {
        const indexTouncheck = this.selectedCheckboxesNew.findIndex(
          (item) => item.start === sensor.start
        );
        if (indexTouncheck === -1) {
          sensor.checked = false;
          sensor.scenes.forEach((scene) => {
            scene.checked = false;
          });
        }
      });
      if (this.selectedCheckboxesNew.length === 0) {
        this.defaultSubdailyCount = 1;
        this.toggleDailyRecurrency(event);
      }
      if (this.selectedCheckboxesNew.length > 0) {
        this.scenesNew.map((scene: any, index: any) => {
          if (scene.scene?.start == sensorSelected.start) {
            this.clearRFSignalsByScene(scene);
          }
        });
        this.scenesNew = this.scenesNew.filter((scene: any) => {
          return scene.scene?.start != sensorSelected.start;
        });
        if (this.selectedSubDailyItemsNew.length > 0) {
          this.selectedSubDailyItemsNew = [];
          this.clearRFSignalsNew();
          this.scenesNew = [];
          this.defaultSubdailyCount =
            this.selectedCheckboxesNew[0].scenes[0].sequence;
          this.selectOptionNew(this.selectedCheckboxesNew[0], 'compare');
        } else if (this.selectedSubDailyItemsNew.length == 0) {
          this.defaultSubdailyCount = 0;
          this.selectOptionNew(this.selectedCheckboxesNew[0], 'compare');
        }
      }
    }
  }

  toggleRecurrentDatesRFbandNew(
    collectionIndex: any,
    recurrencyIndex: any,
    event: any,
    type: any,
    task: any
  ) {
    this.subDailyFinalArray = [];
    if (!this.isCompare) {
      this.clearRFBandsNew();
      this.scenesNew = [];
      this.selectedSubDailyItemsNew = [];
      this.selectedSubDailyItems = [];
    }
    if (event?.checked) {
      let selectedSensor: any;
      this.RF = true;
      this.showSubDailyList = false;
      this.setCollectionRecurrencyArray('recurrencyArray', recurrencyIndex);
      this.collection.recurrencyArray[recurrencyIndex].sensorId =
        this.collection.sensors[0].id;
      this.selectedCheckboxesNew.push(
        this.collection.recurrencyArray[recurrencyIndex]
      );
      if(this.selectedCheckboxesNew.length > 1)
        this.isShowSubDailyLegend = false;
      this.limitSensorSelectionToTwo();
      if (this.selectedSubDailyItemsNew.length == 1) {
        this.defaultSubdailyCount = this.selectedSubDailyItemsNew[0].value;
        this.selectedCheckboxesNew.map((selectedDate, index) => {
          let scenes: any[] = [];
          this.filteredCollection.recurrencyArray.map((recurrency) => {
            if (selectedDate.start == recurrency.start) {
              recurrency.scenes.map((scn) => {
                scn.checked = true;
                scenes.push(scn);
              });
            }
          });
          this.selectedCheckboxesNew[index].scenes = scenes;
        });
        this.selectedCheckboxesNew = this.filterScenesBySubdaily(
          this.selectedCheckboxesNew,
          this.selectedSubDailyItemsNew[0].value
        );
      }
      this.setPreviousSelectiontext();
      this.selectionChange.next(
        this.collection.recurrencyArray[recurrencyIndex]
      );
      this.sensorsNew = this.selectedCheckboxesNew;
      this.selectOptionNew(
        this.collection?.recurrencyArray[recurrencyIndex],
        'compare'
      );
      let sensor = this.collection.recurrencyArray[recurrencyIndex];
      sensor.checked = true;
      if (
        this.selectedSubDailyItemsNew.length == 0 ||
        this.selectedCheckboxesNew.length == 2
      ) {
        sensor.pane =
          this.selectedCheckboxesNew[this.selectedCheckboxesNew.length - 2]
            ?.pane == 'left'
            ? 'right'
            : 'left';
        for (const [sceneIndex, scene] of this.selectedCheckboxesNew[
          this.selectedCheckboxesNew.length - 1
        ]?.scenes.entries()) {
          if (scene?.id && scene?.status !== 'failed') {
            scene.checked = true;
            scene.pane = sensor.pane;
            scene.checked = true;
            scene.start = sensor?.start;
            if (!scene?.s_band && !scene?.x_band && scene?.usl_footprint) {
              scene.x_band = scene?.usl_footprint;
            }
            this.displayRFBandNew(
              scene,
              this.collection.sensors[0].id,
              this.selectedBand
            );
          }
        }
      }
    } else {
      this.selectedCheckboxesNew[this.selectedCheckboxesNew.length - 1]?.pane ==
      'left'
        ? (this.leftBand = false)
        : (this.rightBand = false);
      const indexToRemove =
        type === 'dropdown'
          ? this.selectedCheckboxesNew.findIndex(
              (item) =>
                item.start ===
                this.collection.recurrencyArray[recurrencyIndex].start
            )
          : recurrencyIndex;
      let sensorSelected: any;
      if (this.selectedCheckboxesNew[indexToRemove]) {
        sensorSelected = JSON.parse(
          JSON.stringify(this.selectedCheckboxesNew[indexToRemove])
        );
      }
      this.selectedCheckboxesNew.splice(indexToRemove, 1);
      this.sensorsNew = this.selectedCheckboxesNew;
      this.selectionChange.next(this.selectedCheckboxesNew[0]);
      this.subSelectionSelectionChange.next(1);
      if (
        this.collection.recurrencyArray.filter((item) => item.checked).length >
        0
      ) {
        this.collection.recurrencyArray.forEach((sensor, index) => {
          const indexTouncheck = this.selectedCheckboxesNew.findIndex(
            (item) => item.start === sensor.start
          );
          if (indexTouncheck === -1) {
            sensor.checked = false;
            sensor.scenes.forEach((scene) => {
              scene.checked = false;
            });
          }
        });
      }
      if (this.selectedCheckboxesNew.length === 0) {
        this.defaultSubdailyCount = 1;
        this.toggleDailyRecurrency(event);
      }
      if (this.selectedCheckboxesNew.length > 0) {
        this.scenesNew.map((scene: any, index: any) => {
          if (scene.scene?.start == sensorSelected.start) {
            this.clearRFBandsByScene(scene, false);
          }
        });
        this.scenesNew = this.scenesNew.filter((scene: any) => {
          return (
            scene.scene?.start !=
            this.collection.recurrencyArray[recurrencyIndex].start
          );
        });
        if (this.selectedSubDailyItemsNew.length > 0) {
          this.selectedSubDailyItemsNew = [];
          this.clearRFBandsNew();
          this.scenesNew = [];
          this.defaultSubdailyCount =
            this.selectedCheckboxesNew[0].scenes[0].sequence;
          this.selectOptionNew(this.selectedCheckboxesNew[0], 'compare');
        } else if (this.selectedSubDailyItemsNew.length == 0) {
          this.defaultSubdailyCount = 0;
          this.selectOptionNew(this.selectedCheckboxesNew[0], 'compare');
        }
      }
    }
    this.setLeftandRightBands(this.selectedCheckboxesNew);
  }

  toggleRecurrentDatesRFSignalNew(
    collectionIndex: any,
    recurrencyIndex: any,
    event: any,
    type: any,
    task: any
  ) {
    this.subDailyFinalArray = [];
    if (!this.isCompare) {
      this.clearRFSignalsNew();
      this.scenesNew = [];
      this.selectedSubDailyItemsNew = [];
      this.selectedSubDailyItems = [];
    }
    if (event?.checked) {
      let selectedSensor: any;
      this.RF = true;
      this.showSubDailyList = false;
      this.setCollectionRecurrencyArray('recurrencyArray', recurrencyIndex);
      this.collection.recurrencyArray[recurrencyIndex].sensorId =
        this.collection.sensors[0].id;
      this.selectedCheckboxesNew.push(
        this.collection.recurrencyArray[recurrencyIndex]
      );
      this.limitSensorSelectionToTwo();
      if (this.selectedSubDailyItemsNew.length == 1) {
        this.defaultSubdailyCount = this.selectedSubDailyItemsNew[0].value;
        this.selectedCheckboxesNew.map((selectedDate, index) => {
          let scenes: any[] = [];
          this.filteredCollection.recurrencyArray.map((recurrency) => {
            if (selectedDate.start == recurrency.start) {
              recurrency.scenes.map((scn) => {
                scn.checked = true;
                scenes.push(scn);
              });
            }
          });
          this.selectedCheckboxesNew[index].scenes = scenes;
        });
        this.selectedCheckboxesNew = this.filterScenesBySubdaily(
          this.selectedCheckboxesNew,
          this.selectedSubDailyItemsNew[0].value
        );
      }
      this.setPreviousSelectiontext();
      this.selectionChange.next(
        this.collection.recurrencyArray[recurrencyIndex]
      );
      this.sensorsNew = this.selectedCheckboxesNew;
      this.selectOptionNew(
        this.collection?.recurrencyArray[recurrencyIndex],
        'compare'
      );
      let sensor = this.collection.recurrencyArray[recurrencyIndex];
      sensor.checked = true;
      if (
        this.selectedSubDailyItemsNew.length == 0 ||
        this.selectedCheckboxesNew.length == 2
      ) {
        sensor.pane =
          this.selectedCheckboxesNew[this.selectedCheckboxesNew.length - 2]
            ?.pane == 'left'
            ? 'right'
            : 'left';
        for (const [sceneIndex, scene] of this.selectedCheckboxesNew[
          this.selectedCheckboxesNew.length - 1
        ]?.scenes.entries()) {
          if (scene?.id && scene?.status !== 'failed') {
            scene.checked = true;
            scene.pane = sensor.pane;
            scene.checked = true;
            scene.start = sensor?.start;
            this.displayRFSignalsNew(
              scene,
              this.collection.sensors[0].id,
              this.signalSelected
            );
          }
        }
      }
    } else {
      this.selectedCheckboxesNew[this.selectedCheckboxesNew.length - 1]?.pane ==
      'left'
        ? (this.leftBand = false)
        : (this.rightBand = false);
      const indexToRemove =
        type === 'dropdown'
          ? this.selectedCheckboxesNew.findIndex(
              (item) =>
                item.start ===
                this.collection.recurrencyArray[recurrencyIndex].start
            )
          : recurrencyIndex;
      let sensorSelected: any;
      if (this.selectedCheckboxesNew[indexToRemove]) {
        sensorSelected = JSON.parse(
          JSON.stringify(this.selectedCheckboxesNew[indexToRemove])
        );
      }
      this.selectedCheckboxesNew.splice(indexToRemove, 1);
      this.sensorsNew = this.selectedCheckboxesNew;
      this.selectionChange.next(this.selectedCheckboxesNew[0]);
      this.subSelectionSelectionChange.next(1);
      if (
        this.collection.recurrencyArray.filter((item) => item.checked).length >
        0
      ) {
        this.collection.recurrencyArray.forEach((sensor, index) => {
          const indexTouncheck = this.selectedCheckboxesNew.findIndex(
            (item) => item.start === sensor.start
          );
          if (indexTouncheck === -1) {
            sensor.checked = false;
            sensor.scenes.forEach((scene) => {
              scene.checked = false;
            });
          }
        });
      }
      if (this.selectedCheckboxesNew.length === 0) {
        this.defaultSubdailyCount = 1;
        this.toggleDailyRecurrency(event);
      }
      if (this.selectedCheckboxesNew.length > 0) {
        this.scenesNew.map((scene: any, index: any) => {
          if (scene.scene?.start == sensorSelected.start) {
            this.clearRFSignalsByScene(scene);
          }
        });
        this.scenesNew = this.scenesNew.filter((scene: any) => {
          return (
            scene.scene?.start !=
            this.collection.recurrencyArray[recurrencyIndex].start
          );
        });
        if (this.selectedSubDailyItemsNew.length > 0) {
          this.selectedSubDailyItemsNew = [];
          this.clearRFSignalsNew();
          this.scenesNew = [];
          this.defaultSubdailyCount =
            this.selectedCheckboxesNew[0].scenes[0].sequence;
          this.selectOptionNew(this.selectedCheckboxesNew[0], 'compare');
        } else if (this.selectedSubDailyItemsNew.length == 0) {
          this.defaultSubdailyCount = 0;
          this.selectOptionNew(this.selectedCheckboxesNew[0], 'compare');
        }
      }
    }
    this.setLeftandRightBands(this.selectedCheckboxesNew);
  }

  displayRFBandNew(scene, sensorId, band) {
    this.mapLoad = false;
    this.spinnerService.hide();
    let customXbandIcon: any;
    let customSBandIcon: any;
    this.enableBand = false;
    if (band == 'all') {
      this.enableBand = true;
      this.leftBand = true;
    }
    if (scene?.pane == 'left') {
      customXbandIcon = L.icon({
        iconUrl: '../../../assets/images/cross.png',
        iconSize: [20, 20],
      });
      customSBandIcon = L.icon({
        iconUrl: '../../../assets/images/cross-S.png',
        iconSize: [20, 20],
      });
    } else {
      customXbandIcon = L.icon({
        iconUrl: '../../../assets/images/green-cross.png',
        iconSize: [20, 20],
      });
      customSBandIcon = L.icon({
        iconUrl: '../../../assets/images/green-cross-S.png',
        iconSize: [20, 20],
      });
    }
    let sBand: any;
    let xBand: any;
    let uslMarkers: any[] = [];
    let xbandLayers: any[] = [];
    let sbandLayers: any[] = [];
    let bboxs: any[] = [];
    if (this.mapPane == '') {
      this.mapPane = 'left';
    }
    (this.map as any).getPane(this.mapPane).style.zIndex = 451;
    if (scene?.metadata?.features?.length > 0) {
      let bbox = L.geoJSON(scene.metadata.features[0], { pane: 'left' });
      bbox.addTo(this.map).setStyle({
        fillColor: 'none',
        color: scene?.pane == 'left' ? 'red' : 'green',
      });
      bboxs.push(bbox);
      this.map.fitBounds(bbox.getBounds());
    }
    if (
      scene.x_band?.features?.length > 0 &&
      (band == 'xband' || band == 'all')
    ) {
      scene.x_band.features.forEach((feature: any, i: any) => {
        let lat = feature.geometry.coordinates[1];
        let lng = feature.geometry.coordinates[0];
        let properties = this.mapProperties(feature.properties);
        xBand = L.marker([lat, lng], {
          pane: 'left',
          icon: customXbandIcon,
        });
        this.attachTooltip(xBand, this.formatProperties(properties));
        xBand.addTo(this.map);
        xbandLayers.push(xBand);
      });
    }
    if (
      scene.s_band?.features?.length > 0 &&
      (band == 'sband' || band == 'all')
    ) {
      scene.s_band.features.forEach((feature: any, i: any) => {
        let lat = feature.geometry.coordinates[1];
        let lng = feature.geometry.coordinates[0];
        let properties = this.mapProperties(feature.properties);
        sBand = L.marker([lat, lng], {
          pane: 'left',
          icon: customSBandIcon,
        });
        this.attachTooltip(sBand, this.formatProperties(properties));
        sBand.addTo(this.map);
        sbandLayers.push(sBand);
      });
    } else {
      if (!scene?.s_band && !scene?.x_band) {
        if (scene?.uslFootprint?.features.length > 0) {
          scene.uslFootprint.features.forEach((feature: any, i: any) => {
            let lat = feature.geometry.coordinates[1];
            let lng = feature.geometry.coordinates[0];
            let properties = this.mapProperties(feature.properties);
            let uslmarker = L.marker([lat, lng], {
              pane: 'left',
              icon: L.icon({
                iconUrl: '../../../assets/images/cross.png',
                iconSize: [20, 20],
              }),
            });
            this.attachTooltip(uslmarker, this.formatProperties(properties));
            uslmarker.addTo(this.map);
            uslMarkers.push(uslmarker);
          });
          this.map.fitBounds(L.geoJSON(scene?.uslFootprint).getBounds());
        }
      }
    }

    this.scenesNew.push({
      id: scene.id,
      sensorId: sensorId,
      scene: scene,
      bboxs: bboxs,
      sbands: sbandLayers,
      xbands: xbandLayers,
      uslMarkers: uslMarkers,
      pane: this.mapPane,
    });
  }

  displaySubdailyRFBandNew(scene, subDailyCount, band) {
    let customIcon = L.icon({
      iconUrl: 'assets/images/cross-icon.svg',
      iconSize: [18, 90],
    });
    let sBand: any;
    let xBand: any;
    let xbandLayers: any[] = [];
    let sbandLayers: any[] = [];
    let bboxs: any[] = [];
    let bbox = L.geoJSON(scene.metadata.features[0], { pane: 'left' });
    bbox.addTo(this.map).setStyle({ fillColor: 'none', color: 'green' });
    bboxs.push(bbox);
    if (band == 'xband' || band == 'all') {
      scene.x_band.features.forEach((feature: any, i: any) => {
        let lat = feature.geometry.coordinates[1];
        let lng = feature.geometry.coordinates[0];
        let properties = feature.properties;
        xBand = L.marker([lat, lng], {
          pane: 'left',
          icon: customIcon,
        });
        this.attachTooltip(
          xBand,
          `<span style="text-transform: capitalize;">
            ${this.formatProperties(properties)}
            </span>`
        );
        xBand.addTo(this.map);
        xbandLayers.push(xBand);
      });
    }
    if (band == 'sband' || band == 'all') {
      scene.s_band.features.forEach((feature: any, i: any) => {
        let lat = feature.geometry.coordinates[1];
        let lng = feature.geometry.coordinates[0];
        let properties = feature.properties;
        sBand = (L as any).circleMarker([lat, lng], { pane: 'left' });
        this.attachTooltip(
          sBand,
          `<span style="text-transform: capitalize;">
            ${this.formatProperties(properties)}
        </span>`
        );
        sBand.addTo(this.map);
        sBand.setStyle({ color: 'red', fillColor: 'none' });
        sbandLayers.push(sBand);
      });
    }
    this.map.fitBounds(bbox.getBounds());
    this.scenesNew.push({
      id: scene.id,
      subDailyCount: subDailyCount,
      scene: scene,
      bboxs: bboxs,
      sbands: sbandLayers,
      xbands: xbandLayers,
    });
  }

  createColoredIcon(color) {
    return L.divIcon({
      className: 'custom-marker',
      html: `<div style="background-color: ${color}; width: 8px; height: 8px; border-radius: 50%;"></div>`,
      iconSize: [10, 10],
      iconAnchor: [5, 5],
    });
  }

  calculateCombineBound() {
    if (this.scenesNew.length > 0) {
      let maxNorth = -Infinity;
      let maxEast = -Infinity;
      let minSouth = Infinity;
      let minWest = Infinity;
      this.scenesNew.forEach((scene) => {
        const bounds = scene.leftImageLayer.getBounds();
        const northEast = bounds.getNorthEast();
        const southWest = bounds.getSouthWest();
        if (northEast.lat > maxNorth) maxNorth = northEast.lat;
        if (northEast.lng > maxEast) maxEast = northEast.lng;
        if (southWest.lat < minSouth) minSouth = southWest.lat;
        if (southWest.lng < minWest) minWest = southWest.lng;
      });
      const customBounds: any = L.latLngBounds(
        L.latLng(minSouth, maxEast),
        L.latLng(maxNorth, maxEast)
      );
      return customBounds;
    }
  }

  selectedSignals: any[] = [];
  displayRFSignalsNew(scene, sensorId, selectedsignal) {
    if (scene?.start) {
      scene.openWindow = scene.start;
    }
    let sensor = this.selectedCheckboxesNew.find(
      (selectedCheckbox) =>
        new Date(selectedCheckbox.start).getTime() ==
        new Date(scene.openWindow).getTime()
    );
    let signalLayers: any[] = [];
    this.mapLoad = false;
    this.spinnerService.hide();
    this.enableBand = false;
    if (this.mapPane == '') {
      this.mapPane = 'left';
    }
    (this.map as any).getPane(this.mapPane).style.zIndex = 451;
    for (const signal of scene.signalOfInterest) {
      const signalWithSceneId = {
        ...signal,
        sceneId: scene.id,
        sensorId: sensorId,
      };
      if (selectedsignal === 'All') {
        signalLayers.push(signalWithSceneId);
      } else if (signal.product === selectedsignal) {
        signalLayers.push(signalWithSceneId);
      }
      let vhfsignals = signalLayers.filter(
        (signalLayer) => signalLayer.product == 'VHF'
      );
      if (vhfsignals.length > 0) {
        this.audioAvailable = true;
      }
      if (signalWithSceneId?.product === 'VHF') {
        this.selectedSignals.push(signalWithSceneId);
      }
    }

    const multiPolygonSignals = signalLayers.map((signal) => {
      return signal.features
        .filter(
          (feature) =>
            feature.geometry?.type === 'MultiPolygon' ||
            feature.geometry?.type === 'Polygon'
        )
        .map((feature) => {
          if (feature.properties) feature.properties.product = signal.product;
          return feature;
        });
    });
    let rfSignalLayers: any[] = [];
    let centerMarkers: any[] = [];
    let tooltip;
    multiPolygonSignals.forEach((multiPolygonSignal) => {
      const signalGeoJson = L.geoJSON(multiPolygonSignal, {
        onEachFeature: (feature, layer: any) => {
          const timeStamp = feature?.properties?.utc;
          let date = '';
          if (timeStamp) {
            date = new Date(timeStamp).toISOString();
          }
          if (feature.properties) {
            if (
              feature.properties.title == 'Estimated Emitter and Error Ellipse'
            ) {
              if (feature.properties.band == 'VHF') {
                layer.setStyle({ color: 'yellow' });
              }
              if (feature.properties.band == 'UHF') {
                layer.setStyle({ color: 'darkgrey' });
              }
              if (feature.properties.band == 'GPS L1') {
                layer.setStyle({ color: 'green' });
              }
              if (feature.properties.band == 'GPS L2') {
                layer.setStyle({ color: 'hotpink' });
              }
              if (feature.properties.band == 'GPS L5') {
                layer.setStyle({ color: 'yellowgrey' });
              }
              if (feature.properties.band == 'L-band(ADS-B)') {
                layer.setStyle({ color: 'magenta' });
              }
              if (feature.properties.band == 'L-band(GNSS)') {
                layer.setStyle({ color: 'blue' });
              }
              if (feature.properties.band == 'L-band(SATCOM)') {
                layer.setStyle({ color: 'darkgreen' });
              }
              const centerMarker = L.marker(layer.getBounds().getCenter(), {
                icon: this.createColoredIcon(
                  sensor?.pane == 'left' ? 'red' : 'green'
                ),
              }).addTo(this.map);
              const tooltipContent = `
                   <strong>Signal: </strong> ${feature.properties.product}<br>
                    <strong>Lng: </strong> ${feature.properties.lon}<br>
                    <strong>Lat: </strong> ${feature?.properties.lat}<br>
                    <strong>Timestamp UTC: </strong> ${date}<br>
                    <strong>Error radius: </strong> ${feature?.properties?.error_radius}
                `;

              this.attachTooltip(centerMarker, tooltipContent);
              centerMarkers.push(centerMarker);
              const CurrenttooltipContent = `
                    <strong>Signal: </strong> ${feature.properties.product}<br>
                    <strong>Lng: </strong> ${feature.properties.lon.toFixed(
                      2
                    )}<br>
                    <strong>Lat: </strong> ${feature.properties.lat.toFixed(
                      2
                    )}<br>
                    <strong>Title: </strong> ${feature.properties.title}
                `;
              this.attachTooltip(layer, CurrenttooltipContent);
            } else {
              layer.setStyle({ color: 'blue' });
            }
          } else {
            layer.setStyle({ color: 'blue' });
          }
        },
      }).addTo(this.map);
      rfSignalLayers.push(signalGeoJson);
    });
    this.scenesNew.push({
      id: scene.id,
      scene: scene,
      signalLayers: rfSignalLayers,
      pane: this.mapPane,
      sensorId: sensorId,
      centerMarkers: centerMarkers,
    });
    if (rfSignalLayers.length > 0) {
      this.map.fitBounds(rfSignalLayers[0].getBounds());
    }
  }

  openAudioSignals() {
    const hasAudioFiles = this.selectedSignals.some(
      (item) => item.audioFiles && item.audioFiles.length > 0
    );
    if (hasAudioFiles) {
      let selectedSignals = this.selectedSignals.filter((signal) =>
        this.collection.sensors.some(
          (col) => col.id == signal.sensorId && col.operatorKey === 'Spire-RF'
        )
      );
      let sensorIds = selectedSignals.map((signal) => signal.sensorId);
      const sensorId = sensorIds;
      const action = 'audioDownload';
      const taskId = this.collection.taskId;
      const sensorObj = {
        sensorId: sensorId,
        sceneId: undefined,
        action: action,
        fileType: 'audio',
        taskId: taskId,
      };
      const dialogRef = this.matdialog.open(FilterPopupComponent, {
        width: '30%',
        backdropClass: 'blurr',
        disableClose: true,
        data: {
          type: 'audio',
          signals: selectedSignals,
          sensorData: sensorObj,
        },
      });
    } else {
      const message =
        'There is no audio recording within the AOI for this task.';
      this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
    }
  }

  clearRFBandsByScene(scene: any, isUslMarker: any) {
    if (scene?.xbands) {
      scene?.xbands.map((xband: any) => {
        this.map.removeLayer(xband);
      });
    }
    if (scene?.sbands) {
      scene?.sbands.map((sband: any) => {
        this.map.removeLayer(sband);
      });
    }
    if (scene?.bboxs) {
      scene?.bboxs.map((bbox: any) => {
        this.map.removeLayer(bbox);
      });
    }
    if (isUslMarker) {
      if (scene?.uslMarkers) {
        scene?.uslMarkers.map((marker: any) => {
          this.map.removeLayer(marker);
        });
      }
    }
  }

  clearRFBandsNew() {
    this.scenesNew.map((scene: any, index: any) => {
      this.clearRFBandsByScene(scene, true);
    });
  }

  clearRFSignalsByScene(scene: any) {
    if (scene?.signalLayers) {
      scene?.signalLayers.map((signalLayer: any) => {
        this.map.removeLayer(signalLayer);
      });
    }
    if (scene?.centerMarkers) {
      scene?.centerMarkers.map((centerMarker: any) => {
        this.map.removeLayer(centerMarker);
      });
    }
  }

  clearRFSignalsNew() {
    this.selectedSignals = [];
    this.scenesNew.map((scene: any, index: any) => {
      this.clearRFSignalsByScene(scene);
    });
  }

  getTooltipMessage(sensor) {
    this.tooltipDisabled = false;
    if (sensor.operatorKey === OPERATORS.CAPELLA) {
      this.downloadTooltip =
        'Click here for additional GEO, SLC and SICD files available for download';
    } else if (
      sensor.operatorKey === OPERATORS.UMBRA &&
      sensor?.isAdditionalProducts
    ) {
      this.downloadTooltip =
        'Click here for additional CPHD, SIDD, and SICD files available for download';
    } else if (
      sensor.operatorKey === OPERATORS.UMBRA &&
      sensor?.isAdditionalCSIProducts
    ) {
      this.downloadTooltip =
        'Click here for additional CSI-TIFF and CSI-SIDD files available for download';
    } else if (sensor.operatorKey === OPERATORS.SATELLOGIC) {
      this.downloadTooltip =
        'Click to request for the Orthorectified (L1D) product';
    }
  }

  onMouseOut() {
    this.tooltipDisabled = true;
    this.downloadTooltip = '';
  }

  downloadScn(url: any) {
    let link = document.createElement('a');
    link.setAttribute('type', 'hidden');
    link.href = url;
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  zipDownload(urls: any, taskId: any, sensorId: any, sceneId: any) {
    var zip = new JSZip();
    var count = 0;
    var zipFilename = 'zipFilename.zip';
    urls.forEach((url: any) => {
      const filename = url.split('/')[url.split('/').length - 1].split('?')[0];
      JSZipUtils.getBinaryContent(url, (err: any, data: any) => {
        if (err) {
          this.progress = 0;
          this.mapLoad = false;
          this.spinnerService.hide();
          this.freeze = false;
          this.downloadClick = false;
          const message =
            'An error occurred during processing and ingestion of the request. Please try after sometime.';
          throw err;
        }
        zip.file(filename, data, { binary: true });
        count++;
        const totalCount = urls.length;
        const percentComplete = Math.round((count / totalCount) * 100);
        this.progress = percentComplete;
        const sensorObj = {
          progress: this.progress,
          taskId: taskId,
          sensorId: sensorId,
          sceneId: sceneId,
          download: this.downloadClick,
        };
        this.downloadService.setProgress(sensorObj);
        if (count == urls.length) {
          this.progress = 0;
          this.mapLoad = false;
          this.spinnerService.hide();
          this.freeze = false;
          this.disable = false;
          zip.generateAsync({ type: 'blob' }).then(function (content) {
            const objectUrl: string = URL.createObjectURL(content);
            const link: any = document.createElement('a');
            link.download = `${taskId}.zip`;
            link.href = objectUrl;
            link.click();
          });
        }
      });
    });
  }

  /**
   *
   * @param i
   * @param j
   * @param k
   */
  fullDownload(i: any, j: any, k: any) {
    var urls: any = [];
    this.collections[i]?.taskCollection?.map((item: any, index: any) => {
      if (this.collections[i]?.sensorName.includes('Capella')) {
        [
          { path: 'HH', ext: '.tiff' },
          { path: 'metadata', ext: '.json' },
          { path: 'thumbnail', ext: '.png' },
          { path: 'preview', ext: '.tiff' },
        ]?.map((downlaodItem) => {
          urls.push(
            environment.eeDownloadUrl +
              `collections/orders/${this.collections[i].taskId}/${downlaodItem?.path}/${item}${downlaodItem?.ext}`
          );
        });
      } else {
        if (this.collections[i]?.sensorName.includes('Satellogic')) {
          urls.push(
            environment.eeDownloadUrl +
              `collections/orders/${this.collections[i].taskId}/delivery_zip/${item}.zip`
          );
        }
      }
    });
    if (this.collections[i]?.sensorName.includes('21AT')) {
      urls.push(
        environment.eeDownloadUrl +
          `collections/${this.collections[i].sensors[j].downloadUrl}`
      );
    }
  }

  checkDownloaded(scene: any): boolean {
    const isDownloaded =
      this.downloadedScene.includes(scene.id) || scene.downloaded;
    return isDownloaded;
  }

  checkSensorDownloaded(sensor: any): boolean {
    const isDownloaded =
      this.downloadedSensor.includes(sensor.id) || sensor.downloaded;
    return isDownloaded;
  }

  getAdditionalData(taskId: any, sensor: any) {
    let message: any;
    let sensorObj = {
      sensorId: sensor.id,
      taskId: taskId,
    };
    this.apiService.addCollectionData(sensorObj).subscribe((res: any) => {
      if (res) {
        if (res.msg === 'success' && res?.refundRequested) {
          message =
            'As you requested a refund of the L1B product, L1D is unavailable.';
          this.popupService.openPopup(
            CollectionPopupComponent,
            message,
            '',
            '40%'
          );
        } else if (res.msg === 'success') {
          const type = 'download';
          message =
            'Thank you for submitting additional files for download. You will be notified via email when the files are ready.';
          this.popupService.openPopup(
            WarningPopupComponent,
            message,
            type,
            '40%'
          );
        } else if (res.msg === 'already requested') {
          message =
            'The download request for additional files has either already been made and is being processed.';
          this.popupService.openPopup(
            CollectionPopupComponent,
            message,
            '',
            '40%'
          );
        } else if (res?.msg === 'user storage') {
          const message =
            'We cannot download the image as the delivery was made to your storage. You can access the image via your storage.';
          this.popupService.openPopup(
            CollectionPopupComponent,
            message,
            '',
            '40%'
          );
        } else {
          message =
            'An error occurred during processing and ingestion of the request. Please try after sometime.';
          this.popupService.openPopup(
            CollectionPopupComponent,
            message,
            '',
            '40%'
          );
        }
      } else {
        message =
          'An error occurred during processing and ingestion of the request. Please try after sometime.';
        this.popupService.openPopup(
          CollectionPopupComponent,
          message,
          '',
          '40%'
        );
      }
    });
  }

  download(i: any, j: any, k: any, scene: any, mode: any = false) {
    let sceneId: any = [],
      scenesId: any = [];
    let sensorId: any, infoId: any, sensorObj: any;
    let action: any;
    let urls: any = [];
    let sensorDownloadId: any;
    let sceneType = mode == 'rawdataDownload' ? 'raw_iq' : '';
    const taskId = this.collections[i]?.taskId;
    this.ecursSensorObject = null;

    let refCount;
    const selcetedSensor = this.collection.sensors[j];
    if (
      selcetedSensor?.operatorKey === this.OPERATOR.CLYDE &&
      selcetedSensor.status === 'canceled'
    ) {
      const message =
        'The user has cancelled the task, and the data is unavailable';
      this.popupService.openPopup(WarningPopupComponent, message, '', '40%');
      return;
    }

    if (this.collection.sensors[j].operatorKey === OPERATORS.SPIRE) {
      refCount =
        this.collection.sensors[j].updatedRefreshes == 0
          ? 0
          : this.collection.sensors[j].updatedRefreshes ||
            this.collection.sensors[j].noOfRefreshes;
    }
    if (
      (refCount > 0 && scene.operatorKey === OPERATORS.SPIRE) ||
      scene.operatorKey !== OPERATORS.SPIRE
    ) {
      const endDate = new Date(this.collections[i].closeWindow);
      const currentDate = new Date();

      if (this.freeze) {
        const message =
          'A download is in progress. Please wait until the current download finishes to continue downloading others.';
        this.popupService.openPopup(
          CollectionPopupComponent,
          message,
          '',
          '40%'
        );
        return;
      } else if (
        ((scene?.downloaded ||
          this.checkDownloaded(scene) ||
          this.checkSensorDownloaded(scene)) &&
          !mode) ||
        scene?.rawIQDownloaded
      ) {
        let message = 'download';
        if (mode && scene?.rawIQDownloaded) {
          message = 'rawIQmessage';
        }
        this.popupService.openPopup(
          CollectionPopupComponent,
          message,
          '',
          '40%'
        );
        return;
      } else if (
        scene.operatorKey === OPERATORS.CLYDE &&
        endDate.getTime() < currentDate.getTime()
      ) {
        const message =
          'The time of interest (TOI) has been passed. Download is possible only during the TOI.';
        this.popupService.openPopup(
          CollectionPopupComponent,
          message,
          '',
          '40%'
        );
        return;
      } else this.spinnerService.show();
      this.freeze = true;
      this.fail = 0;
      this.progress = 0;
      this.downloadClick = true;
      const sensor = this.collections[i].sensors[j];

      if (scene?.insightDatas && !mode) {
        this.mapLoad = false;
        sensorId = scene?.sensorId;
        action = this.combinedScenes ? 'sensorFeed' : 'ISDownload';
        infoId = scene?._id;
        sceneId = this.selectedSceneNew.id;
        if (
          this.collections[i]?.sensors[j]?.operatorKey === OPERATORS.AXELSPACE
        )
          sceneId = scene?.sensorId;
        sensorObj = {
          sensorId: sensorId,
          sceneId: sceneId,
          action: action,
          feedId: infoId,
        };
      } else if (scene?.refreshId && !mode) {
        sensorId = scene?.sensorId;
        action = 'download';
        sceneId = sensor.scenes[0].id;
        sensorObj = {
          sensorId: sensorId,
          sceneId: sceneId,
          action: action,
          refreshId: scene?.refreshId,
        };
      } else if (k === undefined && !mode) {
        sensor.scenes.forEach(async (scn: any, index: any) => {
          sceneId.push(scn.id);
          scenesId.push(scn.id);
        });
        sensorId = sensor?.id;
        action = 'sensorDownload';
        sensorDownloadId = sensor?.id;
        sensorObj = { sensorId: sensorId, sceneId: sceneId, action: action };
      } else if (mode) {
        sensorId = this.collections[i].sensors[j].id;
        sensorDownloadId = this.collections[i].sensors[j].id;
        scenesId = scene?.id;
        action = mode;
        sensorObj = {
          sensorId: this.collections[i].sensors[j].id,
          sceneId: scene?.id,
          action: mode,
          type: 'zip',
        };
      } else {
        sceneId = scene?.id;
        scenesId.push(scene?.id);
        action = 'sceneDownload';
        sensorId = sensor?.id;
        sensorObj = {
          sensorId: sensorId,
          sceneId: sceneId,
          action: action,
          type: this.imageType,
        };
      }

      const downloadObj = {
        progress: this.progress,
        taskId: this.collections[i].taskId,
        sensorId: sensorDownloadId,
        sceneId: scenesId,
        download: this.downloadClick,
        type: sceneType,
      };
      if (!(sensor?.sensorType == 'InSAR') || k == undefined) {
        this.downloadService.setProgress(downloadObj);
      }
    }
    const proceedDownload = async () => {
      this.apiService
        .getCollectionImage(taskId, sensorObj)
        .subscribe(async (res: any) => {
          if (res?.msg === 'Failed' || res?.msg === 'user storage') {
            this.DisplayPopupsBasedOnResponse(res);
            this.downloadService.unsubscribeProgress();
          } else {
            for (const [index, item] of res.result.entries()) {
              let url = item;

              const xhr = new XMLHttpRequest();
              xhr.open('GET', url);
              xhr.responseType = 'blob';

              xhr.onprogress = (event) => {
                if (event.lengthComputable) {
                  const percentComplete = (event.loaded / event.total) * 100;
                  this.progress = percentComplete.toFixed(2);
                  const sensorObj = {
                    progress: this.progress,
                    taskId: this.collections[i].taskId,
                    sensorId: sensorDownloadId,
                    sceneId: scenesId,
                    download: this.downloadClick,
                    type: sceneType,
                  };
                  this.downloadService.setProgress(sensorObj);
                }
              };

              xhr.onload = () => {
                if (xhr.status === 200) {
                  const blob = xhr.response;
                  const fileName = this.getFileNameFromS3SignedUrl(url);
                  const link = document.createElement('a');
                  link.href = URL.createObjectURL(blob);
                  link.download = fileName;
                  link.click();
                  URL.revokeObjectURL(link.href);

                  // Reset progress after download
                  this.progress = 0;
                  this.spinnerService.hide();
                  this.freeze = false;
                  this.disable = false;
                  if (mode == 'rawdataDownload') scene.rawIQDownloaded = true;
                } else {
                  this.showDownloadError();
                }
              };

              xhr.onerror = () => {
                this.showDownloadError();
                // Handle errors
              };
              xhr.send();
            }
          }
        });
    };
    if (scene?.refreshId && !mode) {
      const sensor = this.collections[i].sensors[j];

      this.displayRefreshData(
        '$event',
        sensor.scenes[0],
        sensor,
        action,
        scene
      );
    } else if (
      ((scene.operatorKey === OPERATORS.SPIRE && scene.aisDownloadable) ||
        (scene.operatorKey === OPERATORS.CLYDE && scene.aisAvailable)) &&
      !mode
    ) {
      const sensors = this.collections[i].sensors[j];
      this.AISDownload(sensors);
    } else {
      if (
        (scene?.operatorKey == OPERATORS.ECURS ||
          scene?.operatorKey == OPERATORS.ECURS_L) &&
        this.collections[i].sensors[j].sensorType === 'InSAR' &&
        k != undefined &&
        !mode
      ) {
        let sceneIds = [scene.id];
        let index = this.collections[i].sensors[j]?.scenes.findIndex(
          (scn) => scn.id == scene.id
        );
        if (index > 0) {
          const scenes = this.collections?.[i]?.sensors?.[j]?.scenes ?? [];
          const downloadedSet = new Set(this.downloadedScene ?? []);
          const prior = scenes.slice(0, Math.max(0, index));

          const missingPrevScenes: any[] = prior.filter(
            (s) => s && !(s.downloaded || downloadedSet.has(s.id))
          );
          if (missingPrevScenes.length > 0) {
            const message = 'downloadWarning';
            this.downloadClick = false;
            this.freeze = false;
            const dialog = this.popupService.openPopup(
              CollectionPopupComponent,
              message,
              '',
              '40%'
            );
            dialog.afterClosed().subscribe((res) => {
              if (res == 'cancel') {
                this.freeze = false;
                this.fail = 0;
                this.progress = 0;
                this.downloadClick = false;
                return;
              } else if (res == 'yes') {
                const dialog = this.popupService.openPopup(
                  CollectionPopupComponent,
                  'downloadProgress',
                  '',
                  '40%'
                );
                dialog.afterClosed().subscribe((res) => {
                  this.downloadClick = true;
                  this.freeze = false;
                  missingPrevScenes.forEach((scn) => {
                    sceneIds.push(scn.id);
                  });
                  sensorObj = {
                    sensorId: sensorId,
                    sceneIds: sceneIds,
                    action: action,
                    type: this.imageType,
                  };
                  this.ecursSensorObject = sensorObj;
                  proceedDownload();
                });
              } else if (res == 'no') {
                this.downloadClick = true;
                this.freeze = false;
                sensorObj = {
                  sensorId: sensorId,
                  sceneIds: sceneIds,
                  action: action,
                  type: this.imageType,
                };
                this.ecursSensorObject = sensorObj;
                proceedDownload();
              }
            });
          } else {
            this.ecursSensorObject = sensorObj;
            proceedDownload();
          }
        } else {
          sensorObj = {
            sensorId: sensorId,
            sceneIds: sceneIds,
            action: action,
            type: this.imageType,
          };
          proceedDownload();
        }
      } else {
        proceedDownload();
      }
    }
    return;
  }
  getFileNameFromS3SignedUrl(signedUrl) {
    const filename = signedUrl
      .split('/')
      [signedUrl.split('/').length - 1].split('?')[0];
    return `${filename}`;
  }

  handleclickMenuItemWithAbort(menuItem: ProjectInfo, index: number) {
    this.observationEnabled =false;
    if (this.opManager?.isOperationRunning) {
      return this.showAbortRetainPopup().then((shouldAbort) => {
        if (shouldAbort) {
          this.opManager.abortOperation();
          this.resetAllFeedPanels();
          this.clearAllPredictionData();
          this.clearFilteredLayerAndRestore(true);
          this.resetMapNew();
          this.progressing = false;
          this.spinnerService.hide();
          return this.clickMenuItem(menuItem, index);
        }
      });
    }
    return this.clickMenuItem(menuItem, index);
  }

  clickMenuItem(menuItem, index) {
    this.resetAllFeedPanels();
    this.clearAllPredictionData();
    this.fail = 0;
    this.imageType = this.checkType();
    this.mapPane = '';
    this.audioAvailable = false;
    this.selectedSignals = [];
    this.jump = false;
    this.mapLoad = false;
    this.sliderView = false;
    this.sliderDateRangeArray = [];
    this.recurrentSlider = false;
    this.isCompare = false;
    this.isCompareClicked = false;
    this.taskSelected = false;
    this.selectedSubDailyItems = [];
    this.selectedSubDailyItemsNew = [];
    this.subDailyFinalArray = [];
    this.selectedCheckboxes = [];
    this.subDailyArray = [];
    this.showDailyRecurrencyCheckboxes = false;
    this.spinnerService.hide();
    this.loadTiff = false;
    this.operatorArray = [];
    this.defaultSubdailyCount = 1;
    this.showDailyRecurrencyCheckboxes = false;
    this.subDailyCount = '';
    this.selectedSubdaily = '';
    this.selectedBand = 'all';
    this.scnLyr = [];
    this.scnLyr2 = [];
    this.taskCollection = '';
    this.selectedSites = [];
    this.collections = [];
    this.collection = null;
    this.subDailyCountarray = [];
    this.isSitechanged = false;
    this.resetMapNew();
    this.emissionMessage = '';
    this.scenes = [];
    this.sensors = [];
    this.sliderShow = false;
    this.removeVectorOverlay();
    this.imageType = 'png';
    this.feedUi = { showFilterIcon: false };
    this.filterInfoVisible = false;
    this.combinedScenes = false;
    if (
      (this.previousSelectedProject !== null &&
        JSON.stringify(this.previousSelectedProject) !==
          JSON.stringify(menuItem)) ||
      this.previousSelectedProject === null
    ) {
      this.previousSelectedProject = menuItem;
      this.getCollections(menuItem?.projectid, 0);
      this.projectName = menuItem?.project;
      this.collectionIndex = 0;
    }

    this.removeISLayers();
    if (this.displayedIS) {
      this.displayedIS = null;
    }
    if (this.getCollectionSub) {
      this.getCollectionSub.unsubscribe();
      this.spinnerService.hide();
    }
    this.unSubscribeAPI();
  }

  unSubscribeAPI() {
    // If already fetching prediction → cancel it
    if (this.predictionSubscription) {
      this.predictionSubscription.unsubscribe();
      this.predictionSubscription = null;
      this.progressing = false;
    }
  }

  getCollections(item, idx) {
    this.taskCollection = '';
    this.sliderView = false;
    this.timeseries = false;
    this.jump = false;
    this.currentSliderValue = 0;
    this.signalSelected = 'All';
    this.feedInfo = false;
    this.removeDynamicLayer();

    this.clydeHistoricalLayer.map((layer) => {
      this.map.removeLayer(layer.marker);
    });
    this.spireHistoricalLayer.map((layer) => {
      this.map.removeLayer(layer.marker);
    });
    this.clydeHistoricalLayer = [];
    this.spireHistoricalLayer = [];
    if (this.displayedIS) {
      this.displayedIS = null;
    }
    this.apiService.getCollections(item).subscribe((res: any) => {
      this.dataSource = res.result;
      if (res.result?.length > 0) {
        this.collectionsData = res.result;
        this.collections = [];
        this.fullCollection = [];
        let count: any;
        res.result.forEach((item, index) => {
          const project = item.project;
          const taskname = item.taskname;
          const createdDate = item?.createdAt;
          const taskId = item.id;
          const questionId = item.questionId;
          let sensorName = item?.sensors?.[0]?.sensor;
          const target = JSON.parse(item.target);
          const sensors: any = [];
          const start: Date = new Date(item?.openWindow);
          const end: Date = new Date(item?.closeWindow);
          let datesArray: any[] = [];
          if (
            item?.repeatFrequency === 'Daily' ||
            item?.repeatFrequency === 'Sub-daily'
          ) {
            count = 1;
            this.dateRange = false;
          } else if (item?.repeatFrequency === 'Weekly') {
            count = 7;
            this.dateRange = true;
          } else if (item?.repeatFrequency === 'Monthly') {
            count = 30;
            this.dateRange = true;
          }

          function generateDateRangeArray(startDate, endDate, daysInterval) {
            const dateRangeArray: any = [];
            let currentDate = new Date(startDate);
            while (currentDate <= endDate) {
              let isDisabled = true;
              let scenesFilterarray: any = [],
                scenesList: any = [];
              const endDateCopy = new Date(currentDate);
              endDateCopy.setDate(endDateCopy.getDate() + daysInterval - 1);
              if (endDateCopy > endDate) {
                endDateCopy.setTime(endDate.getTime());
              }
              endDateCopy.setUTCHours(23, 59, 59, 0);
              const convertedStart = new Date(currentDate).toISOString();
              const convertedEnd = endDateCopy.toISOString();
              const startDateOnly = new Date(currentDate)
                .toISOString()
                .split('T')[0];

              for (const [
                sceneIndex,
                scenes,
              ] of item?.sensors?.[0].scenes.entries()) {
                scenes.operatorKey = item?.sensors[0]?.operatorKey;
                scenes.sceneName = scenes.name;
                const datePredicted = scenes.predicted_date;
                let PredictedDateOnly;
                if (scenes.predicted_date != undefined) {
                  PredictedDateOnly = new Date(scenes.predicted_date)
                    .toISOString()
                    .split('T')[0];
                }
                if (
                  (item?.repeatFrequency === 'Sub-daily' ||
                    item?.repeatFrequency === 'Daily') &&
                  PredictedDateOnly == startDateOnly &&
                  scenes.status !== 'error'
                ) {
                  const indexToRemove = scenesFilterarray.findIndex(
                    (item) => item.predicted_date === scenes.predicted_date
                  );
                  if (indexToRemove === -1) {
                    scenesFilterarray.push(scenes);
                    isDisabled = false;
                  }
                } else if (
                  datePredicted >= convertedStart &&
                  datePredicted <= convertedEnd &&
                  scenes.status !== 'error'
                ) {
                  const indexToRemove = scenesFilterarray.findIndex(
                    (item) => item.predicted_date === scenes.predicted_date
                  );
                  if (indexToRemove === -1) {
                    scenesFilterarray.push(scenes);
                    isDisabled = false;
                  }
                }
              }
              scenesFilterarray.forEach((element, index) => {
                element.sceneIdx = index + 1;
                if (element?.id != null && element?.status != 'failed') {
                  scenesList.push({ id: element.id });
                }
              });
              const unfailedScenes = scenesFilterarray.filter(
                (scene) => scene.status != 'failed'
              );
              if (unfailedScenes.length === 0) isDisabled = true;
              dateRangeArray.push({
                start: convertedStart,
                end: convertedEnd,
                repeatFrequency: item?.repeatFrequency,
                checked: false,
                disabled: isDisabled,
                scenes: scenesFilterarray,
                scenesList: scenesList,
                InfoServices: item?.sensors?.[0].informationServices || []
              });
              currentDate.setDate(currentDate.getDate() + daysInterval);
            }
            return dateRangeArray;
          }

          function hasTimeReached(openWindow) {
            const targetTime = new Date(openWindow);
            const currentTime = new Date();
            return currentTime >= targetTime;
          }

          function hasCloseWindowPassed(closeWindow) {
            const closeTime = new Date(closeWindow);
            const currentTime = new Date();

            return currentTime > closeTime;
          }

          if (item?.frequency === 1) {
            const dateRange = generateDateRangeArray(start, end, count);
            datesArray = dateRange;
          }
          item.sensors.forEach((sensor, i) => {
            const scenes: any = [];
            const scenesList: any = [];
            const startDate = new Date(item?.openWindow);
            const endDate = new Date(item?.closeWindow);
            let gropVessel: any;
            let valueAddedOption: any;
            let superResolutions: any;
            let indicesDetails: any;
            if (sensor?.operatorKey === this.OPERATOR.GHG) {
              const daysInterval = 30;
              datesArray = [];
              item.repeatFrequency = 'GHG-Monthly';
              this.dateRange = true;
              const dateRange = generateDateRangeArray(
                startDate,
                endDate,
                daysInterval
              );
              datesArray = dateRange;
              function generateDateRangeArray(
                startDate,
                endDate,
                daysInterval
              ) {
                const dateRangeArray: any = [];
                let currentDate = new Date(startDate);
                while (currentDate <= endDate) {
                  let isDisabled = true;
                  let scenesFilterarray: any = [],
                    scenesList: any = [];
                  const endDateCopy = new Date(currentDate);
                  endDateCopy.setDate(endDateCopy.getDate() + daysInterval - 1);
                  if (endDateCopy > endDate) {
                    endDateCopy.setTime(endDate.getTime());
                  }
                  endDateCopy.setUTCHours(23, 59, 59, 0);
                  const convertedStart = new Date(currentDate).toISOString();
                  const convertedEnd = endDateCopy.toISOString();
                  for (const [
                    sceneIndex,
                    scenes,
                  ] of item?.sensors?.[0].scenes.entries()) {
                    scenes.operatorKey = item?.sensors[0]?.operatorKey;
                    const datePredicted = scenes.predicted_date;
                    if (
                      datePredicted >= convertedStart &&
                      datePredicted <= convertedEnd &&
                      scenes.status !== 'error'
                    ) {
                      const indexToRemove = scenesFilterarray.findIndex(
                        (item) => item.predicted_date === scenes.predicted_date
                      );
                      if (indexToRemove === -1) {
                        scenesFilterarray.push(scenes);
                        isDisabled = false;
                      }
                    }
                  }
                  scenesFilterarray.forEach((element, index) => {
                    element.sceneIdx = index + 1;
                    if (element?.id != null && element?.status != 'failed') {
                      scenesList.push({ id: element.id });
                    }
                  });
                  const unfailedScenes = scenesFilterarray.filter(
                    (scene) => scene.status != 'failed'
                  );
                  if (unfailedScenes.length === 0) isDisabled = true;
                  dateRangeArray.push({
                    start: convertedStart,
                    end: convertedEnd,
                    repeatFrequency: 'GHG-Monthly',
                    checked: false,
                    disabled: isDisabled,
                    scenes: scenesFilterarray,
                    scenesList: scenesList,
                  });
                  currentDate.setDate(currentDate.getDate() + daysInterval);
                }
                return dateRangeArray;
              }
            }

            if (sensor?.valueAddedOption) {
              valueAddedOption = this.getValueAddedOption(
                sensor?.valueAddedOption
              );
            }
            if (sensor?.super_resolution) {
              superResolutions = sensor?.super_resolution;
            }
            if (sensor?.indices) {
              indicesDetails = sensor?.indices;
            }
            if (sensor?.pastPredictions) {
              gropVessel = sensor?.pastPredictions.reduce((acc, item) => {
                if (!acc[item.mmsi]) acc[item.mmsi] = [];
                acc[item.mmsi].push(item);
                return acc;
              }, {} as { [key: string]: any[] });
              this.groupedVessels = gropVessel;
            }
            const isNonImagery = this.nonImageryKey.includes(
              sensor?.operatorKey ?? false
            );
            if (
              sensor?.scenes?.length > 0 &&
              sensor?.status != 'rejected' &&
              sensor?.status != 'approved' &&
              sensor?.status != 'review' &&
              sensor?.status != 'pending' &&
              sensor?.status != 'failed' &&
              ((sensor?.status != 'canceled' &&
                sensor?.operatorKey != OPERATORS.CLYDE) ||
                sensor?.operatorKey === OPERATORS.CLYDE)
            ) {
              sensor?.scenes?.forEach((scene, index) => {
                const predictedDate = new Date(
                  scene?.predicted_date
                ).getUTCDate();
                scene.checked = false;
                let thumbnailUrl;
                let aisAvailable = hasTimeReached(item?.openWindow);
                let aisDownloadable = hasCloseWindowPassed(item?.closeWindow);
                sensor.scenes[index] = scene;
                thumbnailUrl =
                  environment.eeTaskServer + '/' + scene.thumbnailUrl || '';
                if (scene.status != 'error') {
                  scenes.push({
                    id: scene.id,
                    name: `Scene ${index + 1}`,
                    sceneIdx: index + 1,
                    footprint: scene.footprint,
                    aisAvailable,
                    aisDownloadable,
                    openWindow: item?.openWindow,
                    closeWindow: item?.closeWindow,
                    metadata: scene.metadata,
                    metadata_tooltip: scene?.metadata_tooltip,
                    thumbnailUrl: thumbnailUrl,
                    previewUrl: scene.previewUrl,
                    downloadUrl: scene.downloadUrl,
                    checked: false,
                    color: 'primary',
                    imageType: this.imageType,
                    scene_id: scene?.scene_id,
                    predictedDate: scene?.predicted_date,
                    status: scene?.status,
                    RRdeliveryDate: scene?.RRdeliveryDate,
                    sequenceNumber: scene?.sequence,
                    uslFootprint: scene?.usl_footprint,
                    s_band: scene?.s_band,
                    x_band: scene?.x_band,
                    operatorKey: sensor?.operatorKey,
                    downloaded: scene?.downloaded,
                    refundRequest: scene?.refundRequest,
                    returnRefundAccept: scene?.returnRefundAccept,
                    returnRefundReject: scene?.returnRefundReject,
                    siteId: scene?.siteId,
                    target: scene?.target,
                    isName: scene?.isName,
                    png_footprint: scene?.png_footprint,
                    tif_footprint: scene?.tif_footprint,
                    legendScale: scene?.legendScale,
                    legend_min: scene?.legend_min,
                    legend_max: scene?.legend_max,
                    legend_long: scene?.legend_long,
                    legend_lat: scene?.legend_lat,
                    ch4srData: scene?.ch4srData,
                    signals: this.getSignals(scene?.signalOfInterest),
                    signalOfInterest: scene?.signalOfInterest,
                    skipPreview: scene?.skipPreview,
                    isNonImagery: isNonImagery,
                    min: scene?.min,
                    max: scene?.max,
                    tif: false,
                    sceneName: scene.name,
                    rawIQDownloaded: scene?.raw_iq_downloaded,
                    rawIQIncluded: scene?.raw_iq_included,
                    tnqSensorType: sensor?.tnqSensorType,
                    pastPrediction: gropVessel,
                  });
                }

                for (const [idx, scene] of scenes.entries()) {
                  scene.name = `Scene ${idx + 1}`;
                  scene.sceneIdx = idx + 1;
                }

                if (scene?.id != null && scene?.status != 'failed') {
                  sensor.scenes[index] = scene;
                  scenesList.push({
                    id: scene.id,
                  });
                }
              });
              if (scenes.length > 0) {
                sensors.push({
                  name: sensor.sensor,
                  scenes,
                  checked: false,
                  id: sensor?.sensor_uuid,
                  downloadUrl: sensor?.downloadUrl,
                  scenesList,
                  latency: sensor?.latency,
                  downloaded: sensor?.downloaded,
                  resolution_tooltip: sensor.resolution_tooltip,
                  siteData: sensor?.siteData,
                  InfoServices: sensor.informationServices || [],
                  Observation: sensor.observation || [],
                  intervals: sensor?.intervals,
                  status: sensor?.status,
                  restoreStatus: sensor?.restoreStatus,
                  restoreOption: sensor?.restoreOption,
                  operatorKey: sensor?.operatorKey,
                  noOfRefreshes: sensor?.noOfRefreshes,
                  updatedRefreshes: sensor?.updatedRefreshes,
                  timeExpired: sensor?.timeExpired,
                  isHistorical: sensor?.isHistorical,
                  noOfHistoricalData: sensor?.noOfHistoricalData,
                  updatedFetches: sensor?.updatedFetches,
                  valueAddedOption: valueAddedOption,
                  superResolutions: superResolutions,
                  indicesDetails: indicesDetails,
                  isAdditionalCSIProducts: sensor?.isAdditionalCSIProducts,
                  obfuscateName: sensor?.obfuscateName,
                  unUsedRefreshes:
                    sensor.updatedRefreshes == 0
                      ? 0
                      : sensor.updatedRefreshes || sensor.noOfRefreshes,
                  unUsedFetches:
                    sensor.updatedFetches == 0
                      ? 0
                      : sensor.updatedFetches || sensor.noOfHistoricalData,
                  assetsDelivered: sensor?.assetsDelivered,
                  refreshHistory: sensor?.refreshHistory,
                  sensorType: sensor?.sensorType,
                  tnqSensorType: sensor?.tnqSensorType,
                  pastPrediction: gropVessel,
                  feed_results: sensor?.feed_results,
                  questionName: sensor?.questionName,
                  questionId: sensor?.questionId,
                });
              }
            }
          });
          let taskCollection = item?.taskcollection;
          let captures = item?.captures;
          let sensorsName = item?.sensorsName;
          let info = item?.info;
          if (sensors.length > 0) {
            this.collections.push({
              project,
              taskname,
              target,
              sensors,
              taskId,
              sensorName,
              taskCollection,
              captures,
              sensorsName,
              info,
              frequency: item?.frequency,
              repeatFrequency: item?.repeatFrequency,
              noOfRepeats: item?.noOfRepeats,
              recurrencyArray: datesArray,
              subDailyCount: item?.subDailyCount,
              feasibilityTask: item?.feasibilityTask,
              opportunityList: item?.opportunityList,
              projectId: item?.projectid,
              returnRefund: item?.returnRefund,
              createdDate,
              openWindow: item?.openWindow,
              closeWindow: item?.closeWindow,
              feedBased: item?.feed_based,
              questionId
            });
          }
        });
        const sensorWithData = this.collections[0].sensors.find(
          (sensor) => sensor.InfoServices
        );

        const sensorWithindicesDetails = this.collections[0].sensors.find(
          (sensor) => sensor.indicesDetails
        );

        const sensorWithSR = this.collections[0].sensors.find(
          (sensor) => sensor.superResolutions
        );
        if (sensorWithData) {
          const infoServicesLength = sensorWithData.InfoServices.length;
          this.selectedIS = Array(infoServicesLength).fill(false);
        }
        this.collection = this.collections[idx];
        this.taskName = this.collections[idx].taskname;
        this.taskid = this.collections[idx].taskId;
        this.sensorList = this.collections[idx].sensors;
        this.isFeedTasking = this.taskMode === 'feed' || (this.collections[idx].feedBased ?? false);
        this.fullCollection = JSON.parse(JSON.stringify(this.collections[idx]));
        this.recurrencyArray = this.collections[idx].recurrencyArray;
        if (sensorWithData) {
          this.collection.sensors.map((sensor) => {
            sensor.InfoServices.map((infoService) => {
              infoService.isDisable = true;
            });
          });
        }
        if (sensorWithindicesDetails) {
          this.collection.sensors.map((sensor) => {
            sensor.indicesDetails?.map((indicesDetails) => {
              indicesDetails.isDisable = true;
              indicesDetails.loadTif = false;
            });
          });
        }
        if (sensorWithSR) {
          this.collection.sensors.map((sensor) => {
            sensor.superResolutions?.map((superResolution) => {
              superResolution.isDisable = true;
            });
          });
        }
        if (
          (this.collection?.frequency === 1 &&
            this.collection?.recurrencyArray?.length > 0) ||
          this.collection?.recurrencyArray[0]?.repeatFrequency ===
            'GHG-Monthly' ||
          (this.collection?.feasibilityTask &&
            this.collection?.opportunityList?.length > 0)
        ) {
          this.recurrentTask = true;
        } else this.recurrentTask = false;
        this.taskCreatedDate = this.collections[idx].createdDate;
        for (const [
          sensorIndex,
          opprDates,
        ] of this.collection.opportunityList.entries()) {
          const givenDateObj = new Date(opprDates.date);
          givenDateObj.setHours(0, 0, 0, 0);
          opprDates.checked = false;
          opprDates.name = this.collections[idx].sensors[0].name;
          opprDates.id = this.collections[idx].sensors[0]?.id;
          opprDates.scenes = this.collections[idx].sensors[0].scenes.filter(
            (scene) => {
              const dateObj = new Date(scene.predictedDate);
              dateObj.setHours(0, 0, 0, 0);
              return givenDateObj.getTime() === dateObj.getTime();
            }
          );
        }
        if (
          (this.collections[idx]?.frequency === 1 &&
            this.collections[idx]?.recurrencyArray?.length > 0) ||
          this.collections[idx]?.repeatFrequency === 'GHG-Monthly'
        ) {
          this.initializeDefaultValue();
          this.selectOptionNew(
            this.collections[idx]?.recurrencyArray[0],
            'normal'
          );
        } else if (
          this.collections[idx]?.feasibilityTask &&
          this.collections[idx]?.opportunityList?.length > 0
        ) {
          this.selectOpportunity(
            this.collections[idx]?.opportunityList[0],
            'normal'
          );
        }
      } else {
        this.collectionsData = [];
      }
      this.spire = false;
      this.usl = false;
      this.lband = false;
      for (const [sensorIndex, sensor] of this.collections[
        idx
      ].sensors.entries()) {
        if (
          sensor?.operatorKey === OPERATORS.SPIRE ||
          sensor?.operatorKey === OPERATORS.CLYDE
        ) {
          this.spire = true;
        } else if (sensor?.operatorKey === OPERATORS.USL) {
          this.usl = true;
        } else if (sensor?.operatorKey === OPERATORS.LBAND) {
          this.lband = true;
        }
      }
      this.sensorLength = this.collections[idx].sensors.length;
    });
  }

  getSignals(signalOfInterest) {
    let signals;
    if (signalOfInterest) {
      signals = [
        {
          features: [],
          product: 'All',
          type: 'FeatureCollection',
        },
        ...signalOfInterest,
      ];
    }

    return signals;
  }

  selectSignals(sensor: any, signal: any) {
    this.signalSelected = signal;
    this.audioAvailable = false;
    this.clearRFSignalsNew();
    this.scenesNew = this.scenesNew.filter(
      (scnNew) => !scnNew.hasOwnProperty('signalLayers')
    );
    if (this.isCompare) {
      this.collection.recurrencyArray.forEach((recurrency) => {
        recurrency.scenes.forEach((scene) => {
          if (scene.checked) {
            this.displayRFSignalsNew(scene, sensor.id, this.signalSelected);
          }
        });
      });
    } else {
      sensor.scenes.map((scene: any) => {
        if (scene.checked == true) {
          this.displayRFSignalsNew(scene, sensor.id, this.signalSelected);
        }
      });
    }
  }

  getValueAddedOption(dataArray: any) {
    let productsData: any;
    productsData = dataArray[0];

    const productsInfo = ((productsData || {}).products || []).map(
      (product) => ({
        ...product,
        product_id: productsData.product_id,
        sensorid: productsData.sensorId,
        releaseRequest: dataArray[0]?.releaseRequest,
      })
    );

    productsInfo.sort((a, b) => {
      const actionA = a.product || '';
      const actionB = b.product || '';
      return actionA.localeCompare(actionB);
    });

    return productsInfo;
  }

  restTask() {
    this.selectedCheckboxes = [];
    this.showDailyRecurrencyCheckboxes = false;
  }

  handleclickTaskItemWithAbort(menuItem: ProjectInfo, index: number) {
    this.observationEnabled = false;
    if (this.opManager?.isOperationRunning) {
      return this.showAbortRetainPopup().then((shouldAbort) => {
        if (shouldAbort) {
          this.opManager.abortOperation();
          return this.clickTask(menuItem, index);
        }
      });
    }
    return this.clickTask(menuItem, index);
  }

  clickTask(taskItem, index) {
    this.removeVectorOverlay();
    (this.imageType = 'png'), (this.loadTiff = false);
    this.feedUi = { showFilterIcon: false };
    this.taskSelected = true;
    this.taskCollection = JSON.parse(JSON.stringify(taskItem));
    this.collectionIndex = JSON.parse(JSON.stringify(index));
    this.defaultSubdailyCount = 1;
    this.isSitechanged = false;
    this.filterInfoVisible = false;
    this.toggleDailyRecurrency(index);
    this.resetAllFeedPanels;
    this.clearAllPredictionData();
    this.combinedScenes = false;
    this.sliderShow = false;
    if (this.getCollectionSub) {
      this.getCollectionSub.unsubscribe();
      this.spinnerService.hide();
    }
    this.unSubscribeAPI();
  }

  selectOpportunity(event, type: any) {
    this.opportunityId = event.oppid[0];
    this.filteredCollection = [];
    let scenesList: any = [];
    const collection = this.fullCollection;
    let opportunityDate = new Date(event.date);
    opportunityDate.setHours(0, 0, 0, 0);
    this.selectedStartDate = event.date;
    for (const [sensorIndex, sensors] of collection.sensors.entries()) {
      let sceneArray: any = [];
      for (const [sceneIndex, scenes] of sensors.scenes.entries()) {
        let predictedDate = new Date(scenes.predictedDate);
        predictedDate.setHours(0, 0, 0, 0);
        scenes.checked = false;
        if (predictedDate.getTime() === opportunityDate.getTime()) {
          sceneArray.push(scenes);
        }
      }
      sceneArray.forEach((element, index) => {
        element.sceneIdx = index + 1;
        if (element?.id != null && element?.status != 'failed') {
          scenesList.push({ id: element.id });
        }
      });
      this.collection.sensors[sensorIndex].scenesList = scenesList;
      this.collection.sensors[sensorIndex].scenes = sceneArray;
    }
    this.collection.sensors.forEach((element, index) => {
      element.checked = false;
    });
    this.resetFeedsStatus(this.collection);
    this.resetMapNew();
    this.removeVectorOverlay();
  }

  selectSiteOptionNew(event, type: any) {
    this.selectOptionNew(event, type);
  }

  selectOptionNew(event, type: any) {
    this.subSelectionSelectionChange.next(1);
    this.filteredCollection = [];
    let scenesList: any = [];
    const collection = this.fullCollection;
    this.sceneBands = '';
    this.selectedStartDate = '';
    this.selectedEndDate = '';
    const parseLocalBoundaryDate = (value: any, endOfDay = false) => {
      if (value instanceof Date) {
        return new Date(
          value.getFullYear(),
          value.getMonth(),
          value.getDate(),
          endOfDay ? 23 : 0,
          endOfDay ? 59 : 0,
          endOfDay ? 59 : 0,
          endOfDay ? 999 : 0
        );
      }

      const datePart = String(value ?? '').split('T')[0];
      const [year, month, day] = datePart.split('-').map(Number);

      if (!year || !month || !day) {
        const fallbackDate = new Date(value);
        return new Date(
          fallbackDate.getFullYear(),
          fallbackDate.getMonth(),
          fallbackDate.getDate(),
          endOfDay ? 23 : 0,
          endOfDay ? 59 : 0,
          endOfDay ? 59 : 0,
          endOfDay ? 999 : 0
        );
      }

      return new Date(
        year,
        month - 1,
        day,
        endOfDay ? 23 : 0,
        endOfDay ? 59 : 0,
        endOfDay ? 59 : 0,
        endOfDay ? 999 : 0
      );
    };
    const startDate = parseLocalBoundaryDate(event.start);
    const endDate = parseLocalBoundaryDate(event.end, true);
    const toLocalDateKey = (date: Date) => {
      const year = date.getFullYear();
      const month = `${date.getMonth() + 1}`.padStart(2, '0');
      const day = `${date.getDate()}`.padStart(2, '0');
      return `${year}-${month}-${day}`;
    };
    this.selectionChange.next(event);
    this.selectedValue = event;
    this.selectedStartDate = event.start;
    this.selectedEndDate = event.end;
    this.filterInfoVisible = false;
    for (const [sensorIndex, sensors] of collection.sensors.entries()) {
      let sceneArray: any = [];
      for (const [sceneIndex, scenes] of sensors.scenes.entries()) {
        let datePredicted = new Date(scenes.predictedDate);
        const predictedDate = scenes.predictedDate;
        scenes.checked = false;
        if (
          event?.repeatFrequency === 'Daily' &&
          datePredicted >= startDate &&
          datePredicted <= endDate
        ) {
          sceneArray.push(scenes);
        } else if (
          event?.repeatFrequency === 'Sub-daily' &&
          predictedDate !== undefined
        ) {
          const PredictedDateOnly = toLocalDateKey(new Date(scenes.predictedDate));
          const startDateOnly = toLocalDateKey(startDate);
          const endDateOnly = toLocalDateKey(endDate);
          if (
            PredictedDateOnly == startDateOnly &&
            PredictedDateOnly == endDateOnly
          ) {
            sceneArray.push(scenes);
          } 
        } else if (datePredicted >= startDate && datePredicted <= endDate) {
          sceneArray.push(scenes);
        }
      }
      sceneArray.forEach((element, index) => {
        element.sceneIdx = index + 1;
        if (element?.id != null && element?.status != 'failed') {
          scenesList.push({ id: element.id });
        }
      });
      
      this.collection.sensors[sensorIndex].scenesList = scenesList;
      this.collection.sensors[sensorIndex].scenes = sceneArray;
      this.checkForScenes(scenesList);
    }
    if (
      (type !== 'compare' &&
        ((this.previousSelection !== null &&
          JSON.stringify(this.previousSelection) !== JSON.stringify(event)) ||
          this.previousSelection === null)) ||
      type === 'compare'
    ) {
      this.previousSelection = event;
      if (event?.repeatFrequency !== 'GHG-Monthly') {
        this.collection.sensors.forEach((element, index) => {
          element.checked = false;
        });
      }
      this.filteredCollection = JSON.parse(JSON.stringify(this.collection));
      if (event?.repeatFrequency === 'Sub-daily') {
        this.selectSubdailyNew(this.defaultSubdailyCount, event);
      } else if (event?.repeatFrequency === 'GHG-Monthly') {
        if (type != 'compare') {
          this.resetMapNew();
          this.removeVectorOverlay();
        }
        this.selectSites(this.defaultSubdailyCount, event);
        this.checkForScenes(this.collection.sensors[0].scenes);
      } else if (type != 'compare') {
        this.resetMapNew();
        this.removeVectorOverlay();
      }
    } else {
      this.filteredCollection = JSON.parse(JSON.stringify(this.collection));
      if (event?.repeatFrequency === 'Sub-daily') {
        this.selectSubdailyNew(this.defaultSubdailyCount, event);
      } else if (event?.repeatFrequency === 'GHG-Monthly') {
        this.selectSites(this.defaultSubdailyCount, event);
      }
    }
    this.resetFeedsStatus(this.collection);
  }

  selectSubdailyNew(count: number, event: any) {
    if (this.selectedCheckboxes?.length > 1) return;
    this.subDailyCountarray = [];
    this.defaultSubdailyCount = count;
    let scenesList: any = [];
    for (const [
      sensorIndex,
      sensors,
    ] of this.filteredCollection.sensors.entries()) {
      let sceneArray: any = [];
      for (const [sceneIndex, scenes] of sensors.scenes.entries()) {
        scenes.checked = false;
        sceneArray.push(scenes);
      }
      sceneArray.forEach((element, index) => {
        element.sceneIdx = index + 1;
        if (element?.id != null && element?.status != 'failed') {
          scenesList.push({ id: element.id });
        }
      });
      this.collection.sensors[sensorIndex].checked = false;
      this.collection.sensors[sensorIndex].scenesList = scenesList;
      this.collection.sensors[sensorIndex].scenes = sceneArray;
    }
    this.checkForScenes(scenesList);
    for (let i = 0; i < this.collection?.subDailyCount; i++) {
      const countObject = {
        checked: false,
        value: i + 1,
        disabled: this.disabledCheck(i + 1),
      };
      this.subDailyCountarray.push(countObject);
      this.suppressSubDailyCheckbox = true;
    }
    const sequenceExists = this.collection?.recurrencyArray
     ?.some(r => r?.scenes?.some(s => s?.sequence !== undefined && s.sequence != null));

    if (sequenceExists && count !== 0) {
    this.collection?.recurrencyArray?.forEach((recurrency: any, i: any) => {
      let res = recurrency?.scenes?.filter(
        (scene: any) => scene?.sequence == count
      );
      if (res.length == 0) {
        recurrency.disabled = true;
      } else {
        recurrency.disabled = false;
      }
    });
  }

    if (!this.showDailyRecurrencyCheckboxes && !this.RF) {
      this.resetMapNew();
      this.removeVectorOverlay();
    }
    for (const [subdailyIndex, subdaily] of this.subDailyCountarray.entries()) {
      subdaily.checked = this.defaultSubdailyCount == subdailyIndex + 1;
    }
    let selectedSubdaily = this.subDailyCountarray.find(
      (subDaily) => subDaily.value == this.defaultSubdailyCount
    );
    if (
      this.isCompare &&
      this.selectedCheckboxesNew.length == 1 &&
      this.defaultSubdailyCount != 0
    ) {
      event.checked = true;
      this.selectSubdailyRecurrentNew(event, selectedSubdaily, false);
    }
  }

  clickSites(item: number, event: any) {
    if (!this.isCompare || this.timeseries) {
      this.resetMapNew();
      this.removeVectorOverlay();
    }
    this.isSitechanged = true;
    this.defaultSubdailyCount = item;
    this.resetScenesBySite(item, event);
    this.selectionChange.next(this.collection.recurrencyArray[0]);
    this.selectedValue = this.collection.recurrencyArray[0];
  }

  resetScenesBySite(item, event) {
    this.imageType = this.checkType();
    let scenesList: any = [];
    for (const [sensorIndex, sensors] of [
      this.collection.recurrencyArray[0],
    ].entries()) {
      let sceneArray: any = [];
      for (const [sceneIndex, scenes] of sensors.scenes.entries()) {
        scenes.checked = false;
        scenes.imageType = this.imageType;
        scenes.tif = false;
        scenes.predictedDate = scenes?.predicted_date;
        if (scenes?.siteId == item) {
          sceneArray.push(scenes);
        }
      }
      sceneArray.forEach((element, index) => {
        element.sceneIdx = index + 1;
        if (element?.id != null && element?.status != 'failed') {
          scenesList.push({ id: element.id });
        }
      });
      this.checkForScenes(sceneArray);
      if (this.timeseries) {
        this.currentSliderValue = 0;
        this.previousIndex = -1;
      }
      this.collection.sensors[sensorIndex].scenesList = scenesList;
      this.collection.sensors[sensorIndex].scenes = sceneArray;
      if (sensors.siteData) {
        this.collection.siteData = sensors.siteData;
      }
    }
    this.resetFeedsStatus(this.collection);
    for (const [
      siteIndex,
      site,
    ] of this.fullCollection?.sensors[0].siteData.entries()) {
      site.checked = false;
      site.value = siteIndex + 1;
      site.siteId = site.value;
      site.disabled = this.disabledSiteCheck(site.siteId);
    }
  }

  selectSites(item: number, event: any) {
    this.subDailyCountarray = [];
    this.defaultSubdailyCount = item;
    let scenesList: any = [];
    this.collection.siteData = [];
    if (!this.isCompare || this.timeseries) {
      this.resetMapNew();
      this.removeVectorOverlay();
    }
    for (const [
      sensorIndex,
      sensors,
    ] of this.filteredCollection.sensors.entries()) {
      let sceneArray: any = [];
      for (const [sceneIndex, scenes] of sensors.scenes.entries()) {
        scenes.checked = false;
        if (scenes?.siteId == item) {
          sceneArray.push(scenes);
        }
      }
      sceneArray.forEach((element, index) => {
        element.sceneIdx = index + 1;
        if (element?.id != null && element?.status != 'failed') {
          scenesList.push({ id: element.id });
        }
      });
      this.checkForScenes(sceneArray);
      if (this.timeseries) {
        this.currentSliderValue = 0;
        this.previousIndex = -1;
      }
      this.collection.sensors[sensorIndex].scenesList = scenesList;
      this.collection.sensors[sensorIndex].scenes = sceneArray;

      if (sensors.siteData) {
        this.collection.siteData = sensors.siteData;
      }
    }

    this.resetFeedsStatus(this.collection);

    for (const [siteIndex, site] of this.collection?.siteData.entries()) {
      site.checked = false;
      site.value = siteIndex + 1;
      site.siteId = site.value;
      site.disabled = this.disabledSiteCheck(item);
    }
    for (const [siteIndex, site] of this.collection?.siteData.entries()) {
      site.checked = this.defaultSubdailyCount == siteIndex + 1;
    }

    this.subDailyCountarray = this.collection?.siteData;
    this.fullsubDailyCountarray = JSON.parse(
      JSON.stringify(this.subDailyCountarray)
    );
    let selectedSite = this.fullsubDailyCountarray.find(
      (subDaily) => subDaily.siteId == this.defaultSubdailyCount
    );
    if (
      this.isCompare &&
      this.selectedCheckboxesNew.length <= 1 &&
      this.defaultSubdailyCount != 0
    ) {
      event.checked = true;
      this.selectSiteRecurrentNew(event, selectedSite);
    }
  }

  disabledCheck(count: number) {
    let sceneArray: any = [];
    for (const [
      sensorIndex,
      sensors,
    ] of this.filteredCollection.sensors.entries()) {
      for (const [sceneIndex, scenes] of sensors.scenes.entries()) {
        scenes.checked = false;
        if (scenes?.sequenceNumber == count) {
          sceneArray.push(scenes);
        }
      }
    }
    if (sceneArray.length === 0) return true;
    else return false;
  }

  disabledSiteCheck(count: number) {
    let sceneArray: any = [];
    for (const [
      sensorIndex,
      sensors,
    ] of this.filteredCollection.sensors.entries()) {
      for (const [sceneIndex, scenes] of sensors.scenes.entries()) {
        if (scenes?.siteId == count) {
          sceneArray.push(scenes);
        }
      }
    }
    if (sceneArray.length === 0) return true;
    else return false;
  }

  selectSubdailyRecurrentNew(event, data, isSubdailyCheck = true) {
      if (this.selectedCheckboxesNew.length === 1 && isSubdailyCheck) 
      this.suppressSubDailyCheckbox = false;
    if (this.suppressSubDailyCheckbox) {
      data.checked = false;
      this.suppressSubDailyCheckbox = false;
      return;
    }
    this.isShowSubDailyLegend = data.checked;
    if (this.showSubDailyList == false) {
      this.removeGHGLayer();
      this.removeLayers();
      this.clearRFBandsNew();
      this.scenesNew = [];
    }
    this.showSubDailyList = true;
        if (event.checked) {
      this.selectedSubDailyItems.push(data.value)
      this.subSelectionSelectionChange.next(data.value);
      this.selectedSites.push(data.siteName);
    }
    else {
      let countIndex = this.selectedSubDailyItems.findIndex(item => parseInt(item) === parseInt(data.value));
      this.selectedSubDailyItems.splice(countIndex, 1)
      this.subSelectionSelectionChange.next(this.selectedSubDailyItems[this.selectedSubDailyItems.length - 1]);
      let siteNameIndex = this.selectedSubDailyItems.findIndex(item => (item) === (data.siteName));
      this.selectedSites.splice(siteNameIndex, 1)
    }
    if (this.selectedSubDailyItems.length > 2) {
      // If more than 2 items are selected, remove the first selected item
      this.selectedSubDailyItems.shift();
    }
    if (!data.siteName) {
      this.subDailyCount = 'Sub-daily Count : ' + this.selectedSubDailyItems[0];
      this.selectedSubdaily = 'Sub-daily Count : ' + this.selectedSubDailyItems[1];
      } else {
      this.subDailyCount = 'Site Name : ' + this.selectedSites[0];
      this.selectedSubdaily = 'Site Name : ' + this.selectedSites[1];
    }
    if (event.checked) {
      this.annotateClicked = false;
      this.newTaskButtonClicked = false;
      this.removeAnnotationMarkers();
      this.collection?.recurrencyArray?.forEach((recurrency: any, i: any) => {
        let res = recurrency?.scenes?.filter(
          (scene: any) => scene?.sequence == data.value
        );
        if (res.length == 0) {
          recurrency.disabled = true;
        } else {
          recurrency.disabled = false;
        }
      });

      if (this.selectedSubDailyItemsNew.length == 0) {
        this.mapPane = 'left';
      } else if (
        this.selectedSubDailyItemsNew[this.selectedSubDailyItemsNew.length - 1]
          ?.mapPane == 'left'
      ) {
        this.mapPane = 'right';
      } else {
        this.mapPane = 'left';
      }
      data.mapPane = this.mapPane;
      this.selectedSubDailyItemsNew.push(data);
      this.subSelectionSelectionChange.next(data.value);
      if (this.selectedSubDailyItemsNew.length > 2) {
        let countIndex = 0;
        let selectedSubDaily = JSON.parse(
          JSON.stringify(this.selectedSubDailyItemsNew[countIndex])
        );
        this.subDailyFinalArray = this.subDailyFinalArray.filter((subDaily) => {
          return subDaily.scenes[0].sequenceNumber != selectedSubDaily.value;
        });
        if (this.compare) {
          this.map.removeControl(this.compare);
          this.compare = null;
        }
        const indices: any[] = [];
        this.scenesNew.forEach((scenenew, index) => {
          if (
            Number(scenenew.scene.sequenceNumber) === selectedSubDaily.value
          ) {
            indices.push(index);
          }
        });

        indices.forEach((scenenewIndex) => {
          let ghgIndex = this.ghgLayers.findIndex(
            (ghg) => ghg.scene.id == this.scenesNew[scenenewIndex].id
          );
          if (ghgIndex != -1) {
            this.removeGHGLayerByScene(this.ghgLayers[ghgIndex]);
            this.ghgLayers.splice(ghgIndex, 1);
          }
          this.removeLayerByScene(this.scenesNew[scenenewIndex], {
            paneSpecific: true,
          });
        });

        this.selectedSubDailyItemsNew.splice(countIndex, 1);
        this.scenesNew = this.scenesNew.filter((scenenew) =>
          this.selectedSubDailyItemsNew.some(
            (selectedSubDaily) =>
              Number(scenenew.scene.sequenceNumber) === selectedSubDaily.value
          )
        );
        this.subDailyCountarray.forEach((subDailyCount) => {
          if (selectedSubDaily.value == subDailyCount.value) {
            subDailyCount.checked = false;
            this.changDetectionRef.detectChanges();
          }
        });
      }
      let scenesList: any = [];
      const filterSubDailyArray = this.filteredCollection.sensors;
      let filterArray: any = [];
      let sensor: any;
      let sceneArray: any[] = [];
      this.subDailyCountarray.forEach((subDaily) => {
        if (subDaily.value == data.value) {
          subDaily.checked = true;
          this.changDetectionRef.detectChanges();
        }
      });

      this.selectedCheckboxesNew[this.selectedCheckboxesNew.length - 1].pane =
        this.mapPane;
      for (const [
        countIndex,
        count,
      ] of this.selectedSubDailyItemsNew.entries()) {
        let sceneArray: any;
        for (const [sensorIndex, sensor] of filterSubDailyArray.entries()) {
          sceneArray = this.filteredCollection.sensors[
            sensorIndex
          ].scenes.filter(
            (scene) => parseInt(scene?.sequenceNumber) === parseInt(count.value)
          );
          sceneArray.forEach((element, index) => {
            element.sensorId = sensor.id;
            element.start = sensor.start;
            element.sceneIdx = index + 1;
            element.pane = count.mapPane;
            element.start = this.selectedCheckboxesNew[0].start;
            if (element?.id != null && element?.status != 'failed') {
              scenesList.push({ id: element.id });
            }
          });
          filterArray.push({
            scenes: sceneArray,
            scenesList: scenesList,
            checked: event.checked,
            downloaded: sensor.downloaded,
            id: sensor.id,
            name: sensor.name,
            sequenceNumber: count.value,
            resolution_tooltip: sensor?.resolution_tooltip,
            downloadUrl: sensor?.downloadUrl,
            latency: sensor?.latency,
            status: sensor?.status,
            restoreStatus: sensor?.restoreStatus,
            restoreOption: sensor?.restoreOption,
            pane: count.mapPane,
            isAdditionalCSIProducts: sensor?.isAdditionalCSIProducts,
            obfuscateName: sensor?.obfuscateName,
            assetsDelivered: sensor?.assetsDelivered,
            siteData: sensor?.siteData,
          });
        }
      }
      this.subDailyFinalArray = filterArray;
      this.subDailyFinalArray[this.subDailyFinalArray.length - 1].pane =
        this.subDailyFinalArray[this.subDailyFinalArray.length - 2]?.scenes[0]?.pane == 'left'
          ? 'right'
          : 'left';
      this.subDailyFinalArray[this.subDailyFinalArray.length - 1].scenes.map(
        (scene) => {
          if (scene?.id && scene?.status !== 'failed') {
            scene.checked = true;
            scene.pane =
              this.subDailyFinalArray[this.subDailyFinalArray.length - 1]?.pane;
            if (scene?.operatorKey === this.OPERATOR.USL) {
              if (!scene?.s_band && !scene?.x_band && scene?.uslFootprint) {
                scene.x_band = scene?.uslFootprint;
              }
              this.displayRFBandNew(
                scene,
                this.collection.sensors[0].id,
                this.selectedBand
              );
            } else if (scene?.operatorKey === this.OPERATOR.LBAND) {
              this.displayRFSignalsNew(
                scene,
                this.collection.sensors[0].id,
                this.signalSelected
              );
            } else {
              if (scene?.id && scene?.status !== 'failed') {
                scene.checked = true;
                if (scene.footprint) {
                  const sensorId = scene?.sensorId;
                  const sceneId = scene?.id;
                  const action = 'sensor';
                  const taskId = this.collection?.taskId;
                  const sensorObj = {
                    sensorId: sensorId,
                    sceneId: sceneId,
                    action: action,
                    type: scene.imageType,
                  };
                  this.apiService
                    .getCollectionImage(taskId, sensorObj)
                    .subscribe((res: any) => {
                      this.DisplayPopupsBasedOnResponse(res);
                      scene.thumbnailUrl = res.result?.COGUrl
                        ? res.result?.COGUrl
                        : res.result?.imageUrl;
                      scene.start = scene?.start;
                      this.displayFootprintImageByRecurrentDataNew(
                        scene,
                        res.result,
                        sensorId,
                        this.selectedSubDailyItemsNew
                      );
                      this.spinnerService.hide();
                    });
                }
              }
            }
          }
        }
      );
      this.setLeftandRightBands(this.subDailyFinalArray);
    } else {
      this.selectedSubdaily = '';
      let removeIndex = this.subDailyFinalArray.findIndex(
        (item) => parseInt(item.sequenceNumber) === parseInt(data.value)
      );
      let selectedSubdailycount = JSON.parse(
        JSON.stringify(this.subDailyFinalArray[removeIndex])
      );
      if (this.compare) {
        this.map.removeControl(this.compare);
        this.compare = null;
      }
      this.subDailyFinalArray.splice(removeIndex, 1);
      this.selectedSubDailyItemsNew.splice(removeIndex, 1);
      if (
        this.selectedSubDailyItemsNew[this.selectedSubDailyItemsNew.length - 1]
          ?.mapPane == 'right'
      ) {
        this.mapPane = 'left';
      } else {
        this.mapPane = 'right';
      }
      this.collection?.recurrencyArray?.forEach((recurrency: any, i: any) => {
        let res = recurrency?.scenes?.filter(
          (scene: any) =>
            scene?.sequence == this.selectedSubDailyItemsNew[0]?.value
        );
        if (res.length == 0) {
          recurrency.disabled = true;
        } else {
          recurrency.disabled = false;
        }
        if (
          this.selectedSubDailyItemsNew.length == 0 &&
          recurrency?.scenes?.length > 0
        ) {
          recurrency.disabled = false;
        }
      });

      const indices: any[] = [];
      this.scenesNew.forEach((scenenew, index) => {
        if (
          Number(scenenew.scene.sequenceNumber) ==
          selectedSubdailycount.sequenceNumber
        ) {
          indices.push(index);
        }
      });
      this.scenesNew.map((scene: any, index: any) => {
        if (
          Number(scene.scene.sequenceNumber) ==
          selectedSubdailycount.sequenceNumber
        ) {
          this.clearRFBandsByScene(scene, false);
          this.removeLayerByScene(scene);
          if (scene?.leftImageLayer) {
            this.leftImageNew = null;
          }
          if (scene?.rightImageLayer) {
            this.rightImageNew = null;
          }
          this.removeAnnoatationByScene(scene);
        }
      });

      if (this.mapPane == 'right') {
        this.rightImageNew = null;
        this.mapPane = 'right';
      } else {
        this.mapPane = 'left';
        this.leftImageNew = null;
      }
      if (this.leftImageNew == null && this.rightImageNew == null) {
        this.mapPane = '';
      }

      this.scenesNew = this.scenesNew.filter((scene) => {
        return (
          scene.scene.sequenceNumber != selectedSubdailycount.sequenceNumber
        );
      });
      if (this.selectedSubDailyItemsNew.length == 0) {
        this.mapPane = 'left';
        this.rightBand = false;
        let recurrency = this.filteredCollection.recurrencyArray.filter(
          (recurrency) => {
            return recurrency.start == this.selectedCheckboxesNew[0].start;
          }
        );
        this.selectedCheckboxesNew[0].scenes = recurrency[0].scenes;
        this.showSubDailyList = false;
        let sensor = recurrency;
        sensor.checked = true;
        this.selectedCheckboxesNew[0].pane = this.mapPane;
        for (const [sceneIndex, scene] of this.selectedCheckboxesNew[
          this.selectedCheckboxesNew.length - 1
        ]?.scenes.entries()) {
          if (scene?.id && scene?.status !== 'failed') {
            scene.checked = true;
            scene.pane = this.mapPane;
            scene.start = recurrency[0].start;
            if (scene?.operatorKey == this.OPERATOR.USL) {
              if (!scene?.s_band && !scene?.x_band && scene?.usl_footprint) {
                scene.x_band = scene?.usl_footprint;
              }
              this.displayRFBandNew(
                scene,
                this.collection.sensors[0].id,
                this.selectedBand
              );
            } else {
              scene.checked = true;
              if (scene.footprint) {
                const sensorId = sensor?.id;
                const sceneId = scene?.id;
                const action = 'sensor';
                const taskId = this.collection?.taskId;
                const sensorObj = {
                  sensorId: sensorId,
                  sceneId: sceneId,
                  action: action,
                  fileType: scene.imageType,
                };
                scene.start = sensor[0].start;
                this.tifPopupShown = 0;
                this.fetchImageFromServer(this.collection, sensorObj, scene);
              }
            }
          }
        }
      } else {
        this.selectedCheckboxesNew[0].pane =
          this.selectedSubDailyItemsNew[0].mapPane;
        this.sensorsNew = this.selectedCheckboxesNew;
        this.subSelectionSelectionChange.next(
          this.selectedSubDailyItemsNew[0].value
        );
        this.setLeftandRightBands(this.subDailyFinalArray);
      }
    }
  }

  displayPromise: any;
  selectSiteRecurrentNew(event: any, data1: any) {
    let data = JSON.parse(JSON.stringify(data1));
    if (this.showSubDailyList == false) {
      this.removeGHGLayer();
      this.removeLayers();
      this.scenesNew = [];
    }
    this.showSubDailyList = true;
    if (event.checked) {
      this.annotateClicked = false;
      this.newTaskButtonClicked = false;
      this.removeAnnotationMarkers();
      this.collection?.recurrencyArray?.forEach((recurrency: any, i: any) => {
        let res = recurrency?.scenes?.filter(
          (scene: any) => scene?.siteId == data.value
        );
        if (res.length == 0) {
          recurrency.disabled = true;
        } else {
          recurrency.disabled = false;
        }
      });
      this.mapLoad = true;
      this.spinnerService.show();
      if (this.selectedSites.length == 0) {
        this.mapPane = 'left';
      } else if (
        this.selectedSites.length == 1 &&
        this.selectedCheckboxesNew.length == 1
      ) {
      } else if (
        this.selectedSites[this.selectedSites.length - 1]?.mapPane == 'left'
      ) {
        this.mapPane = 'right';
      } else {
        this.mapPane = 'left';
      }
      data.mapPane = this.mapPane;
      this.selectedSites.push({ ...data });
      this.subSelectionSelectionChange.next(data.value);
      this.spinnerService.hide();
      if (
        this.selectedSites.length > 1 &&
        this.selectedCheckboxesNew.length > 0
      ) {
        this.collection.recurrencyArray.forEach((rec) => {
          rec.checked = false;
        });
        this.selectedCheckboxesNew = [];
        this.subDailyFinalArray = [];
        this.resetMapNew();
        let checkedsite = this.subDailyCountarray.find(
          (subDailyCount) => subDailyCount.checked == true
        );
        checkedsite.mapPane = 'left';
        data.mapPane = 'right';
        this.selectedSites.push({ ...checkedsite });
        this.subDailyCountarray.forEach((site) => {
          if (site.value == data.value) {
            site.checked = true;
          }
        });
        this.selectedSites.forEach((site) => {
          if (site.value == data.value) {
            site.checked = true;
          }
        });
        this.filteredCollection = this.fullCollection;
        let scenesList: any = [];
        const filterSubDailyArray = this.filteredCollection.sensors;
        let filterArray: any = [];
        // this.selectSites(selectedSite.value, event)
        for (const [countIndex, count] of this.selectedSites.entries()) {
          let sceneArray: any;
          for (const [sensorIndex, sensor] of filterSubDailyArray.entries()) {
            sceneArray = sensor.scenes.filter(
              (scene) => parseInt(scene?.siteId) === parseInt(count.value)
            );
            sceneArray.forEach((element, index) => {
              element.sceneIdx = index + 1;
              element.start = this.selectedValue.start;
              if (element?.id != null && element?.status != 'failed') {
                element.checked = true;
                scenesList.push({ id: element.id });
              }
            });

            filterArray.push({
              scenes: sceneArray,
              scenesList: scenesList,
              checked: event.checked,
              downloaded: sensor.downloaded,
              id: sensor.id,
              name: sensor.name,
              sequenceNumber: count.value,
              resolution_tooltip: sensor?.resolution_tooltip,
              downloadUrl: sensor?.downloadUrl,
              latency: sensor?.latency,
              status: sensor?.status,
              restoreStatus: sensor?.restoreStatus,
              restoreOption: sensor?.restoreOption,
              isAdditionalCSIProducts: sensor?.isAdditionalCSIProducts,
              obfuscateName: sensor?.obfuscateName,
              assetsDelivered: sensor?.assetsDelivered,
              tnqSensorType: sensor?.tnqSensorType,
              siteData: sensor?.siteData,
            });
          }
        }
        this.subDailyFinalArray = filterArray;
        const displayPromises = this.subDailyFinalArray[
          this.subDailyFinalArray.length - 1
        ].scenes
          .map((scene) => {
            if (scene?.id && scene?.status !== 'failed') {
              scene.checked = true;
              scene.imageType = 'png';
              this.imageType = this.checkType();
              scene.tif = false;
              if (scene.footprint) {
                const sensorId =
                  this.subDailyFinalArray[this.subDailyFinalArray.length - 1]
                    ?.id;
                const sceneId = scene?.id;
                const action = 'sensor';
                const taskId = this.collection?.taskId;
                const sensorObj = {
                  sensorId: sensorId,
                  sceneId: sceneId,
                  action: action,
                  type: scene.imageType,
                };

                return new Promise((resolve) => {
                  this.apiService
                    .getCollectionImage(taskId, sensorObj)
                    .subscribe((res: any) => {
                      this.mapLoad = false;
                      this.spinnerService.hide();
                      scene.thumbnailUrl = res.result?.COGUrl
                        ? res.result?.COGUrl
                        : res.result?.imageUrl;
                      if (
                        this.scenesNew.findIndex(
                          (sceneNew) => sceneNew.id == scene.id
                        ) == -1
                      ) {
                        this.mapPane = 'left';
                        this.displayFootprintImageByRecurrentDataNew(
                          scene,
                          res.result,
                          sensorId,
                          this.selectedSites
                        );
                        resolve(true);
                      } else {
                        resolve(false);
                      }
                    });
                });
              }
            }
            return null;
          })
          .filter((promise) => promise !== null);
        Promise.all(displayPromises).then(() => {
          this.selectedSites.push({ ...data });
          this.subDailyCountarray.forEach((site) => {
            if (site.value == data.value) {
              site.checked = true;
            }
          });
          this.selectedSites.forEach((site) => {
            if (site.value == data.value) {
              site.checked = true;
            }
          });
          this.filteredCollection = this.fullCollection;
          scenesList = [];
          filterArray = [];
          for (const [countIndex, count] of this.selectedSites.entries()) {
            let sceneArray: any;
            for (const [sensorIndex, sensor] of filterSubDailyArray.entries()) {
              sceneArray = sensor.scenes.filter(
                (scene) => parseInt(scene?.siteId) === parseInt(count.value)
              );
              sceneArray.forEach((element, index) => {
                element.sceneIdx = index + 1;
                element.start = this.selectedValue.start;
                if (element?.id != null && element?.status != 'failed') {
                  element.checked = true;
                  scenesList.push({ id: element.id });
                }
              });
              filterArray.push({
                scenes: sceneArray,
                scenesList: scenesList,
                checked: event.checked,
                downloaded: sensor.downloaded,
                id: sensor.id,
                name: sensor.name,
                sequenceNumber: count.value,
                resolution_tooltip: sensor?.resolution_tooltip,
                downloadUrl: sensor?.downloadUrl,
                latency: sensor?.latency,
                status: sensor?.status,
                restoreStatus: sensor?.restoreStatus,
                restoreOption: sensor?.restoreOption,
                isAdditionalCSIProducts: sensor?.isAdditionalCSIProducts,
                obfuscateName: sensor?.obfuscateName,
                assetsDelivered: sensor?.assetsDelivered,
                siteData: sensor?.siteData,
              });
            }
          }
          this.subDailyFinalArray = filterArray;
          this.subDailyFinalArray[
            this.subDailyFinalArray.length - 1
          ].scenes.map((scene) => {
            if (scene?.id && scene?.status !== 'failed') {
              scene.checked = true;
              if (scene.footprint) {
                this.imageType = this.checkType();
                scene.imageType = 'png';
                scene.tif = false;
                const sensorId =
                  this.subDailyFinalArray[this.subDailyFinalArray.length - 1]
                    ?.id;
                const sceneId = scene?.id;
                const action = 'sensor';
                const taskId = this.collection?.taskId;
                const sensorObj = {
                  sensorId: sensorId,
                  sceneId: sceneId,
                  action: action,
                  type: this.imageType,
                };
                this.apiService
                  .getCollectionImage(taskId, sensorObj)
                  .subscribe((res: any) => {
                    this.mapLoad = false;
                    this.spinnerService.hide();
                    this.DisplayPopupsBasedOnResponse(res);
                    scene.thumbnailUrl = res.result?.COGUrl
                      ? res.result?.COGUrl
                      : res.result?.imageUrl;
                    if (
                      this.scenesNew.findIndex(
                        (sceneNew) => sceneNew.id == scene.id
                      ) == -1
                    ) {
                      this.mapPane = 'right';
                      this.spinnerService.hide();
                      this.displayFootprintImageByRecurrentDataNew(
                        scene,
                        res.result,
                        sensorId,
                        this.selectedSites
                      );
                    }
                  });
              }
            }
          });
          this.leftData = this.selectedSites.filter(
            (site) => site.mapPane == 'left'
          );
          this.rightData = this.selectedSites.filter(
            (site) => site.mapPane == 'right'
          );
        });
      } else {
        if (this.selectedSites.length > 2) {
          let countIndex = 0;
          let site = JSON.parse(JSON.stringify(this.selectedSites[countIndex]));
          this.subDailyFinalArray = this.subDailyFinalArray.filter(
            (subDaily) => {
              return subDaily.scenes[0].siteId != site.value;
            }
          );
          if (this.compare) {
            this.map.removeControl(this.compare);
            this.compare = null;
          }
          this.scenesNew.map((scene: any, index: any) => {
            if (scene.scene.siteId == site.value) {
              this.removeLayerByScene(scene, { paneSpecific: true });
              let ghgIndex = this.ghgLayers.findIndex(
                (ghg) => ghg.scene.id == scene.id
              );
              if (ghgIndex != -1) {
                this.removeGHGLayerByScene(this.ghgLayers[ghgIndex]);
                this.ghgLayers.splice(ghgIndex, 1);
              }
            }
          });
          this.scenesNew = this.scenesNew.filter((scene) => {
            return scene.scene.siteId != site.value;
          });
          this.selectedSites.splice(countIndex, 1);
          this.subDailyCountarray.forEach((subDailyCount) => {
            if (site.value == subDailyCount.value) {
              subDailyCount.checked = false;
              this.changDetectionRef.detectChanges();
            }
          });
        }
        let scenesList: any = [];
        const filterSubDailyArray = this.fullCollection.sensors;
        let filterArray: any = [];
        let recurrency = this.filteredCollection.recurrencyArray.filter(
          (recurrency1) => {
            return recurrency1.start == this.selectedCheckboxesNew[0]?.start;
          }
        );
        this.subDailyCountarray.forEach((site) => {
          if (site.value == data.value) {
            site.checked = true;
            this.changDetectionRef.detectChanges();
          }
        });
        this.defaultSubdailyCount =
          this.selectedSites[this.selectedSites.length - 1].value;
        for (const [countIndex, count] of this.selectedSites.entries()) {
          let sceneArray: any;
          for (const [sensorIndex, sensor] of filterSubDailyArray.entries()) {
            if (this.selectedCheckboxesNew.length > 0) {
              sceneArray = recurrency[0].scenes.filter(
                (scene) => parseInt(scene?.siteId) === parseInt(count.value)
              );
            } else {
              sceneArray = sensor.scenes.filter(
                (scene) => parseInt(scene?.siteId) === parseInt(count.value)
              );
            }
            sceneArray.forEach((element, index) => {
              element.sceneIdx = index + 1;
              element.start = this.selectedValue.start;
              if (element?.id != null && element?.status != 'failed') {
                scenesList.push({ id: element.id });
              }
            });
            filterArray.push({
              scenes: sceneArray,
              scenesList: scenesList,
              checked: event.checked,
              downloaded: sensor.downloaded,
              id: sensor.id,
              name: sensor.name,
              sequenceNumber: count.value,
              resolution_tooltip: sensor?.resolution_tooltip,
              downloadUrl: sensor?.downloadUrl,
              latency: sensor?.latency,
              status: sensor?.status,
              restoreStatus: sensor?.restoreStatus,
              restoreOption: sensor?.restoreOption,
              isAdditionalCSIProducts: sensor?.isAdditionalCSIProducts,
              obfuscateName: sensor?.obfuscateName,
              assetsDelivered: sensor?.assetsDelivered,
              siteData: sensor?.siteData,
            });
          }
        }
        this.subDailyFinalArray = filterArray;
        this.collection?.recurrencyArray?.forEach((recurrency: any, i: any) => {
          let res = recurrency?.scenes?.filter(
            (scene: any) => scene?.siteId == this.selectedSites[0]?.value
          );

          if (res.length == 0) {
            recurrency.disabled = true;
          } else {
            recurrency.disabled = false;
          }

          if (
            this.selectedSites.length == 0 &&
            recurrency?.scenes?.length > 0
          ) {
            recurrency.disabled = false;
          }
        });
        this.subDailyFinalArray[this.subDailyFinalArray.length - 1].scenes.map(
          (scene) => {
            if (scene?.id && scene?.status !== 'failed') {
              scene.checked = true;
              if (scene.footprint) {
                this.imageType = this.checkType();
                scene.imageType = 'png';
                scene.tif = false;
                const sensorId =
                  this.subDailyFinalArray[this.subDailyFinalArray.length - 1]
                    ?.id;
                const sceneId = scene?.id;
                const action = 'sensor';
                const taskId = this.collection?.taskId;
                const sensorObj = {
                  sensorId: sensorId,
                  sceneId: sceneId,
                  action: action,
                  type: this.imageType,
                };
                this.apiService
                  .getCollectionImage(taskId, sensorObj)
                  .subscribe((res: any) => {
                    this.mapLoad = false;
                    this.spinnerService.hide();
                    this.DisplayPopupsBasedOnResponse(res);
                    scene.thumbnailUrl = res.result?.COGUrl
                      ? res.result?.COGUrl
                      : res.result?.imageUrl;
                    if (
                      this.scenesNew.findIndex(
                        (sceneNew) => sceneNew.id == scene.id
                      ) == -1
                    ) {
                      this.spinnerService.hide();
                      this.displayFootprintImageByRecurrentDataNew(
                        scene,
                        res.result,
                        sensorId,
                        this.selectedSites
                      );
                    }
                  });
              }
            }
          }
        );
        this.leftData = this.selectedSites.filter(
          (site) => site.mapPane == 'left'
        );
        this.rightData = this.selectedSites.filter(
          (site) => site.mapPane == 'right'
        );
      }
    } else {
      data.checked = false;
      let countIndex = this.selectedSites.findIndex(
        (item) => parseInt(item.value) === parseInt(data.value)
      );
      let site = this.selectedSites[countIndex];
      this.subDailyFinalArray = this.subDailyFinalArray.filter((subDaily) => {
        return subDaily.scenes[0].siteId != site.value;
      });

      if (this.compare) {
        this.map.removeControl(this.compare);
        this.compare = null;
        if (this.selectedSites.length > 0) this.filterSiteData = [];
      }
      this.scenesNew.forEach((scenenew) => {
        if (scenenew.scene.siteId == site.value) {
          let ghgIndex = this.ghgLayers.findIndex(
            (ghg) => ghg.scene.id == scenenew.id
          );
          if (ghgIndex != -1) {
            this.removeGHGLayerByScene(this.ghgLayers[ghgIndex]);
            this.ghgLayers.splice(ghgIndex, 1);
          }
          this.removeLayerByScene(scenenew, { paneSpecific: true });
        }
      });
      this.scenesNew = this.scenesNew.filter((scene: any) => {
        return scene.scene?.siteId != site.value;
      });
      this.selectedSites.splice(countIndex, 1);
      if (this.selectedSites.length == 0) {
        this.toggleDailyRecurrency(event);
      } else {
        if (this.selectedSites.length > 0) {
          this.defaultSubdailyCount = this.selectedSites[0].value;
          if (this.selectedCheckboxesNew.length > 0) {
            this.selectedCheckboxesNew[0].pane =
              this.selectedSites[this.selectedSites.length - 1].mapPane;
          }
          this.selectedSite = this.subDailyCountarray.filter(
            (subDailyCount) => {
              return subDailyCount.value == this.selectedSites[0].value;
            }
          )[0].value;
        }
        this.collection?.recurrencyArray?.forEach((recurrency: any, i: any) => {
          let res = recurrency?.scenes?.filter(
            (scene: any) => scene?.siteId == this.selectedSites[0]?.value
          );
          if (res.length == 0) {
            recurrency.disabled = true;
          } else {
            recurrency.disabled = false;
          }
          if (
            this.selectedSites.length == 0 &&
            recurrency?.scenes?.length > 0
          ) {
            recurrency.disabled = false;
          }
        });
      }
    }
  }

  compareOpportunityNew(
    collectionIndex: any,
    opportunityIndex: any,
    event: any,
    type: any,
    task: any
  ) {
    this.toggleRecurrentDatesNew(
      collectionIndex,
      opportunityIndex,
      event,
      type,
      task
    );
  }

  toggleSubDailyRecurrentSensorNew(sensorIndex: any, sensor: any, event: any) {
    if (event.checked == false) {
       this.selectedSubdaily = '';
       this.isShowSubDailyLegend = false;
      if (this.selectedSubDailyItemsNew.length > 0) {
        let selectedSensor = JSON.parse(
          JSON.stringify(this.subDailyFinalArray[sensorIndex])
        );
        this.subDailyCountarray.map((subdaily) => {
          if (subdaily.value == selectedSensor.scenes[0]?.sequenceNumber) {
            subdaily.checked = false;
          }
        });
        let countIndex = this.selectedSubDailyItemsNew.findIndex(
          (item) =>
            parseInt(item.value) ===
            parseInt(selectedSensor.scenes[0].sequenceNumber)
        );
        let selectedsubdaily = this.selectedSubDailyItemsNew[countIndex];
        this.subDailyFinalArray = this.subDailyFinalArray.filter((subDaily) => {
          return subDaily.scenes[0].sequenceNumber != selectedsubdaily.value;
        });
        let scenenewIndex: any = this.scenesNew.findIndex(
          (scenenew) => scenenew.scene.sequenceNumber == selectedsubdaily.value
        );
        if (this.subDailyFinalArray.length == 0) {
          this.showDailyRecurrencyCheckboxes = false;
          this.toggleDailyRecurrency(event);
        }
        this.changDetectionRef.detectChanges();
        if (this.compare) {
          this.map.removeControl(this.compare);
          this.compare = null;
        }
        this.scenesNew.map((scene: any, index: any) => {
          if (scene.scene.sequenceNumber == selectedsubdaily.value) {
            this.clearRFBandsByScene(scene, false);
            this.removeLayerByScene(scene, { paneSpecific: true });
            this.clearRFSignalsByScene(scene);
            this.removeAnnoatationByScene(scene);
          }
        });

        this.selectedSubDailyItemsNew.splice(sensorIndex, 1);
        this.scenesNew = this.scenesNew.filter((scene) => {
          return scene.scene.sequenceNumber != selectedsubdaily.value;
        });

        this.collection?.recurrencyArray?.forEach((recurrency: any, i: any) => {
          let res = recurrency?.scenes?.filter(
            (scene: any) =>
              scene?.sequence == this.selectedSubDailyItemsNew[0]?.value
          );
          if (res.length == 0) {
            recurrency.disabled = true;
          } else {
            recurrency.disabled = false;
          }
          if (
            this.selectedSubDailyItemsNew.length == 0 &&
            recurrency?.scenes?.length > 0
          ) {
            recurrency.disabled = false;
          }
        });

        if (this.selectedSubDailyItemsNew.length == 0) {
          this.mapPane = '';
          let recurrency = this.filteredCollection.recurrencyArray.filter(
            (recurrency) => {
              return recurrency.start == this.selectedCheckboxesNew[0].start;
            }
          );
          this.selectedCheckboxesNew[0].pane = 'left';
          this.selectedCheckboxesNew[0].scenes = recurrency[0].scenes;
          this.showSubDailyList = false;
          let sensor = recurrency;
          sensor.checked = true;
          this.rightBand = false;
          for (const [sceneIndex, scene] of this.selectedCheckboxesNew[
            this.selectedCheckboxesNew.length - 1
          ]?.scenes.entries()) {
            if (
              scene?.id &&
              scene?.status !== 'failed' &&
              (scene?.operatorKey == this.OPERATOR.USL ||
                scene?.operatorKey == this.OPERATOR.LBAND)
            ) {
              scene.checked = true;
              scene.start = sensor[0].start;
              scene.pane = 'left';
              if (scene?.operatorKey == this.OPERATOR.USL) {
                if (!scene?.s_band && !scene?.x_band && scene?.usl_footprint) {
                  scene.x_band = scene?.usl_footprint;
                }
                this.displayRFBandNew(
                  scene,
                  this.collection.sensors[0].id,
                  this.selectedBand
                );
              } else {
                this.displayRFSignalsNew(
                  scene,
                  this.collection.sensors[0].id,
                  this.signalSelected
                );
              }
            } else {
              if (scene?.id && scene?.status !== 'failed') {
                scene.checked = true;
                if (scene.footprint) {
                  const sensorId = this.collection.sensors[0]?.id;
                  const sceneId = scene?.id;
                  const action = 'sensor';
                  const taskId = this.collection?.taskId;
                  const sensorObj = {
                    sensorId: sensorId,
                    sceneId: sceneId,
                    action: action,
                    fileType: scene.imageType,
                  };
                  scene.start = sensor[0].start;
                  this.tifPopupShown = 0;
                  this.fetchImageFromServer(this.collection, sensorObj, scene);
                }
              }
            }
          }
        } else {
          this.selectedCheckboxesNew[0].pane =
            this.selectedSubDailyItemsNew[0].mapPane;
          this.sensorsNew = this.selectedCheckboxesNew;
          this.subSelectionSelectionChange.next(
            this.selectedSubDailyItemsNew[0].value
          );
          this.leftBand =
            this.subDailyFinalArray.filter(
              (subDailyFinal) => subDailyFinal.pane == 'left'
            ).length > 0;
          this.rightBand =
            this.subDailyFinalArray.filter(
              (subDailyFinal) => subDailyFinal.pane == 'right'
            ).length > 0;
        }
      } else {
        let selectedSensor = JSON.parse(
          JSON.stringify(this.subDailyFinalArray[sensorIndex])
        );
        if (this.selectedSites.length == 2) {
          this.subDailyCountarray.map((subdaily) => {
            if (subdaily.value == selectedSensor.scenes[0].siteId) {
              subdaily.checked = false;
            }
          });
          let countIndex = this.selectedSites.findIndex(
            (item) =>
              parseInt(item.value) === parseInt(selectedSensor.scenes[0].siteId)
          );
          let site = this.selectedSites[countIndex];
          this.subDailyFinalArray = this.subDailyFinalArray.filter(
            (subDaily) => {
              return subDaily.scenes[0].siteId != site.value;
            }
          );
          if (this.compare) {
            this.map.removeControl(this.compare);
            this.compare = null;
          }
          this.scenesNew.forEach((scenenew) => {
            if (scenenew.scene.siteId == site.value) {
              this.removeAnnoatationByScene(scenenew);
              let ghgIndex = this.ghgLayers.findIndex(
                (ghg) => ghg.scene.id == scenenew.id
              );
              if (ghgIndex != -1) {
                this.removeGHGLayerByScene(this.ghgLayers[ghgIndex]);
                this.ghgLayers.splice(ghgIndex, 1);
              }
              this.removeLayerByScene(scenenew, { paneSpecific: true });
            }
          });
          this.scenesNew = this.scenesNew.filter((scene: any) => {
            return scene.scene?.siteId != site.value;
          });
          this.selectedSites.splice(countIndex, 1);
          if (this.selectedSites.length > 0) {
            if (this.selectedCheckboxesNew.length > 0) {
              this.selectedCheckboxesNew[0].pane =
                this.selectedSites[this.selectedSites.length - 1].mapPane;
            }
            this.selectedSite = this.subDailyCountarray.filter(
              (subDailyCount) => {
                return subDailyCount.value == this.selectedSites[0]?.value;
              }
            )[0].value;
            this.collection?.recurrencyArray?.forEach(
              (recurrency: any, i: any) => {
                let res = recurrency?.scenes?.filter(
                  (scene: any) => scene?.siteId == this.selectedSites[0]?.value
                );
                if (res.length == 0) {
                  recurrency.disabled = true;
                } else {
                  recurrency.disabled = false;
                }
              }
            );
          }
        } else {
          if (this.selectedCheckboxesNew.length == 0) {
            this.toggleDailyRecurrency(event);
          } else {
            this.subDailyFinalArray = this.subDailyFinalArray.filter(
              (subDaily) => {
                return subDaily.start != selectedSensor.start;
              }
            );
            this.collection?.recurrencyArray?.forEach(
              (recurrency: any, i: any) => {
                if (recurrency.start == selectedSensor.start) {
                  recurrency.checked = false;
                }
              }
            );

            if (this.subDailyFinalArray.length > 0) {
              this.selectedValue = this.collection.recurrencyArray.filter(
                (recurrency) => {
                  return recurrency.start == this.subDailyFinalArray[0].start;
                }
              )[0];
            } else {
              this.collection?.recurrencyArray?.forEach(
                (recurrency: any, i: any) => {
                  if (recurrency.start == this.selectedCheckboxesNew[0].start) {
                    this.selectedValue = recurrency;
                  }
                }
              );
            }

            this.selectedCheckboxesNew = this.subDailyFinalArray;
            if (this.compare) {
              this.map.removeControl(this.compare);
              this.compare = null;
            }
            let scenenewIndex: any = this.scenesNew.findIndex(
              (scenenew) => scenenew.scene.start == selectedSensor.start
            );
            if (scenenewIndex != -1) {
              this.removeAnnoatationByScene(this.scenesNew[scenenewIndex]);
              let ghgIndex = this.ghgLayers.findIndex(
                (ghg) => ghg.scene.id == this.scenesNew[scenenewIndex].id
              );
              if (ghgIndex != -1) {
                this.removeGHGLayerByScene(this.ghgLayers[ghgIndex]);
              }
              this.removeLayerByScene(this.scenesNew[scenenewIndex], {
                paneSpecific: true,
              });
              this.removeAnnoatationByScene(this.scenesNew[scenenewIndex]);
              this.ghgLayers.splice(ghgIndex, 1);
              this.scenesNew.splice(scenenewIndex, 1);
            }
            if (this.selectedCheckboxesNew.length == 0) {
              this.collection.recurrencyArray.forEach((recurrency) => {
                recurrency.checked = false;
              });
              this.defaultSubdailyCount = this.selectedSites[0]?.siteId;
              this.resetMapNew();
              this.filteredCollection = this.fullCollection;
              this.subDailyFinalArray = [];
              this.selectSites(this.defaultSubdailyCount, event);
            }
          }
        }
      }
      this.changDetectionRef.detectChanges();
    }
  }

  downloadProgress(progress: any) {
    if (
      progress?.sensorId != undefined &&
      !progress?.product &&
      !progress?.type
    ) {
      const sensor = this.fullCollection.sensors.find(
        (sensor) => sensor.id === progress?.sensorId
      );
      const nonEmptyIds = sensor.scenes
        .filter((scene) => scene.id !== '')
        .map((scene) => scene.id);

      progress.sceneId = nonEmptyIds;
    }
    let sensorObj = {
      taskId: progress.taskId,
      sensorId: progress?.sensorId,
      sceneId: progress?.sceneId,
      product: progress?.product,
      type: progress?.type,
    };
    if (progress?.type) {
      sensorObj.sceneId = [progress?.sceneId];
    }

    if (
      progress?.downloadClick &&
      progress.progress > 0 &&
      progress.progress < 100
    ) {
      this.freeze = true;
      this.spinnerService.show();
    } else if (
      progress?.downloadClick &&
      progress.progress >= 100 &&
      progress?.action != 'aisDownload'
    ) {
      localStorage.setItem('scene-downloaded', progress?.sceneId);
      if (progress?.sensorId != undefined && !progress?.product) {
        localStorage.setItem('sensor-downloaded', progress?.sensorId);
      }
      if (!progress?.product) {
        if (this.ecursSensorObject) {
          this.downloadedScene = this.downloadedScene.concat(
            this.ecursSensorObject?.sceneIds
          );
        } else {
          this.downloadedScene = this.downloadedScene.concat(progress?.sceneId);
        }
        this.downloadedSensor.push(localStorage.getItem('sensor-downloaded'));
      }

      this.freeze = false;
      this.downloadClick = false;
      this.spinnerService.hide();

      if (progress?.action === 'aisDownload') return;

      if (this.ecursSensorObject) {
        sensorObj = {
          taskId: progress.taskId,
          sensorId: progress?.sensorId,
          sceneId: this.ecursSensorObject?.sceneIds,
          product: progress?.product,
          type: '',
        };
      }
      this.apiService
        .updateCollectionDownload(sensorObj)
        .subscribe(async (res: any) => {
          if (res.msg === 'Success' && progress?.product) {
            switch (progress?.product) {
              case 'CWSI':
              case 'MBSI':
              case 'NDVI':
              case 'NCCI':
              case 'NDTI':
              case 'NDRE':
              case 'NDMI':
              case 'TVDI':
                this.setDownloadedIndices();
                break;
              default:
                this.setDownloadedVADP();
                break;
            }
          }
        });
    }
  }

  setDownloadedVADP() {
    this.collections[this.currentDownloadingVADP.collectionIndex].sensors[
      this.currentDownloadingVADP.sensorIndex
    ].valueAddedOption.forEach((row) => {
      if (row.product == this.currentDownloadingVADP.product) {
        row.isDownloaded = true;
      }
    });
    this.currentDownloadingVADP = {};
  }
  fullsubDailyCountarray: any[] = [];
  toggleDailyRecurrency(event: any) {
    this.feasibilityArray = [];
    for (const opportunity of this.collection.opportunityList) {
      opportunity.checked = false;
    }
    this.signalSelected = 'All';
    this.selectedBand = 'all';
    this.isSitechanged = false;
    this.selectedSensors = [];
    this.recurrencyArray = [];
    this.selectedCheckboxes = [];
    this.selectedCheckboxesNew = [];
    this.subDailyFinalArray = [];
    this.subDailyArray = [];
    this.selectedSubDailyItems = [];
    this.selectedSubDailyItemsNew = [];
    this.selectedSites = [];
    this.isVisible = false;
    this.showSubDailyList = false;
    this.annotateClicked = false;
    this.newTaskButtonClicked = false;
    this.resetMapNew();
    this.sensors = [];
    this.scenes = [];
    this.scnLyr = [];
    this.scnLyr2 = [];
    this.feedInfo = false;
    this.oilSpil = false;
    this.imageType = this.checkType();
    this.leftFeedPanels.clear();
    this.rightFeedPanels.clear();
    this.needsCompareResetToCenter = true;


    this.removeDynamicLayer();

    this.collection.sensors.forEach((sensor, index) => {
      sensor.checked = false;
      sensor.scenes.forEach((scene) => {
        scene.checked = false;
      });
    });
    this.resetFeedsStatus(this.collection);
    this.collection?.recurrencyArray.forEach((recurrency) => {
      recurrency.checked = false;
    });
    this.leftBand = false;
    this.rightBand = false;
    this.leftData = [];
    this.rightData = [];
    this.resetAllFeedPanels();
    if (event.checked) {
      this.mapPane = '';
      this.isCompare = true;
      this.isCompareRecurrency = true;
      this.isCompareClicked = true;
      this.showDailyRecurrencyCheckboxes = true;
      if (
        this.selectedStartDate &&
        this.collection.sensors[0].operatorKey != OPERATORS.GHG
      ) {
      } else {
        this.fullsubDailyCountarray = JSON.parse(
          JSON.stringify(this.subDailyCountarray)
        );
        this.collection.recurrencyArray.map((recurrency, index) => {
          if (this.selectedValue.start == recurrency.start) {
            recurrency.checked = false;
            this.subDailyCountarray.forEach((subDailyCount) => {
              if (subDailyCount.siteId == this.defaultSubdailyCount) {
                subDailyCount.checked = false;
                this.selectedSite = subDailyCount.value;
              } else {
                subDailyCount.checked = false;
              }
            });
          }
        });
      }
    } else {
      this.showDailyRecurrencyCheckboxes = false;
      this.mapPane = '';
      this.isCompare = false;
      this.isCompareRecurrency = false;
      this.isCompareClicked = false;
      this.RF = false;
      this.defaultSubdailyCount = 1;
      this.metric = 'kg';
      if (this.taskSelected) {
        this.collections = [];
        this.getCollections(
          this.previousSelectedProject?.projectid
            ? this.previousSelectedProject?.projectid
            : this.projectSelected,
          this.collectionIndex
        );
        this.selectionChange.next(this.collection.recurrencyArray[0]);
      } else {
        this.collections = [];
        this.getCollections(
          this.previousSelectedProject?.projectid
            ? this.previousSelectedProject?.projectid
            : this.projectSelected,
          0
        );
        this.selectionChange.next(this.collection.recurrencyArray[0]);
      }
      this.filterSiteData = [];
      this.filterDateData = [];
    }
  }

  countSelectedOptions(): number {
    return this.collection.recurrencyArray.filter((item) => item.checked)
      .length;
  }

  exceedsSelectionLimit(): boolean {
    return this.countSelectedOptions() >= this.maxSelections;
  }

  fetchAndCombineGeoJson(urls: string[], info, sensor?): void {
    if (!urls?.length) {
      this.spinnerService.hide();
      return;
    }
    this.spinnerService.show();
    const geoJsonRequests = urls.map((url) => this.httpClient.get(url));
    forkJoin(geoJsonRequests).subscribe({
      next: (geoJsonDataArray: any[]) => {
        const combinedGeoJson = this.combineGeoJsonFeatures(geoJsonDataArray);
        this.displayISNew({
          insightFootprint: combinedGeoJson,
          isInfo: info,
          sensor: sensor,
        });
        this.displayedIS = {
          insightFootprint: JSON.parse(JSON.stringify(combinedGeoJson)),
          isInfo: info,
        };
        this.cleanupAfterOperation();
      },
      error: (error) => {
        this.spinnerService.hide();
        this.mapLoad = false;
        this.cleanupAfterOperation();
      },
    });
  }

  fetchAndCombineIndesisGeoJson(urls: any[], indices?): void {
    this.spinnerService.show();

    if (!urls?.length) {
      this.spinnerService.hide();
      return;
    }

    const geoJsonRequests = urls.map((item: any) =>
      this.httpClient.get(item.imageUrl)
    );

    forkJoin(geoJsonRequests).subscribe({
      next: (responses: any[]) => {
        try {
          let combinedGeoJson;
          if (responses.length > 1) {
            combinedGeoJson = this.combineGeoJsonFeatures(responses);
          } else {
            combinedGeoJson = responses[0];
          }

          this.displayIndesisLayer(combinedGeoJson, indices);

          this.displayedIS = {
            insightFootprint: JSON.parse(JSON.stringify(combinedGeoJson)),
            indices: indices,
          };
        } finally {
          this.spinnerService.hide();
        }
      },

      error: (error) => {
        this.spinnerService.hide();
        this.mapLoad = false;
      },
    });
  }

  private displayIndesisLayer(insightFootprint, indices): void {
    if (!insightFootprint) return;

    if (this.indicesLayer) {
      this.map.removeLayer(this.indicesLayer);
    }

    // Create or reuse a pane for indices layers
    if (!this.map.getPane('indicesPane')) {
      const indicesPane = this.map.createPane('indicesPane');
      indicesPane.style.zIndex = '650'; // higher than default overlayPane (400)
      indicesPane.style.pointerEvents = 'auto'; // optional, allows interaction
    }

    const feedResults = insightFootprint?.feed_results || {};
    const hasFeedResults = Object.keys(feedResults).length > 0;

    this.indicesLayer = L.geoJSON(insightFootprint, {
      pane: 'indicesPane',
      style: (feature) => {
        const value = feature?.properties?.value ?? 0;
        return {
          fillColor: getIndicesColor(value, indices.product),
          color: '#000',
          weight: 1,
          fillOpacity: 0.95,
        };
      },
      onEachFeature: (feature, layer) => {
        const classValue = feature?.properties?.value;
        if (classValue == null || !hasFeedResults) {
          return;
        }

        const areaPercent = feedResults[String(classValue)];
        if (areaPercent == null) {
          return;
        }

        const categoryMap = {
          CWSI: cwsiCategories,
          MBSI: mbsiCategories,
          NCCI: ncciCategories,
          NDTI: ndtiCategories,
          NDMI: ndmiCategories,
          NDRE: ndreCategories,
          NDVI: ndviCategories,
          TVDI: tvdiCategories,
        };
        const classLabel = (categoryMap[indices?.product] || []).find(
          (item: any) => item.value === Number(classValue)
        )?.label ?? `Class ${classValue}`;
        layer.bindTooltip(`${classLabel}: ${areaPercent}%`, {
          sticky: true,
          direction: 'top',
          className: 'indices-tooltip',
        });
     layer.on('mousedown', (e: L.LeafletMouseEvent) => {
     L.DomEvent.preventDefault(e.originalEvent);
      });
      },
    }).addTo(this.map);

    this.indicesLayer.bringToFront();
    this.addColorLegend(indices.product, indices?.products?.[0]?.message);

    this.map.fitBounds(this.indicesLayer.getBounds());
  }

  private addColorLegend(name, message?): void {
    // Remove existing legend if any
    if (this.colorLegendControl) {
      this.map.removeControl(this.colorLegendControl);
    }
    const categoryConfig: any = {
      CWSI: { title: 'CWSI', list: cwsiCategories },
      MBSI: { title: 'MBSI', list: mbsiCategories },
      NCCI: { title: 'NCCI', list: ncciCategories },
      NDTI: { title: 'NDTI', list: ndtiCategories },
      NDMI: { title: 'NDMI', list: ndmiCategories },
      NDRE: { title: 'NDRE', list: ndreCategories },
      NDVI: { title: 'NDVI', list: ndviCategories },
      TVDI: { title: 'TVDI', list: tvdiCategories },
      SOIL_MOISTURE_SAR: {
        title: 'Soil Moisture',
        list: Object.entries(SOIL_MOISTURE_SAR_CLASS_MAP).map(
          ([key, value]) => ({
            label: value.label,
            color: value.color,
          })
        ),
      },
    };
    if (!categoryConfig[name]) return;
    this.colorLegendControl = L.control.zoom({ position: 'bottomleft' });
    this.colorLegendControl.onAdd = () => {
      const div = L.DomUtil.create('div', 'info legend');
      div.style.marginBottom = '50px';

      const infoIconHtml = message
        ? `
      <span class="legend-info" aria-label="Index info">
      ℹ
      <span class="legend-tooltip">
        ${message}
      </span>
    </span>
     `
        : '';
      let html = `
      <div style="display:flex; align-items:center; justify-content:space-between; padding-bottom:5px">
      <h6 style="color:white; margin:0;">
         ${categoryConfig[name].title}
      </h6>
      ${infoIconHtml}
     </div>`;

      categoryConfig[name].list.forEach((product) => {
        html += `
    <div style="display:flex; align-items:center; margin-bottom:3px;">
      <span style="
        background:${product.color};
        width:18px;
        height:18px;
        display:inline-block;
        margin-right:6px;
        border:1px solid #333;
      "></span>
      <span style="color:white; font-size:12px;">${product.label}</span>
    </div>
      `;
      });

      div.innerHTML = html;
      div.style.padding = '6px 8px';
      div.style.background = 'rgba(0,0,0,0.7)';
      div.style.boxShadow = '0 0 15px rgba(0,0,0,0.2)';
      div.style.borderRadius = '5px';

      return div;
    };

    this.colorLegendControl.addTo(this.map);
}

  combineGeoJsonFeatures(geoJsonDataArray: any[]): any {
    const allFeatures = geoJsonDataArray.flatMap((geoJson) => geoJson.features);
    return {
      type: 'FeatureCollection',
      features: allFeatures,
      metadata: geoJsonDataArray[0]?.metadata,
      feed_results: geoJsonDataArray[0]?.feed_results,
    };
  }

  private stopHover() {
    if (!this.map) return;
    if (this._hoverMove) this.map.off('mousemove', this._hoverMove);
    if (this._hoverOut) this.map.off('mouseout', this._hoverOut);
    this._hoverMove = undefined;
    this._hoverOut = undefined;
    if (this.currentTooltip && this.map.hasLayer(this.currentTooltip)) {
      this.map.removeLayer(this.currentTooltip);
      this.currentTooltip = null;
    }
    (this.map.getContainer() as HTMLElement).style.cursor = '';
  }

  // optional: a pane for vectors above raster tiles
  private ensureVectorPane(z = 3000) {
    const pane =
      this.map.getPane('vector-overlays') ||
      this.map.createPane('vector-overlays');
    pane.style.zIndex = String(z);
    pane.style.pointerEvents = 'auto';
  }

  /** Ensure we have a dedicated tooltip pane (once). */
  private ensureTooltipPane() {
    if (!this.map) return;
    if (!this.map.getPane('eeTooltipPane')) {
      const pane = this.map.createPane('eeTooltipPane');
      pane.style.zIndex = '10000';
      pane.style.pointerEvents = 'none';
    }
  }

  /** Fallback offsets if this.OFFSETS isn't defined yet */
  private readonly DEFAULT_OFFSETS: Record<
    'top' | 'bottom' | 'left' | 'right',
    L.PointExpression
  > = {
    top: [0, -10],
    bottom: [0, 10],
    left: [-10, 0],
    right: [10, 0],
  };

  private bindEeTooltip(
    layer: L.Layer,
    dir: 'top' | 'bottom' | 'left' | 'right',
    text: string = ''
  ): L.Tooltip | undefined {
    if (!this.map || !layer) return;
    this.ensureTooltipPane();

    // use your OFFSETS if present; otherwise defaults
    const offsets = (this as any).OFFSETS ?? this.DEFAULT_OFFSETS;
    // Clear anything old on this layer
    (layer as any).off?.('mouseover');
    (layer as any).off?.('mouseout');
    (layer as any).unbindTooltip?.();
    layer.bindTooltip(text, {
      pane: 'eeTooltipPane',
      permanent: false,
      direction: dir,
      offset: offsets[dir],
      className: 'custom-black-tooltip',
      opacity: 0.9,
      sticky: false,
    });

    return (layer as any).getTooltip?.();
  }

  private showEeTooltip(
    layer: L.Layer,
    dir: 'top' | 'bottom' | 'left' | 'right',
    contentHtml: string,
    anchorLatLng?: L.LatLngExpression
  ): void {
    this.attachTooltip(layer, contentHtml);
  }

  async loadFeedOnTiff(
    collectionIndex: number,
    sensorIndex: number,
    infoServiceIndex: number,
    event: any,
    info: any,
    config: any
  ) {
    if (!this.map) return;
    this.spinnerService.show();
    this.currentFilteredLayers = this.currentFilteredLayers || {};
    const feedKey = this.getFeedKey(info, config);
    if (this.currentFilteredLayers[feedKey]) return;

    this.spinnerService.show();
    let result: any = null;
    try {
      if (this.combinedScenes) {
        const payload = {
          customerid: this.currentUser?.id,
          feedId: info?._id,
          taskId: this.currentTaskId,
          sensorId: this.collections[collectionIndex].sensors[sensorIndex].id,
        };

        const res: any = await firstValueFrom(
          this.apiService
            .getFeedFromGeoCollection(payload)
            .pipe(takeUntil(this.destroy$))
        );

        if (res?.msg === 'Failed') {
          this.pointerEvent = 'auto';
          this.mapLoad = false;
          this.spinnerService.hide();
          this.fail = this.fail + 1;
          if (this.fail == 1) {
            const message =
              'An error occurred during processing and ingestion of the request. Please try after sometime.';
            this.popupService.openPopup(
              CollectionPopupComponent,
              message,
              '',
              '40%'
            );
          }
          return;
        }

        result = res.result;
      } else if (
        this.collections[collectionIndex].sensors[sensorIndex].scenes.filter(
          (scene) => scene.checked == true
        ).length === 1
      ) {
        const scenes =
          this.collections[collectionIndex].sensors[sensorIndex].scenes;
        const selectedScene = scenes.find((scene) => scene.checked === true)!;
        const sensorObj = {
          sensorId: this.collections[collectionIndex].sensors[sensorIndex].id,
          sceneId: selectedScene.id,
          action: 'scene',
          fileType: selectedScene.imageType,
        };
        this.tifPopupShown = 0;
        result = await this.fetchImageFromServerWithResult(
          this.collections[collectionIndex],
          sensorObj,
          selectedScene
        );
        result = this.responseResult;
        this.selectedSceneNew = selectedScene;
      } else {
        result = this.responseResult;
      }
      if (!result?.layer) return;

      const shapeList = result.layer.shapes;
      if (!shapeList?.length) return;

      const matchedShape = shapeList.find((s) =>
        s.sceneId ? s.sceneId === info?.sceneId : s.id === info?._id
      );
      if (!matchedShape) return;
      const classFilter = this.helperService.classCqlStrict(
        config?.class,
        'class'
      );

      const baseCql = this.helperService.combineFilters(
        matchedShape.cql,
        classFilter
      );

    const wfsBase = environment.geoServerUrl.replace(/\/wms\b/i, '/wfs');
    const qs = this.helperService.makeWfsParams(
      matchedShape.layerName ?? matchedShape.layername
    );
    if (baseCql) qs.set('CQL_FILTER', baseCql);
      const url = `${wfsBase}?${qs.toString()}`;
      let geojson: any;
      try {
      geojson = await firstValueFrom(this.http.get<any>(url));
      } catch (err) {
      return;
      }
      // const wfsRes = await fetch(`${wfsBase}?${qs.toString()}`);
      // if (!wfsRes.ok) return;

      // const geojson = await wfsRes.json();
      if (!geojson?.features?.length) return;

      const isUpperCase =
        config?.type === 'Vessel' || config?.type === 'Transshipment' || config?.type === 'Transhipment';

      this.vessel = [
        'Ship',
        'Vessel',
        'Transshipment',
        'Transhipment',
      ].includes(config?.type);
      const isExists = info?.isInfo?.insightDatas?.length > 0;
      let count = 0;

      if (!isUpperCase && isExists && !this.combinedScenes) {
        count = info?.isInfo?.insightDatas?.[0]?.insightFootprint?.feed_results;
      } else if (this.combinedScenes) {
        count =
          this.collections[collectionIndex].sensors[sensorIndex].feed_results;
      } else {
        if (info?.feed_results) {
          count = info?.feed_results;
        } else {
          const selectedscen = this.collections[collectionIndex].sensors[
            sensorIndex
          ].scenes.filter((scene) => scene.checked == true);
          const feedResult = info.insightDatas.find(
            (scene) => scene.sceneId === selectedscen[0]?.id
          );
          count = feedResult?.insightFootprint?.feed_results ?? 0;
        }
      }

      geojson.feed_results = count || 0;
      const vm = this.helperService.buildFeedSections(
        config,
        geojson.feed_results
      );

      this.feedSections = vm.sections;
      const title = this.feedTitleOf(config, info?.feedName || info?.name);
      const color = config?.color;

      this.addFeedPanel(feedKey, title, color, this.feedSections);
      this.feedUi = vm.ui;
      const fcRendered =
        geojson?.type === 'FeatureCollection'
          ? geojson
          : { type: 'FeatureCollection', features: geojson?.features };

      this.geoByFeed.set(feedKey, {
        fc: fcRendered,
        type: config?.type,
        color: config?.color,
        title,
      });

      this.activeFeedKeys.add(feedKey);
      const paneId = `tiff-pane-${feedKey}`;
      let pane = this.map.getPane(paneId);

      if (!pane) {
        pane = this.map.createPane(paneId);
        pane.style.zIndex = String(matchedShape.zIndex ?? 3000);
        pane.style.pointerEvents = 'auto';
      }
      if (config?.colorMode === 'CLASS_BASED') {
        pane.style.zIndex = '1500';
      }

      if (info?.isInfo?.modelType === this.infoserviceModelType) {
        pane.style.zIndex = '99999';
      }

      const feedName = config?.name || 'Unknown Feed';
      let feedColor = color || '#007bff';

      const isVesselType = [
        'ship',
        'vessel',
        'transshipment',
        'transhipment',
        'vessel-classification'
      ].includes((config?.type || '').toLowerCase());
      const dotCanvas = L.canvas({ padding: 0.5, pane: paneId });
      const overlay = L.geoJSON(fcRendered, {
        pane: paneId,
        style: (feature: any) => {
          // Soil Moisture: color based on class
          const isSoilMoistureSar = config?.type === 'Soil Moisture - SAR';
          const isVesselClassification = config?.type === 'Vessel-classification';
          const cls = feature?.properties?.class;

          if (isSoilMoistureSar && cls != null) {
            const entry = SOIL_MOISTURE_SAR_CLASS_MAP[cls];
            if (entry) {
              return {
                color: entry.color,
                fillColor: entry.color,
                fillOpacity: 0.8,
                weight: 0.4,
              };
            }
            } else if (isVesselClassification && cls != null) {
          const entry = VESSEL_CLASS_COLOR_MAP[cls];
          if (entry) {
            return {
              color: entry.color,
              fillColor: entry.color,
              fillOpacity: 1.0,
            };
          }
        }
        else if (config?.colorMode == 'CLASS_BASED') {
          const feedColor = config?.color;
          return {
            color: feedColor[cls]?.color,
            fillColor: feedColor[cls]?.color,
            fillOpacity: 1.0,
          };
        }

          return {
            color: feedColor,
            fillColor: feedColor,
            fillOpacity: 1,
          };
        },

        pointToLayer: (feature, latlng) => {
          if (config?.type === 'Tuna-detection') {
            return L.circleMarker(latlng, {
              radius: 6,
              fillColor: '#2ecc71',
              color: '#27ae60',
              weight: 2,
              opacity: 0.9,
              fillOpacity: 0.8,
              renderer: dotCanvas,
            });
          }
          if (config?.type === 'Tree counting') {
            return L.circleMarker(latlng, {
              radius: 4,
              color: feedColor,
              weight: 1,
              fillColor: feedColor,
              fillOpacity: 0.9,
              renderer: dotCanvas,
            });
          }
          if (config?.type === 'Container detection') {
            return L.circleMarker(latlng, {
              radius: 2,
              color: feedColor,
              weight: 1,
              fillColor: feedColor,
              fillOpacity: 0.9,
              renderer: dotCanvas,
            });
          }
          return L.circleMarker(latlng, { radius: 4, color: feedColor });
        },

        onEachFeature: (feature, layer) => {
            attachVesselHoverPopup({
              layer,
              feature,
              feedName,
              map: this.map,
              nonVesselFeed: this.nonVesselFeed,
              helperService: this.helperService,
              nudgeInsideView: this.nudgeInsideView.bind(this),
              pickDirection: this.pickDirection.bind(this),
              showEeTooltip: this.showEeTooltip.bind(this),
            });
        },
      });

      if (config?.type === 'Soil Moisture - SAR')
        this.addColorLegend('SOIL_MOISTURE_SAR');
      if (config?.colorMode === 'CLASS_BASED') {
        overlay.addTo(this.map);
        overlay.bringToBack();
      } else {
        overlay.addTo(this.map);
      }
      this.currentShapeLayerName =
        matchedShape.layerName ?? matchedShape.layername;
      this.currentFilteredLayers[feedKey] = overlay;

      if (overlay.getBounds?.().isValid()) {
        this.map.fitBounds(overlay.getBounds(), {
          padding: [50, 50],
          animate: true,
        });
      }

      this.feedInfo = true;


      if(this.isCompareRecurrency && (this.rightComparisonObjectLayer || this.rightImageNew) && (this.leftComparisonObjectLayer  || this.leftImageNew)) {
      const mapWidth = (this.map.getSize().x);
      this.updateObjectVisibility(this.lastSliderValue === 0 ? mapWidth/2 : this.lastSliderValue);
      this.needsCompareResetToCenter = false;
      }
    
    } catch (err) {
      this.pointerEvent = 'auto';
      this.mapLoad = false;
      this.spinnerService.hide();
      this.fail = this.fail + 1;
      if (this.fail == 1) {
        const message =
          'An error occurred during processing and ingestion of the request. Please try after sometime.';
        this.popupService.openPopup(
          CollectionPopupComponent,
          message,
          '',
          '40%'
        );
      }
      return;
    } finally {
      this.spinnerService.hide();
    }
  }

  fetchImageFromServerWithResult(
    collection: any,
    sensorObj: any,
    scene: any
  ): Promise<any> {
    this.mapLoad = true;
    this.spinnerService.show();

    return new Promise((resolve, reject) => {
      this.apiService
        .getCollectionImage(collection.taskId, sensorObj)
        .subscribe(
          (res: any) => {
            this.spinnerService.hide();
            this.mapLoad = false;

            if (res?.result) {
              this.responseResult = res.result;

              this.displayFootprintImageNew(
                scene,
                res.result,
                sensorObj.sensorId,
                'image',
                collection.taskId
              );

              resolve(res.result);
            } else {
              reject(res);
            }
          },
          (error) => {
            this.mapLoad = false;
            this.spinnerService.hide();
            reject(error);
          }
        );
    });
  }

  private pickDirection(
    pt: L.Point,
    margin = 120,
    inset: { left?: number; right?: number; top?: number; bottom?: number } = {
      right: 100,
      top: 60,
    }
  ): 'left' | 'right' | 'top' | 'bottom' {
    const size = this.map.getSize();
    const Lm = (inset.left ?? 0) + margin;
    const Rm = (inset.right ?? 0) + margin;
    const Tm = (inset.top ?? 0) + margin;
    const Bm = (inset.bottom ?? 0) + margin;

    const nearLeft = pt.x <= Lm;
    const nearRight = pt.x >= size.x - Rm;
    const nearTop = pt.y <= Tm;
    const nearBottom = pt.y >= size.y - Bm;
    // prioritize horizontal flip, then vertical
    if (nearRight) return 'left';
    if (nearLeft) return 'right';
    if (nearTop) return 'bottom';
    if (nearBottom) return 'top';
    return 'right';
  }

  private nudgeInsideView(ll: L.LatLngExpression, pad = 80): L.LatLng {
    const p = this.map.latLngToContainerPoint(ll);
    const s = this.map.getSize();
    p.x = Math.max(pad, Math.min(s.x - pad, p.x));
    p.y = Math.max(pad, Math.min(s.y - pad, p.y));
    return this.map.containerPointToLatLng(p);
  }

  applyFeedSection(config: any, feed_results: any) {
    const vm = this.helperService.buildFeedSections(config, feed_results);
    this.feedSections = vm.sections;
    this.feedUi = vm.ui;
    return vm;
  }

  /** Wrap expressions with parens when they contain OR (to preserve precedence). */
  wrapIfNeeded = (s: string) =>
    /\bOR\b/i.test(s) && !(s.trim().startsWith('(') && s.trim().endsWith(')'))
      ? `(${s.trim()})`
      : s.trim();

  private upsertFeedResultCount(targetObj: any, key: string, value: number) {
    if (!targetObj.insightFootprint) targetObj.insightFootprint = {};
    if (!targetObj.insightFootprint.feed_results)
      targetObj.insightFootprint.feed_results = {};
    targetObj.insightFootprint.feed_results[key] = value;
  }

  removeVectorOverlay() {
    try {
      (this.shapeVectorOverlay as any).off?.();
    } catch {}
    if (this.shapeVectorOverlay && this.map.hasLayer(this.shapeVectorOverlay))
      this.map.removeLayer(this.shapeVectorOverlay);
    this.shapeVectorOverlay = undefined;
    this.feedInfo = false;
    this.feedData = '';
  }

  showNoFeedMessage(feedName) {
    const message = `Please see the ${feedName} after enabling the data in GeoTiff format on the map by toggling to Load Tiff.`;
    this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
    this.spinnerService.hide();
  }

  guardTreeCounting(e: MouseEvent, info: any) {
    const feedId = info?._id;
    const config = feedId ? feedsConfig[feedId] : null;

    const disallowed =
      this.imageType === 'png' && (config?.type === 'Tree counting' || config?.type === 'Container detection');
    if (disallowed) {
      e.preventDefault();
      e.stopPropagation();
      this.showNoFeedMessage(info?.feedName);
    }
  }

  selectISNew(
    collectionIndex: number,
    sensorIndex: number,
    infoServiceIndex: number,
    event,
    info: any,
    taskId: string
  ) {
    this.spinnerService.show();
    if (this.displayedIS) {
      this.displayedIS = null;
    }
    this.currentTaskId = taskId;
    let feedId = '';
    let config: any = '';
    if (info) {
      feedId = info?._id;
      config = feedsConfig[feedId];
      info.checked = event.checked;
    }

    this.info = info;
    const id = info?._id;
    if (!id) return;
    this.feedInfo = false;
    const key = this.getFeedKey(info, config);

    if (
      event.checked &&
      this.imageType === 'png' &&
      (config?.type === 'Tree counting' || config?.type === 'Container detection')
    ) {
      this.showNoFeedMessage(info?.feedName);
      const row =
        this.collections[collectionIndex].sensors[sensorIndex].InfoServices[
          infoServiceIndex
        ];
      row.checked = false;
      info.checked = false;
      const fakeEvent = { ...event, checked: false };
      this.updateFeedInfo(
        this.collections[collectionIndex].sensors[sensorIndex],
        fakeEvent,
        key
      );
      return;
    }

    info.checked = event.checked;
    this.info = info;
    this.feedInfo = false;

    this.updateFeedInfo(
      this.collections[collectionIndex].sensors[sensorIndex],
      event,
      key
    );

    if (event.checked) {
      if (this.imageType == 'png') {
        this.loadFeedOnPNG(
          collectionIndex,
          sensorIndex,
          infoServiceIndex,
          event,
          info,
          config
        );
      } else if (this.imageType === 'tif') {
        this.loadFeedOnTiff(
          collectionIndex,
          sensorIndex,
          infoServiceIndex,
          event,
          info,
          config
        );
      }
    } else {
      this.collections[collectionIndex].sensors[
        sensorIndex
      ].InfoServices.forEach((InfoService) => {
        if (
          InfoService._id ==
          this.collections[collectionIndex].sensors[sensorIndex].InfoServices[
            infoServiceIndex
          ]._id
        ) {
          InfoService.checked = false;
        }
      });
      this.stopHover();
      this.feedLoaded = false;
      this.feedUi = { showFilterIcon: false };
      this.removeDataLayer(info);
      this.removeFeedPanel(key);
      this.removeIndices();
      this.updateFeedInfo(
        this.collections[collectionIndex].sensors[sensorIndex],
        event,
        key
      );
      this.removeVectorOverlay();
      this.clearFilteredLayerAndRestore(false, key);
      this.activeFeedKeys.delete(key);
      this.spinnerService.hide();
    }
  }

  updateFeedInfo(sensor: any, event?: any, key?: any) {
    this.filterInfoVisible = this.getFeedInfoForFilter(
      sensor.InfoServices,
      event,
      key
    );
   this.filterIconShown = this.hasFilterMessageShown(sensor.InfoServices)
  }

  removeDataLayer(feedOrInfo: any): void {
    const feedKey = String(feedOrInfo?._id ?? feedOrInfo?.name);
    const layer = this.feedLayers[feedKey];
    if (layer) {
      this.removeVesselLabelLayer(layer);
      this.map.removeLayer(layer);
      delete this.feedLayers[feedKey];
    }
   if (this.currentFilteredLayers?.[feedKey]) {
        const layer = this.currentFilteredLayers[feedKey];
        if (layer && this.map.hasLayer(layer)) {
          this.removeVesselLabelLayer(layer);
          this.map.removeLayer(layer);
        }
        delete this.currentFilteredLayers[feedKey];
      }
  }

  private cleanupAfterOperation() {
    this.spinnerService.hide();
    this.mapLoad = false;
    this.opManager.completeOperation();
  }

  loadFeedOnPNG(
    collectionIndex: number,
    sensorIndex: number,
    infoServiceIndex: number,
    event,
    info: any,
    config: any
  ) {
    const row =
      this.collections[collectionIndex].sensors[sensorIndex].InfoServices[
        infoServiceIndex
      ];
    row.checked = !!event.checked;

    const sensor = this.collections[collectionIndex].sensors[sensorIndex];
    const hasObservation = sensor.Observation.length > 0;
    const infy = hasObservation ? sensor.Observation[0] : row;
    this.currentSelectedConfig = { config: config };

    const continueExecution = () => {
      if (event.checked) {
        row.checked = true;

        if (infy?.modelType === this.infoserviceModelType) {
          this.spinnerService.show();
          this.mapLoad = true;

          let payload: any;
          if (sensor?.operatorKey === OPERATORS.AXELSPACE) {
            payload = {
              action: this.combinedScenes ? 'sensorFeed' : 'ISDisplay',
              feedId: info?._id,
              type: 'json',
              sceneId: sensor.id,
              sensorId: sensor.id,
            };
          } else {
            payload = {
              action: this.combinedScenes ? 'sensorFeed' : 'ISDisplay',
              feedId: info?._id,
              type: 'json',
              sceneId: this.sceneSelected,
              sensorId: sensor.id,
            };
          }
          this.spinnerService.show();
          this.getCollectionSub = this.apiService
            .getCollectionImage(this.collection.taskId, payload)
            .subscribe(
              (res: any) => {
                this.fetchAndCombineGeoJson(
                  res?.result?.feedData,
                  info,
                  sensor
                );
              },
              (err) => {
                this.spinnerService.hide();
                this.mapLoad = false;
                this.cleanupAfterOperation();
              }
            );
        } else if (
          this.combinedScenes &&
          infy?.modelType !== this.infoserviceModelType
        ) {
          this.spinnerService.show();
          this.mapLoad = true;
          let payload = {
            customerid: this.currentUser?.id,
            feedId: info?._id,
            taskId: this.currentTaskId,
            sensorId: this.collections[collectionIndex].sensors[sensorIndex].id,
          };
          const selectedSceneIS = info.insightDatas.filter(
            (scene) => scene.sceneId === this.sceneSelected
          );

          this.apiService
            .getObjectDetectionData(payload)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
              next: (res: any) => {
                const feedData = res?.result?.feedData;
                this.displayISNew({
                  insightFootprint: feedData,
                  isInfo: info,
                  sensor: sensor,
                });

                this.displayedIS = {
                  insightFootprint: JSON.parse(JSON.stringify(feedData)),
                  isInfo: info,
                };
              },
              error: () => {
                this.spinnerService.hide();
                this.mapLoad = false;
              },
            });
        } else {
          // cached logic unchanged
          const cached = info?.insightDatas ?? [];
          if (cached.length > 0) {
            if (sensor?.operatorKey === OPERATORS.AXELSPACE) {
              this.displayISNew(cached[0], info);
              this.displayedIS = JSON.parse(JSON.stringify(cached[0]));
            } else {
              if(this.sceneSelected) {
              const s = info.insightDatas.find(
                (sc: any) => sc.sceneId === this.sceneSelected
              );
              if (s && info) s._id = info._id;
              this.displayISNew(s, info);
              this.displayedIS = JSON.parse(JSON.stringify(s));
            } else {
              this.scenIdList.forEach((sceneId) => {
              const s = info.insightDatas.find(
                (sc: any) => sc.sceneId === sceneId
              );
              if (s && info) s._id = info._id;
              this.displayISNew(s, info);
              this.displayedIS = JSON.parse(JSON.stringify(s));
            })
            }
          }
          } else {
            this.spinnerService.hide();
            this.mapLoad = false;
          }
          this.opManager.completeOperation();
        }
      }
    };

    if (!this.opManager.isOperationRunning) {
      continueExecution();
    }
  }
  unCheckISNew(
    collectionIndex: number,
    sensorIndex: number,
    infoServiceIndex: number
  ) {
    this.collections[collectionIndex].sensors[sensorIndex].InfoServices.forEach(
      (InfoService) => {
        if (
          InfoService._id ==
          this.collections[collectionIndex].sensors[sensorIndex].InfoServices[
            infoServiceIndex
          ]._id
        ) {
          InfoService.checked = true;
        } else {
          InfoService.checked = false;
        }
      }
    );
  }

  showFeedData(feedId: any, insightFootprint: any) {
    const config = feedsConfig[feedId];
    let filteredCollection: any = insightFootprint;
    if (config?.filterKey) {
      filteredCollection = this.getFilteredData(
        insightFootprint,
        config?.filterKey
      );
    }
    const count = filteredCollection?.features?.length ?? 0;
    const firstAreaHa =
      filteredCollection?.features?.[0]?.properties?.area_ha ?? null;
    return filteredCollection;
  }

  showNoMatchesMessage() {
    const message = `There are no vessels meeting the search criteria.`;
    this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
  }

  private removeTooltip() {
    if (this.currentTooltip) {
      this.map.removeLayer(this.currentTooltip);
      this.currentTooltip = null;
    }
  }

  displayISNew(sceneISInfo: any, feed: any = null, sensor: any = null, isCompare: boolean = false , pane?) {
    this.spinnerService.show();
    if (!(this.map as any).getPane('markersPane')) {
      this.map.createPane('markersPane');
      (this.map as any).getPane('markersPane').style.zIndex = 2600;
    }
    if (!(this.map as any).getPane('geojsonpane')) {
      this.map.createPane('geojsonpane');
      (this.map as any).getPane('geojsonpane').style.zIndex = 2500;
    }
if (!this.map.getPane('left-objects')) {
  this.map.createPane('left-objects');
  this.map.getPane('left-objects')!.style.zIndex = '650';
}

if (!this.map.getPane('right-objects')) {
  this.map.createPane('right-objects');
  this.map.getPane('right-objects')!.style.zIndex = '650';
}

    if(pane === 'left' && this.leftComparisonObjectLayer && this.map.hasLayer(this.leftComparisonObjectLayer)){
      this.map.removeLayer(this.leftComparisonObjectLayer);
      this.leftComparisonObjectLayer = null;
      this.leftFeedPanels.clear();
    }
    
    if(pane === 'right' && this.rightComparisonObjectLayer && this.map.hasLayer(this.rightComparisonObjectLayer)){
      this.map.removeLayer(this.rightComparisonObjectLayer);
      this.rightComparisonObjectLayer = null;
      this.rightFeedPanels.clear();
    }

if (pane === 'left') {
  this.leftFeedPanels.clear();
}

if (pane === 'right') {
  this.rightFeedPanels.clear();
}



    this.feedLoaded = true;
    if (!sceneISInfo) return;

    let feedName =
      feed?.feedName ||
      sceneISInfo?.isInfo?.feedName ||
      sceneISInfo?.feedName ||
      sceneISInfo?.isInfo?.name ||
      sceneISInfo?.name ||
      feed?.name;
    let feedId = sceneISInfo?.isInfo
      ? sceneISInfo?.isInfo?._id
      : sceneISInfo?._id || feed?._id;
    const config = feedsConfig[feedId];
    const feedKey = String(feedId ?? feedName);
     if(isCompare)
     this.removeFeedPanel(feedKey);
    if (this.feedLayers[feedKey] && !isCompare) {
      try {
        this.map.fitBounds((this.feedLayers[feedKey] as any).getBounds());
      } catch (e) {}
      return;
    }

    const isUpperCase =
      config?.type === 'Vessel' || config?.type === 'Transshipment' || config?.type === 'Transhipment';
    this.vessel =
      config?.type === 'Ship' ||
      config?.type === 'Vessel' ||
      config?.type === 'Transshipment' ||
      config?.type === 'Transhipment';
    this.feedInfo = true;
    this.feedData = '';
    this.oilSpil = false;

    const index = this.nonVesselFeed.findIndex(
      (item) => item.name === feedName
    );
    this.vessel = index === -1;
    const rawFC = this.asFeatureCollection(sceneISInfo);
    if (!rawFC?.features?.length) {
      const formattedDate = formatDate(
        this.taskCreatedDate,
        'dd/MM/yyyy',
        'en-US'
      );
      const msg = `There is no information extracted from the tasked data for ${this.taskName} submitted on ${formattedDate} as the observation of interest is not present.`;
      this.popupService.openPopup(CollectionPopupComponent, msg, '', '40%');
      return;
    }
    const insightFootprint = sceneISInfo?.insightFootprint;
    let filteredCollection = this.getFilteredData(rawFC, 'wake');
    if (config?.filterKey) {
      filteredCollection = this.getFilteredData(rawFC, config?.filterKey);
    }
    const featureCount = filteredCollection?.features?.length ?? 0;

    const isExists = sceneISInfo?.isInfo?.insightDatas?.length > 0;
    let count = 0;

    if (!isUpperCase && isExists && !this.combinedScenes) {
      count =
        sceneISInfo?.isInfo?.insightDatas[0]?.insightFootprint?.feed_results;
    } else if (this.combinedScenes) {
      count = sceneISInfo.sensor?.feed_results;
    } else {
      count = sceneISInfo?.insightFootprint?.feed_results;
    }

    const key = this.getFeedKey(sceneISInfo, config);
    const feed_results = count ? count : 0;
    const vm = this.helperService.buildFeedSections(config, feed_results);
    this.feedSections = vm.sections;
    const titleFallbackInput =
      feed?.feedName ||
      sceneISInfo?.isInfo?.feedName ||
      sceneISInfo?.feedName ||
      sceneISInfo?.isInfo?.name ||
      sceneISInfo?.name ||
      feed?.name;
    const title = this.feedTitleOf(
      config,
      titleFallbackInput
    );
    const color = config?.color;
    const fcRendered: FeatureCollection<Geometry, FeatureProps> =
      filteredCollection?.type === 'FeatureCollection'
        ? filteredCollection
        : {
            type: 'FeatureCollection',
            features: filteredCollection?.features ?? [],
          };

    this.geoByFeed.set(key, {
      fc: fcRendered,
      type: config?.type,
      color: config?.color,
      title,
    });
    this.activeFeedKeys.add(key);
    if(!this.isCompareRecurrency) {
    this.addFeedPanel(key, title, color, this.feedSections);
    }else {
  if (pane === 'left') {
    this.addLeftFeedPanel(key, title, color, this.feedSections);
  } else if (pane === 'right') {
    this.addRightFeedPanel(key, title, color, this.feedSections);
  }
}
    this.feedUi = vm.ui;

    if (!(filteredCollection?.features?.length > 0)) {
      this.feedLoaded = false;
      const formattedDate = formatDate(
        this.taskCreatedDate,
        'dd/MM/yyyy',
        'en-US'
      );
      const message = `There is no information extracted from the tasked data for ${this.taskName} submitted on ${formattedDate} as the observation of interest is not present.`;
      this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
      this.spinnerService.hide();
      return;
    }
let paneName = 'geojsonpane';

if (!this.map.getPane('geojsonpane')) {
  this.map.createPane('geojsonpane');
}

const paneEl = this.map.getPane('geojsonpane');
if (paneEl) {
  paneEl.style.zIndex = '2500';

  if (config?.colorMode === 'CLASS_BASED') {
    paneEl.style.zIndex = '1500';
  } else if (sceneISInfo?.isInfo?.modelType !== this.infoserviceModelType) {
    paneEl.style.zIndex = '9999';
  }
}

const objectPane =
  isCompare && pane === 'left'
    ? 'left-objects'
    : isCompare && pane === 'right'
    ? 'right-objects'
    : paneName;

    const layer = (L as any).geoJSON(filteredCollection, {
      pane: objectPane,
      style: (feature: any) => {
        // Check if feed is Soil Moisture
        const isSoilMoisture = config?.type === 'Soil Moisture - SAR';
        const isVesselClassification = config?.type === 'Vessel-classification';

        const cls = feature?.properties?.class;

        // Soil moisture → color by class
        if (isSoilMoisture && cls != null) {
          const entry = SOIL_MOISTURE_SAR_CLASS_MAP[cls];
          if (entry) {
            return {
              color: entry.color,
              fillColor: entry.color,
              fillOpacity: 0.8,
              weight: 0.4,
            };
          }
        } else if (isVesselClassification && cls != null) {
          const entry = VESSEL_CLASS_COLOR_MAP[cls];
          if (entry) {
            return {
              color: entry.color,
              fillColor: entry.color,
              fillOpacity: 1.0,
            };
          }
        }else if (config?.colorMode == 'CLASS_BASED') {
          const feedColor = config?.color;
          return {
            color: feedColor[cls]?.color,
            fillColor: feedColor[cls]?.color,
            fillOpacity: 1.0,
          };
        }

        // Default → old behavior untouched
        const feedColor = config?.color;
        return {
          color: feedColor,
          fillColor: feedColor,
          fillOpacity: 1.0,
        };
      },
      pointToLayer: (ftr, latlng) => {
        if (config?.type === 'Tuna-detection') {
          return L.circleMarker(latlng, {
            radius: 6,
            fillColor: '#2ecc71',
            color: '#27ae60',
            weight: 2,
            opacity: 0.9,
            fillOpacity: 0.8,
            pane: objectPane
          });
        }
        if (
          this.nonVesselFeed.findIndex((item) => item.name == feedName) != -1
        ) {
          if (
            (ftr.geometry.type === 'Point' ||
              ftr.geometry.type === 'MultiPoint') &&
            feedName === 'Tree crown detection and count'
          ) {
            return new L.Marker(latlng, {
              icon: new L.DivIcon({
                className: 'leaflet-div-icon',
                html: `
                <div style="
                  width: 10px; 
                  height: 10px; 
                  border-radius: 50%; 
                  background-color: green; 
                  border: 2px solid darkgreen;
                  box-shadow: 0 0 3px rgba(0,0,0,0.3);
                "></div>`,
                iconSize: [10, 10],
                iconAnchor: [5, 5],
              }),
            });
          }
        }
        if (config?.type === 'Container detection') {
          const dotCanvas = L.canvas({ padding: 0.5, pane: objectPane });
          return L.circleMarker(latlng, {
            radius: 2,
            color: config.color,
            weight: 1,
            fillColor: config.color,
            fillOpacity: 0.9,
            renderer: dotCanvas,
          });
        }
        return new L.Marker(latlng);
      },
      onEachFeature: (ftr: any, lyr: any) => {
        attachVesselHoverPopup({
          layer: lyr,
          feature: ftr,
          feedName,
          map: this.map,
          nonVesselFeed: this.nonVesselFeed,
          helperService: this.helperService,
          nudgeInsideView: this.nudgeInsideView.bind(this),
          pickDirection: this.pickDirection.bind(this),
          showEeTooltip: this.showEeTooltip.bind(this),
        });
      },
    });
    
    if(!isCompare) {
    if (config?.type === 'Soil Moisture - SAR')
      this.addColorLegend('SOIL_MOISTURE_SAR');
    if (config?.colorMode === 'CLASS_BASED') {
      layer.addTo(this.map);
      layer.bringToBack();
    } else {
      const type = filteredCollection?.type;
      if (type === 'ObjectCollection') {
        // ObjectCollection -> always on top
        layer.addTo(this.map);
        layer.options.isObjectLayer = true;
        this.bringObjectLayersToFront();
      } else if (type === 'FeatureCollection') {
        // FeatureCollection -> always below
        layer.addTo(this.map);
      } else {
        layer.addTo(this.map);
      }
    }
  } else {
    if(pane && pane == 'left') {
      this.leftComparisonObjectLayer  = layer;
      layer.addTo(this.map);
    } else if(pane && pane == 'right') {
      this.rightComparisonObjectLayer  = layer;
      layer.addTo(this.map);
    }

  
    if(this.isCompareRecurrency && (this.rightComparisonObjectLayer || this.rightImageNew) && (this.leftComparisonObjectLayer  || this.leftImageNew)) {
      const mapWidth = (this.map.getSize().x);
    this.updateObjectVisibility(this.lastSliderValue === 0 ? mapWidth/2 : this.lastSliderValue);
    this.needsCompareResetToCenter = false;
    }
  }

    this.feedLayers[feedKey] = layer;

    this.spinnerService.hide();
   if(!isCompare) {
    try {
      this.map.fitBounds(layer.getBounds());
    } catch (e) {}
  }
    this.spinnerService.hide();
  }

  private bringObjectLayersToFront(): void {
    Object.values(this.currentFilteredLayers).forEach((layer: any) => {
      if (layer?.isObjectLayer && layer.bringToFront) {
        layer.bringToFront();
      }
    });
  }

  // Normalize to a FeatureCollection
  private asFeatureCollection(x: any): FeatureCollection {
    if (x?.type === 'FeatureCollection') return x;
    if (x?.insightFootprint?.type === 'FeatureCollection')
      return x.insightFootprint;
    const features = x?.insightFootprint?.features ?? x?.features ?? [];
    return { type: 'FeatureCollection', features };
  }

  private rebuildCombined(): void {
    const out: FeedSection[] = [];

    const combinedSection: FeedSection = {
      show: false,
      className: '',
      style: {},
      items: [],
    };

    for (const { title, color, sections } of this.feedPanels.values()) {
      for (const s of sections) {
        combinedSection.className = s.className;
        combinedSection.items.push(...s.items);
        combinedSection.show = combinedSection.items.length > 0;
      }
    }

    out.push(combinedSection);

    this.combinedFeedSections = out;
    this.feedInfo = this.combinedFeedSections.length > 0;
  }

  private addFeedPanel(
    key: string,
    title: string,
    color: string | SoilMoistureSarClassMap | undefined,
    sections: FeedSection[]
  ): void {
    const next = new Map(this.feedPanels);
    next.set(key, { title, color, sections });
    this.feedPanels = next;
    this.rebuildCombined();
  }

  private addLeftFeedPanel(
  key: string,
  title: string,
  color: string | SoilMoistureSarClassMap | undefined,
  sections: FeedSection[]
): void {
  const next = new Map(this.leftFeedPanels);
  next.set(key, { title, color, sections });
  this.leftFeedPanels = next;
}

private addRightFeedPanel(
  key: string,
  title: string,
  color: string | SoilMoistureSarClassMap | undefined,
  sections: FeedSection[]
): void {
  const next = new Map(this.rightFeedPanels);
  next.set(key, { title, color, sections });
  this.rightFeedPanels = next;
}


  // Remove a feed’s panel by key
  private removeFeedPanel(key: string): void {
    if (!this.feedPanels.has(key)) return;
    const next = new Map(this.feedPanels);
    next.delete(key);
    this.feedPanels = next;
    this.rebuildCombined();
  }
  private getFeedKey(feed: any, config: any): string {
    return String(
      feed?._id ?? feed?.isInfo?._id ?? feed?.id ?? config?.type ?? Date.now()
    );
  }

  private feedTitleOf(config?: { type?: string }, fallback?: string): string {
    return fallback || config?.type || 'Information Service';
  }

  getFilteredData(jsonData: any, className: string) {
    const filteredFeatures = jsonData.features.filter(
      (feature) => feature?.properties?.class != className
    );
    return {
      type: jsonData.type,
      crs: jsonData.crs,
      features: filteredFeatures,
      metadata: jsonData?.metadata,
      feed_results: jsonData?.feed_results,
    };
  }
  openFilter(isCompare?: boolean) {
    const dialogRef = this.matdialog.open(FilterPopupComponent, {
      width: '35%',
      backdropClass: 'blurr',
      disableClose: true,
      data: { type: 'vessel', isCompare: isCompare ?? false },
    });
    dialogRef
      .afterClosed()
      .pipe(take(1))
      .subscribe((result) => {
        if (!result) return;
        const threshold = Number(result.length);
        this.handleVesselLengthFilter({ ...result, length: threshold });
      });
  }

  groupByClass(data: any[]): Record<string, any[]> {
    return data.reduce((groups, item) => {
      const key = item.class || 'unknown';
      if (!groups[key]) groups[key] = [];
      groups[key].push(item);
      return groups;
    }, {} as Record<string, any[]>);
  }

  handleVesselLengthFilter(result: any) {
    const lenLimit = Number(result.length);
    const keepGreater = !!result.isGreater;

    if(!result.isCompare) {
    this.clearFilteredLayerAndRestore(true);
    this.removeISLayers();
    this.feedPanels.clear();
    const vesselPane =
      this.map.getPane('vesselPane') || this.map.createPane('vesselPane');
    vesselPane.style.zIndex = '9999';
    vesselPane.style.pointerEvents = 'auto';

    const nonVesselPane =
      this.map.getPane('nonVesselPane') || this.map.createPane('nonVesselPane');
    nonVesselPane.style.zIndex = '7000';
    nonVesselPane.style.pointerEvents = 'auto';

    const activeEntries: Array<
      [
        string,
        { fc: FeatureCollection; type?: string; color?: string; title: string }
      ]
    > = [];
    for (const key of this.activeFeedKeys) {
      const entry = this.geoByFeed.get(key);
      if (entry) activeEntries.push([key, entry]);
    }

    if (activeEntries.length === 0) {
      this.popupService.openPopup(
        CollectionPopupComponent,
        'No checked feeds to filter.',
        '',
        '40%'
      );
      this.resetAllFeedPanels();
      return;
    }

    const norm = (s?: string) => (s || '').toLowerCase();
    const isVesselType = (t?: string) =>
      ['ship', 'vessel'].includes(norm(t));
    const colorForType = (t?: string, fallback?: string) => {
      const hit = Object.values(feedsConfig).find(
        (c: any) => norm(c?.type) === norm(t)
      );
      return (hit as any)?.color || fallback || '#ffd166';
    };

    const combinedFeatures: GeoJSON.Feature[] = [];
    let vesselMatches = 0;

    for (const [feedKey, entry] of activeEntries) {
      const { fc, type: entryType, color: entryColor, title } = entry;
      const cfg = feedsConfig[feedKey];
      if (!cfg || !fc) continue;

      const effectiveType = cfg?.type ?? entryType;
      const feats = Array.isArray(fc.features) ? fc.features : [];
      const color = colorForType(effectiveType, entryColor);

      // (A) Vessel / Transshipment filtering
      if (isVesselType(effectiveType)) {
        const filtered = feats.filter((f) =>
          this.matchByLength(f, lenLimit, keepGreater)
        );
        vesselMatches += filtered.length;

        const classCounts = this.countsByClass(filtered as any);
        const resultKey = this.getFeedResultKeyForClass(cfg?.type);
        const totalCount = Object.values(classCounts).reduce(
          (sum, n) => sum + n,
          0
        );
        const feedResults = { [resultKey]: totalCount };
        const vm = this.helperService.buildFeedSections(cfg, feedResults);
        this.addFeedPanel(feedKey, title, color, vm.sections);

        for (const f of filtered) {
          const props = { ...(f.properties || {}), _color: color };
          combinedFeatures.push({ ...f, properties: props } as any);
        }
        const paneEl = this.map.getPane('vesselPane');
        if (paneEl) paneEl.style.zIndex = '9999';
        const filteredFC = { type: 'ObjectCollection', features: filtered };
        const filteredLayer = (L as any).geoJSON(filteredFC, {
          pane: 'vesselPane',
          style: (feature: any) => ({
            color: feature?.properties?._color || color,
            fillColor: feature?.properties?._color || color,
            fillOpacity: 1.0,
          }),
          pointToLayer: (ftr, latlng) =>
            new L.CircleMarker(latlng, { radius: 4 }),
          onEachFeature: (ftr: any, lyr: any) => {
            attachVesselHoverPopup({
              layer: lyr,
              feature: ftr,
              feedName: cfg?.name || feedKey,
              map: this.map,
              nonVesselFeed: this.nonVesselFeed,
              helperService: this.helperService,
              nudgeInsideView: this.nudgeInsideView.bind(this),
              pickDirection: this.pickDirection.bind(this),
              showEeTooltip: this.showEeTooltip.bind(this),
            });
          },
        });
        filteredLayer.addTo(this.map);
        this.currentFilteredLayers[feedKey] = filteredLayer;

        continue;
      }

      // (B) Non-vessel feeds → no filtering
      const paneE2 = this.map.getPane('nonVesselPane');
      if (paneE2) paneE2.style.zIndex = '7000';
      const vm = this.helperService.buildFeedSections(
        cfg,
        (fc as any)?.feed_results
      );
      this.addFeedPanel(feedKey, title, color, vm.sections);
       
      for (const f of feats) {
        const props = { ...(f.properties || {}), _color: color };
        combinedFeatures.push({ ...f, properties: props } as any);
      }

      const passthroughFC = { type: 'FeatureCollection', features: feats };
      const passthroughLayer = (L as any).geoJSON(passthroughFC, {
        pane: 'nonVesselPane',
        style: (feature: any) => {
          const isSoilMoisture = cfg?.type === 'Soil Moisture - SAR';

          const cls = feature?.properties?.class;
          if (isSoilMoisture && cls != null) {
            const entry = SOIL_MOISTURE_SAR_CLASS_MAP[cls];
            if (entry) {
              return {
                color: entry.color,
                fillColor: entry.color,
                fillOpacity: 0.8,
                weight: 0.4,
              };
            }
          } else if( cfg?.type === 'Vessel-classification' && cls != null) {
            const entry = VESSEL_CLASS_COLOR_MAP[cls];
            if (entry) {
              return {
                color: entry.color,
                fillColor: entry.color,
                fillOpacity: 1.0,
              };
          }
        }

          const fallbackColor = feature?.properties?._color || color;
          return {
            color: fallbackColor,
            fillColor: fallbackColor,
            fillOpacity: 1.0,
          };
        },
        pointToLayer: (ftr, latlng) =>
          new L.CircleMarker(latlng, { radius: 4 }),
        onEachFeature: (ftr: any, lyr: any) => {
          attachVesselHoverPopup({
            layer: lyr,
            feature: ftr,
            feedName: cfg?.name || feedKey,
            map: this.map,
            nonVesselFeed: this.nonVesselFeed,
            helperService: this.helperService,
            nudgeInsideView: this.nudgeInsideView.bind(this),
            pickDirection: this.pickDirection.bind(this),
            showEeTooltip: this.showEeTooltip.bind(this),
          });
        },
      });
      passthroughLayer.addTo(this.map);
      this.currentFilteredLayers[feedKey] = passthroughLayer;
    }

    if (vesselMatches === 0) {
      this.showNoMatchesMessage();
      return;
    }

    const allFilteredFC = {
      type: 'FeatureCollection',
      features: combinedFeatures,
    };
    const allFilteredLayer = (L as any).geoJSON(allFilteredFC);
    this.map.fitBounds(allFilteredLayer.getBounds());

    this.rebuildCombined();
    this.feedLoaded = true;
  } else {
   const leftCount = this.filterLayersByDiagonal(
    this.leftComparisonObjectLayer,
    lenLimit,
    keepGreater
  );

  const rightCount = this.filterLayersByDiagonal(
    this.rightComparisonObjectLayer,
    lenLimit,
    keepGreater
  );
     if(leftCount === 0 && rightCount === 0) {
    this.showNoMatchesMessage();
  }

  this.leftFeedPanels = this.updateFeedCount(this.leftFeedPanels, leftCount);
  this.rightFeedPanels = this.updateFeedCount(this.rightFeedPanels, rightCount);
   }
 }

private filterLayersByDiagonal(
  layerGroup: any,
  lenLimit: number,
  keepGreater: boolean
): number {

  if (!layerGroup) return 0;

  let visibleCount = 0;

  const process = (layer: any) => {

    if (!layer.getBounds) return;

    const bounds = layer.getBounds();

    const diagonal = this.map.distance(
      bounds.getNorthWest(),
      bounds.getSouthEast()
    );

    const shouldShow = keepGreater
      ? diagonal > lenLimit
      : diagonal < lenLimit;

    layer.setStyle({
      stroke: shouldShow
    });

    if (shouldShow) visibleCount++;
  };

  layerGroup.eachLayer((layer: any) => {
    if (layer.eachLayer) {
      layer.eachLayer(process);
    } else {
      process(layer);
    }
  });

  return visibleCount;
}


private updateFeedCount(
  feedPanels: Map<string, any>,
  count: number
): Map<string, any> {

  if (!feedPanels || feedPanels.size === 0) return feedPanels;

  const next = new Map(feedPanels);

  const key = Array.from(next.keys())[0];
  const panel = next.get(key);
  if (!panel) return feedPanels;

  panel.sections[0].items[0].text = `Vessel count : ${count}`;

  next.set(key, panel);

  return next;
}

  private matchByLength(f: any, len: number, keepGreater: boolean): boolean {
    const v =
      parseFloat(
        (f?.properties?.vessel_length ?? f?.properties?.vessel_len ?? '')
          .toString()
          .replace(/[^\d.]/g, '')
      ) || 0;

    if (Number.isNaN(v)) return false;

    return keepGreater ? v > len : v < len;
  }

  private getFeedResultKeyForClass(
    feedType?: string
  ): 'vessel_count' | 'transhipment_count' {
    const s = String(feedType ?? '')
      .trim()
      .toLowerCase();
    return s.includes('trans') ? 'transhipment_count' : 'vessel_count';
  }

  private countsByClass(
    features: Feature<Geometry, FeatureProps>[]
  ): Record<string, number> {
    return features.reduce((acc, ft: any) => {
      const cls = String(ft?.properties?.class ?? 'Unknown');
      acc[cls] = (acc[cls] || 0) + 1;
      return acc;
    }, {} as Record<string, number>);
  }

  private clearFilteredLayerAndRestore(
    isRestore: boolean,
    feedKey?: string
  ): void {
    // Remove a single filtered layer
    if (feedKey) {
      if (this.currentFilteredLayers?.[feedKey]) {
        const layer = this.currentFilteredLayers[feedKey];
        if (layer && this.map.hasLayer(layer)) {
          this.removeVesselLabelLayer(layer);
          this.map.removeLayer(layer);
        }
        delete this.currentFilteredLayers[feedKey];
      }

      if (this.feedLayers?.[feedKey]) {
        const layer = this.feedLayers[feedKey];
        if (layer && this.map.hasLayer(layer)) {
          this.removeVesselLabelLayer(layer);
          this.map.removeLayer(layer);
        }
        delete this.feedLayers[feedKey];
      }
    }

    if (isRestore) {
      Object.values(this.currentFilteredLayers || {}).forEach((layer) => {
        if (this.map.hasLayer(layer)) {
           this.removeVesselLabelLayer(layer);
          this.map.removeLayer(layer);
        }
      });
      this.currentFilteredLayers = {};
    }

    if (this.shapeVectorOverlay && this.map.hasLayer(this.shapeVectorOverlay)) {
      this.map.removeLayer(this.shapeVectorOverlay);
      this.shapeVectorOverlay = undefined;
    }

    this.rebuildCombined();
  }

  private upsertFeedResultsForFiltered(feedsObj: any, feats: any[]) {
    const filteredCount = feats.length;
    const allTransshipment =
      filteredCount > 0 &&
      feats.every((f) => this.isTransshipmentClass(f?.properties?.class));
    feedsObj.insightFootprint.feed_results = {
      ...(feedsObj.insightFootprint.feed_results ?? {}),
      ...(allTransshipment
        ? { transhipment_count: filteredCount }
        : { vessel_count: filteredCount }),
    };
  }
  private isTransshipmentClass(cls: unknown) {
    const s = String(cls || '')
      .trim()
      .toLowerCase();
    return s.startsWith('transship') || s.startsWith('tranship');
  }

  removeISLayers() {
    if (this.ISGeojsonLayer) {
      this.map.removeLayer(this.ISGeojsonLayer);
      this.ISGeojsonLayer = null;
    }
    if (this.ISMarkers && this.ISMarkers.length > 0) {
      this.ISMarkers.map((marker) => {
        this.map.removeLayer(marker);
        marker = null;
      });
      this.ISMarkers = [];
    }

    Object.values(this.feedLayers).forEach((layer) => {
      if (this.map.hasLayer(layer)) {
        this.map.removeLayer(layer);
      }
    });

    this.feedData = '';
  }

  removeIndices() {
    this.indicesLayers.forEach((indice) => {
      this.map.removeLayer(indice);
    });
    if (this.indicesLayer) {
      this.map.removeLayer(this.indicesLayer);
      this.indicesLayer = null;
    }
    if (this.indicesLegendLayer) {
      this.map.removeLayer(this.indicesLegendLayer);
      this.indicesLegendLayer = null;
    }
    if (this.indicesFootprintLayer) {
      this.map.removeLayer(this.indicesFootprintLayer);
      this.indicesFootprintLayer = null;
    }
    if (this.colorLegendControl) {
      this.map.removeControl(this.colorLegendControl);
      this.colorLegendControl = null;
    }
    this.indicesLayers = [];
  }

  removeSuperResolutions() {
    if (this.superResolutionLayer) {
      this.map.removeLayer(this.superResolutionLayer);
      this.superResolutionLayer = null;
    }
    if (this.superResolutionFootprintLayer) {
      this.map.removeLayer(this.superResolutionFootprintLayer);
      this.superResolutionFootprintLayer = null;
    }
  }

  removeAnnoatationByScene(scene: any) {
    this.annotationMarkers.forEach((annotationMarker) => {
      if (annotationMarker.scene == scene.id) {
        this.map.removeLayer(annotationMarker.marker);
      }
    });
    this.annotationMarkers = this.annotationMarkers.filter(
      (annotationMarker) => {
        return annotationMarker.scene != scene.id;
      }
    );
  }

  removeAnnotationMarkers() {
    if (this.annotaionMarker) {
      this.annotaionMarker.closePopup();
      this.annotaionMarker = null;
    }
    this.annotationMarkers.forEach((annotationMarker) => {
      this.map.removeLayer(annotationMarker.marker);
    });
    this.annotationMarkers = [];
  }

  @HostListener('document:mouseup')
  onMouseUp() {
    this.isDragging = false;
  }

  flattenObject(obj: any): { key: string; value: any }[] {
    const result: { key: string; value: any }[] = [];

    function recurse(curr: any, prop?: string) {
      if (Object(curr) !== curr) {
        result.push({ key: prop || '', value: curr });
      } else if (Array.isArray(curr)) {
        for (let i = 0; i < curr.length; i++) {
          recurse(curr[i], prop ? prop + '[' + i + ']' : '[' + i + ']');
        }
        if (curr.length === 0) {
          result.push({ key: prop || '', value: [] });
        }
      } else {
        let isEmpty = true;
        for (const p in curr) {
          isEmpty = false;
          recurse(curr[p], prop ? prop + '.' + p : p);
        }
        if (isEmpty && prop) {
          result.push({ key: prop, value: {} });
        }
      }
    }
    recurse(obj);
    return result;
  }

  getMetadata(metadata: any) {
    const flattenedJSON = this.flattenObject(metadata);
    this.metaDataTooltip = metadata;
  }

  transformDate(dates: string) {
    return this.datePipe.transform(dates, 'yyyy-MM-dd', 'UTC');
  }

  selectBandNew(band: any) {
    if (!this.leftImageNew && !this.rightImageNew) {
      this.selectedBand = band;
      this.clearRFBandsNew();
      this.scenesNew = [];
      if (this.subDailyFinalArray.length > 0) {
        this.selectedSubDailyItemsNew.map((subDaily) => {
          this.subDailyFinalArray.map((finalArr, index) => {
            if (subDaily.value == finalArr.sequenceNumber) {
              finalArr.scenes.map((scene: any) => {
                scene.pane = this.subDailyFinalArray[index].pane;
                if (
                  scene?.id &&
                  scene?.status !== 'failed' &&
                  scene?.checked != false
                ) {
                  if (
                    !scene?.s_band &&
                    !scene?.x_band &&
                    scene?.usl_footprint
                  ) {
                    scene.x_band = scene?.usl_footprint;
                  }
                  this.displayRFBandNew(
                    scene,
                    scene.sensorId,
                    this.selectedBand
                  );
                }
              });
            }
          });
        });
      } else if (this.selectedCheckboxesNew.length > 0) {
        this.selectedCheckboxesNew.forEach((selecteddate: any, index: any) => {
          if (selecteddate.checked == true) {
            selecteddate.scenes.map((scene: any) => {
              scene.start = this.selectedCheckboxesNew[index].start;
              scene.pane = this.selectedCheckboxesNew[index].pane;
              if (
                scene?.id &&
                scene?.status !== 'failed' &&
                scene?.checked != false
              ) {
                if (!scene?.s_band && !scene?.x_band && scene?.usl_footprint) {
                  scene.x_band = scene?.usl_footprint;
                }
                this.displayRFBandNew(
                  scene,
                  this.collection.sensors[0].id,
                  this.selectedBand
                );
              }
            });
          }
        });
      } else {
        this.sensorsNew.forEach((sensor: any) => {
          if (sensor.checked == true && sensor?.operatorKey == OPERATORS.USL) {
            sensor.scenes.map((scene: any) => {
              if (
                scene?.id &&
                scene?.status !== 'failed' &&
                scene?.checked != false
              ) {
                if (!scene?.s_band && !scene?.x_band && scene?.usl_footprint) {
                  scene.x_band = scene?.usl_footprint;
                }
                this.displayRFBandNew(
                  scene,
                  this.collection.sensors[0].id,
                  this.selectedBand
                );
              }
            });
          }
        });
      }
    }
  }

  resetSelect() {
    if (this.bandSelect) {
      this.bandSelect.value = 'both';
      this.sceneBands = '';
      this.bandSelected = 'both';
    }
  }

  removeLayerByScene(scene: any, options?: any) {
    const paneSpecific = options?.paneSpecific ?? false;
    if (scene?.footprint) {
      this.map.removeLayer(scene?.footprint);
    }
    if (scene?.tiffootprint) {
      this.map.removeLayer(scene?.tiffootprint);
    }
    if (scene?.leftImageLayer) {
      if (!paneSpecific || (paneSpecific && scene.pane == 'left')) {
        this.map.removeLayer(scene.leftImageLayer);
      }
    }
    if (scene?.rightImageLayer) {
      if (!paneSpecific || (paneSpecific && scene.pane == 'right')) {
        this.map.removeLayer(scene.rightImageLayer);
      }
    }
  }

  removeLayers() {
    this.scenesNew.map((scene: any) => {
      this.removeLayerByScene(scene);
      if (scene?.legendScale) {
        this.map.removeLayer(scene?.legendScale);
      }
      if (scene?.ghgLayers && scene?.ghgLayers?.length > 0) {
        scene?.ghgLayers.forEach((layer) => {
          if (layer) {
            this.map.removeLayer(layer);
          }
        });
      }
    });
  }

  removeGHGLayerByScene(ghg: any) {
    if (ghg?.markerLayer) {
      this.map.removeLayer(ghg.markerLayer);
    }
    if (ghg?.legendScale) {
      this.map.removeLayer(ghg.legendScale);
    }
    if (ghg?.trendLine) {
      this.map.removeLayer(ghg?.trendLine);
    }
  }

  removeGHGLayer() {
    this.ghgLayers.map((ghg) => {
      this.removeGHGLayerByScene(ghg);
    });
    this.ghgLayers = [];
    this.trendLinecordinates = [];
  }

  resetClydeHistoricalData() {
    this.clydeHistoricalLayer.map((clydeData) => {
      this.map.removeLayer(clydeData.marker);
    });
    this.clydeHistoricalLayer = [];
  }

  resetSpireHistoricalData() {
    this.spireHistoricalLayer.map((clydeData) => {
      this.map.removeLayer(clydeData.marker);
    });
    this.spireHistoricalLayer = [];
  }

  resetMapNew(isClearSensors: boolean = true) {
    this.annotateClicked = false;
    this.newTaskButtonClicked = false;
    this.mapPane = '';
    if (this.compare) {
      this.map.removeControl(this.compare);
      this.compare = null;
    }
    if (isClearSensors) this.sensorsNew = [];
    this.selectedCheckboxesNew = [];
    this.subDailyFinalArray = [];
    this.removeLayers();
    this.clearRFBandsNew();
    this.clearRFSignalsNew();
    this.removeISLayers();
    this.removeIndices();
    this.removeSuperResolutions();
    this.removeGHGLayer();
    this.removeClydeVesselLayer();
    this.removeSpireVesselLayer();
    this.removeAnnotationMarkers();
    this.resetClydeHistoricalData();
    this.resetSpireHistoricalData();
    this.isClydeHistorical = false;
    this.HistoricalLayer.forEach((HisLayer) => {
      this.map.removeLayer(HisLayer.marker);
    });
    this.geoByFeed.clear();
    this.HistoricalLayer = [];
    this.scenesNew = [];
    this.leftImageNew = null;
    this.rightImageNew = null;
    this.ghgLayers = [];
    this.selectedSites = [];
    if (this.clickedMarker) {
      this.map.removeLayer(this.clickedMarker);
      this.clickedMarker = null;
    }
    if (!this.isAnnotationSaved && this.annotaionMarker) {
      this.map.removeLayer(this.annotaionMarker);
      this.annotaionMarker = null;
    }
    if (this.collectionTaskMarker) {
      this.map.removeLayer(this.collectionTaskMarker);
      this.collectionTaskMarker = null;
    }
    const layersToRemove: L.Layer[] = [];
    this.map.eachLayer((layer: any) => {
      if (layer instanceof L.TileLayer) return;
      layersToRemove.push(layer);
    });
    layersToRemove.forEach((layer) => {
      this.removeVesselLabelLayer(layer);
      this.map.removeLayer(layer);
    });
    Object.values(this.currentFilteredLayers || {}).forEach((layer) => {
        if (this.map.hasLayer(layer)) {
          this.removeVesselLabelLayer(layer);
          this.map.removeLayer(layer);
        }
      });
      this.currentFilteredLayers = {};
    this.filterVesselData = false;
    this.filterData = [];
  }

  removeClydeVesselLayer() {
    if (this.clydeVesselLayer) {
      this.map.removeLayer(this.clydeVesselLayer);
      this.clydeVesselLayer = null;
    }
    if (this.clydevesselfootprintlayer) {
      this.map.removeLayer(this.clydevesselfootprintlayer);
      this.clydevesselfootprintlayer = null;
    }
    this.resetClydeHistoricalData();
  }

  removeSpireVesselLayer() {
    if (this.spireVesselLayer) {
      this.map.removeLayer(this.spireVesselLayer);
      this.spireVesselLayer = null;
    }
    if (this.spirevesselfootprintlayer) {
      this.map.removeLayer(this.spirevesselfootprintlayer);
      this.spirevesselfootprintlayer = null;
    }
    this.resetSpireHistoricalData();
  }

  checkForRelease(sensor) {
    let vadp: boolean = false;
    let sr: boolean = false;
    if (sensor?.valueAddedOption?.length > 0) {
      vadp = sensor.valueAddedOption.every(
        (item) => item?.releaseRequest == true
      );
    } else if (sensor?.superResolutions?.length > 0) {
      if (sensor?.superResolutions[0]?.releaseRequest == true) {
        sr = true;
      }
    }
    return vadp || sr;
  }

  showRefundIcon(scene, collection, downloadedScene, sensor) {
  const cond1 =
    (this.shouldNotDisplayScene(scene, collection, downloadedScene, sensor) ||
      (this.checkForRelease(sensor) && scene.operatorKey !== this.OPERATOR.USL))
    && scene.checked;

  const cond2 =
    !scene.checked ||
    (scene.operatorKey !== this.OPERATOR.SPIRE &&
     scene.operatorKey !== this.OPERATOR.CLYDE);

  return cond1 || cond2;
 }


  releaseVADP(taskId: any, sensor: any) {
    let productName: any, productId: any, product: any;
    if (sensor?.superResolutions?.length > 0) {
      productName = 'superResolutions';
      product = 'Super Resolution';
    } else {
      productName = 'valueAddedOption';
      productId = sensor?.valueAddedOption[0]?.product_id;
      product = 'vadp';
    }

    let message: any;
    let sensorObj = {
      sensorId: sensor.id,
      taskId: taskId,
      vadpId: productId,
      productName: productName,
    };

    let action = 'all';
    if (sensor?.superResolutions?.length > 0) product = 'Super Resolution';

    let params = {
      taskId,
      sensorId: sensor.id,
      product,
      action,
    };

    this.apiService.returnRefundStatus(params).subscribe((resp: any) => {
      if (resp.status != 'found' || (resp.status === 'found' && resp?.refund)) {
        message =
          'You have requested a refund for the value-added data products. You cannot request the products anymore.';
        this.popupService.openPopup(
          CollectionPopupComponent,
          message,
          '',
          '40%'
        );
        return;
      } else {
        this.apiService.processVADP(sensorObj).subscribe((res: any) => {
          if (res) {
            if (res.msg === 'success') {
              const type = 'download';
              message =
                'Thank you for submitting value added products for releasing. You will be notified via email when the files are ready.';
              this.popupService.openPopup(
                WarningPopupComponent,
                message,
                type,
                '40%'
              );
              for (const sensor of this.collection.sensors || []) {
                if (sensor?.valueAddedOption?.length > 0) {
                  sensor.valueAddedOption.releaseRequest = true;
                  for (const option of sensor.valueAddedOption || []) {
                    option.releaseRequest = true;
                  }
                }

                if (sensor.superResolutions?.length > 0) {
                  sensor.superResolutions.releaseRequest = true;
                  for (const option of sensor.superResolutions || []) {
                    option.releaseRequest = true;
                  }
                }
              }
            } else if (res.msg === 'already requested') {
              message =
                'The release request for value added products has either already been made and is being processed.';
              this.popupService.openPopup(
                CollectionPopupComponent,
                message,
                '',
                '40%'
              );
            } else {
              message =
                'An error occurred during processing and ingestion of the request. Please try after sometime.';
              this.popupService.openPopup(
                CollectionPopupComponent,
                message,
                '',
                '40%'
              );
            }
          } else {
            message =
              'An error occurred during processing and ingestion of the request. Please try after sometime.';
            this.popupService.openPopup(
              CollectionPopupComponent,
              message,
              '',
              '40%'
            );
          }
        });
      }
    });
  }

  refundVADP(collectionIndex, sensorIndex, sensor) {
    const taskId = this.collections[collectionIndex]?.taskId;
    let sensorId: any = sensor?.id;
    let product = 'vadp';
    let action = 'all';
    if (sensor?.superResolutions?.length > 0) product = 'Super Resolution';

    let sensorObj = {
      taskId,
      sensorId,
      product,
      action,
    };

    this.apiService.returnRefundStatus(sensorObj).subscribe((res: any) => {
      if (this.isPartialDelivery(res)) {
        return;
      }
      if (res?.status === 'found') {
        if (res?.refund) {
          let message = 'return-refund-accepted';
          if (res?.returnRefundReject) {
            message = 'return-refund-rejected';
          }
          if (res?.returnRefundReject || res?.returnRefundAccept) {
            this.popupService.openPopup(
              CollectionPopupComponent,
              message,
              '',
              '40%'
            );
            return;
          }
        } else {
          const dialog = this.matdialog.open(ReturnRefundComponent, {
            minWidth: '50%',
            data: {
              type: 'return',
              taskId: taskId,
              sensorId: sensorId,
              product: product,
              action: action,
            },
            backdropClass: 'blurred',
            disableClose: true,
          });

          dialog.afterClosed().subscribe((result) => {
            if (result != 'close') {
              const message = 'return-refund-success';
              this.popupService.openPopup(
                CollectionPopupComponent,
                message,
                '',
                '40%'
              );
              for (const sensor of this.collection.sensors || []) {
                for (const option of sensor.valueAddedOption || []) {
                  option.refundRequest = true;
                }

                for (const option of sensor.superResolutions || []) {
                  option.refundRequest = true;
                }
              }
            }
          });
        }
      } else {
        const message = 'return-refund-vadp';
        this.popupService.openPopup(
          CollectionPopupComponent,
          message,
          '',
          '40%'
        );
        return;
      }
    });
  }

  checkForDelivered(sensor) {
    let vadpRefund: boolean = false;
    let srRefund: boolean = false;
    if (sensor?.valueAddedOption?.length > 0) {
      vadpRefund = sensor.valueAddedOption.every(
        (item) => item.product_status === 'DELIVERED'
      );
    } else if (sensor?.superResolutions?.length > 0) {
      if (sensor?.superResolutions[0]?.product_status === 'DELIVERED') {
        srRefund = true;
      }
    }
    return srRefund || vadpRefund;
  }

  OpenReturnRequest(i: any, j: any, info: any, scene: any, action: any) {
    const sensor = this.collections[i].sensors[j];
    const taskId = this.collections[i]?.taskId;
    let sceneId: any = scene?.id;
    let sensorId: any = sensor?.id;
    let product = 'scene';
    let products = 'scene';
    let feedId: any;

    if (sensor?.superResolutions?.length > 0) product = 'Super Resolution';
    else if (sensor?.operatorKey === OPERATORS.SPIRE) {
      product = 'AIS';
      products = 'AIS';
    } else if (info?.insightDatas && action === 'feed') {
      product = 'IS';
      feedId = info?._id;
      products = 'IS';
      sceneId = this.selectedSceneNew?.id;
    } else if (sensor?.operatorKey === OPERATORS.AZISTA) {
      product = OPERATORS.AZISTA;
      products = OPERATORS.AZISTA;
    }

    if (action === 'indices') {
      product = scene.product;
      products = scene.product;
      const currentScene = sensor.scenes.find(
        (scene) => scene.checked === true
      );
      sceneId = currentScene.id;
    }

    let sensorObj = {
      taskId,
      sensorId,
      sceneId,
      product: products,
      feedId,
    };

    let sensorInfo = {
      scene,
      taskId,
      sensorId,
      sceneId,
      product,
      sensor,
      feedId,
      action,
    };

    this.apiService.returnRefundStatus(sensorObj).subscribe((res: any) => {
      if (this.isPartialDelivery(res)) {
        return;
      }
      if (res?.status === 'found') {
        let message = 'return-refund-accepted';
        if (res?.returnRefundReject) {
          message = 'return-refund-rejected';
        }

        if (res?.returnRefundReject || res?.returnRefundAccept) {
          this.popupService.openPopup(
            CollectionPopupComponent,
            message,
            '',
            '40%'
          );
          return;
        } else if (res?.refundRequest && product != 'IS') {
          const message = 'return-refund';
          let type = { msg: product };
          if (action === 'indices') type = { msg: 'indices' };
          if(this.isFeedTasking) type = { msg: 'feed-based' };
          this.popupService.openPopup(
            CollectionPopupComponent,
            message,
            type,
            '40%'
          );
          return;
        } else {
          this.handleRefundRequest(sensorInfo);
        }
      } else if (res?.refundRequest && product === 'IS') {
        const message = 'return-refund';
        let type = { msg: product };
        if (action === 'indices') type = { msg: 'indices' };
        if(this.isFeedTasking) type = { msg: 'feed-based' };
        this.popupService.openPopup(
          CollectionPopupComponent,
          message,
          type,
          '40%'
        );
        return;
      } else {
        this.handleRefundRequest(sensorInfo);
      }
    });
  }

  handleRefundRequest(sensorInfo: any) {
    let scene = sensorInfo.scene;
    let taskId = sensorInfo.taskId;
    let sensorId = sensorInfo.sensorId;
    let sceneId = sensorInfo.sceneId;
    let product = sensorInfo.product;
    let sensor = sensorInfo.sensor;

    if (
      scene?.refundRequest &&
      product != 'IS' &&
      sensor?.operatorKey !== OPERATORS.AZISTA
    ) {
      const message = 'return-refund';
      const type = { msg: product };
      this.popupService.openPopup(
        CollectionPopupComponent,
        message,
        type,
        '40%'
      );
      return;
    } else {
      const dialog = this.matdialog.open(ReturnRefundComponent, {
        minWidth: '50%',
        data: {
          type: 'return',
          taskId: taskId,
          sensorId: sensorId,
          sceneId: sceneId,
          product: this.isFeedTasking ? 'scene' : product,
          action: this.isFeedTasking ? 'scene' :sensorInfo?.action,
          feedId: sensorInfo?.feedId,
        },
        backdropClass: 'blurred',
        disableClose: true,
      });

      dialog.afterClosed().subscribe((result) => {
        if (result != 'close') {
          const message = 'return-refund-success';
          this.popupService.openPopup(
            CollectionPopupComponent,
            message,
            '',
            '40%'
          );
          this.refundRequestScenes.push(localStorage.getItem('refund-request'));
        }
      });
    }
  }

  refundStatus(scene: any) {
    if (
      scene?.refundRequest &&
      (scene?.returnRefundAccept || scene?.returnRefundReject)
    ) {
      let message = 'return-refund-accepted';
      if (scene?.returnRefundReject) {
        message = 'return-refund-rejected';
      }
      this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
      return;
    }
  }

  shouldDisplayScene(
    scene: any,
    collection: any,
    downloadedScene: any[],
    sensor: any
  ): boolean {
    const isSceneValid = scene.id && scene.status !== 'failed';
    const isDownloaded = downloadedScene.includes(scene.id) || scene.downloaded;
    const isReturnRefund = collection?.returnRefund;
    const isNotArchive = sensor?.status != 'archived';
    return isSceneValid && isDownloaded && isReturnRefund && isNotArchive;
  }

  shouldNotDisplayScene(
    scene: any,
    collection: any,
    downloadedScene: any[],
    sensor: any
  ): boolean {
    const hasValidIdAndStatus = scene.id && scene.status !== 'failed';
    const isNotDownloadedAndNotInDownloadedScenes =
      !scene.downloaded && !downloadedScene.includes(scene.id);
    const isArchived =
      sensor?.status === 'archived' && collection?.returnRefund;

    return (
      (hasValidIdAndStatus && isNotDownloadedAndNotInDownloadedScenes) ||
      isArchived || sensor?.status !== 'completed'
    );
  }

  openRestoreRequest(i, j, sensor) {
    const sensors = this.collections[i].sensors[j];
    const taskId = this.collections[i]?.taskId;
    let sensorId: any;
    sensorId = sensors?.id;
    let statusObj = { taskId: taskId, sensorId: sensorId };

    this.apiService.restoreStatus(statusObj).subscribe(async (res: any) => {
      if (res?.restoreStatus === 'Submit') {
        const message = 'restore';
        const type = { msg: 'restore-prerequested' };
        this.popupService.openPopup(
          CollectionPopupComponent,
          message,
          type,
          '40%'
        );
        return;
      } else if (res?.restoreStatus === 'Rejected') {
        const message = 'restore';
        const type = {
          msg: 'rejected',
          taskname: res?.taskname,
          reason: res?.reason,
        };
        this.popupService.openPopup(
          CollectionPopupComponent,
          message,
          type,
          '40%'
        );
      } else {
        const dialog = this.matdialog.open(ReturnRefundComponent, {
          minWidth: '50%',
          data: { type: 'restore' },
          backdropClass: 'blurred',
          disableClose: true,
        });
        dialog.afterClosed().subscribe((result) => {
          if (result != 'close') {
            const message = 'restore';
            const type = { msg: 'restore-success' };
            this.popupService.openPopup(
              CollectionPopupComponent,
              message,
              type,
              '40%'
            );
            const restoreRequestReason = result.restoreReason;
            const restoreOption = result.restoreOption;

            const sensorObj = {
              taskId: taskId,
              sensorId: sensorId,
              restoreOption: restoreOption,
              restoreRequestReason: restoreRequestReason,
            };
            this.apiService
              .restoreRequest(sensorObj)
              .subscribe(async (res: any) => {});
            localStorage.setItem('restore-request', sensorId);
            this.restoreRequestedSensors.push(
              localStorage.getItem('restore-request')
            );
          } else {
            return;
          }
        });
      }
    });
  }

  
    shouldDisableIS(collectionIndex, sensorIndex, scene: any, InfoService?: any, infoServiceIndex: number = 0) {
    const sensor = this.collections[collectionIndex]?.sensors[sensorIndex];

    // Case 1: If single InfoService object is passed
    if (InfoService) {
      return this.evaluateDisable(
        collectionIndex,
        sensorIndex,
        scene,
        InfoService,
      );
    }

    // Case 2: If not passed → use sensor.InfoService array
    const infoServices = sensor?.InfoServices || [];

    if (!infoServices.length) {
      return true; // no InfoService → disable
    }

    // If ANY one is enabled → overall enabled
    const anyEnabled = infoServices.some(
    (service) =>
      this.evaluateDisable(collectionIndex, sensorIndex, scene, service,true),
    );
     return anyEnabled;
  }

private evaluateDisable(
  collectionIndex,
  sensorIndex,
  scene,
  InfoService,
  isTaskBased = false
): boolean {
  const sensorScenes =
    this.collections[collectionIndex]?.sensors[sensorIndex]?.scenes || [];
  const checkedSceneCount = sensorScenes.filter((sensorScene) => sensorScene?.checked).length;
  const insightDatas = Array.isArray(InfoService?.insightDatas)
    ? InfoService.insightDatas
    : [];
  const requiredSceneIds = this.combinedScenes
    ? sensorScenes.map((sensorScene) => sensorScene?.id).filter(Boolean)
    : [(isTaskBased ? scene?.id : this.sceneSelected)].filter(Boolean);

  const selectedSceneIS = insightDatas.filter((sceneData) =>
    requiredSceneIds.includes(sceneData?.sceneId)
  );

  const isData = this.combinedScenes
    ? requiredSceneIds.length > 0 &&
      requiredSceneIds.every((sceneId) =>
        selectedSceneIS.some(
          (sceneData) =>
            sceneData?.sceneId === sceneId && !!sceneData?.insightFootprint
        )
      )
    : selectedSceneIS?.length > 0 && !!selectedSceneIS?.[0]?.insightFootprint;

  this.isData = isData;

  const isSameSensor =
    this.collections[collectionIndex]?.sensors[sensorIndex]?.id ===
    InfoService.sensorId;

  const checkedSensors = this.collections[collectionIndex]?.sensors.filter(
    (scene) => scene.checked === true
  );

  let checkedInfo = true;

  if (checkedSensors?.length > 0) {
    checkedInfo = checkedSensors[0].id === InfoService.sensorId;
  }

  let isDisable = true;

  if (
    this.collections[collectionIndex]?.sensors[sensorIndex]?.operatorKey !==
    OPERATORS.AXELSPACE
  ) {
    isDisable =
      !isSameSensor ||
      !scene?.id ||
      scene?.status === 'failed' ||
      !isData ||
      !checkedInfo;
  } else {
    const isChecked =
      this.collections[collectionIndex]?.sensors[sensorIndex]?.checked;
    const allSceneChecked = this.collections[collectionIndex]?.sensors[
      sensorIndex
    ]?.scenes.every((scene) => scene.checked);
    isDisable = !isChecked || (isChecked && !allSceneChecked);
  }

  if (!isTaskBased) {
    if (
      this.isObservation(
        this.collections[collectionIndex]?.sensors[sensorIndex]
      ) &&
      Object.keys(this.selectedHistory).length > 0
    ) {
      isDisable = false;
    } else if (this.observationEnabled && isData) {
      isDisable = false;
    } else {
      isDisable = true;
      this.resetObservationSelection();
    }

    if (!this.combinedScenes && checkedSceneCount === 1) {
      return false;
    }
  }

  return isDisable;
}

  shouldDisableFeedCompareIS(
  sensor: any,
  scene: any,
  InfoService: any
) {
  const selectedSceneIS = InfoService?.insightDatas?.filter(
    (s) => s.sceneId === sensor.scenes[0]?.id
  );

  const isData =
    selectedSceneIS?.length > 0 &&
    !!selectedSceneIS?.[0]?.insightFootprint;

  this.isData = isData;

  const isSameSensor = sensor?.id === InfoService.sensorId;

  const checkedSensors = this.selectedCheckboxesNew?.filter(
    (s) => s.checked === true
  );

  let checkedInfo: boolean = true;

  if (checkedSensors?.length > 0) {
    checkedInfo = checkedSensors[0].id === InfoService.sensorId;
  }

  let isDisable: boolean = true;

  if (sensor?.operatorKey !== OPERATORS.AXELSPACE) {
    isDisable =
      this.sensorsIS ||
      !isSameSensor ||
      !scene?.id ||
      scene?.status === 'failed' ||
      !isData ||
      !checkedInfo;
  } else {
    const isChecked = sensor?.checked;

    const allSceneChecked = sensor?.scenes?.every(
      (s) => s.checked
    );

    isDisable = !isChecked || (isChecked && !allSceneChecked);
  }

  if (
    this.isObservation(sensor) &&
    Object.keys(this.selectedHistory).length > 0
  ) {
    isDisable = false;
  } else if (this.observationEnabled && isData) {
    isDisable = false;
  } else {
    isDisable = true;
    this.resetObservationSelection();
  }

  return isDisable;
}


    shouldDisableRecurrentIS(
    collectionIndex,
    sensorIndex,
    scene1: any,
    InfoService: any,
    infoServiceIndex: number = 0
  ) {
    
    const scene = this.selectedCheckboxesNew[sensorIndex]?.scenes[0];
    this.selectedCheckboxesNew
    const selectedSceneIS = InfoService?.insightDatas?.filter(
      (sceneValue) => sceneValue.sceneId === scene.id
    );
    const isData = selectedSceneIS?.length > 0;
    this.isData = isData;
    const checkedSensors = this.selectedCheckboxesNew.filter(
      (scene) => scene.checked === true
    );

    let isDisable: boolean = true;
    if (
      this.selectedCheckboxesNew[sensorIndex]?.operatorKey !=
      OPERATORS.AXELSPACE
    ) {
      isDisable =
        !scene.id ||
        scene?.status === 'failed' ||
        !isData 
    } else {
      const isChecked =
        this.selectedCheckboxesNew[sensorIndex]?.checked;
      const allSceneChecked = this.selectedCheckboxesNew[
        sensorIndex
      ]?.scenes.every((scene) => scene.checked);
      isDisable = !isChecked || (isChecked && !allSceneChecked);
    }

    if (
      this.isObservation(
        this.selectedCheckboxesNew[sensorIndex]
      ) &&
      Object.keys(this.selectedHistory).length > 0
    ) {
      isDisable = false;
    } else if (this.observationEnabled) {
      isDisable = false;
    } else {
      isDisable = true;
      this.resetObservationSelection();
    }
    return isDisable;
  }

  shouldScenChecked(collectionIndex, sensorIndex, scene, scenesIndex) {
    if (scenesIndex !== undefined) {
      return (
        this.collections[collectionIndex]?.sensors[sensorIndex]?.scenes[
          scenesIndex
        ]?.checked ?? false
      );
    }
  }

  private _downloadStatesCache: Map<string, boolean> = new Map();
  private _lastInfoServiceData: any;

  shouldDownload(
    collectionIndex,
    sensorIndex,
    scene: any,
    InfoService,
    infoServiceIndex?: number
  ) {
    if (infoServiceIndex !== undefined) {
      return (
        this.collections[collectionIndex]?.sensors[sensorIndex]?.InfoServices?.[
          infoServiceIndex
        ]?.checked ?? false
      );
    }
    if (!this.sceneSelected) {
      return false;
    }

    scene = this.collections[collectionIndex]?.sensors[
      sensorIndex
    ]?.scenes.find((scn) => scn.id === this.sceneSelected);

    if (scene && scene.checked === false) {
      return false;
    }

    // Clear cache if InfoService data changed
    if (this._lastInfoServiceData !== InfoService?.insightDatas) {
      this._downloadStatesCache.clear();
      this._lastInfoServiceData = InfoService?.insightDatas;
    }

    // Create unique key for this combination
    const cacheKey = `${collectionIndex}-${sensorIndex}-${scene?.id}`;

    // Return cached value if exists
    if (this._downloadStatesCache.has(cacheKey)) {
      return this._downloadStatesCache.get(cacheKey)!;
    }
    const selectedSceneIS = InfoService?.insightDatas?.filter(
      (scene) => scene.sceneId === this.sceneSelected
    );
    const isData = selectedSceneIS?.length > 0;
    const isSameSensor =
      this.collections[collectionIndex]?.sensors[sensorIndex]?.id ===
      InfoService.sensorId;
    const isLength =
      isData && selectedSceneIS[0]?.insightFootprint?.features?.length > 0;
    const selectedSensorIS = InfoService?.insightDatas?.length > 0;
    let isDownload: boolean = true;

    const isChecked =
      this.collections[collectionIndex]?.sensors[sensorIndex]?.checked;
    const scenes =
      this.collections[collectionIndex]?.sensors[sensorIndex]?.scenes || [];
    const checkedScenesLength = scenes.filter((scene) => scene.checked).length;
    const totalScenes = scenes.length;
    const isOneOrAllChecked =
      checkedScenesLength === 1 || checkedScenesLength === totalScenes;
    isDownload = checkedScenesLength != 0 && isOneOrAllChecked;
    if (
      this.collections[collectionIndex]?.sensors[sensorIndex].InfoServices
        .length > 1 &&
      checkedScenesLength > 1
    ) {
      return false;
    }
    if (isDownload) {
      if (
        this.collections[collectionIndex]?.sensors[sensorIndex]?.operatorKey !=
        OPERATORS.AXELSPACE
      ) {
        for (let scene of scenes) {
          const hasScene = scene && scene.id;
          const isSceneValid = scene && scene.status !== 'failed';
          isDownload =
            hasScene &&
            isSceneValid &&
            isSameSensor &&
            isData &&
            !this.isVisible &&
            isLength;
          break;
        }
      } else {
        const isChecked =
          this.collections[collectionIndex]?.sensors[sensorIndex]?.checked;
        const allSceneChecked = this.collections[collectionIndex]?.sensors[
          sensorIndex
        ]?.scenes.every((scene) => scene.checked);
        isDownload = isChecked && allSceneChecked && selectedSensorIS;
      }
    }
    // Cache the result
    this._downloadStatesCache.set(cacheKey, isDownload);

    return isDownload;
  }

  shouldDownloadFeedTask(
  collectionIndex,
  sensorIndex,
  scene: any
): boolean {

  const sensor =
    this.collections[collectionIndex]?.sensors[sensorIndex];

  const infoServices = sensor?.InfoServices || [];

  if (!infoServices.length) {
    return false;
  }

  // every() → returns true only if ALL return true
  return infoServices.every((service, index) =>
    !service.isDisable &&
    this.shouldDownload(
      collectionIndex,
      sensorIndex,
      scene,
      service,
      index
    )
  );
}

  shouldDownloadCompareFeed(
  sensor: any,
  scene: any,
  InfoService: any,
  infoServiceIndex?: number
) {
  // If checking InfoService checkbox state
  if (infoServiceIndex !== undefined) {
    return InfoService?.checked ?? false;
  }

  // Find selected scene from sensor.scenes
  const selectedScene = sensor?.scenes?.find(
    (scn: any) => scn.id === sensor.scenes[0]?.id
  );

  if (selectedScene && selectedScene.checked === false) {
    return false;
  }

  // Clear cache if InfoService data changed
  if (this._lastInfoServiceData !== InfoService?.insightDatas) {
    this._downloadStatesCache.clear();
    this._lastInfoServiceData = InfoService?.insightDatas;
  }

  // Create unique key
  const cacheKey = `${sensor?.id}-${selectedScene?.id}`;

  if (this._downloadStatesCache.has(cacheKey)) {
    return this._downloadStatesCache.get(cacheKey)!;
  }

  const selectedSceneIS = InfoService?.insightDatas?.filter(
    (s: any) => s.sceneId === this.sceneSelected
  );

  const isData = selectedSceneIS?.length > 0;

  const isSameSensor = sensor?.id === InfoService?.sensorId;

  const isLength =
    isData &&
    selectedSceneIS?.[0]?.insightFootprint?.features?.length > 0;

  const selectedSensorIS = InfoService?.insightDatas?.length > 0;

  const scenes = sensor?.scenes || [];

  const checkedScenesLength = scenes.filter(
    (s: any) => s.checked
  ).length;

  const totalScenes = scenes.length;

  const isOneOrAllChecked =
    checkedScenesLength === 1 ||
    checkedScenesLength === totalScenes;

  let isDownload =
    checkedScenesLength !== 0 && isOneOrAllChecked;

  // Multiple InfoServices + multiple scenes checked
  if (sensor?.InfoServices?.length > 1 && checkedScenesLength > 1) {
    this._downloadStatesCache.set(cacheKey, false);
    return false;
  }

  if (isDownload) {
    if (sensor?.operatorKey !== OPERATORS.AXELSPACE) {
      const firstScene = scenes[0];

      const hasScene = !!firstScene?.id;
      const isSceneValid = firstScene?.status !== 'failed';

      isDownload =
        hasScene &&
        isSceneValid &&
        isSameSensor &&
        isData &&
        !this.isVisible &&
        isLength;
    } else {
      const isChecked = sensor?.checked;

      const allSceneChecked = scenes.every(
        (s: any) => s.checked
      );

      isDownload =
        isChecked && allSceneChecked && selectedSensorIS;
    }
  }

  // Cache the result
  this._downloadStatesCache.set(cacheKey, isDownload);

  return isDownload;
}


  shouldNotDownload(collectionIndex, sensorIndex, scene: any, InfoService) {
    const selectedSceneIS = InfoService?.insightDatas?.filter(
      (scene) => scene.sceneId === this.sceneSelected
    );
    const isData = selectedSceneIS?.length > 0;
    const isSameSensor =
      this.collections[collectionIndex]?.sensors[sensorIndex]?.id ===
      InfoService.sensorId;
    const isLength =
      isData &&
      (selectedSceneIS[0]?.insightFootprint?.features?.length === 0 ||
        !selectedSceneIS[0]?.insightFootprint);
    const selectedSensorIS = InfoService?.insightDatas?.length > 0;

    let isDownload: boolean = false;
    if (
      this.collections[collectionIndex]?.sensors[sensorIndex]?.operatorKey !=
      OPERATORS.AXELSPACE
    ) {
      isDownload =
        !scene?.id ||
        scene?.status === 'failed' ||
        (this.sensorsIS && isSameSensor) ||
        !isData ||
        this.isVisible ||
        isLength;
    } else {
      const isChecked =
        this.collections[collectionIndex]?.sensors[sensorIndex]?.checked;
      const allSceneChecked = this.collections[collectionIndex]?.sensors[
        sensorIndex
      ]?.scenes.every((scene) => scene.checked);
      isDownload = !isChecked || !allSceneChecked || !selectedSensorIS;
    }
    return isDownload;
  }

  getFeedInfo(info: any) {
    const checkedInfo = info.filter((data) => data.checked === true);
    return checkedInfo.length > 0;
  }

  hasFilterMessageShown(info) {
      return info.some((item) => {
        const cfg = feedsConfig[item._id];
        return (
          item?.checked === true &&
          cfg &&
          ['ship', 'vessel', 'transshipment', 'transhipment'].includes(
            cfg.type?.toLowerCase()
          )
        );
      });
    }

  getFeedInfoForFilter(info: any, event?: any, key?: any) {
    if (!Array.isArray(info)) return false;
    const eventChecked = !!event?.checked;
    const hasCheckedVesselFeed = () =>
      info.some((item) => {
        const cfg = feedsConfig[item._id];
        return (
          item?.checked === true &&
          cfg &&
          ['ship', 'vessel'].includes(
            cfg.type?.toLowerCase()
          )
        );
      });

    if (eventChecked && key) {
      const targetItem = info.find(
        (item) => item._id === key || item.feedName === key || item.name === key
      );
      if (!targetItem) return false;
      const cfg = feedsConfig[targetItem._id];
      const isVesselFeed =
        cfg &&
        ['ship', 'vessel'].includes(
          cfg.type?.toLowerCase()
        );

      if (isVesselFeed) return true;

      return hasCheckedVesselFeed();
    }
    return hasCheckedVesselFeed();
  }

  checkType() {
    return this.imageType == 'png' ? 'png' : 'tiff';
  }
  toggleImageType(
    collection: any,
    event: any,
    collectionIndex: any,
    scene: any,
    scenesIndex: any,
    sensorIndex: any,
    InfoServices
  ) {
    let imageType = 'png';
    this.removeDynamicLayer();
    this.removeVectorOverlay();
    this.feedUi = { showFilterIcon: false };
    if (event.checked) {
      this.imageType = 'tif';
      imageType = 'tif';
      scene.tif = true;
    } else {
      this.imageType = 'png';
      imageType = 'png';
      scene.tif = false;
    }
    InfoServices.forEach((InfoService) => {
      if (InfoService.checked) {
        InfoService.checked = false;
      }
    });
    scene.imageType = imageType;
    if (scene.checked) {
      let sceneIndex = this.scenesNew.findIndex(
        (sceneNew) => sceneNew.id == scene.id
      );
      if (sceneIndex != -1) {
        event.checked = false;
        if (this.selectedCheckboxesNew.length > 0 && this.isCompare) {
          this.toggleRecurrentSceneNew(
            collection,
            collectionIndex,
            sensorIndex,
            scenesIndex,
            scene,
            event
          );
        } else if (this.subDailyFinalArray.length > 0 && this.isCompare) {
          this.toggleRecurrentSubdailySceneNew(
            collection,
            collectionIndex,
            sensorIndex,
            scenesIndex,
            event
          );
        } else {
          this.toggleSceneNew(
            collection,
            collectionIndex,
            sensorIndex,
            scenesIndex,
            event
          );
        }
      }
      event.checked = true;
      scene.imageType = imageType;
      scene.tif = imageType == 'png' ? false : true;
      if (this.selectedCheckboxesNew.length > 0 && this.isCompare) {
        this.toggleRecurrentSceneNew(
          collection,
          collectionIndex,
          sensorIndex,
          scenesIndex,
          scene,
          event
        );
      } else if (this.subDailyFinalArray.length > 0 && this.isCompare) {
        this.toggleRecurrentSubdailySceneNew(
          collection,
          collectionIndex,
          sensorIndex,
          scenesIndex,
          event
        );
      } else {
        this.toggleSceneNew(
          collection,
          collectionIndex,
          sensorIndex,
          scenesIndex,
          event
        );
      }
    }
  }
  controlImageType(event) {
    this.loadTiff = event.checked;
    this.uncheckAll(event.checked);
    this.resetMapNew();
    let imageType = 'png';
    this.filterInfoVisible = false;
    this.removeDynamicLayer();
    this.removeVectorOverlay();
    this.spinnerService.hide();
    this.feedUi = { showFilterIcon: false };
    this.combinedScenes = false;
    this.isCompare = false;
    if (event.checked) {
      this.imageType = 'tif';
      imageType = 'tif';
    } else {
      this.imageType = 'png';
      imageType = 'png';
    }
    this.collection.sensors.forEach((sensor: any) => {
      sensor.InfoServices?.forEach((InfoService: any) => {
        InfoService.isDisable = true;
      });
    });
  }

  clearSelectedBands(event) {
    this.isBandApplied = false;
    this.selectedBands = [];
    this.resetMapNew();
    this.collection.sensors?.forEach(sensor => {
     sensor.checked = false;

     sensor.scenes?.forEach(scene => {
     scene.checked = false;
    });
   });
  }

  mapProperties(properties) {
    return {
      ID: properties?.ID,
      'Timestamp UTC': properties?.timestamp_utc,
      'RF Frequency MHz': properties?.RF_Frequency_MHz,
      Lng: properties?.longitude_deg,
      Lat: properties?.latitude_deg,
      'Accuracy Level': properties?.accuracy_level,
      'Pulses Duration ns': properties?.pulses_duration_ns,
      'Pulses Repetition Frequency Hz':
        properties?.pulses_repetition_frequency_Hz,
    };
  }

  formatProperties(properties: any): string {
    let formattedProps = '';
    for (let key in properties) {
      if (key != 'class' && properties[key] != 'Undefined') {
        formattedProps += `<strong>${key}</strong>  :  ${properties[key]}<br>`;
      }
    }
    return formattedProps;
  }

  /* Init geoSearchControl */
  private initGeoSearchControl(): void {
    const provider = new OpenStreetMapProvider();
    const searchControl = (GeoSearchControl as any)({
      provider: provider,
      showMarker: false,
      style: 'button',
      position: 'topright',
      size: 5,
      searchLabel: 'Enter an address or landmark...',
    });
    this.map.addControl(searchControl);
    const searchFormEl = document.querySelector(
      '.leaflet-geosearch-button form'
    ) as HTMLFormElement;
    const searchInputEl = searchFormEl.querySelector(
      'input'
    ) as HTMLInputElement;
    const leafletBarElement = document.querySelector(
      '.leaflet-bar-part.leaflet-bar-part-single'
    );
    if (leafletBarElement) {
      leafletBarElement.removeAttribute('title');
    }
    let searchBtnParentEl: any;
    searchInputEl.addEventListener('keydown', (event: any) => {
      const query = event.target.value;
      const coords = event.target.value
        .trim()
        .split(',')
        .map((coord) => coord.trim());
      if (coords.length === 2) {
        searchBtnParentEl = document.querySelector('.results');
        if (searchBtnParentEl) {
          searchBtnParentEl.style.display = 'none';
        }
        const lat = parseFloat(coords[0]);
        const lng = parseFloat(coords[1]);
        if (!isNaN(lat) && !isNaN(lng) && event.key == 'Enter') {
          provider.search({ query: `${lng}, ${lat}` }).then((results) => {
            const res: object = { location: results[0] };
            this.resultHandler(res);
          });
        }
      } else {
        if (searchBtnParentEl) {
          searchBtnParentEl.style.display = 'block';
        }
      }
    });

    /* Custom reset button */
    const resetBtn = L.DomUtil.create('button');
    resetBtn.setAttribute('class', 'reset_btn');
    resetBtn.innerHTML = 'x';
    const formEl = document.querySelector(
      '.leaflet-geosearch-button form'
    ) as HTMLFormElement;
    formEl?.appendChild(resetBtn);
    resetBtn.addEventListener('click', (event: any) => {
      this.resetSearchInput();
    });
    this.initHoverOnSearchBox();
    const searchEl = document.querySelector(
      '.leaflet-control-geosearch'
    ) as HTMLFormElement;
    const searchBtnEl = L.DomUtil.create('button');
    searchBtnEl.setAttribute('class', 'searchBtn');
    searchEl.append(searchBtnEl);
    const searchInput = formEl.querySelector('input') as HTMLInputElement;
    searchInput.addEventListener('focus', (event: any) => {
      searchInput.classList.add('active');
      const resetBtn = formEl.querySelector('.reset_btn') as HTMLButtonElement;
      resetBtn.style.display = 'block';
    });
    const mapContainer: any = document.getElementById('map');
    mapContainer.addEventListener('click', (event: any) => {
      this.resetSearchInput();
    });
  }

  private resultHandler(e): void {
    this.zoomLevel = 7;
    this.removeISLayers();
    this.map.flyTo([e.location.raw.lat, e.location.raw.lon], this.zoomLevel);
    this.map.setZoom(7);
  }

  initHoverOnSearchBox() {
    const searchBtnParentEl = document.querySelector(
      '.leaflet-geosearch-button'
    ) as HTMLElement;
    searchBtnParentEl.addEventListener('mouseenter', (event: any) => {
      if (!searchBtnParentEl.classList.contains('active')) {
        this.showAndHideSearchInput(true);
      }
    });
    searchBtnParentEl.addEventListener('mouseleave', (event: any) => {
      if (searchBtnParentEl.classList.contains('active')) {
        this.showAndHideSearchInput(false);
      }
    });
  }

  showAndHideSearchInput(show: boolean): void {
    const searchBtnParentEl = document.querySelector(
      '.leaflet-geosearch-button'
    ) as HTMLElement;
    if (show) {
      var controlContainer = document.getElementsByClassName(
        'leaflet-control-layers-expanded'
      )[0];
      if (
        controlContainer &&
        controlContainer.classList.contains('leaflet-control-layers-expanded')
      ) {
        controlContainer.classList.remove('leaflet-control-layers-expanded');
        document
          .querySelector('.leaflet-control-layers-toggle')
          ?.setAttribute('style', 'top:0px !important');
      }
      searchBtnParentEl.classList.add('active');
      return;
    }
    const searchInput = document.querySelector(
      '.leaflet-geosearch-button form input'
    ) as HTMLInputElement;
    if (!searchInput.value && !searchInput.classList.contains('active')) {
      searchBtnParentEl.classList.remove('active');
    }
  }

  /* Reset search input field */
  private resetSearchInput(): void {
    const searchFormEL = document.querySelector(
      '.leaflet-geosearch-button form'
    ) as HTMLElement;
    const searchInput = searchFormEL.querySelector('input') as HTMLInputElement;
    if (searchInput) {
      searchInput.value = '';
      const resultEl = searchFormEL.querySelector('.results') as HTMLElement;
      resultEl.innerHTML = '';
      resultEl.classList.remove('active');
      searchInput.classList.remove('active');
      this.showAndHideSearchInput(false);
      const resetBtn = searchFormEL.querySelector(
        '.reset_btn'
      ) as HTMLButtonElement;
      resetBtn.style.display = 'none';
    }
  }

  setValueAddedOption(
    valAdOption,
    sensor,
    event,
    collectionIndex,
    sensorIndex,
    valAdOptionIndex
  ) {
    sensor.valueAddedOption ??= [];

    sensor.valueAddedOption[valAdOptionIndex] ??= {
      checked: false,
    };
    this.collections[collectionIndex].sensors[sensorIndex].valueAddedOption.map(
      (valueAddedOption) => {
        valueAddedOption.checked = false;
      }
    );
    sensor.valueAddedOption[valAdOptionIndex].checked = event.checked;
    if (this.imageType !== 'tif') {
      this.handleOptionError(
        event,
        `Value-added data products can only be downloaded now and cannot be visualised on the map here.`
      );
    } else {
      if (event.checked) {
        this.clearVdapImageLayer();
        this.isVadapSelected = true;
        this.isScenSelected = false;
        const scen =
          sensor.scenes.find((scene) => scene.id === this.sceneSelected) ??
          sensor.scenes[0];
        this.selectvdap = valAdOption.product;
        const sensorObj = {
          customerid: this.currentUser?.id,
          sensorId: sensor.id,
          product: valAdOption.product,
          taskId: this.collection.taskId,
        };
        this.tifPopupShown = 0;
        this.fetchImageFromServer(this.collection, sensorObj, scen, true);
      } else {
        this.isVadapSelected = false;
        this.clearVdapImageLayer();
      }
    }
  }

  clearVdapImageLayer() {
    this.scenesNew.forEach((sceneItem) => {
      if (sceneItem?.leftImageLayer && sceneItem?.pane == 'left') {
        this.map.removeLayer(sceneItem?.leftImageLayer);
      }
      if (sceneItem?.rightImageLayer && sceneItem?.pane == 'right') {
        this.map.removeLayer(sceneItem?.rightImageLayer);
      }
    });
  }

  handleOptionError(event, message) {
    event.source.checked = false;
    this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
    this.spinnerService.hide();
  }

  isValueAddedOptionChecked(sensor, option) {
    if (this.selectedSensors.length !== 1) {
      return false;
    }
    return this.isSensorInList(sensor.id) && this.isOptionInList(option);
  }

  isOptionInList(option: string): boolean {
    return this.selectedOptions.some((item) => item === option);
  }

  isSensorInList(sensorId: number): boolean {
    return this.sensorsNew.some((sensor) => sensor.id === sensorId);
  }

  shouldDisableValueAddedOption(sensor, type) {
    if (!this.isSensorInList(sensor.id)) {
      this.clearVdapImageLayer();
      return true;
    }
    if (this.sensorsNew.length > 0) {
      if (this.sensorsNew.length > 1) return true;
      if (this.sensorsNew.length === 1) {
        if (
          sensor.scenes.filter((scene) => scene.checked === true).length === 0
        ) {
          this.clearVdapImageLayer();
          return true;
        }
        if (
          sensor.scenes.filter((scene) => scene.checked === true).length >= 1 &&
          sensor.scenes.length === 1
        ) {
          this.clearVdapImageLayer();
        } else {
          return false;
        }
      }
    }
    this.clearVdapImageLayer();
    return true;
  }

  shouldDisableSuperResolution(
    collectionIndex,
    sensorIndex,
    scene: any,
    superResolution
  ) {
    return false;
  }

  shouldcheckValueAddedOptionEnabled(sensor, valAdOption, valAdOptionIndex) {
    const isScenchecked = sensor.scenes.filter(
      (scene) => scene.checked === true
    );
    if (
      sensor.valueAddedOption[valAdOptionIndex].checked &&
      isScenchecked.length > 0
    ) {
      sensor.valueAddedOption[valAdOptionIndex].checked = true;
      return true;
    } else {
      sensor.valueAddedOption[valAdOptionIndex].checked = false;
      return false;
    }
  }

  isDownloadedSR(superResolution, sensor, scene) {
    let currentScene = sensor.scenes.filter((scene) => scene.checked === true);
    if (currentScene.length > 1) return false;
    return superResolution.products.some((element) => {
      return element.sceneId === currentScene[0]?.id && element.isDownloaded;
    });
  }

  downloadSR(superResolution, collectionIndex, sensor, sensorIndex) {
    const currentScene = sensor.scenes.find((scene) => scene.checked === true);
    let isDownloaded = superResolution.products.some((element) => {
      return element.sceneId === currentScene.id && element.isDownloaded;
    });
    if (this.freeze) {
      const message =
        'A download is in progress. Please wait until the current download finishes to continue downloading others.';
      this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
      return;
    } else if (isDownloaded) {
      const message = 'download_vadp';
      this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
      return;
    } else {
      this.spinnerService.show();
      this.freeze = true;
      this.fail = 0;
      this.progress = 0;
      this.downloadClick = true;
      this.currentDownloadingSR = {
        collectionIndex: collectionIndex,
        sensorIndex: sensorIndex,
        sceneId: currentScene.id,
        product: superResolution.product,
      };

      let sensorObj = {
        taskId: this.taskid,
        sensorId: superResolution.sensorId,
        sceneId: currentScene.id,
        product: superResolution.product,
        type: 'download',
      };

      this.apiService
        .getValueAddedDataImgUrl(sensorObj)
        .subscribe(async (res: any) => {
          let url = res.response.imageUrl;

          if (url) {
            const xhr = new XMLHttpRequest();
            xhr.open('GET', url);
            xhr.responseType = 'blob';

            xhr.onprogress = (event) => {
              if (event.lengthComputable) {
                const percentComplete = (event.loaded / event.total) * 100;
                this.progress = percentComplete.toFixed(2);
                const sensorObj = {
                  progress: this.progress,
                  taskId: this.collections[collectionIndex].taskId,
                  sensorId: sensor.id,
                  sceneId: currentScene.id,
                  download: this.downloadClick,
                  product: superResolution.product,
                };
                this.downloadService.setProgress(sensorObj);
              }
            };

            xhr.onload = () => {
              if (xhr.status === 200) {
                const blob = xhr.response;
                const fileName = this.getFileNameFromS3SignedUrl(url);
                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob);
                link.download = fileName;
                link.click();
                URL.revokeObjectURL(link.href);

                // Reset progress after download
                this.progress = 0;
                this.spinnerService.hide();
                this.freeze = false;
                this.disable = false;
              } else {
                this.showDownloadError();
              }
            };

            xhr.onerror = () => {
              // Handle errors
              this.showDownloadError();
            };
            xhr.send();
          }
        });
    }
  }

  downloadedWarning() {
    const message = 'download_vadp';
    this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
  }

  downloadValueAddedData(valAdOption, collectionIndex, sensor, sensorIndex) {
    if (this.freeze) {
      const message =
        'A download is in progress. Please wait until the current download finishes to continue downloading others.';
      this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
      return;
    } else if (valAdOption?.isDownloaded) {
      const message = 'download_vadp';
      this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
      return;
    } else {
      this.currentDownloadingVADP = {
        collectionIndex: collectionIndex,
        sensorIndex: sensorIndex,
        product: valAdOption.product,
      };
      this.spinnerService.show();
      this.freeze = true;
      this.fail = 0;
      this.progress = 0;
      this.downloadClick = true;
      let sensorObj = {
        product: valAdOption.product,
        id: valAdOption.product_id,
      };
      this.apiService
        .getValueAddedData(sensorObj)
        .subscribe(async (res: any) => {
          let url = res.response.imageUrl;
          if (url) {
            const xhr = new XMLHttpRequest();
            xhr.open('GET', url);
            xhr.responseType = 'blob';
            xhr.onprogress = (event) => {
              if (event.lengthComputable) {
                const percentComplete = (event.loaded / event.total) * 100;
                this.progress = percentComplete.toFixed(2);
                const sensorObj = {
                  progress: this.progress,
                  taskId: this.collections[collectionIndex].taskId,
                  sensorId: sensor.id,
                  download: this.downloadClick,
                  product: valAdOption.product,
                };
                this.downloadService.setProgress(sensorObj);
              }
            };
            xhr.onload = () => {
              if (xhr.status === 200) {
                const blob = xhr.response;
                const fileName = this.getFileNameFromS3SignedUrl(url);
                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob);
                link.download = fileName;
                link.click();
                URL.revokeObjectURL(link.href);
                this.progress = 0;
                valAdOption.isDownloaded = true;
                this.spinnerService.hide();
                this.freeze = false;
                this.disable = false;
              }
            };
            xhr.send();
          }
        });
    }
  }

  refundValueAddedData(collectionIndex, sensorIndex, valAdOption) {
    this.OpenReturnRequestVADP(
      collectionIndex,
      sensorIndex,
      null,
      null,
      valAdOption.product,
      valAdOption
    );
  }

  refundValueAddedStatus(valAdOption: any) {
    if (
      valAdOption?.refundRequest &&
      (valAdOption?.returnRefundAccept || valAdOption?.returnRefundReject)
    ) {
      let message = 'return-refund-accepted';
      if (valAdOption?.returnRefundReject) {
        message = 'return-refund-rejected';
      }
      this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
      return;
    }
  }

  shouldDisableIndices(collectionIndex, sensorIndex, scene, indices): boolean {
    const sensor = this.collections?.[collectionIndex]?.sensors?.[sensorIndex];
    if (!sensor?.scenes) {
      return true;
    }

    const selectedScenes = sensor.scenes.filter((s) => s.checked);

    if (
      selectedScenes.length !== 1 &&
      sensor.operatorKey !== OPERATORS.AXELSPACE
    ) {
      return true;
    }

    const hasValidScene = selectedScenes.some((selected) =>
      indices.products.some(
        (product) =>
          product.sceneId === selected.id && product.status === 'success'
      )
    );

    return !hasValidScene;
  }

  isDownloadedIndices(indices, sensor, scene) {
    let currentScene = sensor.scenes.filter((scene) => scene.checked === true);
    if (currentScene.length > 1) return false;
    return indices.products.some((element) => {
      return element.sceneId === currentScene[0]?.id && element.isDownloaded;
    });
  }

  OpenReturnRequestVADP(
    i: any,
    j: any,
    k: any,
    scene: any,
    product: string = '',
    vadpData: any
  ) {
    const sensor = this.collections[i].sensors[j];
    const taskId = this.collections[i]?.taskId;
    let sceneId: any = scene?.id;
    let sensorId: any = sensor?.id;

    let sensorObj = {
      taskId,
      sensorId,
      sceneId,
      product,
    };

    this.apiService.returnRefundStatus(sensorObj).subscribe((res: any) => {
      if (this.isPartialDelivery(res)) {
        return;
      }
      if (res?.status === 'found') {
        let message = 'return-refund-accepted';
        if (res?.returnRefundReject) {
          message = 'return-refund-rejected';
        }

        if (res?.returnRefundReject || res?.returnRefundAccept) {
          this.popupService.openPopup(
            CollectionPopupComponent,
            message,
            '',
            '40%'
          );
          return;
        } else {
          this.handleRefundRequestVADP(
            scene,
            taskId,
            sensorId,
            sceneId,
            product,
            vadpData
          );
        }
      } else {
        const message = 'return-refund-vadp';
        this.popupService.openPopup(
          CollectionPopupComponent,
          message,
          '',
          '40%'
        );
        return;
      }
    });
  }


  handleRefundRequestVADP(
    scene: any,
    taskId: any,
    sensorId: any,
    sceneId: any,
    product: any = '',
    vadpData: any
  ) {
    const dialog = this.matdialog.open(ReturnRefundComponent, {
      minWidth: '50%',
      data: {
        type: 'return',
        taskId: taskId,
        sensorId: sensorId,
        sceneId: sceneId,
        product: product,
      },
      backdropClass: 'blurred',
      disableClose: true,
    });

    dialog.afterClosed().subscribe((result) => {
      if (result != 'close') {
        const message = 'return-refund-success';
        this.popupService.openPopup(
          CollectionPopupComponent,
          message,
          '',
          '40%'
        );
        this.refundRequestVADP.push({
          sensorId: sensorId,
          product: vadpData?.product,
        });
        this.valueAddedProductLocalUpdate(sensorId, vadpData?.product);
      }
    });
  }

  valueAddedProductLocalUpdate(sensorId: any, product: any) {
    (this.collections || []).forEach((item) => {
      (item.sensors || []).forEach((sensor) => {
        if (sensor.id === sensorId) {
          (sensor.valueAddedOption || []).forEach((element) => {
            if (element.product === product) {
              element.refundRequest = true;
            }
          });
        }
      });
    });
  }

  isEnableSR(superResolution, sensor, scene) {
    let currentScene = sensor.scenes.filter((scene) => scene.checked === true);
    if (currentScene.length > 1) return false;
    return superResolution.products.some((element) => {
      return element.sceneId === currentScene[0]?.id;
    });
  }

  refundStatusCheckSR(superResolution, sensor) {
    let currentScene = this.getCurrentScene(sensor);
    return superResolution.products.some((i) => {
      return (
        i.sceneId === currentScene?.id &&
        (i?.returnRefundAccept || i?.returnRefundReject)
      );
    });
  }

  refundSRStatus(superResolution: any, sensor: any) {
    let currentScene = this.getCurrentScene(sensor);
    let message = '';
    superResolution.products.forEach((i) => {
      if (i.sceneId === currentScene?.id) {
        if (
          i?.refundRequest &&
          (i?.returnRefundAccept || i?.returnRefundReject)
        ) {
          let message = 'return-refund-accepted';
          if (i?.returnRefundReject) {
            message = 'return-refund-rejected';
          }
        }
      }
    });
    if (message) {
      this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
    }
    return;
  }

  OpenReturnRequestSR(collectionIndex, sensorIndex, superResolution) {
    const sensor = this.collections[collectionIndex].sensors[sensorIndex];
    const taskId = this.collections[collectionIndex]?.taskId;
    let currentScene = this.getCurrentScene(sensor);
    let sceneId: any = currentScene?.id;
    let sensorId: any = sensor?.id;
    let product = superResolution.product;
    let sensorObj = {
      taskId,
      sensorId,
      sceneId,
      product,
    };
    this.apiService.returnRefundStatus(sensorObj).subscribe((res: any) => {
      if (this.isPartialDelivery(res)) {
        return;
      }
      if (res?.status === 'found') {
        let message = 'return-refund-accepted';
        if (res?.returnRefundReject) {
          message = 'return-refund-rejected';
        }
        if (res?.returnRefundReject || res?.returnRefundAccept) {
          this.popupService.openPopup(
            CollectionPopupComponent,
            message,
            '',
            '40%'
          );
          return;
        } else {
          this.handleRefundRequestSR(
            currentScene,
            taskId,
            sensorId,
            sceneId,
            product,
            superResolution
          );
        }
      } else {
        const message = 'return-refund-vadp';
        this.popupService.openPopup(
          CollectionPopupComponent,
          message,
          '',
          '40%'
        );
      }
    });
  }

  handleRefundRequestSR(
    scene,
    taskId,
    sensorId,
    sceneId,
    product,
    superResolution
  ) {
    const dialog = this.matdialog.open(ReturnRefundComponent, {
      minWidth: '50%',
      data: {
        type: 'return',
        taskId: taskId,
        sensorId: sensorId,
        sceneId: sceneId,
        product: product,
        action: 'vadp',
      },
      backdropClass: 'blurred',
      disableClose: true,
    });
    dialog.afterClosed().subscribe((result) => {
      if (result != 'close') {
        const message = 'return-refund-success';
        this.popupService.openPopup(
          CollectionPopupComponent,
          message,
          '',
          '40%'
        );
        this.refundRequestSR.push({
          sensorId: sensorId,
          sceneId: sceneId,
          product: superResolution?.product,
        });
        this.valueAddedProductLocalUpdateSR(
          sensorId,
          sceneId,
          superResolution?.product
        );
      }
    });
  }

  valueAddedProductLocalUpdateSR(sensorId: any, sceneId: any, product: any) {
    (this.collections || []).forEach((item) => {
      (item.sensors || []).forEach((sensor) => {
        if (sensor.id === sensorId) {
          (sensor.superResolutions || []).forEach((element) => {
            if (element.product === product) {
              (element.products || []).forEach((row) => {
                if (row.sceneId === sceneId) {
                  row.refundRequest = true;
                }
              });
            }
          });
        }
      });
    });
  }

  getCurrentScene(sensor) {
    let currentScene;
    currentScene = sensor.scenes.find((scene) => scene.checked === true);
    return currentScene;
  }

  private getCheckedSceneIds(sensor: any): string[] {
    const checkedSceneIds = (sensor?.scenes || [])
      .filter((scene: any) => scene?.checked && scene?.id)
      .map((scene: any) => scene.id);

    if (checkedSceneIds.length > 0) {
      return checkedSceneIds;
    }

    if (this.selectedSceneNew?.id) {
      return [this.selectedSceneNew.id];
    }

    return [];
  }

  selectIndices(
    collectionIndex,
    sensorIndex,
    indicesIndex,
    event,
    indices,
    isSelected
  ) {
    if (event.checked) {
      if (isSelected) {
        this.indiceType = 'display';
        this.collections[collectionIndex].sensors[
          sensorIndex
        ].indicesDetails.map((indicesDetails) => {
          indicesDetails.checked = false;
          indicesDetails.loadTif = false;
        });
      }
      this.removeAnnotationMarkers();
      this.removeIndices();
      this.newTaskButtonClicked = false;
      this.annotateClicked = false;
      this.collections[collectionIndex].sensors[sensorIndex].indicesDetails.map(
        (indicesDetails) => {
          indicesDetails.checked = false;
        }
      );
      this.collections[collectionIndex].sensors[sensorIndex].indicesDetails[
        indicesIndex
      ].checked = true;
      this.mapLoad = true;
      const imageLoadPromises: Promise<any>[] = [];
      if (this.imageType === 'png') {
        this.displayIndices(
          indices,
          this.collections[collectionIndex].sensors[sensorIndex],
          event,
          collectionIndex,
          sensorIndex,
          imageLoadPromises
        );
      } else if (this.imageType === 'tif') {
        this.loadIndicesOnTiff(
          collectionIndex,
          sensorIndex,
          indicesIndex,
          event,
          indices
        );
      }
    } else {
      let selectedSceneIndex = this.collection.sensors[
        sensorIndex
      ].scenes.findIndex((scene) => scene.checked == true);
      this.collections[collectionIndex].sensors[
        sensorIndex
      ].indicesDetails.forEach((indicesDetails) => {
        indicesDetails.checked = false;
      });
      this.removeIndices();
    }
  }

  async loadIndicesOnTiff(
    collectionIndex,
    sensorIndex,
    indicesIndex,
    event,
    indices
  ) {
    const paneName = 'indicesPane';

    if (!this.map.getPane(paneName)) {
      const pane = this.map.createPane(paneName);
      pane.style.zIndex = '650';
    }

    this.ensureTooltipPane();

    const sensor = this.collections?.[collectionIndex]?.sensors?.[sensorIndex];
    const sceneIds = this.getCheckedSceneIds(sensor);
    const taskId =
      this.collections?.[collectionIndex]?.taskId ??
      this.collection?.taskId ??
      this.taskid;

    this.spinnerService.show();
    try {
      if (!sensor?.id || !taskId || sceneIds.length === 0) {
        return;
      }

      const payload = {
        sensorId: indices?.sensorId ?? sensor.id,
        sceneIds,
        product: String(indices?.product ?? '').toLowerCase(),
        taskId,
        userId: this.currentUser?.id,
      };

      const geoCollectionResponse: any = await firstValueFrom(
        this.apiService.getIndicesFromGeoCollection(payload)
      );
      const result =
        geoCollectionResponse?.result ??
        geoCollectionResponse?.responseResult ??
        geoCollectionResponse;

      this.responseResult = result;
      if (!result?.layer?.product?.length) {
        return;
      }

      const shapeList = result.layer.product.filter(
        (p) => p.product_type?.toLowerCase() === indices.product?.toLowerCase()
      );
      if (!shapeList.length) {
        return;
      }

      const selectedIndexProducts = (indices?.products || []).filter(
        (product: any) => sceneIds.includes(product?.sceneId)
      );

      const categoryMap = {
        CWSI: cwsiCategories,
        MBSI: mbsiCategories,
        NCCI: ncciCategories,
        NDTI: ndtiCategories,
        NDMI: ndmiCategories,
        NDRE: ndreCategories,
        NDVI: ndviCategories,
        TVDI: tvdiCategories,
      };

      const wfsBase = environment.geoServerUrl.replace(/\/wms\b/i, '/wfs');
      const loadedLayers = (
        await Promise.all(
          shapeList.map(async (matchedShape) => {
            const matchedIndexProduct =
              selectedIndexProducts.find(
                (product: any) => product?.sceneId === matchedShape?.sceneId
              ) ??
              selectedIndexProducts[0] ??
              indices?.products?.[0];

            const qs = this.helperService.makeWfsParams(
              matchedShape.layerName ?? matchedShape.layername
            );
            const url = `${wfsBase}?${qs.toString()}`;
            const geojson = await firstValueFrom(this.http.get<any>(url));

            if (!geojson?.features?.length) {
              return null;
            }

            const feedResults =
              matchedIndexProduct?.feed_results ??
              geojson?.feed_results ??
              matchedShape?.feed_results;
            const hasFeedResults =
              !!feedResults && Object.keys(feedResults).length > 0;

            const layer = L.geoJSON(geojson, {
              pane: 'indicesPane',
              style: (feature) => {
                const value = feature?.properties?.value ?? 0;
                return {
                  fillColor: getIndicesColor(value, indices.product),
                  color: '#000',
                  weight: 1,
                  fillOpacity: 0.95,
                };
              },
              onEachFeature: (feature, layer) => {
                const classValue = feature?.properties?.value;
                if (classValue == null || !hasFeedResults) {
                  return;
                }

                const areaPercent = feedResults?.[String(classValue)];
                if (areaPercent == null) {
                  return;
                }
                const classLabel = (categoryMap[indices?.product] || []).find(
                  (item: any) => item.value === Number(classValue)
                )?.label ?? `Class ${classValue}`;

                layer.bindTooltip(`${classLabel}: ${areaPercent}%`, {
                  sticky: true,
                  direction: 'top',
                  className: 'indices-tooltip',
                  pane: 'eeTooltipPane',
                  offset: L.point(0, -12),
                });
                layer.on('mousedown', (e: L.LeafletMouseEvent) => {
                  L.DomEvent.preventDefault(e.originalEvent);
                });
              },
            }).addTo(this.map);

            layer.bringToFront();
            return layer;
          })
        )
      ).filter((layer): layer is L.GeoJSON => !!layer);

      if (!loadedLayers.length) {
        return;
      }

      this.indicesLayers.push(...loadedLayers);
      this.indicesLayer = loadedLayers[loadedLayers.length - 1];
      this.addColorLegend(
        indices.product,
        selectedIndexProducts[0]?.message ?? indices?.products?.[0]?.message
      );

      const combinedBounds = L.featureGroup(loadedLayers).getBounds();
      if (combinedBounds.isValid()) {
        this.map.fitBounds(combinedBounds);
      }
    } finally {
      this.spinnerService.hide();
    }
  }

  selectSuperResolution(
    collectionIndex: number,
    sensorIndex: number,
    superResolutionIndex: number,
    event,
    superResolution: any
  ) {
    if (event.checked) {
      this.newTaskButtonClicked = false;
      this.annotateClicked = false;
      this.removeAnnotationMarkers();
      this.displaySuperResolutions(
        superResolution,
        this.collections[collectionIndex].sensors[sensorIndex],
        event,
        collectionIndex,
        sensorIndex
      );
    } else {
      let selectedSceneIndex = this.collection.sensors[
        sensorIndex
      ].scenes.findIndex((scene) => scene.checked == true);
      this.collections[collectionIndex].sensors[
        sensorIndex
      ].superResolutions.forEach((superResolutions) => {
        superResolutions.checked = false;
      });
      this.removeSuperResolutions();
    }
  }

  toggleIndicesImageType(
    collectionIndex: any,
    sensorIndex: any,
    indicesIndex: any,
    event: any,
    indices: any
  ) {
    if (event.checked) {
      this.indiceType = 'tiff';
    } else {
      this.indiceType = 'display';
    }
    indices.loadTif = event.checked;
    this.removeIndices();
    event.checked = true;
    this.selectIndices(
      collectionIndex,
      sensorIndex,
      indicesIndex,
      event,
      indices,
      false
    );
  }

  displayIndices(
    indices,
    sensor,
    event,
    collectionIndex,
    sensorIndex,
    imageLoadPromises
  ) {
    let selectedSceneId = sensor.scenes[this.selectedSceneIndex].id;
    let selectedScene = this.scenesNew.find(
      (sceneNew) => sceneNew.id == selectedSceneId
    );
    let selectedSceneIndex = this.scenesNew.find(
      (sceneNew) => sceneNew.id == selectedSceneId
    );
    indices.checked = true;
    let sensorObj
    if(sensor.operatorKey === OPERATORS.AXELSPACE) {
      const checkedSceneIds = sensor.scenes
      .filter(scene => scene.checked)
      .map(scene => scene.scene_id);
      sensorObj = {
      taskId: this.taskid,
      sensorId: indices.sensorId,
      sceneId: checkedSceneIds,
      product: indices.product,
      type: this.indiceType,
      };
    } else {
      sensorObj = {
      taskId: this.taskid,
      sensorId: indices.sensorId,
      sceneId: selectedScene.id,
      product: indices.product,
      type: this.indiceType,
      };
    }
    let ndviObj = JSON.parse(
      JSON.stringify(
        this.collections[collectionIndex].sensors[sensorIndex].indicesDetails
      )
    ).find((item: any) => item.product === 'NDVI');
    if (ndviObj) {
      let ndviScene = ndviObj.products.find(
        (scene: any) => scene.sceneId === selectedScene.id
      );
    }
    let footprintcordinates: any[] = [];
    footprintcordinates = selectedScene?.scene?.footprint?.coordinates[0].map(
      (sub) => {
        return [sub[1], sub[0]];
      }
    );
    this.spinnerService.show();
    this.apiService.getIndicesDataImgUrl(sensorObj).subscribe(
      async (res: any) => {
        let feedDatas = res?.response?.signedUrls;
        this.fetchAndCombineIndesisGeoJson(feedDatas, indices);
      },
      (err) => {
        this.spinnerService.hide();
        this.mapLoad = false;
      }
    );
  }

  displaySuperResolutions(
    superResolution,
    sensor,
    event,
    collectionIndex,
    sensorIndex
  ) {
    let selectedSceneId = sensor.scenes[this.selectedSceneIndex].id;
    let selectedScene = this.scenesNew.find(
      (sceneNew) => sceneNew.id == selectedSceneId
    );
    let selectedSceneIndex = this.scenesNew.find(
      (sceneNew) => sceneNew.id == selectedSceneId
    );
    superResolution.checked = true;
    let sensorObj = {
      taskId: this.taskid,
      sensorId: superResolution.sensorId,
      sceneId: this.selectedSceneNew.id,
      product: superResolution.product,
      type: 'display',
    };
    let footprintcordinates: any[] = [];
    footprintcordinates = this.selectedSceneNew?.footprint?.coordinates[0].map(
      (sub) => {
        return [sub[1], sub[0]];
      }
    );
    this.apiService
      .getValueAddedDataImgUrl(sensorObj)
      .subscribe(async (res: any) => {
        this.superResolutionLayer = L.imageOverlay(
          res.response.imageUrl,
          footprintcordinates,
          { pane: this.mapPane, crossOrigin: true }
        ).addTo(this.map);
        this.spinnerService.hide();
        this.mapLoad = false;
      });
  }

  resetAllFeedPanels(): void {
    for (const layer of Object.values(this.feedLayers)) {
      try {
        this.removeVesselLabelLayer(layer);
        this.map.removeLayer(layer);
      } catch (e) {
      }
    }
    Object.values(this.currentFilteredLayers || {}).forEach((layer) => {
        if (this.map.hasLayer(layer)) {
          this.removeVesselLabelLayer(layer);
          this.map.removeLayer(layer);
        }
      });
      this.currentFilteredLayers = {};

    this.feedLayers = {};
    this.feedPanels.clear();
    this.feedSections = [];
    this.feedLoaded = false;
    this.combinedFeedSections = [];
    this.feedInfo = false;
    this.activeFeedKeys.clear();
    try {
      this.map.invalidateSize();
    } catch (e) {
    }
  }

  downloadIndices(indices, collectionIndex, sensor, sensorIndex) {
    this.currentDownloadingIndices = {
      collectionIndex: collectionIndex,
      sensorIndex: sensorIndex,
      product: indices.product,
    };
    this.downloadIndicesService.downloadIndices(
      indices,
      collectionIndex,
      sensor,
      sensorIndex,
      this.taskid
    );
  }

  setDownloadedIndices() {
    const { product } = this.currentDownloadingIndices;
    if (!product) return;
    this.collections.forEach((collection) => {
      collection.sensors.forEach((sensor) => {
        const matchedRow = sensor.indicesDetails.find(
          (row) => row.product === product
        );

        if (matchedRow) {
          (matchedRow.products || []).forEach((item) => {
            item.isDownloaded = true;
          });
        }
      });
    });

    this.currentDownloadingIndices = {};
  }

  //----------------------------------------
  getLegend(operator: any, type: any) {
    this.selectedOperator = operator;
    if (operator === OPERATORS.SPIRE) {
      this.shipTypes = this.utilsService.getShips();
      if (type === 0) this.refreshData = false;
      else this.refreshData = true;
      this.shipTypes = this.shipTypes.sort((a, b) => {
        if (a.type === 'OTHER') return 1; // Move "OTHER" to the end
        if (b.type === 'OTHER') return -1;
        return a.type.localeCompare(b.type); // Sort the rest alphabetically
      });
    }
  }
  displayRefreshData(event, scene, sensor, action, refreshData) {
    if (event?.checked || action === 'download') {
      this.displaySpireRefreshData(scene, action, sensor, refreshData);
    } else {
      this.removeDataSourceById(refreshData.refreshId);
      this.filterData = [];
      if (this.isObservation(sensor)) {
        delete this.selectedHistory[refreshData.refreshId];
      }
    }
    if (action === 'display') {
      for (const [index, history] of sensor.refreshHistory.entries()) {
        if (history.refreshId === refreshData.refreshId) {
          history.checked = event.checked;
          break;
        }
      }
    }
  }
  displaySpireRefreshData(
    scene: any,
    type: any,
    sensor: any,
    refreshData: any
  ) {
    let sensorId;
    let taskId;
    let currentCrossImage: any, boundingBox, item;
    sensorId = sensor.id;

    if (sensor.operatorKey === OPERATORS.SPIRE) {
      currentCrossImage = 'assets/images/hot-pink.png';
      item = 'SPIRE';
    } else {
      currentCrossImage = 'assets/images/light-blue.png';
      item = 'CLYDE';
    }

    taskId = this.collection?.taskId;
    const aisReq = {
      sensorId: sensorId,
      refreshId: refreshData?.refreshId,
      taskid: taskId,
      action: type,
    };
    if (type !== 'download') {
      this.spinnerService.show();
      this.mapLoad = true;
    }

    this.apiService.getAISRefreshData(aisReq).subscribe((res: any) => {
      if (type !== 'download') {
        this.spinnerService.show();
        this.mapLoad = true;
      }

      if (res?.msg === 'failed') {
        const message =
          'An error occurred during processing and ingestion of the request. Please try after sometime.';
        this.popupService.openPopup(
          CollectionPopupComponent,
          message,
          '',
          '40%'
        );
        this.spinnerService.hide();
        this.mapLoad = false;
        this.freeze = false;
      } else {
        this.httpClient.get(res?.result?.imageUrl).subscribe(
          (data) => {
            this.filterData.push(refreshData.refreshId);
            this.filterVesselData = true;
            const updatedAis = this.convertToGeoJSONNew(data, item);
            if (this.isObservation(sensor)) {
              this.observationChecked = true;
              this.selectedHistory[refreshData.refreshId] = updatedAis;
            }
            // Add the bounding box as a new feature to the existing GeoJSON FeatureCollection
            let BBpoints: number[] = scene?.footprint?.coordinates[0] || [];
            if (type === 'download') {
              // Check if the bounding-box feature is already added
              const boundingBoxExists = updatedAis.features.some(
                (feature) => feature.id === 'bounding-box'
              );

              if (!boundingBoxExists) {
                updatedAis.features.push({
                  type: 'Feature',
                  id: 'bounding-box',
                  geometry: {
                    type: 'Polygon',
                    coordinates: [BBpoints],
                  },
                  properties: {
                    ID: 'bounding-box',
                    Lng: BBpoints[0]?.[0] || 0,
                    Lat: BBpoints[0]?.[1] || 0,
                    MMSI: 'N/A',
                    'Timestamp UTC': '',
                  },
                });
              }
            } else if (type === 'display') {
              updatedAis.features = updatedAis.features.filter(
                (feature) => feature.id !== 'bounding-box'
              );
            }

            if (type === 'display') {
              const geoJsonData = {
                type: 'FeatureCollection',
                features: updatedAis.features || [], // Ensure 'features' exists
              } as GeoJSON.FeatureCollection;

              this.taskScene = 'history';
              const markersLayer = L.geoJSON(geoJsonData, {
                pointToLayer: (feature, latlng) => {
                  return this.displayDirectionInMap(feature, latlng, sensor);
                },
                onEachFeature: (feature, layer) => {
                  // const properties = feature.properties;
                  const tooltipContents = `<div>${this.formatProperties(
                    feature.properties
                  )}</div>`;
                  this.attachTooltip(layer, tooltipContents);
                  (layer as any).type = 'spire';
                },
              }) as CustomGeoJsonLayer;

              markersLayer.refreshId = refreshData.refreshId; // Attach custom refreshId property
              markersLayer.type = 'spire';
              markersLayer.name = 'refreshDataSource';
              markersLayer.addTo(this.map); // Add to map

              if (geoJsonData.features.length > 0) {
                const firstFeature = geoJsonData.features[0];
                if (firstFeature.geometry.type === 'Point') {
                  const [lng, lat] = firstFeature.geometry.coordinates;
                  this.map.flyTo([lat, lng], 10);
                }
              }

              // Fit map to markers
              const bounds = markersLayer.getBounds();
              if (bounds.isValid()) {
                this.map.fitBounds(bounds, { padding: [50, 50] });
              }

              // Bounding Box (Rectangle)
              if (BBpoints) {
                const boundingBox = BBpoints.toString().split(',').map(Number);
                const polylineCoords: [number, number][] = [];

                for (let i = 0; i < boundingBox.length; i += 2) {
                  polylineCoords.push([boundingBox[i + 1], boundingBox[i]]); // Leaflet uses [lat, lng]
                }

                const boundingBoxLayer = L.polyline(polylineCoords, {
                  color: `#${Math.floor(Math.random() * 16777215).toString(
                    16
                  )}`, // Random color
                  weight: 3,
                  opacity: 1,
                }).addTo(this.map);

                (boundingBoxLayer as any).refreshId = refreshData.refreshId;
              }
              this.spinnerService.hide();
              this.mapLoad = false;
              this.taskScene = null;
            } else if (type === 'download') {
              const sensorObj = {
                progress: 100,
                taskId,
                sensorId: sensorId,
                sceneId: scene.id,
                download: this.downloadClick,
                action: 'aisDownload',
              };
              this.downloadService.setProgress(sensorObj);
              const blob = new Blob([JSON.stringify(updatedAis)], {
                type: 'application/json',
              });
              const url = window.URL.createObjectURL(blob);
              const fileName = res?.result?.imageUrl
                .split('/')
                .pop()
                .split('?')[0];
              const link = document.createElement('a');
              link.href = url;
              link.download = fileName;
              link.click();

              // Clean up
              window.URL.revokeObjectURL(url);
              this.progress = 0;
              this.spinnerService.hide();
              this.freeze = false;
              this.disable = false;
            }
          },
          (error) => {}
        );
      }
    });
  }
  removeDataSourceById(id: any) {
    let layersToRemove: L.Layer[] = [];

    this.map.eachLayer((layer) => {
      if (layer instanceof L.GeoJSON && (layer as any).refreshId === id) {
        layersToRemove.push(layer);
      }

      if (
        (layer instanceof L.Polyline || layer instanceof L.Rectangle) &&
        (layer as any).refreshId === id
      ) {
        layersToRemove.push(layer);
      }
    });
    layersToRemove.forEach((layer) => this.map.removeLayer(layer));
    this.filterVesselData = false;
  }
  displayDirectionInMap(feature: any, latlng: any, sensor: any) {
    const mmsi = feature.properties.MMSI;
    let typeOfShip =
      !feature.properties['Ship Type'] ||
      feature.properties['Ship Type'] === 'N/A'
        ? 'OTHER'
        : feature.properties['Ship Type'];

    if (!mmsi) {
      return L.marker(latlng, {
        // icon: this.createArrowIcon(0, typeOfShip)
      });
    }
    const heading = feature.properties['Course']
      ? parseFloat(feature.properties['Course'])
      : 0;
    const vesselMarker = L.marker(latlng, {
      icon: this.createArrowIcon(heading, typeOfShip, sensor),
      /* rotationAngle: heading, */
    } as any);

    return vesselMarker;
  }
  createArrowIcon(heading: number, shipType: string, sensor: any) {
    const size = 24;
    const iconUrl = this.getIconUrl(shipType, sensor);
    return L.divIcon({
      className: 'vessel-icon',
      html: `
      <span
        class="vessel-icon-img"
        style="
          display:inline-block;
          width:${size}px;height:${size}px;
          background-image:url('${iconUrl}');
          background-size:${size}px ${size}px;
          transform: rotate(${heading}deg);
          transform-origin: 50% 50%;
          cursor: pointer;  
        ">
      </span>`,
      iconSize: [size, size],
      iconAnchor: [size / 2, size / 2],
    });
  }
  getIconUrl(shipType: string, sensor: any) {
    let iconColor;
    let iconCanvas;
    if (this.taskScene == 'history') {
      if (sensor.operatorKey === OPERATORS.SPIRE) {
        iconColor = this.utilsService.getHistoricalShipColor(shipType);
      } else {
        iconColor = 'YELLOW';
      }

      iconCanvas = this.createHistoricalNavigationIcon(iconColor);
    } else {
      if (sensor.operatorKey === OPERATORS.SPIRE) {
        iconColor = 'YELLOW';
      } else {
        iconColor = 'ORANGE';
      }
      iconCanvas = this.createNavigationIcon(iconColor);
    }
    return iconCanvas.toDataURL('image/png'); // Convert canvas to base64
  }
  createHistoryNavigationIcon(color: string) {
    let iconCanvas = this.createNavigationIcon(color);
    return iconCanvas.toDataURL('image/png');
  }
  createHistoricalNavigationIcon(color: string): HTMLCanvasElement {
    const canvas = document.createElement('canvas');
    const size = 24; // Material icon default size
    canvas.width = size;
    canvas.height = size;

    const ctx = canvas.getContext('2d');
    if (!ctx) return canvas;

    // Set up the canvas for material icons
    ctx.font = '20px Material Icons';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';

    ctx.lineWidth = 3;
    ctx.strokeStyle = color;
    ctx.strokeText('\ue55d', size / 2, size / 2);

    return canvas;
  }
  createNavigationIcon(color: string): HTMLCanvasElement {
    const canvas = document.createElement('canvas');
    const size = 24; // Material icon default size
    canvas.width = size;
    canvas.height = size;

    const ctx = canvas.getContext('2d');
    if (!ctx) return canvas;

    // Set up the canvas for material icons
    ctx.font = '20px Material Icons';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillStyle = color;

    // Draw the navigation icon (Unicode for Material Icons 'navigation')
    ctx.fillText('\ue55d', size / 2, size / 2);
    return canvas;
  }
  createNavigationIconSpire(
    color: string,
    courseDeg: number,
    history: string
  ): HTMLCanvasElement {
    const canvas = document.createElement('canvas');
    const baseSize = 50;
    const histSize = 24;
    const size = history === 'historySpire' ? histSize : baseSize;
    canvas.width = size;
    canvas.height = size;

    const ctx = canvas.getContext('2d');
    if (!ctx) return canvas;

    ctx.clearRect(0, 0, size, size);
    ctx.save();
    ctx.translate(size / 2, size / 2);
    ctx.rotate((courseDeg * Math.PI) / 180);

    // Set font for Material Icons
    ctx.font = '20px "Material Icons"';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillStyle = color;

    // Draw the Material “navigation” glyph (uE55D)
    ctx.fillText('\ue55d', 0, 0);

    ctx.restore();
    return canvas;
  }

  AISDownload(sensor: any) {
    let sensorId;
    let taskId;
    let currentCrossImage: any;
    let downloadAction: any;

    sensorId = sensor.id;
    taskId = this.collection?.taskId;
    const aisReq = {
      sensorId: sensorId,
      taskid: taskId,
      action: 'zipDownload',
    };

    if (sensor?.operatorKey === OPERATORS.CLYDE) downloadAction = 'aisDownload';
    else downloadAction = '';

    this.apiService.getAISRefreshData(aisReq).subscribe((res: any) => {
      if (res?.msg === 'failed') {
        const message =
          'An error occurred during processing and ingestion of the request. Please try after sometime.';
        this.popupService.openPopup(
          CollectionPopupComponent,
          message,
          '',
          '40%'
        );
        this.spinnerService.hide();
        this.mapLoad = false;
        this.freeze = false;
      } else {
        let url = res.result?.imageUrl;

        const xhr = new XMLHttpRequest();
        xhr.open('GET', url);
        xhr.responseType = 'blob';

        xhr.onprogress = (event) => {
          if (event.lengthComputable) {
            const percentComplete = (event.loaded / event.total) * 100;
            this.progress = percentComplete.toFixed(2);
            const sensorObj = {
              progress: 100,
              taskId,
              sensorId: sensorId,
              sceneId: sensor.scenes[0].id,
              download: this.downloadClick,
              action: downloadAction,
            };
            this.downloadService.setProgress(sensorObj);
          }
        };

        xhr.onload = () => {
          if (xhr.status === 200) {
            const blob = xhr.response;
            const fileName = this.getFileNameFromS3SignedUrl(url);
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
            URL.revokeObjectURL(link.href);

            // Reset progress after download
            this.progress = 0;
            this.spinnerService.hide();
            this.freeze = false;
            this.disable = false;
          }
        };

        xhr.onerror = () => {
          // Handle errors
        };
        xhr.send();
      }
    });
  }

  hasSensorsExist(operatorKey) {
    let checkedSensors: any[] = this.collection?.sensors.filter(
      (sensor) => sensor?.operatorKey === operatorKey
    );
    if(checkedSensors && checkedSensors?.length === 0) {
      return false;
    }
    if (this.subDailyFinalArray.length > 0) {
      let checkedScenes = this.subDailyFinalArray.flatMap((sensor) =>
        sensor.scenes ? sensor.scenes.filter((scene) => scene.checked) : []
      );
      return checkedScenes.length > 0;
    }
    // Get all checked scenes inside the sensors
    else if (checkedSensors?.length > 0) {
      let checkedScenes = checkedSensors.flatMap((sensor) =>
        sensor.scenes ? sensor.scenes.filter((scene) => scene.checked) : []
      );
      return checkedScenes.length > 0;
    }
    return false;
  }

  removeDynamicLayer() {
    this.dynamicLayers.forEach((layer) => {
      this.removeVesselLabelLayer(layer);
      this.map.removeLayer(layer);
    });
    this.dynamicLayers = [];
    this.feedInfo = false;
    this.oilSpil = false;
  }

  shouldShowRawIqRow(scene) {
    return (
      this.currentUser?.raw_iq_approved && scene.operatorKey == OPERATORS.LBAND
    );
  }

  getAvailableSignals(scene: any): string {
    if (scene?.signalOfInterest?.length) {
      return scene.signalOfInterest
        .map((s: any) => s.product)
        .filter((p: string) => !!p) // removes falsy values like undefined/null
        .join(', ');
    }
    return scene?.name || 'N/A';
  }

  getDownloadImage(i: any, j: any, k: any) {
    let sensor = this.collections[i].sensors[j];
    let scene = sensor.scenes[k];
    return scene?.rawIQDownloaded
      ? this.downloadedImage
      : this.checkDownloaded(scene) && scene?.rawIQIncluded
      ? this.downloadImage
      : '../../../assets/images/cloud.png';
  }

  isGrayedOut(scene: any, sensor: any): boolean {
    if (!scene?.id) return true;
    if (scene?.status === 'failed') return true;
    if (sensor?.status === 'archived') return true;
    if (sensor?.status === 'restored' && sensor?.restoreOption === 'view')
      return true;
    return false;
  }
  hasAnnotationFeature(): boolean {
    return this.hasFeature(ANNOTATION);
  }
  hasCollectionPointTaskingFeature(): boolean {
    return this.hasFeature(POINT_TASKING);
  }
  hasFeature(featureKey: string): boolean {
    return (
      this.currentUser?.planDetails?.features?.some(
        (feature) => feature.key.toLowerCase() === featureKey.toLowerCase()
      ) || false
    );
  }

  filterByDateTime(sensor) {
    const dialogRef = this.matdialog.open(FilterPopupComponent, {
      width: '35%',
      backdropClass: 'blurr',
      disableClose: true,
      data: {
        type: 'refreshDateFilter',
        refreshHistory: sensor.refreshHistory,
        currentUser: this.currentUser,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.applyFilter(result, sensor);
      } else {
      }
    });
  }
  applyFilter(selectedDates, sensor) {
    if (!selectedDates.startDateTime || !selectedDates.endDateTime) {
      return;
    }

    const startTimestamp = selectedDates.startDateTime;
    const endTimestamp = selectedDates.endDateTime;
    const result = this.filterClosestTimestamp(
      sensor.refreshHistory,
      startTimestamp,
      endTimestamp
    );
    if (result) {
      let currentEvent = {
        checked: true,
      };
      this.displayRefreshData(
        currentEvent,
        sensor.scenes[0],
        sensor,
        'display',
        result
      );
    } else {
      const message = `There are no vessels meeting the search criteria.`;
      this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
    }
  }
  resetRefreshData(sensor) {
    if (sensor.refreshHistory) {
      for (const [index, history] of sensor.refreshHistory.entries()) {
        history.checked = false;
        this.removeDataSourceById(history.refreshId);
        this.filterData = [];
        // this.removeEntitiesByName(history.refreshId);
        if (this.isObservation(sensor)) {
          delete this.selectedHistory[history.refreshId];
        }
      }
    }
  }
  //  removeEntitiesByName(name) {
  //   let entitiesToRemove: any = [];

  //   this.viewer.entities.values.forEach((entity) => {
  //     if (entity.name === name) {
  //       entitiesToRemove.push(entity);
  //     }
  //   });

  //   entitiesToRemove.forEach((entity) => {
  //     this.viewer.entities.remove(entity);
  //   });
  // }
  filterClosestTimestamp(history: any[], start: string, end: string): any {
    // Convert start and end times to UTC timestamps
    const startTime = new Date(start).getTime();
    const endTime = new Date(end).getTime();

    // Filter timestamps within the range
    const filtered = history
      .map((item) => ({
        ...item,
        timestamp: new Date(item.name).getTime(), // Convert to UTC timestamp
      }))
      .filter(
        (item) => item.timestamp >= startTime && item.timestamp <= endTime
      );

    // Find the closest timestamp to the end time
    if (filtered.length === 0) return null; // No results in the range

    return filtered.reduce((closest, item) =>
      Math.abs(item.timestamp - endTime) < Math.abs(closest.timestamp - endTime)
        ? item
        : closest
    );
  }

  filterHistoricalData(operator) {
    const uniqueFlags = new Set<string>();
    const uniqueDestination = new Set<string>();
    const uniquevesselTypes = new Set<string>();
    const uniqueIMONumbers = new Set<string>();
    const uniqueMMSIList = new Set<string>();
    const uniquevesselNames = new Set<string>();

    // Iterate over all Leaflet layers
    this.map.eachLayer((layer: any) => {
      // Check if layer is a marker/feature with the correct operator type
      if (layer.type === operator.toLowerCase()) {
        // If it's a layer group, iterate through its layers
        if (layer.getLayers) {
          layer.eachLayer((entity: any) => {
            this.collectUniqueValues(
              entity,
              uniqueFlags,
              uniqueDestination,
              uniquevesselTypes,
              uniqueIMONumbers,
              uniqueMMSIList,
              uniquevesselNames
            );
          });
        } else {
          // Single marker/feature
          this.collectUniqueValues(
            layer,
            uniqueFlags,
            uniqueDestination,
            uniquevesselTypes,
            uniqueIMONumbers,
            uniqueMMSIList,
            uniquevesselNames
          );
        }
      }
    });

    // Convert Set to arrays
    const flagArray = Array.from(uniqueFlags);
    const detinationArray = Array.from(uniqueDestination);
    const vesselTypeArray = Array.from(uniquevesselTypes);
    const IMONumbers = Array.from(uniqueIMONumbers);
    const MMSIList = Array.from(uniqueMMSIList);
    const vesselNames = Array.from(uniquevesselNames);

    const dialogRef = this.matdialog.open(FilterPopupComponent, {
      backdropClass: 'blurr',
      disableClose: true,
      data: {
        type: 'aisVessel',
        refreshData: true,
        flagArray: flagArray,
        detinationArray: detinationArray,
        filterObject: this.refreshFilterObject,
        vesselTypeArray: vesselTypeArray,
        IMONumbers,
        MMSIList,
        vesselNames,
        currentUser: this.currentUser,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        let hasVisibleEntities = false;
        let currentVisibleEntities: any[] = [];

        this.refreshFilterObject = result;
        const filters: FilterCriteria = {
          destination: result.destination,
          flag: result.flag,
          length: result.length,
          isGreater: result.isGreater,
          vesselType: result.vesselType,
          vesselSpeed: result.vesselSpeed,
          isSpeedGreater: result.isSpeedGreaterThan,
          vesselName: result.vesselName,
          MMSI: result.MMSI,
          IMO: result.IMO,
        };

        // Iterate over all Leaflet layers and apply filters
        this.map.eachLayer((layer: any) => {
          if (layer.type === operator.toLowerCase()) {
            if (layer.getLayers) {
              layer.eachLayer((entity: any) => {
                const isVisible = this.checkEntityExist(entity, filters);

                if (isVisible) {
                  if (!this.map.hasLayer(entity)) {
                    entity.addTo(this.map);
                  }
                  hasVisibleEntities = true;
                  currentVisibleEntities.push(entity);
                } else {
                  if (this.map.hasLayer(entity)) {
                    this.map.removeLayer(entity);
                  }
                }
              });
            } else {
              const isVisible = this.checkEntityExist(layer, filters);

              if (isVisible) {
                if (!this.map.hasLayer(layer)) {
                  layer.addTo(this.map);
                }
                hasVisibleEntities = true;
                currentVisibleEntities.push(layer);
              } else {
                if (this.map.hasLayer(layer)) {
                  this.map.removeLayer(layer);
                }
              }
            }
          }
        });

        if (hasVisibleEntities) {
          this.lastVisibleEntities = [...currentVisibleEntities];
          this.filterVesselDataValue = true;
        } else {
          const message = `There are no vessels meeting the search criteria.`;
          this.popupService.openPopup(
            CollectionPopupComponent,
            message,
            '',
            '40%'
          );

          // Restore previous state
          if (this.lastVisibleEntities?.length === 0) {
            // Show all entities
            this.map.eachLayer((layer: any) => {
              if (layer.type === operator.toLowerCase()) {
                if (layer.getLayers) {
                  layer.eachLayer((entity: any) => {
                    if (!this.map.hasLayer(entity)) {
                      entity.addTo(this.map);
                    }
                  });
                } else {
                  if (!this.map.hasLayer(layer)) {
                    layer.addTo(this.map);
                  }
                }
              }
            });
          } else {
            // Show only last visible entities
            this.map.eachLayer((layer: any) => {
              if (layer.type === operator.toLowerCase()) {
                if (layer.getLayers) {
                  layer.eachLayer((entity: any) => {
                    if (this.lastVisibleEntities.includes(entity)) {
                      if (!this.map.hasLayer(entity)) {
                        entity.addTo(this.map);
                      }
                    } else {
                      if (this.map.hasLayer(entity)) {
                        this.map.removeLayer(entity);
                      }
                    }
                  });
                } else {
                  if (this.lastVisibleEntities.includes(layer)) {
                    if (!this.map.hasLayer(layer)) {
                      layer.addTo(this.map);
                    }
                  } else {
                    if (this.map.hasLayer(layer)) {
                      this.map.removeLayer(layer);
                    }
                  }
                }
              }
            });
          }
        }
      }
    });
  }

  // Helper method to collect unique values from layer properties
  collectUniqueValues(
    entity: any,
    uniqueFlags: Set<string>,
    uniqueDestination: Set<string>,
    uniquevesselTypes: Set<string>,
    uniqueIMONumbers: Set<string>,
    uniqueMMSIList: Set<string>,
    uniquevesselNames: Set<string>
  ) {
    // Access properties from layer's custom data
    const props =
      entity.options?.properties || entity.feature?.properties || {};

    const flag = props.Flag;
    const destination = props.Destination;
    const vesselType = props['Ship Type'];
    const MMSI = props.MMSI;
    const vesselName = props.Name;
    const IMO = props.IMO;

    if (flag && flag !== 'N/A') {
      uniqueFlags.add(flag);
    }

    if (destination && destination !== 'N/A') {
      uniqueDestination.add(destination);
    }

    if (vesselType && vesselType !== 'N/A') {
      uniquevesselTypes.add(vesselType);
    }

    if (IMO && IMO !== 'N/A') {
      uniqueIMONumbers.add(IMO);
    }

    if (MMSI && MMSI !== 'N/A') {
      uniqueMMSIList.add(MMSI);
    }

    if (vesselName && vesselName !== 'N/A') {
      uniquevesselNames.add(vesselName);
    }
  }

  checkEntityExist(entity: any, filters: any): boolean {
    let isVisible = true;

    // Access properties from layer's custom data
    const props =
      entity.options?.properties || entity.feature?.properties || {};

    const flag = props.Flag;
    const destination = props.Destination;
    const vesselLength = Number(props['Vessel Length']);
    const vesselType = props['Ship Type'];
    const MMSI = props.MMSI;
    const vesselName = props.Name;
    const IMO = props.IMO;

    let speed;
    let speedValue = props.Speed;
    if (
      speedValue !== 'N/A' &&
      speedValue !== null &&
      speedValue !== undefined
    ) {
      speed = Number(speedValue);
    }

    // Apply Flag filter
    if (filters.flag) {
      isVisible = isVisible && flag === filters.flag;
    }

    // Apply Destination filter
    if (filters.destination) {
      isVisible = isVisible && destination === filters.destination;
    }

    // Apply Vessel Type filter
    if (filters.vesselType) {
      isVisible =
        isVisible &&
        (vesselType === filters.vesselType ||
          (filters.vesselType === 'OTHER' && vesselType === null));
    }

    // Apply MMSI filter
    if (filters.MMSI) {
      isVisible = isVisible && MMSI === filters.MMSI;
    }

    // Apply IMO filter
    if (filters.IMO) {
      isVisible = isVisible && IMO === filters.IMO;
    }

    // Apply Vessel Name filter
    if (filters.vesselName) {
      isVisible = isVisible && vesselName === filters.vesselName;
    }

    // Apply Length filter
    if (!isNaN(filters.length) && !isNaN(vesselLength)) {
      if (filters.isGreater) {
        isVisible = isVisible && vesselLength > filters.length;
      } else {
        isVisible = isVisible && vesselLength < filters.length;
      }
    }

    // Apply Speed filter
    if (
      !isNaN(filters.vesselSpeed) &&
      typeof filters.vesselSpeed === 'number'
    ) {
      if (!isNaN(speed)) {
        if (filters.isSpeedGreater) {
          isVisible = isVisible && speed > filters.vesselSpeed;
        } else {
          isVisible = isVisible && speed < filters.vesselSpeed;
        }
      } else if (speedValue === 'N/A') {
        isVisible = false;
      }
    }

    return isVisible;
  }

  resetRefreshFilter(operator) {
    this.map.eachLayer((layer: any) => {
      if (layer.type === operator.toLowerCase()) {
        // If it's a layer group, iterate through its layers
        if (layer.getLayers) {
          layer.eachLayer((entity: any) => {
            if (!this.map.hasLayer(entity)) {
              entity.addTo(this.map);
            }
          });
        } else {
          // Single marker/feature
          if (!this.map.hasLayer(layer)) {
            layer.addTo(this.map);
          }
        }
      }
    });
    this.refreshFilterObject = undefined;
    this.lastVisibleEntities = [];
    this.filterVesselDataValue = false;
  }

  openFilterPopup(sensor?: any) {
    const spireVessels = this.spireJsonData;

    const dialogRef = this.matdialog.open(FilterPopupComponent, {
      backdropClass: 'blurr',
      disableClose: true,
      data: {
        type: 'aisVessel',
        vesselData: spireVessels,
        filterObject: this.filterObject,
        refreshData: false,
        currentUser: this.currentUser,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.filterObject = result;
        const filters: FilterCriteria = {
          destination: result.destination,
          flag: result.flag,
          length: result.length,
          isGreater: result.isGreater,
          vesselType: result.vesselType,
          vesselSpeed: result.vesselSpeed,
          isSpeedGreater: result.isSpeedGreaterThan,
          vesselName: result.vesselName,
          MMSI: result.MMSI,
          IMO: result.IMO,
        };
        let filteredFeatures = this.applyVesselFilters(spireVessels, filters);

        if (filteredFeatures.length === 0) {
          const message = `There are no vessels meeting the search criteria.`;
          this.popupService.openPopup(
            CollectionPopupComponent,
            message,
            '',
            '40%'
          );
        } else {
          const updatedFeatures = {
            type: 'FeatureCollection',
            features: filteredFeatures,
          };
          this.sceneFilterData = true;
          this.clearSpireLayers();
          // this.removeLayerByName('spireDataSource');
          this.updateSpire(updatedFeatures, sensor);
          // this.vesselFilter = true;
        }
      }
    });
  }
  removeLayerByName(layerName: string) {
    if (this.spireLayerRef) {
      this.map.removeLayer(this.spireLayerRef);
      this.spireLayerRef = null;
    }

    // Alternative: iterate through all layers
    this.map.eachLayer((layer: any) => {
      if (layer.layerName === layerName) {
        this.map.removeLayer(layer);
      }
    });
  }

  applyVesselFilters(data: any, filterCriteria: FilterCriteria) {
    return data.features.filter((feature) => {
      const properties = feature.properties;

      // Check all filter criteria
      for (const [key, value] of Object.entries(filterCriteria)) {
        if (value === undefined || value === null || value === '') continue; // Skip empty values

        switch (key) {
          case 'destination':
            if (properties.Destination !== value) return false;
            break;

          case 'flag':
            if (properties.Flag !== value) return false;
            break;

          case 'vesselType':
            if (value === 'OTHER') {
              if (
                properties['Ship Type'] !== null &&
                properties['Ship Type'] !== 'OTHERS'
              ) {
                return false;
              }
            } else if (properties['Ship Type'] !== value) {
              return false;
            }
            break;

          case 'length':
            if (
              properties['Vessel Length'] === 'N/A' ||
              properties['Vessel Length'] === null ||
              properties['Vessel Length'] === undefined
            ) {
              return false;
            }
            const vesselLength = Number(properties['Vessel Length']);
            const filterLength = Number(value);

            if (!isNaN(vesselLength) && !isNaN(filterLength)) {
              if (filterCriteria.isGreater) {
                if (vesselLength <= filterLength) return false;
              } else {
                if (vesselLength >= filterLength) return false;
              }
            }
            break;

          case 'vesselSpeed':
            if (
              properties.Speed === 'N/A' ||
              properties.Speed === null ||
              properties.Speed === undefined
            ) {
              return false;
            }
            const speed = Number(properties.Speed);
            const filterValue = Number(value);

            if (!isNaN(speed) && !isNaN(filterValue)) {
              if (filterCriteria.isSpeedGreater) {
                if (speed <= filterValue) return false;
              } else {
                if (speed >= filterValue) return false;
              }
            }
            break;

          case 'vesselName':
            if (properties.Name !== value) return false;
            break;

          case 'MMSI':
            if (properties.MMSI !== value) return false;
            break;

          case 'IMO':
            if (properties.IMO !== value) return false;
            break;
        }
      }

      return true;
    });
  }

  private clearSpireLayers() {
    if (this.spireGroup) this.spireGroup.clearLayers();

    // defensive: remove any loose layers/markers you may have added before
    this.map.eachLayer((layer: any) => {
      if (layer?.layerName === 'spireDataSource' || layer?.type === 'spire') {
        this.map.removeLayer(layer);
      }
    });

    // if you stored markers individually, remove & reset
    if (Array.isArray(this.spireHistoricalLayer)) {
      this.spireHistoricalLayer.forEach((e: any) => {
        try {
          this.map.removeLayer(e.marker);
        } catch {}
      });
      this.spireHistoricalLayer = [];
    }

    this.spireLayerRef = null;
  }

  updateSpire(filteredGeoJson: any, sensorobj?: any) {
    const type = 'SPIRE';
    const isHistorical = false;
    const sensor = sensorobj;

    // Ensure we're working with a proper FeatureCollection
    const filteredData: GeoJSON.FeatureCollection = {
      type: 'FeatureCollection',
      features: Array.isArray(filteredGeoJson.features)
        ? filteredGeoJson.features
        : Array.isArray(filteredGeoJson)
        ? filteredGeoJson
        : [],
    };

    const spireLayer = L.geoJSON(filteredData, {
      pointToLayer: (feature, latlng) => {
        const icon = this.makeNavIconFromFeature(feature);
        const m = L.marker(latlng, {
          icon,
          zIndexOffset: 100000,
          riseOnHover: true,
          opacity: 1,
        }) as any;
        m.type = 'spire';
        m.layerName = 'spireDataSource';
        m.sensorId = this.spireSensorId;
        m.name = 'vessel';
        return m;
      },
      onEachFeature: (ftr, lyr: any) => {
        lyr.sensorId = this.spireSensorId;
        lyr.name = 'vessel';
        lyr.type = 'spire';
        lyr.layerName = 'spireDataSource';
        const iconOpts = (lyr as any)?.options?.icon?.options;
        const iconW = iconOpts?.iconSize?.[0] ?? 24;
        const offsetX = Math.round(iconW / 2 + 6);
        this.attachTooltip(
          lyr,
          `<span style="text-transform: capitalize;">
           ${this.formatProperties(ftr.properties)}
        </span>`
        );
        {
          sensorobj?.noOfHistoricalData &&
            lyr.on('click', () => {
              this.clickedMarker = lyr;
              if (this.clickedMarker) this.clickedMarker.closeTooltip();
              this.handleLayerClick(
                ftr,
                isHistorical,
                sensor,
                this.clickedMarker
              );
            });
        }

        this.spireHistoricalLayer.push({ marker: lyr, type });
      },
    });

    // Add to the spire group
    if (this.spireGroup) {
      spireLayer.addTo(this.spireGroup);
    } else {
      // Fallback: add directly to map if group doesn't exist
      spireLayer.addTo(this.map);
    }

    // Store reference
    this.spireLayerRef = spireLayer as any;
    (this.spireLayerRef as any).layerName = 'spireDataSource';

    // Fit bounds to filtered vessels
    if (filteredData.features.length > 0) {
      const bounds = (spireLayer as any).getBounds();
      if (bounds?.isValid?.()) {
        this.map.flyToBounds(bounds, { padding: [50, 50], duration: 3 });
      }
    }
  }

 safeDate(v: any) {
  return new Date(v);
 }
  clearFilter(sensorobj: any) {
    this.updateSpire(this.spireJsonData, sensorobj);
    this.sceneFilterData = false;
    this.filterObject = undefined;
  }

  uncheckAll(isChecked: boolean) {
    this.jump = false;
    this.timeseries = false;
    this.showDailyRecurrencyCheckboxes = false;
    if (this.collection?.opportunities) {
      this.collection.opportunities.forEach((o) => (o.checked = false));
    }
    if (this.collection?.recurrencyArray) {
      this.collection.recurrencyArray.forEach((r) => (r.checked = false));
    }
    if (this.selectedSubDailyItemsNew) {
      this.selectedSubDailyItemsNew.forEach((i) => (i.checked = false));
    }
    if (this.selectedSites) {
      this.selectedSites.forEach((s) => (s.checked = false));
    }
    this.uncheckDeepInPlace(this.collection);
    this.uncheckDeepInPlace(this.collections);
    this.uncheckDeepInPlace(this.selectedSites);
    this.uncheckDeepInPlace(this.selectedSubDailyItemsNew);
  }
  // flips every `checked` it finds to false, recursively (arrays + plain objects)
  uncheckDeepInPlace(value: any): void {
    if (Array.isArray(value)) {
      for (const v of value) this.uncheckDeepInPlace(v);
      return;
    }
    if (value && typeof value === 'object') {
      if ('checked' in value) (value as any).checked = false;
      for (const k of Object.keys(value)) {
        const child = (value as any)[k];
        if (child && (Array.isArray(child) || typeof child === 'object')) {
          this.uncheckDeepInPlace(child);
        }
      }
    }
  }
  getMessage() {
    let message =
      'The scene does not have metadata mapped. However, full metadata is included in the zip with the download.';
    this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
    this.spinnerService.hide();
  }
  showDownloadError() {
    const message =
      'Something interrupted your previous download and prevented its completion. Please download again.';
    this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
    this.resetDownload();
    this.spinnerService.hide();
  }
  resetDownload() {
    this.downloadService.unsubscribeProgress();
    this.spinnerService.hide();
    this.mapLoad = false;
    this.freeze = false;
  }
  getRefundStatus(sensor) {
    let status = sensor?.operatorKey == OPERATORS.AZISTA && sensor.downloaded;
    return status;
  }
  inactivateRefundStatus(sensor) {
    let status = sensor?.operatorKey == OPERATORS.AZISTA && !sensor.downloaded;
    return status;
  }

  onObservationToggle(event: any, info: any): void {
    if (event.checked) {
      this.renderObservation(info);
    } else {
      this.removeObservationMarker();
    }
  }
  async renderObservation(info: any) {
    const raw = (info?.observationValue ?? '').trim();
    const parts = raw.split(',').map((s) => parseFloat(s));

    const addCrossMarker = (lon: number, lat: number) => {
      // Remove existing marker if any
      if (this.observationMarkerEntity) {
        this.map.removeLayer(this.observationMarkerEntity);
      }

      // Create custom icon
      const customIcon = L.icon({
        iconUrl: 'assets/images/marker-icon.png',
        iconSize: [20, 30],
        iconAnchor: [10, 30],
        popupAnchor: [0, -30],
      });

      // Add marker to map
      this.observationMarkerEntity = L.marker([lat, lon], {
        icon: customIcon,
      }).addTo(this.map);
    };

    if (
      parts.length === 2 &&
      Number.isFinite(parts[0]) &&
      Number.isFinite(parts[1])
    ) {
      const [lon, lat] = parts;

      addCrossMarker(lon, lat);

      // Fly to location with animation
      this.map.flyTo([lat, lon], 15, {
        duration: 2.5, // duration in seconds
      });
      return;
    }

    try {
      const coordinates = this.getCoordinatesByUnknownKey(
        this.selectedHistory,
        raw
      );
      if (coordinates) {
        const [lon, lat] = coordinates;

        addCrossMarker(lon, lat);

        // Fly to location with animation
        this.map.flyTo([lat, lon], 15, {
          duration: 2.5,
        });
        return;
      } else {
        this.spinnerService.hide();
        this.mapLoad = false;
        let message =
          'The observation of interest is not present in the area of interest.';
        const dialog = this.popupService.openPopup(
          CollectionPopupComponent,
          message,
          '',
          '40%'
        );
        dialog.afterClosed().subscribe((res) => {
          this.resetObservationSelection();
          return;
        });
      }
    } catch (err) {
      const message =
        'An error occurred during processing and ingestion of the request. Please try after sometime.';
      const dialog = this.popupService.openPopup(
        CollectionPopupComponent,
        message,
        '',
        '40%'
      );
      dialog.afterClosed().subscribe((res) => {
        this.resetObservationSelection();
      });
    }
  }

  getCoordinatesByUnknownKey(historyMap: any, searchValue: any) {
    const allFeatures: any[] = [];

    for (const key in historyMap) {
      if (historyMap[key]?.features) {
        allFeatures.push(...historyMap[key].features);
      }
    }

    const match = allFeatures.find((feature) => {
      const props = feature.properties ?? {};
      return Object.values(props).some((val) => val == searchValue);
    });
    return match?.geometry?.coordinates ?? null;
  }

  resetObservationSelection(): void {
    this.checkedObservation = false;
    this.removeObservationMarker();
  }

  removeObservationMarker(): void {
    if (this.observationMarkerEntity) {
      this.map.removeLayer(this.observationMarkerEntity);
      this.observationMarkerEntity = null;
    }
  }
  isObservation(sensor: any) {
    return (
      sensor?.tnqSensorType === 'Tipping' &&
      sensor?.Observation.length > 0 &&
      sensor?.Observation[0]?.ais_observation == true
    );
  }

  createTooltipDiv(): HTMLDivElement {
    const tooltipDiv = document.createElement('div');

    tooltipDiv.className = 'custom-tooltip';
    tooltipDiv.style.position = 'absolute';
    tooltipDiv.style.pointerEvents = 'none';
    tooltipDiv.style.background = '#000';
    tooltipDiv.style.color = 'white';
    tooltipDiv.style.padding = '10px';
    tooltipDiv.style.border = '1px solid black';
    tooltipDiv.style.fontSize = '15px';
    tooltipDiv.style.display = 'none';
    tooltipDiv.style.zIndex = '1000';
    tooltipDiv.style.maxWidth = '300px';
    tooltipDiv.style.minWidth = '200px';
    tooltipDiv.style.lineHeight = '1.8';
    tooltipDiv.style.fontFamily = 'Barlow, sans-serif';
    const mapEl = document.getElementById('map')!;
    mapEl.style.position = 'relative';
    mapEl.appendChild(tooltipDiv);

    return tooltipDiv;
  }

  updateTooltipPosition(e: any, tooltipDiv: HTMLDivElement) {
    const mapEl = document.getElementById('map')!;
    const mapRect = mapEl.getBoundingClientRect();
    const tooltipRect = tooltipDiv.getBoundingClientRect();

    let x = e.originalEvent.clientX - mapRect.left + 10;
    let y = e.originalEvent.clientY - mapRect.top + 10;

    // Flip if overflowing
    if (x + tooltipRect.width > mapRect.width) {
      x = e.originalEvent.clientX - mapRect.left - tooltipRect.width - 10;
    }
    if (y + tooltipRect.height > mapRect.height) {
      y = e.originalEvent.clientY - mapRect.top - tooltipRect.height - 10;
    }

    // Clamp
    x = Math.max(5, Math.min(x, mapRect.width - tooltipRect.width - 5));
    y = Math.max(5, Math.min(y, mapRect.height - tooltipRect.height - 5));

    tooltipDiv.style.left = `${x}px`;
    tooltipDiv.style.top = `${y}px`;
  }

  attachTooltip(layer: any, content: string) {
    const tooltipDiv = this.createTooltipDiv();
    tooltipDiv.innerHTML = content;

    layer.on('mouseover', (e: any) => {
      tooltipDiv.style.display = 'block';
      this.updateTooltipPosition(e, tooltipDiv);
    });

    layer.on('mouseout', () => {
      tooltipDiv.style.display = 'none';
    });

    layer.on('mousemove', (e: any) => {
      this.updateTooltipPosition(e, tooltipDiv);
    });
  }

  isPartialDelivery(res: any) {
    if (res?.isPartialApproved === false && res?.partialPayment === true) {
      this.popupService.openPopup(
        CollectionPopupComponent,
        'partial-delivery',
        '',
        '40%'
      );
      return true;
    }
    return false;
  }

loadTimeSeriesDataObject(info: any, index: number) {
  const recurrencyItem = info?.recurrencyArray?.[index];
  const infoService = recurrencyItem?.InfoServices?.[0];
  const cached = infoService?.insightDatas ?? [];
  const sceneSelected = recurrencyItem?.scenes?.[0]?.id;

  if (!cached.length || !infoService) {
    this.spinnerService.hide();
    this.mapLoad = false;
    this.opManager.completeOperation();
    return;
  }

  // AXELSPACE – take first insight directly
  if (info.sensors?.[0]?.operatorKey === OPERATORS.AXELSPACE) {
    const insight = cached[0];
    this.displayISNew(insight, infoService);
    this.displayedIS = JSON.parse(JSON.stringify(insight));
    this.opManager.completeOperation();
    return;
  }

  // Scene-based selection
  if (sceneSelected) {
    const insight = cached.find(
      (sc: any) => sc.sceneId === sceneSelected
    );

    if (insight) {
      insight._id = infoService._id;
      this.displayISNew(insight, infoService);
      this.displayedIS = JSON.parse(JSON.stringify(insight));
    }

    this.opManager.completeOperation();
    return;
  }

  // Multiple scenes case
  if (this.scenIdList?.length) {
    this.scenIdList.forEach((sceneId) => {
      const insight = cached.find(
        (sc: any) => sc.sceneId === sceneId
      );

      if (insight) {
        insight._id = infoService._id;
        this.displayISNew(insight, infoService);
        this.displayedIS = JSON.parse(JSON.stringify(insight));
      }
    });
  }

  this.opManager.completeOperation();
}

sameDay(start?: string | Date, end?: string | Date): boolean {
  if (!start || !end) return false;

  const s = new Date(start);
  const e = new Date(end);

  return (
    s.getUTCDate() === e.getUTCDate() &&
    s.getUTCMonth() === e.getUTCMonth() &&
    s.getUTCFullYear() === e.getUTCFullYear()
  );
  }

  getBandMinMax(workspace: string, sceneId: string, bands: any) {
  const bandId = bands.map((bandValue: any) => bandValue?.id);
  return this.apiService
    .getBandMinMax(workspace, sceneId, bandId)
    .pipe(take(1));
  }

  removeVesselLabelLayer(layer: any) {
        const vesselLabels = (layer as any)._vesselLabels;
      if (vesselLabels && Array.isArray(vesselLabels)) {
        vesselLabels.forEach((labelMarker) => {
          if (this.map.hasLayer(labelMarker)) {
            this.map.removeLayer(labelMarker);
          }
        });
      }
  }


}

